(function(factory) {
    typeof define == "function" && define.amd ? define("index", factory) : factory()
})((function() {
    "use strict";

    function _typeof(obj) {
        "@babel/helpers - typeof";
        return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof = function(obj2) {
            return typeof obj2
        } : _typeof = function(obj2) {
            return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2
        }, _typeof(obj)
    }

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function")
    }

    function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor)
        }
    }

    function _createClass(Constructor, protoProps, staticProps) {
        return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass != "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: !0,
                configurable: !0
            }
        }), superClass && _setPrototypeOf(subClass, superClass)
    }

    function _getPrototypeOf(o) {
        return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(o2) {
            return o2.__proto__ || Object.getPrototypeOf(o2)
        }, _getPrototypeOf(o)
    }

    function _setPrototypeOf(o, p) {
        return _setPrototypeOf = Object.setPrototypeOf || function(o2, p2) {
            return o2.__proto__ = p2, o2
        }, _setPrototypeOf(o, p)
    }

    function _isNativeReflectConstruct() {
        if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham) return !1;
        if (typeof Proxy == "function") return !0;
        try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0
        } catch (e) {
            return !1
        }
    }

    function _construct(Parent, args, Class) {
        return _isNativeReflectConstruct() ? _construct = Reflect.construct : _construct = function(Parent2, args2, Class2) {
            var a = [null];
            a.push.apply(a, args2);
            var Constructor = Function.bind.apply(Parent2, a),
                instance = new Constructor;
            return Class2 && _setPrototypeOf(instance, Class2.prototype), instance
        }, _construct.apply(null, arguments)
    }

    function _isNativeFunction(fn) {
        return Function.toString.call(fn).indexOf("[native code]") !== -1
    }

    function _wrapNativeSuper(Class) {
        var _cache = typeof Map == "function" ? new Map : void 0;
        return _wrapNativeSuper = function(Class2) {
            if (Class2 === null || !_isNativeFunction(Class2)) return Class2;
            if (typeof Class2 != "function") throw new TypeError("Super expression must either be null or a function");
            if (typeof _cache != "undefined") {
                if (_cache.has(Class2)) return _cache.get(Class2);
                _cache.set(Class2, Wrapper)
            }

            function Wrapper() {
                return _construct(Class2, arguments, _getPrototypeOf(this).constructor)
            }
            return Wrapper.prototype = Object.create(Class2.prototype, {
                constructor: {
                    value: Wrapper,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }), _setPrototypeOf(Wrapper, Class2)
        }, _wrapNativeSuper(Class)
    }

    function _assertThisInitialized(self2) {
        if (self2 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self2
    }

    function _possibleConstructorReturn(self2, call) {
        return call && (typeof call == "object" || typeof call == "function") ? call : _assertThisInitialized(self2)
    }

    function _createSuper(Derived) {
        var hasNativeReflectConstruct = _isNativeReflectConstruct();
        return function() {
            var Super = _getPrototypeOf(Derived),
                result;
            if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget)
            } else result = Super.apply(this, arguments);
            return _possibleConstructorReturn(this, result)
        }
    }

    function _unsupportedIterableToArray(o, minLen) {
        if (o) {
            if (typeof o == "string") return _arrayLikeToArray(o, minLen);
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set") return Array.from(o);
            if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen)
        }
    }

    function _arrayLikeToArray(arr, len) {
        (len == null || len > arr.length) && (len = arr.length);
        for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
        return arr2
    }

    function _createForOfIteratorHelper(o, allowArrayLike) {
        var it;
        if (typeof Symbol == "undefined" || o[Symbol.iterator] == null) {
            if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length == "number") {
                it && (o = it);
                var i = 0,
                    F = function() {};
                return {
                    s: F,
                    n: function() {
                        return i >= o.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: o[i++]
                        }
                    },
                    e: function(e) {
                        throw e
                    },
                    f: F
                }
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }
        var normalCompletion = !0,
            didErr = !1,
            err;
        return {
            s: function() {
                it = o[Symbol.iterator]()
            },
            n: function() {
                var step = it.next();
                return normalCompletion = step.done, step
            },
            e: function(e) {
                didErr = !0, err = e
            },
            f: function() {
                try {
                    !normalCompletion && it.return != null && it.return()
                } finally {
                    if (didErr) throw err
                }
            }
        }
    }
    var animationQueue = {},
        Animation = (function() {
            function Animation2() {
                _classCallCheck(this, Animation2)
            }
            return _createClass(Animation2, null, [{
                key: "slideUp",
                value: function(element, callback) {
                    var propertyToAnimate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "height";
                    element.style[propertyToAnimate] = "".concat(element.scrollHeight, "px"), element.offsetHeight, element.style[propertyToAnimate] = 0, animationQueue[element.id] && (element.removeEventListener("transitionend", animationQueue[element.id]), delete animationQueue[element.id]);
                    var transitionEnded = function transitionEnded2(event2) {
                        event2.propertyName === "height" && (element.removeEventListener("transitionend", transitionEnded2), (callback || function() {})())
                    };
                    element.addEventListener("transitionend", transitionEnded)
                }
            }, {
                key: "slideDown",
                value: function(element, callback) {
                    var propertyToAnimate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "height";
                    element.style[propertyToAnimate] = "".concat(element.scrollHeight, "px");
                    var transitionEnded = function transitionEnded2(event2) {
                        if (event2.propertyName === propertyToAnimate) {
                            var defaultValue = "auto";
                            propertyToAnimate === "max-height" && (defaultValue = "none"), element.style[propertyToAnimate] = defaultValue, element.removeEventListener("transitionend", transitionEnded2), delete animationQueue[element.id], (callback || function() {})()
                        }
                    };
                    element.addEventListener("transitionend", transitionEnded), animationQueue[element.id] = transitionEnded
                }
            }]), Animation2
        })(),
        Dom = (function() {
            function Dom2() {
                _classCallCheck(this, Dom2)
            }
            return _createClass(Dom2, null, [{
                key: "getSiblings",
                value: function(element, filter) {
                    for (var includeSelf = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, siblings = [], currentElement = element; currentElement = currentElement.previousElementSibling;)(!filter || currentElement.matches(filter)) && siblings.push(currentElement);
                    for (includeSelf && siblings.push(element), currentElement = element; currentElement = currentElement.nextElementSibling;)(!filter || currentElement.matches(filter)) && siblings.push(currentElement);
                    return siblings
                }
            }]), Dom2
        })(),
        commonjsGlobal = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};

    function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x.default : x
    }

    function createCommonjsModule(fn, basedir, module) {
        return module = {
            path: basedir,
            exports: {},
            require: function(path, base) {
                return commonjsRequire(path, base == null ? module.path : base)
            }
        }, fn(module, module.exports), module.exports
    }

    function commonjsRequire() {
        throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs")
    }
    var browser = createCommonjsModule(function(module, exports) {
            Object.defineProperty(exports, "__esModule", {
                value: !0
            }), exports.default = void 0;

            function Delegate2(root) {
                this.listenerMap = [{}, {}], root && this.root(root), this.handle = Delegate2.prototype.handle.bind(this), this._removedListeners = []
            }
            Delegate2.prototype.root = function(root) {
                var listenerMap = this.listenerMap,
                    eventType;
                if (this.rootElement) {
                    for (eventType in listenerMap[1]) listenerMap[1].hasOwnProperty(eventType) && this.rootElement.removeEventListener(eventType, this.handle, !0);
                    for (eventType in listenerMap[0]) listenerMap[0].hasOwnProperty(eventType) && this.rootElement.removeEventListener(eventType, this.handle, !1)
                }
                if (!root || !root.addEventListener) return this.rootElement && delete this.rootElement, this;
                this.rootElement = root;
                for (eventType in listenerMap[1]) listenerMap[1].hasOwnProperty(eventType) && this.rootElement.addEventListener(eventType, this.handle, !0);
                for (eventType in listenerMap[0]) listenerMap[0].hasOwnProperty(eventType) && this.rootElement.addEventListener(eventType, this.handle, !1);
                return this
            }, Delegate2.prototype.captureForType = function(eventType) {
                return ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(eventType) !== -1
            }, Delegate2.prototype.on = function(eventType, selector, handler, useCapture) {
                var root, listenerMap, matcher, matcherParam;
                if (!eventType) throw new TypeError("Invalid event type: " + eventType);
                if (typeof selector == "function" && (useCapture = handler, handler = selector, selector = null), useCapture === void 0 && (useCapture = this.captureForType(eventType)), typeof handler != "function") throw new TypeError("Handler must be a type of Function");
                return root = this.rootElement, listenerMap = this.listenerMap[useCapture ? 1 : 0], listenerMap[eventType] || (root && root.addEventListener(eventType, this.handle, useCapture), listenerMap[eventType] = []), selector ? /^[a-z]+$/i.test(selector) ? (matcherParam = selector, matcher = matchesTag) : /^#[a-z0-9\-_]+$/i.test(selector) ? (matcherParam = selector.slice(1), matcher = matchesId) : (matcherParam = selector, matcher = Element.prototype.matches) : (matcherParam = null, matcher = matchesRoot.bind(this)), listenerMap[eventType].push({
                    selector: selector,
                    handler: handler,
                    matcher: matcher,
                    matcherParam: matcherParam
                }), this
            }, Delegate2.prototype.off = function(eventType, selector, handler, useCapture) {
                var i, listener, listenerMap, listenerList, singleEventType;
                if (typeof selector == "function" && (useCapture = handler, handler = selector, selector = null), useCapture === void 0) return this.off(eventType, selector, handler, !0), this.off(eventType, selector, handler, !1), this;
                if (listenerMap = this.listenerMap[useCapture ? 1 : 0], !eventType) {
                    for (singleEventType in listenerMap) listenerMap.hasOwnProperty(singleEventType) && this.off(singleEventType, selector, handler);
                    return this
                }
                if (listenerList = listenerMap[eventType], !listenerList || !listenerList.length) return this;
                for (i = listenerList.length - 1; i >= 0; i--) listener = listenerList[i], (!selector || selector === listener.selector) && (!handler || handler === listener.handler) && (this._removedListeners.push(listener), listenerList.splice(i, 1));
                return listenerList.length || (delete listenerMap[eventType], this.rootElement && this.rootElement.removeEventListener(eventType, this.handle, useCapture)), this
            }, Delegate2.prototype.handle = function(event2) {
                var i, l, type = event2.type,
                    root, phase, listener, returned, listenerList = [],
                    target, eventIgnore = "ftLabsDelegateIgnore";
                if (event2[eventIgnore] !== !0) {
                    switch (target = event2.target, target.nodeType === 3 && (target = target.parentNode), target.correspondingUseElement && (target = target.correspondingUseElement), root = this.rootElement, phase = event2.eventPhase || (event2.target !== event2.currentTarget ? 3 : 2), phase) {
                        case 1:
                            listenerList = this.listenerMap[1][type];
                            break;
                        case 2:
                            this.listenerMap[0] && this.listenerMap[0][type] && (listenerList = listenerList.concat(this.listenerMap[0][type])), this.listenerMap[1] && this.listenerMap[1][type] && (listenerList = listenerList.concat(this.listenerMap[1][type]));
                            break;
                        case 3:
                            listenerList = this.listenerMap[0][type];
                            break
                    }
                    var toFire = [];
                    for (l = listenerList.length; target && l;) {
                        for (i = 0; i < l && (listener = listenerList[i], !!listener); i++) target.tagName && ["button", "input", "select", "textarea"].indexOf(target.tagName.toLowerCase()) > -1 && target.hasAttribute("disabled") ? toFire = [] : listener.matcher.call(target, listener.matcherParam, target) && toFire.push([event2, target, listener]);
                        if (target === root || (l = listenerList.length, target = target.parentElement || target.parentNode, target instanceof HTMLDocument)) break
                    }
                    var ret;
                    for (i = 0; i < toFire.length; i++)
                        if (!(this._removedListeners.indexOf(toFire[i][2]) > -1) && (returned = this.fire.apply(this, toFire[i]), returned === !1)) {
                            toFire[i][0][eventIgnore] = !0, toFire[i][0].preventDefault(), ret = !1;
                            break
                        } return ret
                }
            }, Delegate2.prototype.fire = function(event2, target, listener) {
                return listener.handler.call(target, event2, target)
            };

            function matchesTag(tagName, element) {
                return tagName.toLowerCase() === element.tagName.toLowerCase()
            }

            function matchesRoot(selector, element) {
                return this.rootElement === window ? element === document || element === document.documentElement || element === window : this.rootElement === element
            }

            function matchesId(id, element) {
                return id === element.id
            }
            Delegate2.prototype.destroy = function() {
                this.off(), this.root()
            };
            var _default = Delegate2;
            exports.default = _default, module.exports = exports.default
        }),
        Delegate = getDefaultExportFromCjs(browser),
        CollapsibleManager = (function() {
            function CollapsibleManager2() {
                _classCallCheck(this, CollapsibleManager2), this.domDelegate = new Delegate(document.body), this._attachListeners()
            }
            return _createClass(CollapsibleManager2, [{
                key: "_attachListeners",
                value: function() {
                    this.domDelegate.on("click", '[data-action="toggle-collapsible"]:not([disabled])', this._toggleCollapsible.bind(this)), document.addEventListener("collapsible:toggle", this._toggleCollapsible.bind(this))
                }
            }, {
                key: "_toggleCollapsible",
                value: function(event2, target) {
                    var _this = this;
                    !target && event2.detail && (target = document.querySelector('[aria-controls="'.concat(event2.detail.id, '"]')));
                    var isOpen = target.getAttribute("aria-expanded") === "true",
                        parentCollapsible = target.parentNode;
                    isOpen ? this._close(parentCollapsible) : this._open(parentCollapsible), target.getAttribute("data-close-siblings") !== "false" && Dom.getSiblings(parentCollapsible).forEach(function(collapsibleToClose) {
                        return _this._close(collapsibleToClose)
                    })
                }
            }, {
                key: "_open",
                value: function(collapsible) {
                    var toggleButton = collapsible.querySelector("[aria-controls]");
                    if (!(!toggleButton || toggleButton.getAttribute("aria-expanded") === "true")) {
                        var collapsibleContent = collapsible.querySelector("#".concat(toggleButton.getAttribute("aria-controls")));
                        toggleButton.setAttribute("aria-expanded", "true"), collapsibleContent.hasAttribute("aria-hidden") && collapsibleContent.setAttribute("aria-hidden", "false"), Animation.slideDown(collapsibleContent, function() {
                            toggleButton.hasAttribute("data-collapsible-force-overflow") && (collapsibleContent.style.overflow = "visible");
                            var autofocusElement = collapsibleContent.querySelector("[autofocus]");
                            autofocusElement && autofocusElement.focus()
                        })
                    }
                }
            }, {
                key: "_close",
                value: function(collapsible) {
                    var toggleButton = collapsible.querySelector("[aria-controls]");
                    if (!(!toggleButton || toggleButton.getAttribute("aria-expanded") === "false")) {
                        var collapsibleContent = collapsible.querySelector("#".concat(toggleButton.getAttribute("aria-controls")));
                        toggleButton.hasAttribute("data-collapsible-force-overflow") && (collapsibleContent.style.overflow = "hidden"), collapsibleContent.hasAttribute("aria-hidden") && collapsibleContent.setAttribute("aria-hidden", "true"), toggleButton.setAttribute("aria-expanded", "false"), Animation.slideUp(collapsibleContent)
                    }
                }
            }]), CollapsibleManager2
        })(),
        CountrySelector = (function() {
            function CountrySelector2(countrySelect, provinceSelect) {
                _classCallCheck(this, CountrySelector2), this.countrySelect = countrySelect, this.provinceSelect = provinceSelect, this.countrySelect && this.provinceSelect && (this._attachListeners(), this._initSelectors())
            }
            return _createClass(CountrySelector2, [{
                key: "destroy",
                value: function() {
                    this.countrySelect && this.countrySelect.removeEventListener("change", this._onCountryChangedListener)
                }
            }, {
                key: "_initSelectors",
                value: function() {
                    var defaultCountry = this.countrySelect.getAttribute("data-default");
                    if (defaultCountry) {
                        for (var i = 0; i !== this.countrySelect.options.length; ++i)
                            if (this.countrySelect.options[i].text === defaultCountry) {
                                this.countrySelect.selectedIndex = i;
                                break
                            }
                    } else this.countrySelect.selectedIndex = 0;
                    var event2 = new Event("change", {
                        bubbles: !0
                    });
                    this.countrySelect.dispatchEvent(event2);
                    var defaultProvince = this.provinceSelect.getAttribute("data-default");
                    if (defaultProvince) {
                        for (var _i = 0; _i !== this.provinceSelect.options.length; ++_i)
                            if (this.provinceSelect.options[_i].text === defaultProvince) {
                                this.provinceSelect.selectedIndex = _i;
                                break
                            }
                    }
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this._onCountryChangedListener = this._onCountryChanged.bind(this), this.countrySelect.addEventListener("change", this._onCountryChangedListener)
                }
            }, {
                key: "_onCountryChanged",
                value: function() {
                    var _this = this,
                        selectedOption = this.countrySelect.options[this.countrySelect.selectedIndex];
                    if (selectedOption) {
                        var provinces = JSON.parse(selectedOption.getAttribute("data-provinces") || "[]");
                        if (this.provinceSelect.innerHTML = "", provinces.length === 0) {
                            this.provinceSelect.closest(".form__input-wrapper").style.display = "none";
                            return
                        }
                        provinces.forEach(function(data) {
                            _this.provinceSelect.options.add(new Option(data[1], data[0]))
                        }), this.provinceSelect.closest(".form__input-wrapper").style.display = "block"
                    }
                }
            }]), CountrySelector2
        })(),
        Responsive = (function() {
            function Responsive2() {
                _classCallCheck(this, Responsive2)
            }
            return _createClass(Responsive2, null, [{
                key: "matchesBreakpoint",
                value: function(breakpoint) {
                    switch (breakpoint) {
                        case "phone":
                            return window.matchMedia("screen and (max-width: 640px)").matches;
                        case "tablet":
                            return window.matchMedia("screen and (min-width: 641px) and (max-width: 1023px)").matches;
                        case "tablet-and-up":
                            return window.matchMedia("screen and (min-width: 641px)").matches;
                        case "pocket":
                            return window.matchMedia("screen and (max-width: 1023px)").matches;
                        case "lap":
                            return window.matchMedia("screen and (min-width: 1024px) and (max-width: 1279px)").matches;
                        case "lap-and-up":
                            return window.matchMedia("screen and (min-width: 1024px)").matches;
                        case "desk":
                            return window.matchMedia("screen and (min-width: 1280px)").matches;
                        case "widescreen":
                            return window.matchMedia("screen and (min-width: 1440px)").matches;
                        case "supports-hover":
                            return window.matchMedia("(hover: hover) and (pointer: fine)").matches
                    }
                }
            }, {
                key: "getCurrentBreakpoint",
                value: function() {
                    if (window.matchMedia("screen and (max-width: 640px)").matches) return "phone";
                    if (window.matchMedia("screen and (min-width: 641px) and (max-width: 1023px)").matches) return "tablet";
                    if (window.matchMedia("screen and (min-width: 1024px) and (max-width: 1279px)").matches) return "lap";
                    if (window.matchMedia("screen and (min-width: 1280px)").matches) return "desk"
                }
            }]), Responsive2
        })(),
        DesktopNavigation = (function() {
            function DesktopNavigation2(element, navigationLayout, openTrigger) {
                _classCallCheck(this, DesktopNavigation2), this.element = element, this.delegateElement = new Delegate(this.element), this.delegateRoot = new Delegate(document.documentElement), this.useInlineNavigation = navigationLayout === "inline", this.isNavigationVisible = this.useInlineNavigation, this.openTrigger = openTrigger, Responsive.matchesBreakpoint("supports-hover") || (this.openTrigger = "click"), this.openItems = [], this.dropdownActivationTimeouts = {}, this.dropdownDeactivationTimeouts = {}, this.DROPDOWN_TIMEOUT = 100, this._attachListeners(), this.useInlineNavigation && this._setupInlineNavigation()
            }
            return _createClass(DesktopNavigation2, [{
                key: "destroy",
                value: function() {
                    this.delegateElement.off(), this.delegateRoot.off()
                }
            }, {
                key: "onBlockSelect",
                value: function(event2) {
                    var _this = this;
                    this.useInlineNavigation || this._openNavigation(), Dom.getSiblings(event2.target.parentNode, ".is-dropdown-open").forEach(function(openItem) {
                        _this._deactivateDropdown(event2, openItem.querySelector('[data-type="menuitem"][aria-haspopup]'))
                    }), this._activateDropdown(event2, event2.target.previousElementSibling)
                }
            }, {
                key: "onBlockDeselect",
                value: function(event2) {
                    this.useInlineNavigation || this._closeNavigation(), this._deactivateDropdown(event2, event2.target.parentNode)
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this.delegateElement.on("focusout", this._onFocusOut.bind(this)), this.delegateRoot.on("click", this._onClick.bind(this)), this.delegateElement.on("click", '[data-action="toggle-menu"]', this._toggleNavigation.bind(this)), this.openTrigger === "hover" ? (this.delegateElement.on("focusin", '[data-type="menuitem"][aria-haspopup]', this._activateDropdown.bind(this)), this.delegateElement.on("mouseover", '[data-type="menuitem"][aria-haspopup]', this._activateDropdown.bind(this)), this.delegateElement.on("mouseover", '[data-type="menu"][aria-hidden="false"]', this._blockDropdownDeactivation.bind(this)), this.delegateElement.on("focusout", ".is-dropdown-open", this._deactivateDropdown.bind(this)), this.delegateElement.on("mouseout", ".is-dropdown-open", this._deactivateDropdown.bind(this))) : this.delegateElement.on("click", '[data-type="menuitem"][aria-haspopup]', this._toggleDropdown.bind(this))
                }
            }, {
                key: "_onFocusOut",
                value: function(event2) {
                    event2.relatedTarget !== null && !this.element.contains(event2.relatedTarget) && this._closeNavigation()
                }
            }, {
                key: "_onClick",
                value: function(event2) {
                    this.element.contains(event2.target) || this._closeNavigation()
                }
            }, {
                key: "_openNavigation",
                value: function() {
                    this.useInlineNavigation || (this.element.querySelector('[data-action="toggle-menu"]').setAttribute("aria-expanded", "true"), this.element.querySelector('[data-type="menu"]').setAttribute("aria-hidden", "false"), this.isNavigationVisible = !0)
                }
            }, {
                key: "_closeNavigation",
                value: function() {
                    var _this2 = this;
                    if (this.useInlineNavigation || (this.element.querySelector('[data-action="toggle-menu"]').setAttribute("aria-expanded", "false"), this.element.querySelector('[data-type="menu"]').setAttribute("aria-hidden", "true")), this.isNavigationVisible = !1, this.openTrigger === "click") {
                        var cloneOpenItems = this.openItems.slice(0);
                        cloneOpenItems.forEach(function(item) {
                            _this2._deactivateDropdown(event, item)
                        })
                    }
                }
            }, {
                key: "_toggleNavigation",
                value: function(event2) {
                    this.isNavigationVisible ? this._closeNavigation() : this._openNavigation()
                }
            }, {
                key: "_toggleDropdown",
                value: function(event2, target) {
                    target.getAttribute("aria-expanded") === "false" && event2.preventDefault(), target.getAttribute("aria-expanded") === "true" ? target.getAttribute("href") === "#" && (event2.preventDefault(), this._deactivateDropdown(event2, target.closest(".is-dropdown-open"))) : this._activateDropdown(event2, target)
                }
            }, {
                key: "_activateDropdown",
                value: function(event2, target) {
                    var _this3 = this;
                    if (this.openTrigger === "click") {
                        var cloneOpenItems = this.openItems.slice(0);
                        cloneOpenItems.forEach(function(item) {
                            item.contains(target) || _this3._deactivateDropdown(event2, item)
                        })
                    }
                    var menuToOpen = Dom.getSiblings(target, "[aria-hidden]")[0],
                        callback = function() {
                            if (target.setAttribute("aria-expanded", "true"), target.parentNode.classList.add("is-dropdown-open"), menuToOpen.setAttribute("aria-hidden", "false"), _this3.openTrigger === "hover" && _this3.dropdownDeactivationTimeouts[menuToOpen.id] && (clearTimeout(_this3.dropdownDeactivationTimeouts[menuToOpen.id]), delete _this3.dropdownDeactivationTimeouts[menuToOpen.id]), _this3.useInlineNavigation) {
                                var windowWidth = window.innerWidth,
                                    shouldOpenLeft = !1;
                                menuToOpen.querySelectorAll(".nav-dropdown").forEach(function(subSubMenu) {
                                    subSubMenu.getBoundingClientRect().right > windowWidth && (shouldOpenLeft = !0)
                                }), shouldOpenLeft && menuToOpen.classList.add("nav-dropdown--inverse")
                            }
                            target.closest('[data-type="menu"]').classList.add("nav-dropdown--glued"), menuToOpen.classList.contains("mega-menu") && _this3._setupMegaMenu(menuToOpen), _this3.openTrigger === "click" && _this3.openItems.push(target.parentNode)
                        };
                    if (this.openTrigger === "click") callback();
                    else {
                        for (var toDeactivate in this.dropdownActivationTimeouts) this.dropdownActivationTimeouts.hasOwnProperty(toDeactivate) && (clearTimeout(this.dropdownActivationTimeouts[toDeactivate]), delete this.dropdownActivationTimeouts[toDeactivate]);
                        callback()
                    }
                }
            }, {
                key: "_deactivateDropdown",
                value: function(event2, target) {
                    var _this4 = this;
                    if (!(this.openTrigger === "hover" && target.contains(event2.relatedTarget))) {
                        var menuToClose = target.querySelector("[aria-hidden]"),
                            callback = function() {
                                target.classList.remove("is-dropdown-open"), target.querySelector('[data-type="menuitem"]').setAttribute("aria-expanded", "false");
                                var menuToClose2 = target.querySelector("[aria-hidden]");
                                if (menuToClose2.setAttribute("aria-hidden", "true"), target.closest('[data-type="menu"]').classList.remove("nav-dropdown--glued"), _this4.openTrigger === "click") {
                                    target.querySelectorAll(".is-dropdown-open").forEach(function(item) {
                                        _this4._deactivateDropdown(event2, item);
                                        var index2 = _this4.openItems.indexOf(item);
                                        index2 > -1 && _this4.openItems.splice(index2, 1)
                                    });
                                    var index = _this4.openItems.indexOf(target);
                                    index > -1 && _this4.openItems.splice(index, 1)
                                }
                            };
                        this.openTrigger === "click" ? callback() : this.dropdownDeactivationTimeouts[menuToClose.id] = setTimeout(function() {
                            callback(), delete _this4.dropdownDeactivationTimeouts[menuToClose.id]
                        }, this.DROPDOWN_TIMEOUT)
                    }
                }
            }, {
                key: "_blockDropdownDeactivation",
                value: function(event2, target) {
                    if (this.dropdownDeactivationTimeouts[target.id] !== void 0) {
                        clearTimeout(this.dropdownDeactivationTimeouts[target.id]), delete this.dropdownDeactivationTimeouts[target.id];
                        for (var toDeactivate in this.dropdownActivationTimeouts) this.dropdownActivationTimeouts.hasOwnProperty(toDeactivate) && (clearTimeout(this.dropdownActivationTimeouts[toDeactivate]), delete this.dropdownActivationTimeouts[toDeactivate])
                    }
                }
            }, {
                key: "_setupMegaMenu",
                value: function(megaMenu) {
                    if (!this.useInlineNavigation) {
                        var navDropdownWidth = megaMenu.closest(".nav-dropdown").clientWidth;
                        megaMenu.style.maxWidth = Math.min(1400 - navDropdownWidth, parseInt(window.innerWidth - navDropdownWidth - 80)) + "px"
                    }
                }
            }, {
                key: "_setupInlineNavigation",
                value: function() {
                    var _this5 = this;
                    this.element.querySelectorAll(".mega-menu").forEach(function(megaMenu) {
                        megaMenu.closest(".nav-bar__item").classList.add("nav-bar__item--static")
                    }), "MutationObserver" in window && (this.dropdownMenuObserver = new MutationObserver(function(mutationList) {
                        mutationList.forEach(function(mutation) {
                            mutation.target.getAttribute("aria-hidden") === "false" && mutation.target.style.setProperty("--distance-to-top", "".concat(mutation.target.getBoundingClientRect().top, "px"))
                        })
                    }), this.element.querySelectorAll(".nav-dropdown .nav-dropdown").forEach(function(item) {
                        _this5.dropdownMenuObserver.observe(item, {
                            attributes: !0,
                            attributeFilter: ["aria-hidden"]
                        })
                    }))
                }
            }]), DesktopNavigation2
        })(),
        CollectionFilterDrawer = (function() {
            function CollectionFilterDrawer2(options) {
                _classCallCheck(this, CollectionFilterDrawer2), this.element = document.getElementById("mobile-collection-filters"), this.delegateRoot = new Delegate(document.documentElement), this.options = options, this.isOpen = !1, this.element && this._attachListeners()
            }
            return _createClass(CollectionFilterDrawer2, [{
                key: "destroy",
                value: function() {
                    this.delegateRoot.off()
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this.delegateRoot.on("click", '[aria-controls="mobile-collection-filters"][data-action="open-drawer"]', this.open.bind(this)), this.delegateRoot.on("click", '#mobile-collection-filters [data-action="close-drawer"]', this.close.bind(this)), document.addEventListener("collection-filter:close", this.close.bind(this)), document.addEventListener("click", this._detectOutsideClick.bind(this)), window.addEventListener("resize", this._computeDrawerHeight.bind(this))
                }
            }, {
                key: "open",
                value: function(event2) {
                    event2 && event2.stopPropagation(), this._computeDrawerHeight(), this.isOpen = !0, document.querySelector('[aria-controls="mobile-collection-filters"]').setAttribute("aria-expanded", "true"), document.getElementById("mobile-collection-filters").setAttribute("aria-hidden", "false"), document.body.classList.add("no-mobile-scroll")
                }
            }, {
                key: "close",
                value: function(event2) {
                    event2 && event2.stopPropagation(), this.isOpen = !1, document.querySelector('[aria-controls="mobile-collection-filters"]').setAttribute("aria-expanded", "false"), document.getElementById("mobile-collection-filters").setAttribute("aria-hidden", "true"), document.body.classList.remove("no-mobile-scroll")
                }
            }, {
                key: "_computeDrawerHeight",
                value: function() {
                    document.getElementById("mobile-collection-filters").querySelector(".collection-drawer").style.maxHeight = "".concat(window.innerHeight, "px")
                }
            }, {
                key: "_detectOutsideClick",
                value: function(event2) {
                    this.isOpen && !event2.target.closest(".collection-drawer__inner") && this.close()
                }
            }]), CollectionFilterDrawer2
        })(),
        ExitPopup = (function() {
            function ExitPopup2(element) {
                _classCallCheck(this, ExitPopup2), this.element = element, this.delegateElement = new Delegate(this.element), this.rootDelegateElement = new Delegate(document.body), this.options = JSON.parse(element.getAttribute("data-popup-settings")), this.hasOpenOnceInCurrentPage = !1;
                try {
                    window.location.hash === "#exit-popup" && window.theme.pageType !== "captcha" && this._openPopup()
                } catch (error) {}
                this._attachListeners()
            }
            return _createClass(ExitPopup2, [{
                key: "destroy",
                value: function() {
                    this.delegateElement.off()
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    var _this = this;
                    this._onKeyPressedListener = this._onKeyPressed.bind(this), Responsive.matchesBreakpoint("supports-hover") && (this.delegateElement.on("click", '[data-action="close-popup"]', this._closePopup.bind(this)), document.body.addEventListener("mouseleave", function() {
                        _this.hasOpenOnceInCurrentPage || (!_this.options.showOnlyOnce || _this.options.showOnlyOnce && localStorage.getItem("themeExitPopup") === null) && _this._openPopup()
                    }), this._clickOutsideListener = this._checkClickOutside.bind(this))
                }
            }, {
                key: "_openPopup",
                value: function() {
                    window.theme.isNewsletterPopupOpen || (this.element.setAttribute("aria-hidden", "false"), localStorage.setItem("themeExitPopup", "true"), this.hasOpenOnceInCurrentPage = !0, window.theme.isExitPopupOpen = !0, this.delegateElement.on("click", this._clickOutsideListener), this.rootDelegateElement.on("keyup", this._onKeyPressedListener))
                }
            }, {
                key: "_closePopup",
                value: function() {
                    this.element.setAttribute("aria-hidden", "true"), window.theme.isExitPopupOpen = !1, this.delegateElement.off("click", this._clickOutsideListener), this.rootDelegateElement.off("keyup", this._onKeyPressedListener)
                }
            }, {
                key: "_checkClickOutside",
                value: function(event2) {
                    (!this.element.contains(event2.target) || this.element === event2.target) && this._closePopup()
                }
            }, {
                key: "_onKeyPressed",
                value: function(event2) {
                    event2.key === "Escape" && this._closePopup()
                }
            }]), ExitPopup2
        })(),
        LoadingBar = (function() {
            function LoadingBar2() {
                _classCallCheck(this, LoadingBar2), this.element = document.querySelector(".loading-bar"), this.element && (document.addEventListener("theme:loading:start", this._onLoadingStart.bind(this)), document.addEventListener("theme:loading:end", this._onLoadingEnd.bind(this)), this.element.addEventListener("transitionend", this._onTransitionEnd.bind(this)))
            }
            return _createClass(LoadingBar2, [{
                key: "_onLoadingStart",
                value: function() {
                    this.element.classList.add("is-visible"), this.element.style.transform = "scaleX(0.4)"
                }
            }, {
                key: "_onLoadingEnd",
                value: function() {
                    this.element.style.transform = "scaleX(1)", this.element.classList.add("is-finished")
                }
            }, {
                key: "_onTransitionEnd",
                value: function(event2) {
                    event2.propertyName === "transform" && this.element.classList.contains("is-finished") && (this.element.classList.remove("is-visible"), this.element.classList.remove("is-finished"), this.element.style.transform = "scaleX(0)")
                }
            }]), LoadingBar2
        })(),
        Accessibility = (function() {
            function Accessibility2() {
                _classCallCheck(this, Accessibility2)
            }
            return _createClass(Accessibility2, null, [{
                key: "trapFocus",
                value: function(container, namespace) {
                    this.listeners = this.listeners || {};
                    var elementToFocus = container.querySelector("[autofocus]") || container;
                    container.setAttribute("tabindex", "-1"), elementToFocus.focus(), this.listeners[namespace] = function(event2) {
                        container !== event2.target && !container.contains(event2.target) && elementToFocus.focus()
                    }, document.addEventListener("focusin", this.listeners[namespace])
                }
            }, {
                key: "removeTrapFocus",
                value: function(container, namespace) {
                    container && container.removeAttribute("tabindex"), document.removeEventListener("focusin", this.listeners[namespace])
                }
            }, {
                key: "clearTrapFocus",
                value: function() {
                    for (var key in this.listeners) this.listeners.hasOwnProperty(key) && document.removeEventListener("focusin", this.listeners[key]);
                    this.listeners = {}
                }
            }]), Accessibility2
        })(),
        Cart = (function() {
            function Cart2(element, options) {
                _classCallCheck(this, Cart2), this.element = element, this.delegateElement = new Delegate(this.element), this.delegateRoot = new Delegate(document.documentElement), this.options = options, this.element && (this.miniCartElement = this.element.querySelector(".mini-cart"), this.isMiniCartOpen = !1, window.theme.pageType !== "cart" && this.miniCartElement && (this.miniCartToggleElement = this.element.querySelector('[aria-controls="'.concat(this.miniCartElement.id, '"]')), this._checkMiniCartScrollability()), this.itemCount = window.theme.cartCount, this._attachListeners())
            }
            return _createClass(Cart2, [{
                key: "destroy",
                value: function() {
                    this.delegateElement.off(), this.delegateRoot.off(), window.removeEventListener("resize", this._calculateMiniCartHeightListener)
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this._calculateMiniCartHeightListener = this._calculateMiniCartHeight.bind(this), window.theme.pageType !== "cart" && window.theme.cartType !== "page" && (this.delegateElement.on("click", '[data-action="toggle-mini-cart"]', this._toggleMiniCart.bind(this)), this.delegateElement.on("keyup", this._checkMiniCartClose.bind(this)), this.delegateRoot.on("click", this._onWindowClick.bind(this)), window.addEventListener("resize", this._calculateMiniCartHeightListener)), this.delegateRoot.on("click", '[data-action="decrease-quantity"]', this._updateQuantity.bind(this)), this.delegateRoot.on("click", '[data-action="increase-quantity"]', this._updateQuantity.bind(this)), this.delegateRoot.on("change", ".quantity-selector:not(.quantity-selector--product) .quantity-selector__value", this._updateQuantity.bind(this)), this.delegateRoot.on("keyup", ".quantity-selector:not(.quantity-selector--product) .quantity-selector__value", this._updateQuantitySize.bind(this)), this.delegateRoot.on("keydown", ".quantity-selector__value", this._blockEnterKey.bind(this)), this.delegateRoot.on("product:added", this._onProductAdded.bind(this)), this.delegateRoot.on("cart:refresh", this._onCartRefresh.bind(this))
                }
            }, {
                key: "_toggleMiniCart",
                value: function(event2) {
                    event2 && event2.preventDefault(), this.isMiniCartOpen ? this._closeMiniCart() : this._openMiniCart()
                }
            }, {
                key: "_openMiniCart",
                value: function() {
                    this.miniCartToggleElement.setAttribute("aria-expanded", "true"), Responsive.getCurrentBreakpoint() === "phone" && this.miniCartToggleElement.querySelector(".header__cart-icon").setAttribute("aria-expanded", "true"), this.miniCartElement.setAttribute("aria-hidden", "false"), this.isMiniCartOpen = !0, this._calculateMiniCartHeight(), Accessibility.trapFocus(this.miniCartElement, "mini-cart"), document.body.classList.add("no-mobile-scroll")
                }
            }, {
                key: "_closeMiniCart",
                value: function() {
                    this.miniCartToggleElement.setAttribute("aria-expanded", "false"), Responsive.getCurrentBreakpoint() === "phone" && (this.miniCartToggleElement.querySelector(".header__cart-icon").setAttribute("aria-expanded", "false"), this.miniCartElement.style.maxHeight = ""), this.miniCartElement.setAttribute("aria-hidden", "true"), this.isMiniCartOpen = !1, document.body.classList.remove("no-mobile-scroll")
                }
            }, {
                key: "_checkMiniCartClose",
                value: function(event2) {
                    this.isMiniCartOpen && event2.key === "Escape" && this._closeMiniCart()
                }
            }, {
                key: "_calculateMiniCartHeight",
                value: function() {
                    if (Responsive.getCurrentBreakpoint() === "phone")
                        if (this.isMiniCartOpen) {
                            var maxHeight = window.innerHeight - document.querySelector(".header").getBoundingClientRect().bottom;
                            this.miniCartElement.style.maxHeight = "".concat(maxHeight, "px");
                            var miniCartContentElement = this.miniCartElement.querySelector(".mini-cart__content"),
                                miniCartRecapElement = this.miniCartElement.querySelector(".mini-cart__recap");
                            miniCartRecapElement && (miniCartContentElement.style.maxHeight = "".concat(maxHeight - miniCartRecapElement.clientHeight, "px"))
                        } else this.miniCartElement.style.maxHeight = "", this.miniCartElement.querySelector(".mini-cart__content").style.maxHeight = "";
                    else this.miniCartElement.style.maxHeight = "", this.miniCartElement.querySelector(".mini-cart__content").style.maxHeight = ""
                }
            }, {
                key: "_updateQuantity",
                value: function(event2, target) {
                    var _this = this,
                        parsedQuantity = 1;
                    if (target.tagName === "INPUT" ? parsedQuantity = parseInt(target.value) : parsedQuantity = parseInt(target.getAttribute("data-quantity")), window.theme.cartType === "page") {
                        target.hasAttribute("data-href") ? window.location.href = target.getAttribute("data-href") : window.location.href = "".concat(window.routes.cartChangeUrl, "?line=").concat(target.getAttribute("data-line"), "&quantity=").concat(parsedQuantity);
                        return
                    }
                    document.dispatchEvent(new CustomEvent("theme:loading:start")), fetch("".concat(window.routes.cartChangeUrl, ".js"), {
                        body: JSON.stringify({
                            line: target.getAttribute("data-line"),
                            quantity: parsedQuantity
                        }),
                        credentials: "same-origin",
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest"
                        }
                    }).then(function(cart) {
                        cart.json().then(function(content) {
                            _this.itemCount = content.item_count, _this._rerender(!1).then(function() {
                                document.dispatchEvent(new CustomEvent("theme:loading:end"))
                            })
                        })
                    }), event2.preventDefault()
                }
            }, {
                key: "_updateQuantitySize",
                value: function(event2, target) {
                    target.setAttribute("size", Math.max(target.value.length, 2))
                }
            }, {
                key: "_blockEnterKey",
                value: function(event2) {
                    if (event2.key === "Enter") return !1
                }
            }, {
                key: "_rerender",
                value: function() {
                    var _this2 = this,
                        scrollToTop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0,
                        url = "";
                    if (window.theme.pageType !== "cart") url = "".concat(window.routes.cartUrl, "?section_id=mini-cart");
                    else {
                        var cartSection = document.querySelector('[data-section-type="cart"]');
                        url = "".concat(window.routes.cartUrl, "?section_id=").concat(cartSection.getAttribute("data-section-id"))
                    }
                    return fetch(url, {
                        credentials: "same-origin",
                        method: "GET",
                        headers: {
                            "Cache-Control": "no-cache"
                        }
                    }).then(function(content) {
                        content.text().then(function(html) {
                            var myDiv = document.createElement("div");
                            if (myDiv.innerHTML = html, myDiv.firstElementChild && myDiv.firstElementChild.hasAttribute("data-item-count") && (_this2.itemCount = parseInt(myDiv.firstElementChild.getAttribute("data-item-count"))), _this2.element.querySelector(".header__cart-count").textContent = _this2.itemCount, window.theme.cartType !== "page")
                                if (window.theme.pageType !== "cart") {
                                    var tempElement = document.createElement("div");
                                    tempElement.innerHTML = html;
                                    var miniCartItemListElement = _this2.miniCartElement.querySelector(".mini-cart__line-item-list"),
                                        scrollPosition = null;
                                    miniCartItemListElement && (scrollPosition = miniCartItemListElement.scrollTop), _this2.miniCartElement.innerHTML = tempElement.querySelector(".mini-cart").innerHTML;
                                    var newMiniCartItemListElement = _this2.miniCartElement.querySelector(".mini-cart__line-item-list");
                                    newMiniCartItemListElement && scrollPosition !== null && (newMiniCartItemListElement.scrollTop = scrollPosition), _this2._checkMiniCartScrollability(), _this2._calculateMiniCartHeight(), _this2.element.dispatchEvent(new CustomEvent("cart:rerendered"))
                                } else {
                                    var _tempElement = document.createElement("div");
                                    _tempElement.innerHTML = html;
                                    var originalCart = document.querySelector('[data-section-type="cart"]');
                                    originalCart.innerHTML = _tempElement.querySelector('[data-section-type="cart"]').innerHTML, scrollToTop && window.scrollTo({
                                        top: 0,
                                        behavior: "smooth"
                                    }), _this2.element.dispatchEvent(new CustomEvent("cart:rerendered", {
                                        bubbles: !0
                                    }))
                                }
                        })
                    })
                }
            }, {
                key: "_checkMiniCartScrollability",
                value: function() {
                    var miniCartItemList = this.miniCartElement.querySelector(".mini-cart__line-item-list");
                    miniCartItemList && miniCartItemList.scrollHeight > miniCartItemList.clientHeight && miniCartItemList.classList.add("is-scrollable")
                }
            }, {
                key: "_onProductAdded",
                value: function(event2) {
                    var _this3 = this;
                    this.itemCount += event2.detail.quantity, this._onCartRefresh().then(function() {
                        window.theme.pageType !== "cart" && (window.theme.cartType === "drawer" && !_this3.options.useStickyHeader && window.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        }), window.theme.cartType === "message" && event2.detail.button && (event2.detail.button.innerHTML = window.languages.productAddedShort, setTimeout(function() {
                            event2.detail.button.innerHTML = window.languages.productFormAddToCart
                        }, 1500)), window.theme.pageType !== "cart" && window.theme.cartType === "drawer" && _this3._openMiniCart())
                    })
                }
            }, {
                key: "_onCartRefresh",
                value: function(event2) {
                    var scrollToTop = !0;
                    return event2 && event2.detail && (scrollToTop = event2.detail.scrollToTop), this._rerender(scrollToTop).then(function() {
                        document.dispatchEvent(new CustomEvent("theme:loading:end"))
                    })
                }
            }, {
                key: "_onWindowClick",
                value: function(event2) {
                    this.miniCartElement && this.isMiniCartOpen && !this.element.contains(event2.target) && this._closeMiniCart()
                }
            }]), Cart2
        })(),
        MobileNavigation = (function() {
            function MobileNavigation2(element) {
                _classCallCheck(this, MobileNavigation2), this.element = element, this.delegateElement = new Delegate(this.element), this.delegateRoot = new Delegate(document.documentElement), this.mobileMenuElement = this.element.querySelector(".mobile-menu"), this.mobileMenuToggleElement = this.element.querySelector('[aria-controls="'.concat(this.mobileMenuElement.id, '"]')), this.isOpen = !1, this._attachListeners()
            }
            return _createClass(MobileNavigation2, [{
                key: "destroy",
                value: function() {
                    this.delegateElement.off(), this.delegateRoot.off(), window.removeEventListener("resize", this._calculatMaxHeightListener)
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this._calculatMaxHeightListener = this._calculateMaxHeight.bind(this), this.delegateElement.on("click", '[data-action="toggle-menu"]', this._toggleMenu.bind(this)), this.delegateElement.on("click", '[data-action="open-panel"]', this._openPanel.bind(this)), this.delegateElement.on("click", '[data-action="close-panel"]', this._closePanel.bind(this)), this.delegateRoot.on("click", this._onWindowClick.bind(this)), window.addEventListener("resize", this._calculatMaxHeightListener)
                }
            }, {
                key: "_toggleMenu",
                value: function() {
                    this.isOpen = !this.isOpen, this.mobileMenuToggleElement.setAttribute("aria-expanded", this.isOpen ? "true" : "false"), this.mobileMenuElement.setAttribute("aria-hidden", this.isOpen ? "false" : "true"), this.isOpen ? (this._calculateMaxHeight(), document.body.classList.add("no-mobile-scroll")) : (this.mobileMenuElement.style.maxHeight = "", this.element.querySelectorAll(".mobile-menu__panel.is-open").forEach(function(item) {
                        item.classList.remove("is-open")
                    }), document.body.classList.remove("no-mobile-scroll"))
                }
            }, {
                key: "_openPanel",
                value: function(event2, target) {
                    target.setAttribute("aria-expanded", "true"), this.element.querySelector("#".concat(target.getAttribute("aria-controls"))).classList.add("is-open")
                }
            }, {
                key: "_closePanel",
                value: function(event2, target) {
                    var panelToClose = target.closest(".mobile-menu__panel.is-open");
                    panelToClose.classList.remove("is-open"), this.element.querySelector('[aria-controls="'.concat(panelToClose.id, '"]')).setAttribute("aria-expanded", "false")
                }
            }, {
                key: "_calculateMaxHeight",
                value: function() {
                    this.isOpen && (this.mobileMenuElement.style.maxHeight = "".concat(window.innerHeight - document.querySelector(".header").getBoundingClientRect().bottom, "px"))
                }
            }, {
                key: "_onWindowClick",
                value: function(event2) {
                    this.isOpen && !this.element.contains(event2.target) && this._toggleMenu()
                }
            }]), MobileNavigation2
        })(),
        ModalManager = (function() {
            function ModalManager2() {
                _classCallCheck(this, ModalManager2), this.domDelegate = new Delegate(document.body), this.activeModalsQueue = [];
                var activeModal = document.querySelector('.modal[aria-hidden="false"]');
                activeModal && this.activeModalsQueue.push(activeModal), this._attachListeners()
            }
            return _createClass(ModalManager2, [{
                key: "_attachListeners",
                value: function() {
                    this._onKeyPressedListener = this._onKeyPressed.bind(this), this.domDelegate.on("click", '[data-action="open-modal"]', this._openModal.bind(this)), this.domDelegate.on("click", '[data-action="close-modal"]', this._closeModal.bind(this)), document.addEventListener("modal:close", this._closeModal.bind(this)), this._clickOutsideListener = this._checkClickOutside.bind(this), this.activeModalsQueue.length > 0 && (document.documentElement.classList.add("is-locked"), this.domDelegate.on("click", this._clickOutsideListener))
                }
            }, {
                key: "_openModal",
                value: function(event2, target) {
                    var _this = this,
                        modal = document.querySelector("#".concat(target.getAttribute("aria-controls")));
                    if (modal) {
                        var onOpen = function onOpen2(event3) {
                            event3.propertyName === "visibility" && (modal.removeEventListener("transitionend", onOpen2), Accessibility.trapFocus(modal, "modal" + modal.id), _this.activeModalsQueue.push(modal))
                        };
                        return modal.addEventListener("transitionend", onOpen), modal.setAttribute("aria-hidden", "false"), document.documentElement.classList.add("is-locked"), this.domDelegate.on("click", this._clickOutsideListener), this.domDelegate.on("keyup", this._onKeyPressedListener), !1
                    }
                }
            }, {
                key: "_closeModal",
                value: function() {
                    if (this.activeModalsQueue.length > 0) {
                        var modalToClose = this.activeModalsQueue.pop(),
                            onClose = function onClose2(event2) {
                                event2.propertyName === "visibility" && (modalToClose.removeEventListener("transitionend", onClose2), Accessibility.removeTrapFocus(modalToClose, "modal" + modalToClose.id), modalToClose.dispatchEvent(new CustomEvent("modal:closed")))
                            };
                        modalToClose.addEventListener("transitionend", onClose), modalToClose.setAttribute("aria-hidden", "true"), document.documentElement.classList.remove("is-locked"), this.domDelegate.off("click", this._clickOutsideListener), this.domDelegate.off("keyup", this._onKeyPressedListener)
                    }
                }
            }, {
                key: "_checkClickOutside",
                value: function(event2) {
                    if (this.activeModalsQueue.length !== 0) {
                        var modalToClose = this.activeModalsQueue[this.activeModalsQueue.length - 1];
                        modalToClose && (!modalToClose.contains(event2.target) || modalToClose === event2.target) && this._closeModal()
                    }
                }
            }, {
                key: "_onKeyPressed",
                value: function(event2) {
                    event2.key === "Escape" && this._closeModal()
                }
            }]), ModalManager2
        })(),
        NewsletterPopup = (function() {
            function NewsletterPopup2(element) {
                _classCallCheck(this, NewsletterPopup2), this.element = element, this.delegateElement = new Delegate(this.element), this.rootDelegateElement = new Delegate(document.body), this.options = JSON.parse(element.getAttribute("data-popup-settings"));
                try {
                    window.location.hash === "#newsletter-popup" && window.theme.pageType !== "captcha" ? this._openPopup() : (!this.options.showOnlyOnce || this.options.showOnlyOnce && localStorage.getItem("themePopup") === null) && setTimeout(this._openPopup.bind(this), this.options.apparitionDelay * 1e3)
                } catch (error) {}
                this._attachListeners()
            }
            return _createClass(NewsletterPopup2, [{
                key: "destroy",
                value: function() {
                    this.delegateElement.off()
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this._onKeyPressedListener = this._onKeyPressed.bind(this), this.delegateElement.on("click", '[data-action="close-popup"]', this._closePopup.bind(this)), this._clickOutsideListener = this._checkClickOutside.bind(this)
                }
            }, {
                key: "_openPopup",
                value: function() {
                    window.theme.isExitPopupOpen || (this.element.setAttribute("aria-hidden", "false"), localStorage.setItem("themePopup", "true"), window.theme.isNewsletterPopupOpen = !0, this.delegateElement.on("click", this._clickOutsideListener), this.rootDelegateElement.on("keyup", this._onKeyPressedListener))
                }
            }, {
                key: "_closePopup",
                value: function() {
                    this.element.setAttribute("aria-hidden", "true"), window.theme.isNewsletterPopupOpen = !1, this.delegateElement.off("click"), this.rootDelegateElement.off("keyup", this._onKeyPressedListener)
                }
            }, {
                key: "_checkClickOutside",
                value: function(event2) {
                    (!this.element.contains(event2.target) || this.element === event2.target) && this._closePopup()
                }
            }, {
                key: "_onKeyPressed",
                value: function(event2) {
                    event2.key === "Escape" && this._closePopup()
                }
            }]), NewsletterPopup2
        })(),
        fastdom = createCommonjsModule(function(module) {
            (function(win) {
                var debug = function() {},
                    raf = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.msRequestAnimationFrame || function(cb) {
                        return setTimeout(cb, 16)
                    };

                function FastDom() {
                    var self2 = this;
                    self2.reads = [], self2.writes = [], self2.raf = raf.bind(win)
                }
                FastDom.prototype = {
                    constructor: FastDom,
                    measure: function(fn, ctx) {
                        var task = ctx ? fn.bind(ctx) : fn;
                        return this.reads.push(task), scheduleFlush(this), task
                    },
                    mutate: function(fn, ctx) {
                        var task = ctx ? fn.bind(ctx) : fn;
                        return this.writes.push(task), scheduleFlush(this), task
                    },
                    clear: function(task) {
                        return remove(this.reads, task) || remove(this.writes, task)
                    },
                    extend: function(props) {
                        if (_typeof(props) != "object") throw new Error("expected object");
                        var child = Object.create(this);
                        return mixin(child, props), child.fastdom = this, child.initialize && child.initialize(), child
                    },
                    catch: null
                };

                function scheduleFlush(fastdom2) {
                    fastdom2.scheduled || (fastdom2.scheduled = !0, fastdom2.raf(flush.bind(null, fastdom2)))
                }

                function flush(fastdom2) {
                    var writes = fastdom2.writes,
                        reads = fastdom2.reads,
                        error;
                    try {
                        debug("flushing reads", reads.length), runTasks(reads), debug("flushing writes", writes.length), runTasks(writes)
                    } catch (e) {
                        error = e
                    }
                    if (fastdom2.scheduled = !1, (reads.length || writes.length) && scheduleFlush(fastdom2), error)
                        if (debug("task errored", error.message), fastdom2.catch) fastdom2.catch(error);
                        else throw error
                }

                function runTasks(tasks) {
                    for (var task; task = tasks.shift();) task()
                }

                function remove(array, item) {
                    var index = array.indexOf(item);
                    return !!~index && !!array.splice(index, 1)
                }

                function mixin(target, source) {
                    for (var key in source) source.hasOwnProperty(key) && (target[key] = source[key])
                }
                var exports = win.fastdom = win.fastdom || new FastDom;
                module.exports = exports
            })(typeof window != "undefined" ? window : commonjsGlobal)
        }),
        OverflowScroller = (function() {
            function OverflowScroller2(element, options) {
                _classCallCheck(this, OverflowScroller2), element && (this.element = element, this.options = options, this.lastKnownY = window.scrollY, this.currentTop = 0, this.initialTopOffset = options.offsetTop || parseInt(window.getComputedStyle(this.element).top), this._attachListeners())
            }
            return _createClass(OverflowScroller2, [{
                key: "destroy",
                value: function() {
                    window.removeEventListener("scroll", this._checkPositionListener)
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this._checkPositionListener = this._checkPosition.bind(this), window.addEventListener("scroll", this._checkPositionListener)
                }
            }, {
                key: "_checkPosition",
                value: function() {
                    var _this = this;
                    fastdom.measure(function() {
                        var bounds = _this.element.getBoundingClientRect(),
                            maxTop = bounds.top + window.scrollY - _this.element.offsetTop + _this.initialTopOffset,
                            minTop = _this.element.clientHeight - window.innerHeight + (_this.options.offsetBottom || 0);
                        window.scrollY < _this.lastKnownY ? _this.currentTop -= window.scrollY - _this.lastKnownY : _this.currentTop += _this.lastKnownY - window.scrollY, _this.currentTop = Math.min(Math.max(_this.currentTop, -minTop), maxTop, _this.initialTopOffset), _this.lastKnownY = window.scrollY
                    }), fastdom.mutate(function() {
                        _this.element.style.top = "".concat(_this.currentTop, "px")
                    })
                }
            }]), OverflowScroller2
        })(),
        PopoverManager = (function() {
            function PopoverManager2() {
                _classCallCheck(this, PopoverManager2), this.delegateElement = new Delegate(document.body), this.delegateRoot = new Delegate(document.documentElement), this.activePopover = null, this._attachListeners()
            }
            return _createClass(PopoverManager2, [{
                key: "_attachListeners",
                value: function() {
                    this._onLooseFocusListener = this._onLooseFocus.bind(this), this.delegateElement.on("click", '[data-action="toggle-popover"]', this._togglePopover.bind(this)), this.delegateElement.on("click", '[data-action="show-popover-panel"]', this._showPanel.bind(this)), this.delegateRoot.on("click", this._onWindowClick.bind(this)), document.addEventListener("popover:close", this._closeActivePopover.bind(this)), window.addEventListener("resize", this._windowResized.bind(this))
                }
            }, {
                key: "_togglePopover",
                value: function(event2, target) {
                    var hasActivePopover = this.activePopover !== null,
                        previousActivePopoverId = this.activePopover ? this.activePopover.id : null;
                    target.hasAttribute("data-follow-link") && Responsive.matchesBreakpoint(target.getAttribute("data-follow-link")) || (hasActivePopover && this._closeActivePopover(), (!hasActivePopover || hasActivePopover && target.getAttribute("aria-controls") !== previousActivePopoverId) && this._openPopover(target), event2.preventDefault())
                }
            }, {
                key: "_closeActivePopover",
                value: function() {
                    this.activePopover.setAttribute("aria-hidden", "true"), document.querySelector('[aria-controls="'.concat(this.activePopover.id, '"]')).setAttribute("aria-expanded", "false"), this.activePopover.removeEventListener("focusout", this._onLooseFocusListener), this.activePopover = null
                }
            }, {
                key: "_openPopover",
                value: function(target) {
                    var element = document.getElementById(target.getAttribute("aria-controls"));
                    if (target.setAttribute("aria-expanded", "true"), element.setAttribute("aria-hidden", "false"), Responsive.getCurrentBreakpoint() === "phone") element.style.height = "".concat(window.innerHeight - document.querySelector(".header").getBoundingClientRect().bottom, "px");
                    else {
                        element.style.height = "";
                        var panelList = element.querySelector(".popover__panel-list");
                        panelList && (panelList.style.height = "".concat(panelList.clientHeight, "px"))
                    }
                    this.activePopover = element, this.activePopover.addEventListener("focusout", this._onLooseFocusListener)
                }
            }, {
                key: "_showPanel",
                value: function(event2, target) {
                    if (this.activePopover) {
                        var panels = this.activePopover.querySelectorAll(".popover__panel");
                        panels.forEach(function(panel) {
                            panel.id === target.getAttribute("aria-controls") ? (panel.classList.add("is-selected"), panel.closest(".popover__panel-list").style.height = "".concat(panel.clientHeight, "px")) : panel.classList.remove("is-selected")
                        })
                    }
                }
            }, {
                key: "_onWindowClick",
                value: function(event2) {
                    event2.target.getAttribute("data-action") === "toggle-popover" || event2.target.closest('[data-action="toggle-popover"]') || this.activePopover && !this.activePopover.contains(event2.target) && this._closeActivePopover()
                }
            }, {
                key: "_onLooseFocus",
                value: function(event2) {
                    this.activePopover && event2.relatedTarget !== null && !this.activePopover.contains(event2.relatedTarget) && this._closeActivePopover()
                }
            }, {
                key: "_windowResized",
                value: function() {
                    Responsive.getCurrentBreakpoint() === "phone" && this.activePopover && (this.activePopover.style.height = "".concat(window.innerHeight - document.querySelector(".header").getBoundingClientRect().bottom, "px"))
                }
            }]), PopoverManager2
        })(),
        ProductItemColorSwatch = (function() {
            function ProductItemColorSwatch2(element) {
                _classCallCheck(this, ProductItemColorSwatch2), this.element = element, this.delegateElement = new Delegate(this.element), this._attachListeners(), this.recalculateSwatches()
            }
            return _createClass(ProductItemColorSwatch2, [{
                key: "destroy",
                value: function() {
                    this.delegateElement.off(), window.removeEventListener("resize", this._recalculateSwatchesListener)
                }
            }, {
                key: "recalculateSwatches",
                value: function() {
                    var _this = this;
                    fastdom.measure(function() {
                        _this.element.querySelectorAll(".product-item__swatch-list").forEach(function(swatchList) {
                            var currentWidth = swatchList.clientWidth,
                                maxAllowedWidth = parseInt(Math.min(currentWidth, 200)),
                                maxFit = Math.floor(maxAllowedWidth / 30);
                            fastdom.mutate(function() {
                                var colorSwatches = swatchList.querySelectorAll(".color-swatch");
                                colorSwatches.forEach(function(colorSwatch, index) {
                                    colorSwatch.classList.remove("color-swatch--view-more"), maxFit === index + 1 && maxFit !== colorSwatches.length && colorSwatch.classList.add("color-swatch--view-more")
                                })
                            })
                        })
                    })
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this._recalculateSwatchesListener = this.recalculateSwatches.bind(this), this.delegateElement.on("change", ".product-item__swatch-list .color-swatch__radio", this._colorChanged.bind(this)), window.addEventListener("resize", this._recalculateSwatchesListener)
                }
            }, {
                key: "_colorChanged",
                value: function(event2, target) {
                    var productItem = target.closest(".product-item"),
                        variantUrl = target.getAttribute("data-variant-url");
                    productItem.querySelector(".product-item__image-wrapper").setAttribute("href", variantUrl), productItem.querySelector(".product-item__title").setAttribute("href", variantUrl);
                    var originalImageElement = productItem.querySelector(".product-item__primary-image");
                    if (target.hasAttribute("data-image-url") && target.getAttribute("data-media-id") !== originalImageElement.getAttribute("data-media-id")) {
                        var newImageElement = document.createElement("img");
                        newImageElement.className = "product-item__primary-image lazyload image--fade-in", newImageElement.setAttribute("data-media-id", target.getAttribute("data-media-id")), newImageElement.setAttribute("data-src", target.getAttribute("data-image-url")), newImageElement.setAttribute("data-widths", target.getAttribute("data-image-widths")), newImageElement.setAttribute("data-sizes", "auto"), originalImageElement.parentNode.style.paddingBottom = "".concat(100 / newImageElement.getAttribute("data-image-aspect-ratio"), "%"), originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement)
                    }
                }
            }]), ProductItemColorSwatch2
        })(),
        Currency = (function() {
            function Currency2() {
                _classCallCheck(this, Currency2)
            }
            return _createClass(Currency2, null, [{
                key: "formatMoney",
                value: function(cents, format) {
                    typeof cents == "string" && (cents = cents.replace(".", ""));
                    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
                        formatString = format || "${{amount}}";

                    function defaultTo(value2, defaultValue) {
                        return value2 == null || value2 !== value2 ? defaultValue : value2
                    }

                    function formatWithDelimiters(number, precision, thousands, decimal) {
                        if (precision = defaultTo(precision, 2), thousands = defaultTo(thousands, ","), decimal = defaultTo(decimal, "."), isNaN(number) || number == null) return 0;
                        number = (number / 100).toFixed(precision);
                        var parts = number.split("."),
                            dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
                            centsAmount = parts[1] ? decimal + parts[1] : "";
                        return dollarsAmount + centsAmount
                    }
                    var value = "";
                    switch (formatString.match(placeholderRegex)[1]) {
                        case "amount":
                            value = formatWithDelimiters(cents, 2);
                            break;
                        case "amount_no_decimals":
                            value = formatWithDelimiters(cents, 0);
                            break;
                        case "amount_with_space_separator":
                            value = formatWithDelimiters(cents, 2, " ", ".");
                            break;
                        case "amount_no_decimals_with_comma_separator":
                            value = formatWithDelimiters(cents, 0, ",", ".");
                            break;
                        case "amount_no_decimals_with_space_separator":
                            value = formatWithDelimiters(cents, 0, " ");
                            break;
                        case "amount_with_comma_separator":
                            value = formatWithDelimiters(cents, 2, ".", ",");
                            break
                    }
                    return formatString.indexOf("with_comma_separator") !== -1, formatString.replace(placeholderRegex, value)
                }
            }]), Currency2
        })(),
        Form = (function() {
            function Form2() {
                _classCallCheck(this, Form2)
            }
            return _createClass(Form2, null, [{
                key: "serialize",
                value: function(form) {
                    function stringKey(key, value) {
                        var beginBracket = key.lastIndexOf("[");
                        if (beginBracket === -1) {
                            var _hash = {};
                            return _hash[key] = value, _hash
                        }
                        var newKey = key.substr(0, beginBracket),
                            newValue = {};
                        return newValue[key.substring(beginBracket + 1, key.length - 1)] = value, stringKey(newKey, newValue)
                    }
                    for (var hash = {}, i = 0, len = form.elements.length; i < len; i++) {
                        var formElement = form.elements[i];
                        if (!(formElement.name === "" || formElement.disabled) && formElement.name && !formElement.disabled && (formElement.checked || /select|textarea/i.test(formElement.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(formElement.type))) {
                            var stringKeys = stringKey(formElement.name, formElement.value);
                            hash = Form2.extend(hash, stringKeys)
                        }
                    }
                    return hash
                }
            }, {
                key: "extend",
                value: function() {
                    for (var extended = {}, i = 0, merge = function(obj) {
                            for (var prop in obj) obj.hasOwnProperty(prop) && (Object.prototype.toString.call(obj[prop]) === "[object Object]" ? extended[prop] = Form2.extend(extended[prop], obj[prop]) : extended[prop] = obj[prop])
                        }; i < arguments.length; i++) merge(arguments[i]);
                    return extended
                }
            }]), Form2
        })(),
        StoreAvailability = (function() {
            function StoreAvailability2(element) {
                if (_classCallCheck(this, StoreAvailability2), this.element = element, !!this.element) {
                    var modal = this.element.querySelector(".store-availabilities-modal");
                    modal && document.body.appendChild(modal)
                }
            }
            return _createClass(StoreAvailability2, [{
                key: "updateWithVariant",
                value: function(variant) {
                    if (this.element) {
                        if (!variant) {
                            this.element.textContent = "";
                            return
                        }
                        this._renderAvailabilitySection(variant.id)
                    }
                }
            }, {
                key: "_renderAvailabilitySection",
                value: function(id) {
                    var _this = this;
                    this.element.innerHTML = "";
                    var availabilityModal = document.getElementById("StoreAvailabilityModal-".concat(id));
                    return availabilityModal && availabilityModal.remove(), fetch("".concat(window.routes.rootUrlWithoutSlash, "/variants/").concat(id, "?section_id=store-availability")).then(function(response) {
                        return response.text().then(function(content) {
                            var fakeDiv = document.createElement("div");
                            if (fakeDiv.innerHTML = content, fakeDiv.innerHTML = fakeDiv.firstElementChild.innerHTML, fakeDiv.firstElementChild.getAttribute("data-count") !== "0") {
                                _this.element.innerHTML = fakeDiv.innerHTML;
                                var availabilityModal2 = document.getElementById("StoreAvailabilityModal-".concat(id));
                                document.body.appendChild(availabilityModal2)
                            }
                        })
                    })
                }
            }]), StoreAvailability2
        })(),
        ProductVariants = (function() {
            function ProductVariants2(element, options) {
                var _this = this;
                _classCallCheck(this, ProductVariants2), this.element = element, this.delegateElement = new Delegate(this.element), this.options = options;
                var productJsonElement = this.element.querySelector("[data-product-json]");
                if (productJsonElement) {
                    var jsonData = JSON.parse(productJsonElement.innerHTML);
                    this.productData = jsonData.product, this.productOptionsWithValues = jsonData.options_with_values, this.variantsInventories = jsonData.inventories || {}, this.variantSelectors = this.element.querySelectorAll(".product-form__option[data-selector-type]"), this.masterSelector = this.element.querySelector("#product-select-".concat(this.productData.id)), this.productData.variants.forEach(function(variant) {
                        variant.id === jsonData.selected_variant_id && (_this.currentVariant = variant, _this.option1 = variant.option1, _this.option2 = variant.option2, _this.option3 = variant.option3)
                    }), this.storeAvailability = new StoreAvailability(this.element.querySelector(".product-meta__store-availability-container"))
                }
                this._updateSelectors(this.currentVariant), this._setupStockCountdown(), this._attachListeners()
            }
            return _createClass(ProductVariants2, [{
                key: "destroy",
                value: function() {
                    this.delegateElement.off("click")
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this.delegateElement.on("change", ".product-form__single-selector", this._onOptionChanged.bind(this)), this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this))
                }
            }, {
                key: "_onVariantChanged",
                value: function(previousVariant, newVariant) {
                    this._updateProductPrices(newVariant, previousVariant), this._updateInventory(newVariant, previousVariant), this._updateSku(newVariant, previousVariant), this._updateDiscountLabel(newVariant, previousVariant), this._updateUnitPrice(newVariant, previousVariant), this._updateSelectors(newVariant, previousVariant), this._updateAddToCartButton(newVariant, previousVariant), this.storeAvailability.updateWithVariant(newVariant), this.element.dispatchEvent(new CustomEvent("variant:changed", {
                        bubbles: !0,
                        detail: {
                            variant: newVariant,
                            previousVariant: previousVariant
                        }
                    }))
                }
            }, {
                key: "_updateProductPrices",
                value: function(newVariant, previousVariant) {
                    var productPrices = this.element.querySelector(".price-list"),
                        currencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
                    if (productPrices)
                        if (!newVariant) productPrices.style.display = "none";
                        else {
                            if (previousVariant && previousVariant.price === newVariant.price && previousVariant.compare_at_price === newVariant.compare_at_price) return;
                            productPrices.innerHTML = "", newVariant.compare_at_price > newVariant.price ? (productPrices.innerHTML += '<span class="price price--highlight"><span class="visually-hidden">'.concat(window.languages.productSalePrice, "</span>").concat(Currency.formatMoney(newVariant.price, currencyFormat), "</span>"), productPrices.innerHTML += '<span class="price price--compare"><span class="visually-hidden">'.concat(window.languages.productRegularPrice, "</span>").concat(Currency.formatMoney(newVariant.compare_at_price, currencyFormat), "</span>")) : productPrices.innerHTML += '<span class="price"><span class="visually-hidden">'.concat(window.languages.productSalePrice, "</span>").concat(Currency.formatMoney(newVariant.price, currencyFormat), "</span>"), productPrices.style.display = ""
                        }
                }
            }, {
                key: "_updateInventory",
                value: function(newVariant) {
                    if (!(!this.options.showInventoryQuantity || !newVariant)) {
                        var productFormInventoryElement = this.element.querySelector(".product-form__inventory"),
                            variantInventoryManagement = this.variantsInventories[newVariant.id].inventory_management,
                            variantInventoryPolicy = this.variantsInventories[newVariant.id].inventory_policy,
                            variantInventoryQuantity = this.variantsInventories[newVariant.id].inventory_quantity,
                            variantInventoryMessage = this.variantsInventories[newVariant.id].inventory_message;
                        if (productFormInventoryElement) {
                            productFormInventoryElement.classList.remove("inventory--high"), productFormInventoryElement.classList.remove("inventory--low"), newVariant.available && (variantInventoryManagement !== null && variantInventoryPolicy === "deny" && this.options.lowInventoryThreshold > 0 && variantInventoryQuantity <= this.options.lowInventoryThreshold ? productFormInventoryElement.classList.add("inventory--low") : productFormInventoryElement.classList.add("inventory--high"));
                            var stockCountdown = this.element.querySelector(".inventory-bar");
                            if (stockCountdown) {
                                var stockCountdownProgress = Math.min(Math.max(variantInventoryQuantity / parseInt(stockCountdown.getAttribute("data-stock-countdown-max")) * 100, 0), 100);
                                stockCountdown.classList.toggle("inventory-bar--hidden", stockCountdownProgress === 0), stockCountdown.firstElementChild.style.width = "".concat(stockCountdownProgress, "%")
                            }
                            productFormInventoryElement.innerHTML = variantInventoryMessage
                        }
                    }
                }
            }, {
                key: "_updateSku",
                value: function(newVariant, previousVariant) {
                    var productSku = this.element.querySelector(".product-meta__sku");
                    if (productSku) {
                        var productSkuNumber = productSku.querySelector(".product-meta__sku-number");
                        if (!newVariant || newVariant.sku === "") productSku.style.display = "none";
                        else {
                            if (previousVariant && previousVariant.sku === newVariant.sku) return;
                            productSkuNumber.innerHTML = newVariant.sku, productSku.style.display = ""
                        }
                    }
                }
            }, {
                key: "_updateDiscountLabel",
                value: function(newVariant, previousVariant) {
                    if (window.theme.showDiscount) {
                        var discountLabel = this.element.querySelector(".product-meta .product-label--on-sale");
                        if (discountLabel)
                            if (!newVariant || !(newVariant.price < newVariant.compare_at_price)) discountLabel.style.display = "none";
                            else {
                                var savings = null;
                                window.theme.discountMode === "percentage" ? savings = "".concat(Math.round((newVariant.compare_at_price - newVariant.price) * 100 / newVariant.compare_at_price), "%") : savings = "<span>".concat(Currency.formatMoney(newVariant.compare_at_price - newVariant.price, window.theme.moneyFormat), "</span>"), discountLabel.innerHTML = "".concat(window.languages.collectionOnSaleLabel.replace("{{savings}}", savings)), discountLabel.style.display = "inline-block"
                            }
                    }
                }
            }, {
                key: "_updateUnitPrice",
                value: function(newVariant, previousVariant) {
                    var unitPriceMeasurement = this.element.querySelector(".unit-price-measurement");
                    if (unitPriceMeasurement)
                        if (!newVariant || !newVariant.unit_price_measurement) unitPriceMeasurement.parentNode.style.display = "none";
                        else {
                            unitPriceMeasurement.parentNode.style.display = "block", unitPriceMeasurement.querySelector(".unit-price-measurement__price").innerHTML = Currency.formatMoney(newVariant.unit_price, window.theme.moneyFormat), unitPriceMeasurement.querySelector(".unit-price-measurement__reference-unit").innerHTML = newVariant.unit_price_measurement.reference_unit;
                            var unitPriceReferenceValue = unitPriceMeasurement.querySelector(".unit-price-measurement__reference-value");
                            unitPriceReferenceValue.innerHTML = newVariant.unit_price_measurement.reference_value, unitPriceReferenceValue.style.display = newVariant.unit_price_measurement.reference_value === 1 ? "none" : "inline"
                        }
                }
            }, {
                key: "_updateSelectors",
                value: function(newVariant) {
                    var _this2 = this,
                        applyClassToSelector = function(selector, valueIndex, available) {
                            var selectorType = selector.getAttribute("data-selector-type");
                            switch (selectorType) {
                                case "color":
                                    selector.querySelector(".color-swatch:nth-child(".concat(valueIndex + 1, ")")).classList.toggle("color-swatch--disabled", !available);
                                    break;
                                case "variant":
                                    selector.querySelector(".variant-swatch:nth-child(".concat(valueIndex + 1, ")")).classList.toggle("variant-swatch--disabled", !available);
                                    break;
                                case "block":
                                    selector.querySelector(".block-swatch:nth-child(".concat(valueIndex + 1, ")")).classList.toggle("block-swatch--disabled", !available);
                                    break
                            }
                        };
                    this.variantSelectors && this.variantSelectors[0] && this.productOptionsWithValues[0].values.forEach(function(value, valueIndex) {
                        applyClassToSelector(_this2.variantSelectors[0], valueIndex, _this2.productData.variants.some(function(variant) {
                            return variant.option1 === value && variant.available
                        })), _this2.variantSelectors[1] && _this2.productOptionsWithValues[1].values.forEach(function(value2, valueIndex2) {
                            applyClassToSelector(_this2.variantSelectors[1], valueIndex2, _this2.productData.variants.some(function(variant) {
                                return variant.option2 === value2 && variant.option1 === _this2.option1 && variant.available
                            })), _this2.variantSelectors[2] && _this2.productOptionsWithValues[2].values.forEach(function(value3, valueIndex3) {
                                applyClassToSelector(_this2.variantSelectors[2], valueIndex3, _this2.productData.variants.some(function(variant) {
                                    return variant.option3 === value3 && variant.option1 === _this2.option1 && variant.option2 === _this2.option2 && variant.available
                                }))
                            })
                        })
                    })
                }
            }, {
                key: "_updateAddToCartButton",
                value: function(newVariant) {
                    var addToCartButtonElement = this.element.querySelector(".product-form__add-button"),
                        infoListElement = this.element.querySelector(".product-form__info-list");
                    if (addToCartButtonElement && (newVariant ? (infoListElement.style.display = "block", newVariant.available ? (addToCartButtonElement.removeAttribute("disabled"), addToCartButtonElement.classList.remove("button--disabled"), addToCartButtonElement.classList.add("button--primary"), addToCartButtonElement.setAttribute("data-action", "add-to-cart"), addToCartButtonElement.innerHTML = window.languages.productFormAddToCart) : (addToCartButtonElement.setAttribute("disabled", "disabled"), addToCartButtonElement.classList.add("button--disabled"), addToCartButtonElement.classList.remove("button--primary"), addToCartButtonElement.removeAttribute("data-action"), addToCartButtonElement.innerHTML = window.languages.productFormSoldOut)) : (addToCartButtonElement.setAttribute("disabled", "disabled"), addToCartButtonElement.classList.add("button--disabled"), addToCartButtonElement.classList.remove("button--primary"), addToCartButtonElement.removeAttribute("data-action"), addToCartButtonElement.innerHTML = window.languages.productFormUnavailable, infoListElement.style.display = "none"), this.options.showPaymentButton)) {
                        var paymentButtonElement = this.element.querySelector(".shopify-payment-button");
                        if (!paymentButtonElement) return;
                        !newVariant || !newVariant.available ? paymentButtonElement.style.display = "none" : paymentButtonElement.style.display = "block"
                    }
                }
            }, {
                key: "_onOptionChanged",
                value: function(event2, target) {
                    this["option" + target.getAttribute("data-option-position")] = target.value;
                    var selectedValueElement = target.closest(".product-form__option").querySelector(".product-form__selected-value");
                    selectedValueElement && (selectedValueElement.innerHTML = target.value);
                    var previousVariant = this.currentVariant;
                    if (this.currentVariant = this._getCurrentVariantFromOptions(), this._onVariantChanged(previousVariant, this.currentVariant), this.currentVariant) {
                        if (this.options.enableHistoryState && history.replaceState) {
                            var newUrl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?variant=").concat(this.currentVariant.id);
                            window.history.replaceState({
                                path: newUrl
                            }, "", newUrl)
                        }
                        this.masterSelector.querySelector("[selected]").removeAttribute("selected"), this.masterSelector.querySelector('[value="'.concat(this.currentVariant.id, '"]')).setAttribute("selected", "selected")
                    }
                }
            }, {
                key: "_getCurrentVariantFromOptions",
                value: function() {
                    var _this3 = this,
                        found = !1;
                    return this.productData.variants.forEach(function(variant) {
                        variant.option1 === _this3.option1 && variant.option2 === _this3.option2 && variant.option3 === _this3.option3 && (found = variant)
                    }), found || null
                }
            }, {
                key: "_addToCart",
                value: function(event2, target) {
                    var _this4 = this;
                    if (window.theme.cartType !== "page") {
                        event2.preventDefault(), event2.stopPropagation(), target.setAttribute("disabled", "disabled"), document.dispatchEvent(new CustomEvent("theme:loading:start"));
                        var formElement = this.element.querySelector('form[action*="/cart/add"]');
                        fetch("".concat(window.routes.cartAddUrl, ".js"), {
                            body: JSON.stringify(Form.serialize(formElement)),
                            credentials: "same-origin",
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Requested-With": "XMLHttpRequest"
                            }
                        }).then(function(response) {
                            document.dispatchEvent(new CustomEvent("theme:loading:end")), response.ok ? (target.removeAttribute("disabled"), _this4.element.dispatchEvent(new CustomEvent("product:added", {
                                bubbles: !0,
                                detail: {
                                    variant: _this4.currentVariant,
                                    quantity: parseInt(formElement.querySelector('[name="quantity"]').value)
                                }
                            })), _this4.options.isQuickView && window.theme.cartType === "drawer" && document.dispatchEvent(new CustomEvent("modal:close")), window.theme.cartType === "message" && _this4._showAlert(window.languages.productAdded, "success", target)) : response.json().then(function(content) {
                                _this4._showAlert(content.description, "error", target)
                            })
                        }), event2.preventDefault()
                    }
                }
            }, {
                key: "_setupStockCountdown",
                value: function() {
                    var _this5 = this,
                        stockCountdown = this.element.querySelector(".inventory-bar");
                    if (stockCountdown) {
                        var onStockCountdownVisible = function() {
                            var variantInventoryQuantity = _this5.variantsInventories[_this5.currentVariant.id].inventory_quantity,
                                stockCountdownProgress = Math.min(Math.max(variantInventoryQuantity / parseInt(stockCountdown.getAttribute("data-stock-countdown-max")) * 100, 0), 100);
                            stockCountdown.classList.toggle("inventory-bar--hidden", stockCountdownProgress === 0), stockCountdown.firstElementChild.style.width = "".concat(stockCountdownProgress, "%")
                        };
                        if (window.IntersectionObserver) {
                            var stockCountdownIntersectionObserver = new IntersectionObserver(function(entries) {
                                entries.forEach(function(item) {
                                    item.isIntersecting && (onStockCountdownVisible(), stockCountdownIntersectionObserver.disconnect())
                                })
                            });
                            stockCountdownIntersectionObserver.observe(stockCountdown)
                        } else onStockCountdownVisible()
                    }
                }
            }, {
                key: "_showAlert",
                value: function(message, type, afterElement) {
                    var messageElement = document.createElement("div");
                    messageElement.className = "product-form__status-message", messageElement.innerHTML = '<p class="alert '.concat(type === "success" ? "alert--success" : "alert--error", '">').concat(message, "</p>"), afterElement.removeAttribute("disabled"), afterElement.parentNode.insertAdjacentElement("afterend", messageElement), Animation.slideDown(messageElement), setTimeout(function() {
                        Animation.slideUp(messageElement, function() {
                            messageElement.remove()
                        })
                    }, 5500)
                }
            }]), ProductVariants2
        })(),
        ProductModel = (function() {
            function ProductModel2(element) {
                _classCallCheck(this, ProductModel2), this.element = element, this.delegateElement = new Delegate(this.element), this.delegateRoot = new Delegate(document.documentElement), this._attachListeners();
                var stylesheet = document.createElement("link");
                stylesheet.rel = "stylesheet", stylesheet.href = "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css", document.head.appendChild(stylesheet), window.Shopify.loadFeatures([{
                    name: "model-viewer-ui",
                    version: "1.0",
                    onLoad: this._setupModelViewerUI.bind(this)
                }, {
                    name: "shopify-xr",
                    version: "1.0"
                }])
            }
            return _createClass(ProductModel2, [{
                key: "destroy",
                value: function() {}
            }, {
                key: "_attachListeners",
                value: function() {
                    var _this = this;
                    this.element.querySelector("model-viewer").addEventListener("shopify_model_viewer_ui_toggle_play", function() {
                        _this.element.dispatchEvent(new CustomEvent("model:played", {
                            bubbles: !0
                        }))
                    }), this.element.querySelector("model-viewer").addEventListener("shopify_model_viewer_ui_toggle_pause", function() {
                        _this.element.dispatchEvent(new CustomEvent("model:paused", {
                            bubbles: !0
                        }))
                    })
                }
            }, {
                key: "hasBeenSelected",
                value: function(isInitialLoading) {
                    Responsive.matchesBreakpoint("supports-hover") && !isInitialLoading && this.modelUi.play()
                }
            }, {
                key: "hasBeenDeselected",
                value: function() {
                    this.modelUi.pause()
                }
            }, {
                key: "_setupModelViewerUI",
                value: function() {
                    this.modelElement = this.element.querySelector("model-viewer"), this.modelUi = new window.Shopify.ModelViewerUI(this.modelElement)
                }
            }]), ProductModel2
        })(),
        ProductVideo = (function() {
            function ProductVideo2(element, enableVideoLooping) {
                switch (_classCallCheck(this, ProductVideo2), this.element = element, this.delegateElement = new Delegate(this.element), this.enableVideoLooping = enableVideoLooping, this.player = null, this.element.getAttribute("data-media-type")) {
                    case "video":
                        var stylesheet = document.createElement("link");
                        stylesheet.rel = "stylesheet", stylesheet.href = "https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css", document.head.appendChild(stylesheet), window.Shopify.loadFeatures([{
                            name: "video-ui",
                            version: "1.0",
                            onLoad: this._setupHtml5Video.bind(this)
                        }]);
                        break;
                    case "external_video":
                        this._setupExternalVideo();
                        break
                }
            }
            return _createClass(ProductVideo2, [{
                key: "destroy",
                value: function() {
                    this.player && this.player.destroy()
                }
            }, {
                key: "hasBeenSelected",
                value: function(isInitialLoading) {
                    Responsive.matchesBreakpoint("supports-hover") && !isInitialLoading && this.play()
                }
            }, {
                key: "hasBeenDeselected",
                value: function() {
                    this.pause()
                }
            }, {
                key: "play",
                value: function() {
                    switch (this.element.getAttribute("data-media-type")) {
                        case "video":
                            this.player.play();
                            break;
                        case "external_video":
                            this.player.playVideo(), this.element.focus();
                            break
                    }
                }
            }, {
                key: "pause",
                value: function() {
                    switch (this.element.getAttribute("data-media-type")) {
                        case "video":
                            this.player.pause();
                            break;
                        case "external_video":
                            this.player.pauseVideo();
                            break
                    }
                }
            }, {
                key: "_setupHtml5Video",
                value: function() {
                    var _this = this;
                    this.player = new Shopify.Plyr(this.element.querySelector("video"), {
                        controls: ["play", "progress", "mute", "volume", "play-large", "fullscreen"],
                        loop: {
                            active: this.enableVideoLooping
                        },
                        hideControlsOnPause: !0,
                        clickToPlay: !0,
                        iconUrl: "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg",
                        tooltips: {
                            controls: !1,
                            seek: !0
                        }
                    }), this.player.on("play", function() {
                        _this.element.dispatchEvent(new CustomEvent("video:played", {
                            bubbles: !0
                        }))
                    }), this.player.on("pause", function() {
                        _this.element.dispatchEvent(new CustomEvent("video:paused", {
                            bubbles: !0
                        }))
                    })
                }
            }, {
                key: "_setupExternalVideo",
                value: function() {
                    this.element.getAttribute("data-media-host") === "youtube" && this._loadYouTubeScript().then(this._setupYouTubePlayer.bind(this))
                }
            }, {
                key: "_setupYouTubePlayer",
                value: function() {
                    var _this2 = this,
                        playerLoadingInterval = setInterval(function() {
                            window.YT !== void 0 && window.YT.Player !== void 0 && (_this2.player = new YT.Player(_this2.element.querySelector("iframe"), {
                                videoId: _this2.element.getAttribute("data-video-id"),
                                events: {
                                    onStateChange: function(event2) {
                                        event2.data === 0 && _this2.enableVideoLooping && event2.target.seekTo(0)
                                    }
                                }
                            }), clearInterval(playerLoadingInterval))
                        }, 50)
                }
            }, {
                key: "_loadYouTubeScript",
                value: function() {
                    return new Promise(function(resolve, reject) {
                        var script = document.createElement("script");
                        document.body.appendChild(script), script.onload = resolve, script.onerror = reject, script.async = !0, script.src = "//www.youtube.com/iframe_api"
                    })
                }
            }]), ProductVideo2
        })(),
        evEmitter = createCommonjsModule(function(module) {
            (function(global2, factory) {
                module.exports ? module.exports = factory() : global2.EvEmitter = factory()
            })(typeof window != "undefined" ? window : commonjsGlobal, function() {
                function EvEmitter() {}
                var proto = EvEmitter.prototype;
                return proto.on = function(eventName, listener) {
                    if (!(!eventName || !listener)) {
                        var events = this._events = this._events || {},
                            listeners = events[eventName] = events[eventName] || [];
                        return listeners.indexOf(listener) == -1 && listeners.push(listener), this
                    }
                }, proto.once = function(eventName, listener) {
                    if (!(!eventName || !listener)) {
                        this.on(eventName, listener);
                        var onceEvents = this._onceEvents = this._onceEvents || {},
                            onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
                        return onceListeners[listener] = !0, this
                    }
                }, proto.off = function(eventName, listener) {
                    var listeners = this._events && this._events[eventName];
                    if (!(!listeners || !listeners.length)) {
                        var index = listeners.indexOf(listener);
                        return index != -1 && listeners.splice(index, 1), this
                    }
                }, proto.emitEvent = function(eventName, args) {
                    var listeners = this._events && this._events[eventName];
                    if (!(!listeners || !listeners.length)) {
                        listeners = listeners.slice(0), args = args || [];
                        for (var onceListeners = this._onceEvents && this._onceEvents[eventName], i = 0; i < listeners.length; i++) {
                            var listener = listeners[i],
                                isOnce = onceListeners && onceListeners[listener];
                            isOnce && (this.off(eventName, listener), delete onceListeners[listener]), listener.apply(this, args)
                        }
                        return this
                    }
                }, proto.allOff = function() {
                    delete this._events, delete this._onceEvents
                }, EvEmitter
            })
        }),
        getSize = createCommonjsModule(function(module) {
            /*!
             * getSize v2.0.3
             * measure size of elements
             * MIT license
             */
            (function(window2, factory) {
                module.exports ? module.exports = factory() : window2.getSize = factory()
            })(window, function() {
                function getStyleSize(value) {
                    var num = parseFloat(value),
                        isValid = value.indexOf("%") == -1 && !isNaN(num);
                    return isValid && num
                }

                function noop() {}
                var logError = typeof console == "undefined" ? noop : function(message) {
                        console.error(message)
                    },
                    measurements = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
                    measurementsLength = measurements.length;

                function getZeroSize() {
                    for (var size = {
                            width: 0,
                            height: 0,
                            innerWidth: 0,
                            innerHeight: 0,
                            outerWidth: 0,
                            outerHeight: 0
                        }, i = 0; i < measurementsLength; i++) {
                        var measurement = measurements[i];
                        size[measurement] = 0
                    }
                    return size
                }

                function getStyle(elem) {
                    var style = getComputedStyle(elem);
                    return style || logError("Style returned " + style + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), style
                }
                var isSetup = !1,
                    isBoxSizeOuter;

                function setup() {
                    if (!isSetup) {
                        isSetup = !0;
                        var div = document.createElement("div");
                        div.style.width = "200px", div.style.padding = "1px 2px 3px 4px", div.style.borderStyle = "solid", div.style.borderWidth = "1px 2px 3px 4px", div.style.boxSizing = "border-box";
                        var body = document.body || document.documentElement;
                        body.appendChild(div);
                        var style = getStyle(div);
                        isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200, getSize2.isBoxSizeOuter = isBoxSizeOuter, body.removeChild(div)
                    }
                }

                function getSize2(elem) {
                    if (setup(), typeof elem == "string" && (elem = document.querySelector(elem)), !(!elem || _typeof(elem) != "object" || !elem.nodeType)) {
                        var style = getStyle(elem);
                        if (style.display == "none") return getZeroSize();
                        var size = {};
                        size.width = elem.offsetWidth, size.height = elem.offsetHeight;
                        for (var isBorderBox = size.isBorderBox = style.boxSizing == "border-box", i = 0; i < measurementsLength; i++) {
                            var measurement = measurements[i],
                                value = style[measurement],
                                num = parseFloat(value);
                            size[measurement] = isNaN(num) ? 0 : num
                        }
                        var paddingWidth = size.paddingLeft + size.paddingRight,
                            paddingHeight = size.paddingTop + size.paddingBottom,
                            marginWidth = size.marginLeft + size.marginRight,
                            marginHeight = size.marginTop + size.marginBottom,
                            borderWidth = size.borderLeftWidth + size.borderRightWidth,
                            borderHeight = size.borderTopWidth + size.borderBottomWidth,
                            isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter,
                            styleWidth = getStyleSize(style.width);
                        styleWidth !== !1 && (size.width = styleWidth + (isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth));
                        var styleHeight = getStyleSize(style.height);
                        return styleHeight !== !1 && (size.height = styleHeight + (isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight)), size.innerWidth = size.width - (paddingWidth + borderWidth), size.innerHeight = size.height - (paddingHeight + borderHeight), size.outerWidth = size.width + marginWidth, size.outerHeight = size.height + marginHeight, size
                    }
                }
                return getSize2
            })
        }),
        matchesSelector = createCommonjsModule(function(module) {
            (function(window2, factory) {
                module.exports ? module.exports = factory() : window2.matchesSelector = factory()
            })(window, function() {
                var matchesMethod = (function() {
                    var ElemProto = window.Element.prototype;
                    if (ElemProto.matches) return "matches";
                    if (ElemProto.matchesSelector) return "matchesSelector";
                    for (var prefixes = ["webkit", "moz", "ms", "o"], i = 0; i < prefixes.length; i++) {
                        var prefix = prefixes[i],
                            method = prefix + "MatchesSelector";
                        if (ElemProto[method]) return method
                    }
                })();
                return function(elem, selector) {
                    return elem[matchesMethod](selector)
                }
            })
        }),
        utils = createCommonjsModule(function(module) {
            (function(window2, factory) {
                module.exports ? module.exports = factory(window2, matchesSelector) : window2.fizzyUIUtils = factory(window2, window2.matchesSelector)
            })(window, function(window2, matchesSelector2) {
                var utils2 = {};
                utils2.extend = function(a, b) {
                    for (var prop in b) a[prop] = b[prop];
                    return a
                }, utils2.modulo = function(num, div) {
                    return (num % div + div) % div
                };
                var arraySlice = Array.prototype.slice;
                utils2.makeArray = function(obj) {
                    if (Array.isArray(obj)) return obj;
                    if (obj == null) return [];
                    var isArrayLike = _typeof(obj) == "object" && typeof obj.length == "number";
                    return isArrayLike ? arraySlice.call(obj) : [obj]
                }, utils2.removeFrom = function(ary, obj) {
                    var index = ary.indexOf(obj);
                    index != -1 && ary.splice(index, 1)
                }, utils2.getParent = function(elem, selector) {
                    for (; elem.parentNode && elem != document.body;)
                        if (elem = elem.parentNode, matchesSelector2(elem, selector)) return elem
                }, utils2.getQueryElement = function(elem) {
                    return typeof elem == "string" ? document.querySelector(elem) : elem
                }, utils2.handleEvent = function(event2) {
                    var method = "on" + event2.type;
                    this[method] && this[method](event2)
                }, utils2.filterFindElements = function(elems, selector) {
                    elems = utils2.makeArray(elems);
                    var ffElems = [];
                    return elems.forEach(function(elem) {
                        if (elem instanceof HTMLElement) {
                            if (!selector) {
                                ffElems.push(elem);
                                return
                            }
                            matchesSelector2(elem, selector) && ffElems.push(elem);
                            for (var childElems = elem.querySelectorAll(selector), i = 0; i < childElems.length; i++) ffElems.push(childElems[i])
                        }
                    }), ffElems
                }, utils2.debounceMethod = function(_class, methodName, threshold) {
                    threshold = threshold || 100;
                    var method = _class.prototype[methodName],
                        timeoutName = methodName + "Timeout";
                    _class.prototype[methodName] = function() {
                        var timeout = this[timeoutName];
                        clearTimeout(timeout);
                        var args = arguments,
                            _this = this;
                        this[timeoutName] = setTimeout(function() {
                            method.apply(_this, args), delete _this[timeoutName]
                        }, threshold)
                    }
                }, utils2.docReady = function(callback) {
                    var readyState = document.readyState;
                    readyState == "complete" || readyState == "interactive" ? setTimeout(callback) : document.addEventListener("DOMContentLoaded", callback)
                }, utils2.toDashed = function(str) {
                    return str.replace(/(.)([A-Z])/g, function(match, $1, $2) {
                        return $1 + "-" + $2
                    }).toLowerCase()
                };
                var console2 = window2.console;
                return utils2.htmlInit = function(WidgetClass, namespace) {
                    utils2.docReady(function() {
                        var dashedNamespace = utils2.toDashed(namespace),
                            dataAttr = "data-" + dashedNamespace,
                            dataAttrElems = document.querySelectorAll("[" + dataAttr + "]"),
                            jsDashElems = document.querySelectorAll(".js-" + dashedNamespace),
                            elems = utils2.makeArray(dataAttrElems).concat(utils2.makeArray(jsDashElems)),
                            dataOptionsAttr = dataAttr + "-options",
                            jQuery = window2.jQuery;
                        elems.forEach(function(elem) {
                            var attr = elem.getAttribute(dataAttr) || elem.getAttribute(dataOptionsAttr),
                                options;
                            try {
                                options = attr && JSON.parse(attr)
                            } catch (error) {
                                console2 && console2.error("Error parsing " + dataAttr + " on " + elem.className + ": " + error);
                                return
                            }
                            var instance = new WidgetClass(elem, options);
                            jQuery && jQuery.data(elem, namespace, instance)
                        })
                    })
                }, utils2
            })
        }),
        cell = createCommonjsModule(function(module) {
            (function(window2, factory) {
                module.exports ? module.exports = factory(window2, getSize) : (window2.Flickity = window2.Flickity || {}, window2.Flickity.Cell = factory(window2, window2.getSize))
            })(window, function(window2, getSize2) {
                function Cell(elem, parent) {
                    this.element = elem, this.parent = parent, this.create()
                }
                var proto = Cell.prototype;
                return proto.create = function() {
                    this.element.style.position = "absolute", this.element.setAttribute("aria-hidden", "true"), this.x = 0, this.shift = 0
                }, proto.destroy = function() {
                    this.unselect(), this.element.style.position = "";
                    var side = this.parent.originSide;
                    this.element.style[side] = ""
                }, proto.getSize = function() {
                    this.size = getSize2(this.element)
                }, proto.setPosition = function(x) {
                    this.x = x, this.updateTarget(), this.renderPosition(x)
                }, proto.updateTarget = proto.setDefaultTarget = function() {
                    var marginProperty = this.parent.originSide == "left" ? "marginLeft" : "marginRight";
                    this.target = this.x + this.size[marginProperty] + this.size.width * this.parent.cellAlign
                }, proto.renderPosition = function(x) {
                    var side = this.parent.originSide;
                    this.element.style[side] = this.parent.getPositionValue(x)
                }, proto.select = function() {
                    this.element.classList.add("is-selected"), this.element.removeAttribute("aria-hidden")
                }, proto.unselect = function() {
                    this.element.classList.remove("is-selected"), this.element.setAttribute("aria-hidden", "true")
                }, proto.wrapShift = function(shift) {
                    this.shift = shift, this.renderPosition(this.x + this.parent.slideableWidth * shift)
                }, proto.remove = function() {
                    this.element.parentNode.removeChild(this.element)
                }, Cell
            })
        }),
        slide = createCommonjsModule(function(module) {
            (function(window2, factory) {
                module.exports ? module.exports = factory() : (window2.Flickity = window2.Flickity || {}, window2.Flickity.Slide = factory())
            })(window, function() {
                function Slide(parent) {
                    this.parent = parent, this.isOriginLeft = parent.originSide == "left", this.cells = [], this.outerWidth = 0, this.height = 0
                }
                var proto = Slide.prototype;
                return proto.addCell = function(cell2) {
                    if (this.cells.push(cell2), this.outerWidth += cell2.size.outerWidth, this.height = Math.max(cell2.size.outerHeight, this.height), this.cells.length == 1) {
                        this.x = cell2.x;
                        var beginMargin = this.isOriginLeft ? "marginLeft" : "marginRight";
                        this.firstMargin = cell2.size[beginMargin]
                    }
                }, proto.updateTarget = function() {
                    var endMargin = this.isOriginLeft ? "marginRight" : "marginLeft",
                        lastCell = this.getLastCell(),
                        lastMargin = lastCell ? lastCell.size[endMargin] : 0,
                        slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
                    this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign
                }, proto.getLastCell = function() {
                    return this.cells[this.cells.length - 1]
                }, proto.select = function() {
                    this.cells.forEach(function(cell2) {
                        cell2.select()
                    })
                }, proto.unselect = function() {
                    this.cells.forEach(function(cell2) {
                        cell2.unselect()
                    })
                }, proto.getCellElements = function() {
                    return this.cells.map(function(cell2) {
                        return cell2.element
                    })
                }, Slide
            })
        }),
        animate = createCommonjsModule(function(module) {
            (function(window2, factory) {
                module.exports ? module.exports = factory(window2, utils) : (window2.Flickity = window2.Flickity || {}, window2.Flickity.animatePrototype = factory(window2, window2.fizzyUIUtils))
            })(window, function(window2, utils2) {
                var proto = {};
                return proto.startAnimation = function() {
                    this.isAnimating || (this.isAnimating = !0, this.restingFrames = 0, this.animate())
                }, proto.animate = function() {
                    this.applyDragForce(), this.applySelectedAttraction();
                    var previousX = this.x;
                    if (this.integratePhysics(), this.positionSlider(), this.settle(previousX), this.isAnimating) {
                        var _this = this;
                        requestAnimationFrame(function() {
                            _this.animate()
                        })
                    }
                }, proto.positionSlider = function() {
                    var x = this.x;
                    this.options.wrapAround && this.cells.length > 1 && (x = utils2.modulo(x, this.slideableWidth), x = x - this.slideableWidth, this.shiftWrapCells(x)), this.setTranslateX(x, this.isAnimating), this.dispatchScrollEvent()
                }, proto.setTranslateX = function(x, is3d) {
                    x += this.cursorPosition, x = this.options.rightToLeft ? -x : x;
                    var translateX = this.getPositionValue(x);
                    this.slider.style.transform = is3d ? "translate3d(" + translateX + ",0,0)" : "translateX(" + translateX + ")"
                }, proto.dispatchScrollEvent = function() {
                    var firstSlide = this.slides[0];
                    if (firstSlide) {
                        var positionX = -this.x - firstSlide.target,
                            progress = positionX / this.slidesWidth;
                        this.dispatchEvent("scroll", null, [progress, positionX])
                    }
                }, proto.positionSliderAtSelected = function() {
                    this.cells.length && (this.x = -this.selectedSlide.target, this.velocity = 0, this.positionSlider())
                }, proto.getPositionValue = function(position) {
                    return this.options.percentPosition ? Math.round(position / this.size.innerWidth * 1e4) * .01 + "%" : Math.round(position) + "px"
                }, proto.settle = function(previousX) {
                    !this.isPointerDown && Math.round(this.x * 100) == Math.round(previousX * 100) && this.restingFrames++, this.restingFrames > 2 && (this.isAnimating = !1, delete this.isFreeScrolling, this.positionSlider(), this.dispatchEvent("settle", null, [this.selectedIndex]))
                }, proto.shiftWrapCells = function(x) {
                    var beforeGap = this.cursorPosition + x;
                    this._shiftCells(this.beforeShiftCells, beforeGap, -1);
                    var afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
                    this._shiftCells(this.afterShiftCells, afterGap, 1)
                }, proto._shiftCells = function(cells, gap, shift) {
                    for (var i = 0; i < cells.length; i++) {
                        var cell2 = cells[i],
                            cellShift = gap > 0 ? shift : 0;
                        cell2.wrapShift(cellShift), gap -= cell2.size.outerWidth
                    }
                }, proto._unshiftCells = function(cells) {
                    if (!(!cells || !cells.length))
                        for (var i = 0; i < cells.length; i++) cells[i].wrapShift(0)
                }, proto.integratePhysics = function() {
                    this.x += this.velocity, this.velocity *= this.getFrictionFactor()
                }, proto.applyForce = function(force) {
                    this.velocity += force
                }, proto.getFrictionFactor = function() {
                    return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"]
                }, proto.getRestingPosition = function() {
                    return this.x + this.velocity / (1 - this.getFrictionFactor())
                }, proto.applyDragForce = function() {
                    if (!(!this.isDraggable || !this.isPointerDown)) {
                        var dragVelocity = this.dragX - this.x,
                            dragForce = dragVelocity - this.velocity;
                        this.applyForce(dragForce)
                    }
                }, proto.applySelectedAttraction = function() {
                    var dragDown = this.isDraggable && this.isPointerDown;
                    if (!(dragDown || this.isFreeScrolling || !this.slides.length)) {
                        var distance = this.selectedSlide.target * -1 - this.x,
                            force = distance * this.options.selectedAttraction;
                        this.applyForce(force)
                    }
                }, proto
            })
        }),
        flickity = createCommonjsModule(function(module) {
            (function(window2, factory) {
                if (module.exports) module.exports = factory(window2, evEmitter, getSize, utils, cell, slide, animate);
                else {
                    var _Flickity = window2.Flickity;
                    window2.Flickity = factory(window2, window2.EvEmitter, window2.getSize, window2.fizzyUIUtils, _Flickity.Cell, _Flickity.Slide, _Flickity.animatePrototype)
                }
            })(window, function(window2, EvEmitter, getSize2, utils2, Cell, Slide, animatePrototype) {
                var jQuery = window2.jQuery,
                    getComputedStyle2 = window2.getComputedStyle,
                    console2 = window2.console;

                function moveElements(elems, toElem) {
                    for (elems = utils2.makeArray(elems); elems.length;) toElem.appendChild(elems.shift())
                }
                var GUID = 0,
                    instances = {};

                function Flickity(element, options) {
                    var queryElement = utils2.getQueryElement(element);
                    if (!queryElement) {
                        console2 && console2.error("Bad element for Flickity: " + (queryElement || element));
                        return
                    }
                    if (this.element = queryElement, this.element.flickityGUID) {
                        var instance = instances[this.element.flickityGUID];
                        return instance.option(options), instance
                    }
                    jQuery && (this.$element = jQuery(this.element)), this.options = utils2.extend({}, this.constructor.defaults), this.option(options), this._create()
                }
                Flickity.defaults = {
                    accessibility: !0,
                    cellAlign: "center",
                    freeScrollFriction: .075,
                    friction: .28,
                    namespaceJQueryEvents: !0,
                    percentPosition: !0,
                    resize: !0,
                    selectedAttraction: .025,
                    setGallerySize: !0
                }, Flickity.createMethods = [];
                var proto = Flickity.prototype;
                utils2.extend(proto, EvEmitter.prototype), proto._create = function() {
                    var id = this.guid = ++GUID;
                    this.element.flickityGUID = id, instances[id] = this, this.selectedIndex = 0, this.restingFrames = 0, this.x = 0, this.velocity = 0, this.originSide = this.options.rightToLeft ? "right" : "left", this.viewport = document.createElement("div"), this.viewport.className = "flickity-viewport", this._createSlider(), (this.options.resize || this.options.watchCSS) && window2.addEventListener("resize", this);
                    for (var eventName in this.options.on) {
                        var listener = this.options.on[eventName];
                        this.on(eventName, listener)
                    }
                    Flickity.createMethods.forEach(function(method) {
                        this[method]()
                    }, this), this.options.watchCSS ? this.watchCSS() : this.activate()
                }, proto.option = function(opts) {
                    utils2.extend(this.options, opts)
                }, proto.activate = function() {
                    if (!this.isActive) {
                        this.isActive = !0, this.element.classList.add("flickity-enabled"), this.options.rightToLeft && this.element.classList.add("flickity-rtl"), this.getSize();
                        var cellElems = this._filterFindCellElements(this.element.children);
                        moveElements(cellElems, this.slider), this.viewport.appendChild(this.slider), this.element.appendChild(this.viewport), this.reloadCells(), this.options.accessibility && (this.element.tabIndex = 0, this.element.addEventListener("keydown", this)), this.emitEvent("activate"), this.selectInitialIndex(), this.isInitActivated = !0, this.dispatchEvent("ready")
                    }
                }, proto._createSlider = function() {
                    var slider = document.createElement("div");
                    slider.className = "flickity-slider", slider.style[this.originSide] = 0, this.slider = slider
                }, proto._filterFindCellElements = function(elems) {
                    return utils2.filterFindElements(elems, this.options.cellSelector)
                }, proto.reloadCells = function() {
                    this.cells = this._makeCells(this.slider.children), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize()
                }, proto._makeCells = function(elems) {
                    var cellElems = this._filterFindCellElements(elems),
                        cells = cellElems.map(function(cellElem) {
                            return new Cell(cellElem, this)
                        }, this);
                    return cells
                }, proto.getLastCell = function() {
                    return this.cells[this.cells.length - 1]
                }, proto.getLastSlide = function() {
                    return this.slides[this.slides.length - 1]
                }, proto.positionCells = function() {
                    this._sizeCells(this.cells), this._positionCells(0)
                }, proto._positionCells = function(index) {
                    index = index || 0, this.maxCellHeight = index && this.maxCellHeight || 0;
                    var cellX = 0;
                    if (index > 0) {
                        var startCell = this.cells[index - 1];
                        cellX = startCell.x + startCell.size.outerWidth
                    }
                    for (var len = this.cells.length, i = index; i < len; i++) {
                        var cell2 = this.cells[i];
                        cell2.setPosition(cellX), cellX += cell2.size.outerWidth, this.maxCellHeight = Math.max(cell2.size.outerHeight, this.maxCellHeight)
                    }
                    this.slideableWidth = cellX, this.updateSlides(), this._containSlides(), this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0
                }, proto._sizeCells = function(cells) {
                    cells.forEach(function(cell2) {
                        cell2.getSize()
                    })
                }, proto.updateSlides = function() {
                    if (this.slides = [], !!this.cells.length) {
                        var slide2 = new Slide(this);
                        this.slides.push(slide2);
                        var isOriginLeft = this.originSide == "left",
                            nextMargin = isOriginLeft ? "marginRight" : "marginLeft",
                            canCellFit = this._getCanCellFit();
                        this.cells.forEach(function(cell2, i) {
                            if (!slide2.cells.length) {
                                slide2.addCell(cell2);
                                return
                            }
                            var slideWidth = slide2.outerWidth - slide2.firstMargin + (cell2.size.outerWidth - cell2.size[nextMargin]);
                            canCellFit.call(this, i, slideWidth) || (slide2.updateTarget(), slide2 = new Slide(this), this.slides.push(slide2)), slide2.addCell(cell2)
                        }, this), slide2.updateTarget(), this.updateSelectedSlide()
                    }
                }, proto._getCanCellFit = function() {
                    var groupCells = this.options.groupCells;
                    if (groupCells) {
                        if (typeof groupCells == "number") {
                            var number = parseInt(groupCells, 10);
                            return function(i) {
                                return i % number !== 0
                            }
                        }
                    } else return function() {
                        return !1
                    };
                    var percentMatch = typeof groupCells == "string" && groupCells.match(/^(\d+)%$/),
                        percent = percentMatch ? parseInt(percentMatch[1], 10) / 100 : 1;
                    return function(i, slideWidth) {
                        return slideWidth <= (this.size.innerWidth + 1) * percent
                    }
                }, proto._init = proto.reposition = function() {
                    this.positionCells(), this.positionSliderAtSelected()
                }, proto.getSize = function() {
                    this.size = getSize2(this.element), this.setCellAlign(), this.cursorPosition = this.size.innerWidth * this.cellAlign
                };
                var cellAlignShorthands = {
                    center: {
                        left: .5,
                        right: .5
                    },
                    left: {
                        left: 0,
                        right: 1
                    },
                    right: {
                        right: 0,
                        left: 1
                    }
                };
                return proto.setCellAlign = function() {
                    var shorthand = cellAlignShorthands[this.options.cellAlign];
                    this.cellAlign = shorthand ? shorthand[this.originSide] : this.options.cellAlign
                }, proto.setGallerySize = function() {
                    if (this.options.setGallerySize) {
                        var height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
                        this.viewport.style.height = height + "px"
                    }
                }, proto._getWrapShiftCells = function() {
                    if (this.options.wrapAround) {
                        this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
                        var gapX = this.cursorPosition,
                            cellIndex = this.cells.length - 1;
                        this.beforeShiftCells = this._getGapCells(gapX, cellIndex, -1), gapX = this.size.innerWidth - this.cursorPosition, this.afterShiftCells = this._getGapCells(gapX, 0, 1)
                    }
                }, proto._getGapCells = function(gapX, cellIndex, increment) {
                    for (var cells = []; gapX > 0;) {
                        var cell2 = this.cells[cellIndex];
                        if (!cell2) break;
                        cells.push(cell2), cellIndex += increment, gapX -= cell2.size.outerWidth
                    }
                    return cells
                }, proto._containSlides = function() {
                    if (!(!this.options.contain || this.options.wrapAround || !this.cells.length)) {
                        var isRightToLeft = this.options.rightToLeft,
                            beginMargin = isRightToLeft ? "marginRight" : "marginLeft",
                            endMargin = isRightToLeft ? "marginLeft" : "marginRight",
                            contentWidth = this.slideableWidth - this.getLastCell().size[endMargin],
                            isContentSmaller = contentWidth < this.size.innerWidth,
                            beginBound = this.cursorPosition + this.cells[0].size[beginMargin],
                            endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
                        this.slides.forEach(function(slide2) {
                            isContentSmaller ? slide2.target = contentWidth * this.cellAlign : (slide2.target = Math.max(slide2.target, beginBound), slide2.target = Math.min(slide2.target, endBound))
                        }, this)
                    }
                }, proto.dispatchEvent = function(type, event2, args) {
                    var emitArgs = event2 ? [event2].concat(args) : args;
                    if (this.emitEvent(type, emitArgs), jQuery && this.$element) {
                        type += this.options.namespaceJQueryEvents ? ".flickity" : "";
                        var $event = type;
                        if (event2) {
                            var jQEvent = jQuery.Event(event2);
                            jQEvent.type = type, $event = jQEvent
                        }
                        this.$element.trigger($event, args)
                    }
                }, proto.select = function(index, isWrap, isInstant) {
                    if (this.isActive && (index = parseInt(index, 10), this._wrapSelect(index), (this.options.wrapAround || isWrap) && (index = utils2.modulo(index, this.slides.length)), !!this.slides[index])) {
                        var prevIndex = this.selectedIndex;
                        this.selectedIndex = index, this.updateSelectedSlide(), isInstant ? this.positionSliderAtSelected() : this.startAnimation(), this.options.adaptiveHeight && this.setGallerySize(), this.dispatchEvent("select", null, [index]), index != prevIndex && this.dispatchEvent("change", null, [index]), this.dispatchEvent("cellSelect")
                    }
                }, proto._wrapSelect = function(index) {
                    var len = this.slides.length,
                        isWrapping = this.options.wrapAround && len > 1;
                    if (!isWrapping) return index;
                    var wrapIndex = utils2.modulo(index, len),
                        delta = Math.abs(wrapIndex - this.selectedIndex),
                        backWrapDelta = Math.abs(wrapIndex + len - this.selectedIndex),
                        forewardWrapDelta = Math.abs(wrapIndex - len - this.selectedIndex);
                    !this.isDragSelect && backWrapDelta < delta ? index += len : !this.isDragSelect && forewardWrapDelta < delta && (index -= len), index < 0 ? this.x -= this.slideableWidth : index >= len && (this.x += this.slideableWidth)
                }, proto.previous = function(isWrap, isInstant) {
                    this.select(this.selectedIndex - 1, isWrap, isInstant)
                }, proto.next = function(isWrap, isInstant) {
                    this.select(this.selectedIndex + 1, isWrap, isInstant)
                }, proto.updateSelectedSlide = function() {
                    var slide2 = this.slides[this.selectedIndex];
                    slide2 && (this.unselectSelectedSlide(), this.selectedSlide = slide2, slide2.select(), this.selectedCells = slide2.cells, this.selectedElements = slide2.getCellElements(), this.selectedCell = slide2.cells[0], this.selectedElement = this.selectedElements[0])
                }, proto.unselectSelectedSlide = function() {
                    this.selectedSlide && this.selectedSlide.unselect()
                }, proto.selectInitialIndex = function() {
                    var initialIndex = this.options.initialIndex;
                    if (this.isInitActivated) {
                        this.select(this.selectedIndex, !1, !0);
                        return
                    }
                    if (initialIndex && typeof initialIndex == "string") {
                        var cell2 = this.queryCell(initialIndex);
                        if (cell2) {
                            this.selectCell(initialIndex, !1, !0);
                            return
                        }
                    }
                    var index = 0;
                    initialIndex && this.slides[initialIndex] && (index = initialIndex), this.select(index, !1, !0)
                }, proto.selectCell = function(value, isWrap, isInstant) {
                    var cell2 = this.queryCell(value);
                    if (cell2) {
                        var index = this.getCellSlideIndex(cell2);
                        this.select(index, isWrap, isInstant)
                    }
                }, proto.getCellSlideIndex = function(cell2) {
                    for (var i = 0; i < this.slides.length; i++) {
                        var slide2 = this.slides[i],
                            index = slide2.cells.indexOf(cell2);
                        if (index != -1) return i
                    }
                }, proto.getCell = function(elem) {
                    for (var i = 0; i < this.cells.length; i++) {
                        var cell2 = this.cells[i];
                        if (cell2.element == elem) return cell2
                    }
                }, proto.getCells = function(elems) {
                    elems = utils2.makeArray(elems);
                    var cells = [];
                    return elems.forEach(function(elem) {
                        var cell2 = this.getCell(elem);
                        cell2 && cells.push(cell2)
                    }, this), cells
                }, proto.getCellElements = function() {
                    return this.cells.map(function(cell2) {
                        return cell2.element
                    })
                }, proto.getParentCell = function(elem) {
                    var cell2 = this.getCell(elem);
                    return cell2 || (elem = utils2.getParent(elem, ".flickity-slider > *"), this.getCell(elem))
                }, proto.getAdjacentCellElements = function(adjCount, index) {
                    if (!adjCount) return this.selectedSlide.getCellElements();
                    index = index === void 0 ? this.selectedIndex : index;
                    var len = this.slides.length;
                    if (1 + adjCount * 2 >= len) return this.getCellElements();
                    for (var cellElems = [], i = index - adjCount; i <= index + adjCount; i++) {
                        var slideIndex = this.options.wrapAround ? utils2.modulo(i, len) : i,
                            slide2 = this.slides[slideIndex];
                        slide2 && (cellElems = cellElems.concat(slide2.getCellElements()))
                    }
                    return cellElems
                }, proto.queryCell = function(selector) {
                    if (typeof selector == "number") return this.cells[selector];
                    if (typeof selector == "string") {
                        if (selector.match(/^[#\.]?[\d\/]/)) return;
                        selector = this.element.querySelector(selector)
                    }
                    return this.getCell(selector)
                }, proto.uiChange = function() {
                    this.emitEvent("uiChange")
                }, proto.childUIPointerDown = function(event2) {
                    event2.type != "touchstart" && event2.preventDefault(), this.focus()
                }, proto.onresize = function() {
                    this.watchCSS(), this.resize()
                }, utils2.debounceMethod(Flickity, "onresize", 150), proto.resize = function() {
                    if (this.isActive) {
                        this.getSize(), this.options.wrapAround && (this.x = utils2.modulo(this.x, this.slideableWidth)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize(), this.emitEvent("resize");
                        var selectedElement = this.selectedElements && this.selectedElements[0];
                        this.selectCell(selectedElement, !1, !0)
                    }
                }, proto.watchCSS = function() {
                    var watchOption = this.options.watchCSS;
                    if (watchOption) {
                        var afterContent = getComputedStyle2(this.element, ":after").content;
                        afterContent.indexOf("flickity") != -1 ? this.activate() : this.deactivate()
                    }
                }, proto.onkeydown = function(event2) {
                    var isNotFocused = document.activeElement && document.activeElement != this.element;
                    if (!(!this.options.accessibility || isNotFocused)) {
                        var handler = Flickity.keyboardHandlers[event2.keyCode];
                        handler && handler.call(this)
                    }
                }, Flickity.keyboardHandlers = {
                    37: function() {
                        var leftMethod = this.options.rightToLeft ? "next" : "previous";
                        this.uiChange(), this[leftMethod]()
                    },
                    39: function() {
                        var rightMethod = this.options.rightToLeft ? "previous" : "next";
                        this.uiChange(), this[rightMethod]()
                    }
                }, proto.focus = function() {
                    var prevScrollY = window2.pageYOffset;
                    this.element.focus({
                        preventScroll: !0
                    }), window2.pageYOffset != prevScrollY && window2.scrollTo(window2.pageXOffset, prevScrollY)
                }, proto.deactivate = function() {
                    this.isActive && (this.element.classList.remove("flickity-enabled"), this.element.classList.remove("flickity-rtl"), this.unselectSelectedSlide(), this.cells.forEach(function(cell2) {
                        cell2.destroy()
                    }), this.element.removeChild(this.viewport), moveElements(this.slider.children, this.element), this.options.accessibility && (this.element.removeAttribute("tabIndex"), this.element.removeEventListener("keydown", this)), this.isActive = !1, this.emitEvent("deactivate"))
                }, proto.destroy = function() {
                    this.deactivate(), window2.removeEventListener("resize", this), this.allOff(), this.emitEvent("destroy"), jQuery && this.$element && jQuery.removeData(this.element, "flickity"), delete this.element.flickityGUID, delete instances[this.guid]
                }, utils2.extend(proto, animatePrototype), Flickity.data = function(elem) {
                    elem = utils2.getQueryElement(elem);
                    var id = elem && elem.flickityGUID;
                    return id && instances[id]
                }, utils2.htmlInit(Flickity, "flickity"), jQuery && jQuery.bridget && jQuery.bridget("flickity", Flickity), Flickity.setJQuery = function(jq) {
                    jQuery = jq
                }, Flickity.Cell = Cell, Flickity.Slide = Slide, Flickity
            })
        }),
        unipointer = createCommonjsModule(function(module) {
            /*!
             * Unipointer v2.3.0
             * base class for doing one thing with pointer event
             * MIT license
             */
            (function(window2, factory) {
                module.exports ? module.exports = factory(window2, evEmitter) : window2.Unipointer = factory(window2, window2.EvEmitter)
            })(window, function(window2, EvEmitter) {
                function noop() {}

                function Unipointer() {}
                var proto = Unipointer.prototype = Object.create(EvEmitter.prototype);
                proto.bindStartEvent = function(elem) {
                    this._bindStartEvent(elem, !0)
                }, proto.unbindStartEvent = function(elem) {
                    this._bindStartEvent(elem, !1)
                }, proto._bindStartEvent = function(elem, isAdd) {
                    isAdd = isAdd === void 0 ? !0 : isAdd;
                    var bindMethod = isAdd ? "addEventListener" : "removeEventListener",
                        startEvent = "mousedown";
                    window2.PointerEvent ? startEvent = "pointerdown" : "ontouchstart" in window2 && (startEvent = "touchstart"), elem[bindMethod](startEvent, this)
                }, proto.handleEvent = function(event2) {
                    var method = "on" + event2.type;
                    this[method] && this[method](event2)
                }, proto.getTouch = function(touches) {
                    for (var i = 0; i < touches.length; i++) {
                        var touch = touches[i];
                        if (touch.identifier == this.pointerIdentifier) return touch
                    }
                }, proto.onmousedown = function(event2) {
                    var button = event2.button;
                    button && button !== 0 && button !== 1 || this._pointerDown(event2, event2)
                }, proto.ontouchstart = function(event2) {
                    this._pointerDown(event2, event2.changedTouches[0])
                }, proto.onpointerdown = function(event2) {
                    this._pointerDown(event2, event2)
                }, proto._pointerDown = function(event2, pointer) {
                    event2.button || this.isPointerDown || (this.isPointerDown = !0, this.pointerIdentifier = pointer.pointerId !== void 0 ? pointer.pointerId : pointer.identifier, this.pointerDown(event2, pointer))
                }, proto.pointerDown = function(event2, pointer) {
                    this._bindPostStartEvents(event2), this.emitEvent("pointerDown", [event2, pointer])
                };
                var postStartEvents = {
                    mousedown: ["mousemove", "mouseup"],
                    touchstart: ["touchmove", "touchend", "touchcancel"],
                    pointerdown: ["pointermove", "pointerup", "pointercancel"]
                };
                return proto._bindPostStartEvents = function(event2) {
                    if (event2) {
                        var events = postStartEvents[event2.type];
                        events.forEach(function(eventName) {
                            window2.addEventListener(eventName, this)
                        }, this), this._boundPointerEvents = events
                    }
                }, proto._unbindPostStartEvents = function() {
                    this._boundPointerEvents && (this._boundPointerEvents.forEach(function(eventName) {
                        window2.removeEventListener(eventName, this)
                    }, this), delete this._boundPointerEvents)
                }, proto.onmousemove = function(event2) {
                    this._pointerMove(event2, event2)
                }, proto.onpointermove = function(event2) {
                    event2.pointerId == this.pointerIdentifier && this._pointerMove(event2, event2)
                }, proto.ontouchmove = function(event2) {
                    var touch = this.getTouch(event2.changedTouches);
                    touch && this._pointerMove(event2, touch)
                }, proto._pointerMove = function(event2, pointer) {
                    this.pointerMove(event2, pointer)
                }, proto.pointerMove = function(event2, pointer) {
                    this.emitEvent("pointerMove", [event2, pointer])
                }, proto.onmouseup = function(event2) {
                    this._pointerUp(event2, event2)
                }, proto.onpointerup = function(event2) {
                    event2.pointerId == this.pointerIdentifier && this._pointerUp(event2, event2)
                }, proto.ontouchend = function(event2) {
                    var touch = this.getTouch(event2.changedTouches);
                    touch && this._pointerUp(event2, touch)
                }, proto._pointerUp = function(event2, pointer) {
                    this._pointerDone(), this.pointerUp(event2, pointer)
                }, proto.pointerUp = function(event2, pointer) {
                    this.emitEvent("pointerUp", [event2, pointer])
                }, proto._pointerDone = function() {
                    this._pointerReset(), this._unbindPostStartEvents(), this.pointerDone()
                }, proto._pointerReset = function() {
                    this.isPointerDown = !1, delete this.pointerIdentifier
                }, proto.pointerDone = noop, proto.onpointercancel = function(event2) {
                    event2.pointerId == this.pointerIdentifier && this._pointerCancel(event2, event2)
                }, proto.ontouchcancel = function(event2) {
                    var touch = this.getTouch(event2.changedTouches);
                    touch && this._pointerCancel(event2, touch)
                }, proto._pointerCancel = function(event2, pointer) {
                    this._pointerDone(), this.pointerCancel(event2, pointer)
                }, proto.pointerCancel = function(event2, pointer) {
                    this.emitEvent("pointerCancel", [event2, pointer])
                }, Unipointer.getPointerPoint = function(pointer) {
                    return {
                        x: pointer.pageX,
                        y: pointer.pageY
                    }
                }, Unipointer
            })
        }),
        unidragger = createCommonjsModule(function(module) {
            /*!
             * Unidragger v2.3.1
             * Draggable base class
             * MIT license
             */
            (function(window2, factory) {
                module.exports ? module.exports = factory(window2, unipointer) : window2.Unidragger = factory(window2, window2.Unipointer)
            })(window, function(window2, Unipointer) {
                function Unidragger() {}
                var proto = Unidragger.prototype = Object.create(Unipointer.prototype);
                proto.bindHandles = function() {
                    this._bindHandles(!0)
                }, proto.unbindHandles = function() {
                    this._bindHandles(!1)
                }, proto._bindHandles = function(isAdd) {
                    isAdd = isAdd === void 0 ? !0 : isAdd;
                    for (var bindMethod = isAdd ? "addEventListener" : "removeEventListener", touchAction = isAdd ? this._touchActionValue : "", i = 0; i < this.handles.length; i++) {
                        var handle = this.handles[i];
                        this._bindStartEvent(handle, isAdd), handle[bindMethod]("click", this), window2.PointerEvent && (handle.style.touchAction = touchAction)
                    }
                }, proto._touchActionValue = "none", proto.pointerDown = function(event2, pointer) {
                    var isOkay = this.okayPointerDown(event2);
                    isOkay && (this.pointerDownPointer = {
                        pageX: pointer.pageX,
                        pageY: pointer.pageY
                    }, event2.preventDefault(), this.pointerDownBlur(), this._bindPostStartEvents(event2), this.emitEvent("pointerDown", [event2, pointer]))
                };
                var cursorNodes = {
                        TEXTAREA: !0,
                        INPUT: !0,
                        SELECT: !0,
                        OPTION: !0
                    },
                    clickTypes = {
                        radio: !0,
                        checkbox: !0,
                        button: !0,
                        submit: !0,
                        image: !0,
                        file: !0
                    };
                return proto.okayPointerDown = function(event2) {
                    var isCursorNode = cursorNodes[event2.target.nodeName],
                        isClickType = clickTypes[event2.target.type],
                        isOkay = !isCursorNode || isClickType;
                    return isOkay || this._pointerReset(), isOkay
                }, proto.pointerDownBlur = function() {
                    var focused = document.activeElement,
                        canBlur = focused && focused.blur && focused != document.body;
                    canBlur && focused.blur()
                }, proto.pointerMove = function(event2, pointer) {
                    var moveVector = this._dragPointerMove(event2, pointer);
                    this.emitEvent("pointerMove", [event2, pointer, moveVector]), this._dragMove(event2, pointer, moveVector)
                }, proto._dragPointerMove = function(event2, pointer) {
                    var moveVector = {
                        x: pointer.pageX - this.pointerDownPointer.pageX,
                        y: pointer.pageY - this.pointerDownPointer.pageY
                    };
                    return !this.isDragging && this.hasDragStarted(moveVector) && this._dragStart(event2, pointer), moveVector
                }, proto.hasDragStarted = function(moveVector) {
                    return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3
                }, proto.pointerUp = function(event2, pointer) {
                    this.emitEvent("pointerUp", [event2, pointer]), this._dragPointerUp(event2, pointer)
                }, proto._dragPointerUp = function(event2, pointer) {
                    this.isDragging ? this._dragEnd(event2, pointer) : this._staticClick(event2, pointer)
                }, proto._dragStart = function(event2, pointer) {
                    this.isDragging = !0, this.isPreventingClicks = !0, this.dragStart(event2, pointer)
                }, proto.dragStart = function(event2, pointer) {
                    this.emitEvent("dragStart", [event2, pointer])
                }, proto._dragMove = function(event2, pointer, moveVector) {
                    this.isDragging && this.dragMove(event2, pointer, moveVector)
                }, proto.dragMove = function(event2, pointer, moveVector) {
                    event2.preventDefault(), this.emitEvent("dragMove", [event2, pointer, moveVector])
                }, proto._dragEnd = function(event2, pointer) {
                    this.isDragging = !1, setTimeout(function() {
                        delete this.isPreventingClicks
                    }.bind(this)), this.dragEnd(event2, pointer)
                }, proto.dragEnd = function(event2, pointer) {
                    this.emitEvent("dragEnd", [event2, pointer])
                }, proto.onclick = function(event2) {
                    this.isPreventingClicks && event2.preventDefault()
                }, proto._staticClick = function(event2, pointer) {
                    this.isIgnoringMouseUp && event2.type == "mouseup" || (this.staticClick(event2, pointer), event2.type != "mouseup" && (this.isIgnoringMouseUp = !0, setTimeout(function() {
                        delete this.isIgnoringMouseUp
                    }.bind(this), 400)))
                }, proto.staticClick = function(event2, pointer) {
                    this.emitEvent("staticClick", [event2, pointer])
                }, Unidragger.getPointerPoint = Unipointer.getPointerPoint, Unidragger
            })
        }),
        drag = createCommonjsModule(function(module) {
            (function(window2, factory) {
                module.exports ? module.exports = factory(window2, flickity, unidragger, utils) : window2.Flickity = factory(window2, window2.Flickity, window2.Unidragger, window2.fizzyUIUtils)
            })(window, function(window2, Flickity, Unidragger, utils2) {
                utils2.extend(Flickity.defaults, {
                    draggable: ">1",
                    dragThreshold: 3
                }), Flickity.createMethods.push("_createDrag");
                var proto = Flickity.prototype;
                utils2.extend(proto, Unidragger.prototype), proto._touchActionValue = "pan-y";
                var isTouch = "createTouch" in document,
                    isTouchmoveScrollCanceled = !1;
                proto._createDrag = function() {
                    this.on("activate", this.onActivateDrag), this.on("uiChange", this._uiChangeDrag), this.on("deactivate", this.onDeactivateDrag), this.on("cellChange", this.updateDraggable), isTouch && !isTouchmoveScrollCanceled && (window2.addEventListener("touchmove", function() {}), isTouchmoveScrollCanceled = !0)
                }, proto.onActivateDrag = function() {
                    this.handles = [this.viewport], this.bindHandles(), this.updateDraggable()
                }, proto.onDeactivateDrag = function() {
                    this.unbindHandles(), this.element.classList.remove("is-draggable")
                }, proto.updateDraggable = function() {
                    this.options.draggable == ">1" ? this.isDraggable = this.slides.length > 1 : this.isDraggable = this.options.draggable, this.isDraggable ? this.element.classList.add("is-draggable") : this.element.classList.remove("is-draggable")
                }, proto.bindDrag = function() {
                    this.options.draggable = !0, this.updateDraggable()
                }, proto.unbindDrag = function() {
                    this.options.draggable = !1, this.updateDraggable()
                }, proto._uiChangeDrag = function() {
                    delete this.isFreeScrolling
                }, proto.pointerDown = function(event2, pointer) {
                    if (!this.isDraggable) {
                        this._pointerDownDefault(event2, pointer);
                        return
                    }
                    var isOkay = this.okayPointerDown(event2);
                    isOkay && (this._pointerDownPreventDefault(event2), this.pointerDownFocus(event2), document.activeElement != this.element && this.pointerDownBlur(), this.dragX = this.x, this.viewport.classList.add("is-pointer-down"), this.pointerDownScroll = getScrollPosition(), window2.addEventListener("scroll", this), this._pointerDownDefault(event2, pointer))
                }, proto._pointerDownDefault = function(event2, pointer) {
                    this.pointerDownPointer = {
                        pageX: pointer.pageX,
                        pageY: pointer.pageY
                    }, this._bindPostStartEvents(event2), this.dispatchEvent("pointerDown", event2, [pointer])
                };
                var focusNodes = {
                    INPUT: !0,
                    TEXTAREA: !0,
                    SELECT: !0
                };
                proto.pointerDownFocus = function(event2) {
                    var isFocusNode = focusNodes[event2.target.nodeName];
                    isFocusNode || this.focus()
                }, proto._pointerDownPreventDefault = function(event2) {
                    var isTouchStart = event2.type == "touchstart",
                        isTouchPointer = event2.pointerType == "touch",
                        isFocusNode = focusNodes[event2.target.nodeName];
                    !isTouchStart && !isTouchPointer && !isFocusNode && event2.preventDefault()
                }, proto.hasDragStarted = function(moveVector) {
                    return Math.abs(moveVector.x) > this.options.dragThreshold
                }, proto.pointerUp = function(event2, pointer) {
                    delete this.isTouchScrolling, this.viewport.classList.remove("is-pointer-down"), this.dispatchEvent("pointerUp", event2, [pointer]), this._dragPointerUp(event2, pointer)
                }, proto.pointerDone = function() {
                    window2.removeEventListener("scroll", this), delete this.pointerDownScroll
                }, proto.dragStart = function(event2, pointer) {
                    this.isDraggable && (this.dragStartPosition = this.x, this.startAnimation(), window2.removeEventListener("scroll", this), this.dispatchEvent("dragStart", event2, [pointer]))
                }, proto.pointerMove = function(event2, pointer) {
                    var moveVector = this._dragPointerMove(event2, pointer);
                    this.dispatchEvent("pointerMove", event2, [pointer, moveVector]), this._dragMove(event2, pointer, moveVector)
                }, proto.dragMove = function(event2, pointer, moveVector) {
                    if (this.isDraggable) {
                        event2.preventDefault(), this.previousDragX = this.dragX;
                        var direction = this.options.rightToLeft ? -1 : 1;
                        this.options.wrapAround && (moveVector.x = moveVector.x % this.slideableWidth);
                        var dragX = this.dragStartPosition + moveVector.x * direction;
                        if (!this.options.wrapAround && this.slides.length) {
                            var originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
                            dragX = dragX > originBound ? (dragX + originBound) * .5 : dragX;
                            var endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
                            dragX = dragX < endBound ? (dragX + endBound) * .5 : dragX
                        }
                        this.dragX = dragX, this.dragMoveTime = new Date, this.dispatchEvent("dragMove", event2, [pointer, moveVector])
                    }
                }, proto.dragEnd = function(event2, pointer) {
                    if (this.isDraggable) {
                        this.options.freeScroll && (this.isFreeScrolling = !0);
                        var index = this.dragEndRestingSelect();
                        if (this.options.freeScroll && !this.options.wrapAround) {
                            var restingX = this.getRestingPosition();
                            this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target
                        } else !this.options.freeScroll && index == this.selectedIndex && (index += this.dragEndBoostSelect());
                        delete this.previousDragX, this.isDragSelect = this.options.wrapAround, this.select(index), delete this.isDragSelect, this.dispatchEvent("dragEnd", event2, [pointer])
                    }
                }, proto.dragEndRestingSelect = function() {
                    var restingX = this.getRestingPosition(),
                        distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex)),
                        positiveResting = this._getClosestResting(restingX, distance, 1),
                        negativeResting = this._getClosestResting(restingX, distance, -1),
                        index = positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
                    return index
                }, proto._getClosestResting = function(restingX, distance, increment) {
                    for (var index = this.selectedIndex, minDistance = 1 / 0, condition = this.options.contain && !this.options.wrapAround ? function(d, md) {
                            return d <= md
                        } : function(d, md) {
                            return d < md
                        }; condition(distance, minDistance) && (index += increment, minDistance = distance, distance = this.getSlideDistance(-restingX, index), distance !== null);) distance = Math.abs(distance);
                    return {
                        distance: minDistance,
                        index: index - increment
                    }
                }, proto.getSlideDistance = function(x, index) {
                    var len = this.slides.length,
                        isWrapAround = this.options.wrapAround && len > 1,
                        slideIndex = isWrapAround ? utils2.modulo(index, len) : index,
                        slide2 = this.slides[slideIndex];
                    if (!slide2) return null;
                    var wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
                    return x - (slide2.target + wrap)
                }, proto.dragEndBoostSelect = function() {
                    if (this.previousDragX === void 0 || !this.dragMoveTime || new Date - this.dragMoveTime > 100) return 0;
                    var distance = this.getSlideDistance(-this.dragX, this.selectedIndex),
                        delta = this.previousDragX - this.dragX;
                    return distance > 0 && delta > 0 ? 1 : distance < 0 && delta < 0 ? -1 : 0
                }, proto.staticClick = function(event2, pointer) {
                    var clickedCell = this.getParentCell(event2.target),
                        cellElem = clickedCell && clickedCell.element,
                        cellIndex = clickedCell && this.cells.indexOf(clickedCell);
                    this.dispatchEvent("staticClick", event2, [pointer, cellElem, cellIndex])
                }, proto.onscroll = function() {
                    var scroll = getScrollPosition(),
                        scrollMoveX = this.pointerDownScroll.x - scroll.x,
                        scrollMoveY = this.pointerDownScroll.y - scroll.y;
                    (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) && this._pointerDone()
                };

                function getScrollPosition() {
                    return {
                        x: window2.pageXOffset,
                        y: window2.pageYOffset
                    }
                }
                return Flickity
            })
        }),
        prevNextButton = createCommonjsModule(function(module) {
            (function(window2, factory) {
                module.exports ? module.exports = factory(window2, flickity, unipointer, utils) : factory(window2, window2.Flickity, window2.Unipointer, window2.fizzyUIUtils)
            })(window, function(window2, Flickity, Unipointer, utils2) {
                var svgURI = "http://www.w3.org/2000/svg";

                function PrevNextButton(direction, parent) {
                    this.direction = direction, this.parent = parent, this._create()
                }
                PrevNextButton.prototype = Object.create(Unipointer.prototype), PrevNextButton.prototype._create = function() {
                    this.isEnabled = !0, this.isPrevious = this.direction == -1;
                    var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
                    this.isLeft = this.direction == leftDirection;
                    var element = this.element = document.createElement("button");
                    element.className = "flickity-button flickity-prev-next-button", element.className += this.isPrevious ? " previous" : " next", element.setAttribute("type", "button"), this.disable(), element.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
                    var svg = this.createSVG();
                    element.appendChild(svg), this.parent.on("select", this.update.bind(this)), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
                }, PrevNextButton.prototype.activate = function() {
                    this.bindStartEvent(this.element), this.element.addEventListener("click", this), this.parent.element.appendChild(this.element)
                }, PrevNextButton.prototype.deactivate = function() {
                    this.parent.element.removeChild(this.element), this.unbindStartEvent(this.element), this.element.removeEventListener("click", this)
                }, PrevNextButton.prototype.createSVG = function() {
                    var svg = document.createElementNS(svgURI, "svg");
                    svg.setAttribute("class", "flickity-button-icon"), svg.setAttribute("viewBox", "0 0 100 100");
                    var path = document.createElementNS(svgURI, "path"),
                        pathMovements = getArrowMovements(this.parent.options.arrowShape);
                    return path.setAttribute("d", pathMovements), path.setAttribute("class", "arrow"), this.isLeft || path.setAttribute("transform", "translate(100, 100) rotate(180) "), svg.appendChild(path), svg
                };

                function getArrowMovements(shape) {
                    return typeof shape == "string" ? shape : "M " + shape.x0 + ",50 L " + shape.x1 + "," + (shape.y1 + 50) + " L " + shape.x2 + "," + (shape.y2 + 50) + " L " + shape.x3 + ",50  L " + shape.x2 + "," + (50 - shape.y2) + " L " + shape.x1 + "," + (50 - shape.y1) + " Z"
                }
                PrevNextButton.prototype.handleEvent = utils2.handleEvent, PrevNextButton.prototype.onclick = function() {
                    if (this.isEnabled) {
                        this.parent.uiChange();
                        var method = this.isPrevious ? "previous" : "next";
                        this.parent[method]()
                    }
                }, PrevNextButton.prototype.enable = function() {
                    this.isEnabled || (this.element.disabled = !1, this.isEnabled = !0)
                }, PrevNextButton.prototype.disable = function() {
                    this.isEnabled && (this.element.disabled = !0, this.isEnabled = !1)
                }, PrevNextButton.prototype.update = function() {
                    var slides = this.parent.slides;
                    if (this.parent.options.wrapAround && slides.length > 1) {
                        this.enable();
                        return
                    }
                    var lastIndex = slides.length ? slides.length - 1 : 0,
                        boundIndex = this.isPrevious ? 0 : lastIndex,
                        method = this.parent.selectedIndex == boundIndex ? "disable" : "enable";
                    this[method]()
                }, PrevNextButton.prototype.destroy = function() {
                    this.deactivate(), this.allOff()
                }, utils2.extend(Flickity.defaults, {
                    prevNextButtons: !0,
                    arrowShape: {
                        x0: 10,
                        x1: 60,
                        y1: 50,
                        x2: 70,
                        y2: 40,
                        x3: 30
                    }
                }), Flickity.createMethods.push("_createPrevNextButtons");
                var proto = Flickity.prototype;
                return proto._createPrevNextButtons = function() {
                    this.options.prevNextButtons && (this.prevButton = new PrevNextButton(-1, this), this.nextButton = new PrevNextButton(1, this), this.on("activate", this.activatePrevNextButtons))
                }, proto.activatePrevNextButtons = function() {
                    this.prevButton.activate(), this.nextButton.activate(), this.on("deactivate", this.deactivatePrevNextButtons)
                }, proto.deactivatePrevNextButtons = function() {
                    this.prevButton.deactivate(), this.nextButton.deactivate(), this.off("deactivate", this.deactivatePrevNextButtons)
                }, Flickity.PrevNextButton = PrevNextButton, Flickity
            })
        }),
        pageDots = createCommonjsModule(function(module) {
            (function(window2, factory) {
                module.exports ? module.exports = factory(window2, flickity, unipointer, utils) : factory(window2, window2.Flickity, window2.Unipointer, window2.fizzyUIUtils)
            })(window, function(window2, Flickity, Unipointer, utils2) {
                function PageDots(parent) {
                    this.parent = parent, this._create()
                }
                PageDots.prototype = Object.create(Unipointer.prototype), PageDots.prototype._create = function() {
                    this.holder = document.createElement("ol"), this.holder.className = "flickity-page-dots", this.dots = [], this.handleClick = this.onClick.bind(this), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
                }, PageDots.prototype.activate = function() {
                    this.setDots(), this.holder.addEventListener("click", this.handleClick), this.bindStartEvent(this.holder), this.parent.element.appendChild(this.holder)
                }, PageDots.prototype.deactivate = function() {
                    this.holder.removeEventListener("click", this.handleClick), this.unbindStartEvent(this.holder), this.parent.element.removeChild(this.holder)
                }, PageDots.prototype.setDots = function() {
                    var delta = this.parent.slides.length - this.dots.length;
                    delta > 0 ? this.addDots(delta) : delta < 0 && this.removeDots(-delta)
                }, PageDots.prototype.addDots = function(count) {
                    for (var fragment = document.createDocumentFragment(), newDots = [], length = this.dots.length, max = length + count, i = length; i < max; i++) {
                        var dot = document.createElement("li");
                        dot.className = "dot", dot.setAttribute("aria-label", "Page dot " + (i + 1)), fragment.appendChild(dot), newDots.push(dot)
                    }
                    this.holder.appendChild(fragment), this.dots = this.dots.concat(newDots)
                }, PageDots.prototype.removeDots = function(count) {
                    var removeDots = this.dots.splice(this.dots.length - count, count);
                    removeDots.forEach(function(dot) {
                        this.holder.removeChild(dot)
                    }, this)
                }, PageDots.prototype.updateSelected = function() {
                    this.selectedDot && (this.selectedDot.className = "dot", this.selectedDot.removeAttribute("aria-current")), this.dots.length && (this.selectedDot = this.dots[this.parent.selectedIndex], this.selectedDot.className = "dot is-selected", this.selectedDot.setAttribute("aria-current", "step"))
                }, PageDots.prototype.onTap = PageDots.prototype.onClick = function(event2) {
                    var target = event2.target;
                    if (target.nodeName == "LI") {
                        this.parent.uiChange();
                        var index = this.dots.indexOf(target);
                        this.parent.select(index)
                    }
                }, PageDots.prototype.destroy = function() {
                    this.deactivate(), this.allOff()
                }, Flickity.PageDots = PageDots, utils2.extend(Flickity.defaults, {
                    pageDots: !0
                }), Flickity.createMethods.push("_createPageDots");
                var proto = Flickity.prototype;
                return proto._createPageDots = function() {
                    this.options.pageDots && (this.pageDots = new PageDots(this), this.on("activate", this.activatePageDots), this.on("select", this.updateSelectedPageDots), this.on("cellChange", this.updatePageDots), this.on("resize", this.updatePageDots), this.on("deactivate", this.deactivatePageDots))
                }, proto.activatePageDots = function() {
                    this.pageDots.activate()
                }, proto.updateSelectedPageDots = function() {
                    this.pageDots.updateSelected()
                }, proto.updatePageDots = function() {
                    this.pageDots.setDots()
                }, proto.deactivatePageDots = function() {
                    this.pageDots.deactivate()
                }, Flickity.PageDots = PageDots, Flickity
            })
        }),
        player = createCommonjsModule(function(module) {
            (function(window2, factory) {
                module.exports ? module.exports = factory(evEmitter, utils, flickity) : factory(window2.EvEmitter, window2.fizzyUIUtils, window2.Flickity)
            })(window, function(EvEmitter, utils2, Flickity) {
                function Player(parent) {
                    this.parent = parent, this.state = "stopped", this.onVisibilityChange = this.visibilityChange.bind(this), this.onVisibilityPlay = this.visibilityPlay.bind(this)
                }
                Player.prototype = Object.create(EvEmitter.prototype), Player.prototype.play = function() {
                    if (this.state != "playing") {
                        var isPageHidden = document.hidden;
                        if (isPageHidden) {
                            document.addEventListener("visibilitychange", this.onVisibilityPlay);
                            return
                        }
                        this.state = "playing", document.addEventListener("visibilitychange", this.onVisibilityChange), this.tick()
                    }
                }, Player.prototype.tick = function() {
                    if (this.state == "playing") {
                        var time = this.parent.options.autoPlay;
                        time = typeof time == "number" ? time : 3e3;
                        var _this = this;
                        this.clear(), this.timeout = setTimeout(function() {
                            _this.parent.next(!0), _this.tick()
                        }, time)
                    }
                }, Player.prototype.stop = function() {
                    this.state = "stopped", this.clear(), document.removeEventListener("visibilitychange", this.onVisibilityChange)
                }, Player.prototype.clear = function() {
                    clearTimeout(this.timeout)
                }, Player.prototype.pause = function() {
                    this.state == "playing" && (this.state = "paused", this.clear())
                }, Player.prototype.unpause = function() {
                    this.state == "paused" && this.play()
                }, Player.prototype.visibilityChange = function() {
                    var isPageHidden = document.hidden;
                    this[isPageHidden ? "pause" : "unpause"]()
                }, Player.prototype.visibilityPlay = function() {
                    this.play(), document.removeEventListener("visibilitychange", this.onVisibilityPlay)
                }, utils2.extend(Flickity.defaults, {
                    pauseAutoPlayOnHover: !0
                }), Flickity.createMethods.push("_createPlayer");
                var proto = Flickity.prototype;
                return proto._createPlayer = function() {
                    this.player = new Player(this), this.on("activate", this.activatePlayer), this.on("uiChange", this.stopPlayer), this.on("pointerDown", this.stopPlayer), this.on("deactivate", this.deactivatePlayer)
                }, proto.activatePlayer = function() {
                    this.options.autoPlay && (this.player.play(), this.element.addEventListener("mouseenter", this))
                }, proto.playPlayer = function() {
                    this.player.play()
                }, proto.stopPlayer = function() {
                    this.player.stop()
                }, proto.pausePlayer = function() {
                    this.player.pause()
                }, proto.unpausePlayer = function() {
                    this.player.unpause()
                }, proto.deactivatePlayer = function() {
                    this.player.stop(), this.element.removeEventListener("mouseenter", this)
                }, proto.onmouseenter = function() {
                    this.options.pauseAutoPlayOnHover && (this.player.pause(), this.element.addEventListener("mouseleave", this))
                }, proto.onmouseleave = function() {
                    this.player.unpause(), this.element.removeEventListener("mouseleave", this)
                }, Flickity.Player = Player, Flickity
            })
        }),
        addRemoveCell = createCommonjsModule(function(module) {
            (function(window2, factory) {
                module.exports ? module.exports = factory(window2, flickity, utils) : factory(window2, window2.Flickity, window2.fizzyUIUtils)
            })(window, function(window2, Flickity, utils2) {
                function getCellsFragment(cells) {
                    var fragment = document.createDocumentFragment();
                    return cells.forEach(function(cell2) {
                        fragment.appendChild(cell2.element)
                    }), fragment
                }
                var proto = Flickity.prototype;
                return proto.insert = function(elems, index) {
                    var cells = this._makeCells(elems);
                    if (!(!cells || !cells.length)) {
                        var len = this.cells.length;
                        index = index === void 0 ? len : index;
                        var fragment = getCellsFragment(cells),
                            isAppend = index == len;
                        if (isAppend) this.slider.appendChild(fragment);
                        else {
                            var insertCellElement = this.cells[index].element;
                            this.slider.insertBefore(fragment, insertCellElement)
                        }
                        if (index === 0) this.cells = cells.concat(this.cells);
                        else if (isAppend) this.cells = this.cells.concat(cells);
                        else {
                            var endCells = this.cells.splice(index, len - index);
                            this.cells = this.cells.concat(cells).concat(endCells)
                        }
                        this._sizeCells(cells), this.cellChange(index, !0)
                    }
                }, proto.append = function(elems) {
                    this.insert(elems, this.cells.length)
                }, proto.prepend = function(elems) {
                    this.insert(elems, 0)
                }, proto.remove = function(elems) {
                    var cells = this.getCells(elems);
                    if (!(!cells || !cells.length)) {
                        var minCellIndex = this.cells.length - 1;
                        cells.forEach(function(cell2) {
                            cell2.remove();
                            var index = this.cells.indexOf(cell2);
                            minCellIndex = Math.min(index, minCellIndex), utils2.removeFrom(this.cells, cell2)
                        }, this), this.cellChange(minCellIndex, !0)
                    }
                }, proto.cellSizeChange = function(elem) {
                    var cell2 = this.getCell(elem);
                    if (cell2) {
                        cell2.getSize();
                        var index = this.cells.indexOf(cell2);
                        this.cellChange(index)
                    }
                }, proto.cellChange = function(changedCellIndex, isPositioningSlider) {
                    var prevSelectedElem = this.selectedElement;
                    this._positionCells(changedCellIndex), this._getWrapShiftCells(), this.setGallerySize();
                    var cell2 = this.getCell(prevSelectedElem);
                    cell2 && (this.selectedIndex = this.getCellSlideIndex(cell2)), this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex), this.emitEvent("cellChange", [changedCellIndex]), this.select(this.selectedIndex), isPositioningSlider && this.positionSliderAtSelected()
                }, Flickity
            })
        }),
        lazyload = createCommonjsModule(function(module) {
            (function(window2, factory) {
                module.exports ? module.exports = factory(window2, flickity, utils) : factory(window2, window2.Flickity, window2.fizzyUIUtils)
            })(window, function(window2, Flickity, utils2) {
                Flickity.createMethods.push("_createLazyload");
                var proto = Flickity.prototype;
                proto._createLazyload = function() {
                    this.on("select", this.lazyLoad)
                }, proto.lazyLoad = function() {
                    var lazyLoad = this.options.lazyLoad;
                    if (lazyLoad) {
                        var adjCount = typeof lazyLoad == "number" ? lazyLoad : 0,
                            cellElems = this.getAdjacentCellElements(adjCount),
                            lazyImages = [];
                        cellElems.forEach(function(cellElem) {
                            var lazyCellImages = getCellLazyImages(cellElem);
                            lazyImages = lazyImages.concat(lazyCellImages)
                        }), lazyImages.forEach(function(img) {
                            new LazyLoader(img, this)
                        }, this)
                    }
                };

                function getCellLazyImages(cellElem) {
                    if (cellElem.nodeName == "IMG") {
                        var lazyloadAttr = cellElem.getAttribute("data-flickity-lazyload"),
                            srcAttr = cellElem.getAttribute("data-flickity-lazyload-src"),
                            srcsetAttr = cellElem.getAttribute("data-flickity-lazyload-srcset");
                        if (lazyloadAttr || srcAttr || srcsetAttr) return [cellElem]
                    }
                    var lazySelector = "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]",
                        imgs = cellElem.querySelectorAll(lazySelector);
                    return utils2.makeArray(imgs)
                }

                function LazyLoader(img, flickity2) {
                    this.img = img, this.flickity = flickity2, this.load()
                }
                return LazyLoader.prototype.handleEvent = utils2.handleEvent, LazyLoader.prototype.load = function() {
                    this.img.addEventListener("load", this), this.img.addEventListener("error", this);
                    var src = this.img.getAttribute("data-flickity-lazyload") || this.img.getAttribute("data-flickity-lazyload-src"),
                        srcset = this.img.getAttribute("data-flickity-lazyload-srcset");
                    this.img.src = src, srcset && this.img.setAttribute("srcset", srcset), this.img.removeAttribute("data-flickity-lazyload"), this.img.removeAttribute("data-flickity-lazyload-src"), this.img.removeAttribute("data-flickity-lazyload-srcset")
                }, LazyLoader.prototype.onload = function(event2) {
                    this.complete(event2, "flickity-lazyloaded")
                }, LazyLoader.prototype.onerror = function(event2) {
                    this.complete(event2, "flickity-lazyerror")
                }, LazyLoader.prototype.complete = function(event2, className) {
                    this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
                    var cell2 = this.flickity.getParentCell(this.img),
                        cellElem = cell2 && cell2.element;
                    this.flickity.cellSizeChange(cellElem), this.img.classList.add(className), this.flickity.dispatchEvent("lazyLoad", event2, cellElem)
                }, Flickity.LazyLoader = LazyLoader, Flickity
            })
        }),
        js = createCommonjsModule(function(module) {
            /*!
             * Flickity v2.2.1
             * Touch, responsive, flickable carousels
             *
             * Licensed GPLv3 for open source use
             * or Flickity Commercial License for commercial use
             *
             * https://flickity.metafizzy.co
             * Copyright 2015-2019 Metafizzy
             */
            (function(window2, factory) {
                module.exports && (module.exports = factory(flickity, drag, prevNextButton, pageDots, player, addRemoveCell, lazyload))
            })(window, function(Flickity) {
                return Flickity
            })
        }),
        flickityFade = createCommonjsModule(function(module) {
            (function(window2, factory) {
                module.exports ? module.exports = factory(js, utils) : factory(window2.Flickity, window2.fizzyUIUtils)
            })(commonjsGlobal, function(Flickity, utils2) {
                var Slide = Flickity.Slide,
                    slideUpdateTarget = Slide.prototype.updateTarget;
                Slide.prototype.updateTarget = function() {
                    if (slideUpdateTarget.apply(this, arguments), !!this.parent.options.fade) {
                        var slideTargetX = this.target - this.x,
                            firstCellX = this.cells[0].x;
                        this.cells.forEach(function(cell2) {
                            var targetX = cell2.x - firstCellX - slideTargetX;
                            cell2.renderPosition(targetX)
                        })
                    }
                }, Slide.prototype.setOpacity = function(alpha) {
                    this.cells.forEach(function(cell2) {
                        cell2.element.style.opacity = alpha
                    })
                };
                var proto = Flickity.prototype;
                Flickity.createMethods.push("_createFade"), proto._createFade = function() {
                    this.fadeIndex = this.selectedIndex, this.prevSelectedIndex = this.selectedIndex, this.on("select", this.onSelectFade), this.on("dragEnd", this.onDragEndFade), this.on("settle", this.onSettleFade), this.on("activate", this.onActivateFade), this.on("deactivate", this.onDeactivateFade)
                };
                var updateSlides = proto.updateSlides;
                proto.updateSlides = function() {
                    updateSlides.apply(this, arguments), this.options.fade && this.slides.forEach(function(slide2, i) {
                        var alpha = i == this.selectedIndex ? 1 : 0;
                        slide2.setOpacity(alpha)
                    }, this)
                }, proto.onSelectFade = function() {
                    this.fadeIndex = Math.min(this.prevSelectedIndex, this.slides.length - 1), this.prevSelectedIndex = this.selectedIndex
                }, proto.onSettleFade = function() {
                    if (delete this.didDragEnd, !!this.options.fade) {
                        this.selectedSlide.setOpacity(1);
                        var fadedSlide = this.slides[this.fadeIndex];
                        fadedSlide && this.fadeIndex != this.selectedIndex && this.slides[this.fadeIndex].setOpacity(0)
                    }
                }, proto.onDragEndFade = function() {
                    this.didDragEnd = !0
                }, proto.onActivateFade = function() {
                    this.options.fade && this.element.classList.add("is-fade")
                }, proto.onDeactivateFade = function() {
                    this.options.fade && (this.element.classList.remove("is-fade"), this.slides.forEach(function(slide2) {
                        slide2.setOpacity("")
                    }))
                };
                var positionSlider = proto.positionSlider;
                proto.positionSlider = function() {
                    if (!this.options.fade) {
                        positionSlider.apply(this, arguments);
                        return
                    }
                    this.fadeSlides(), this.dispatchScrollEvent()
                };
                var positionSliderAtSelected = proto.positionSliderAtSelected;
                proto.positionSliderAtSelected = function() {
                    this.options.fade && this.setTranslateX(0), positionSliderAtSelected.apply(this, arguments)
                }, proto.fadeSlides = function() {
                    if (!(this.slides.length < 2)) {
                        var indexes = this.getFadeIndexes(),
                            fadeSlideA = this.slides[indexes.a],
                            fadeSlideB = this.slides[indexes.b],
                            distance = this.wrapDifference(fadeSlideA.target, fadeSlideB.target),
                            progress = this.wrapDifference(fadeSlideA.target, -this.x);
                        progress = progress / distance, fadeSlideA.setOpacity(1 - progress), fadeSlideB.setOpacity(progress);
                        var fadeHideIndex = indexes.a;
                        this.isDragging && (fadeHideIndex = progress > .5 ? indexes.a : indexes.b);
                        var isNewHideIndex = this.fadeHideIndex != null && this.fadeHideIndex != fadeHideIndex && this.fadeHideIndex != indexes.a && this.fadeHideIndex != indexes.b;
                        isNewHideIndex && this.slides[this.fadeHideIndex].setOpacity(0), this.fadeHideIndex = fadeHideIndex
                    }
                }, proto.getFadeIndexes = function() {
                    return !this.isDragging && !this.didDragEnd ? {
                        a: this.fadeIndex,
                        b: this.selectedIndex
                    } : this.options.wrapAround ? this.getFadeDragWrapIndexes() : this.getFadeDragLimitIndexes()
                }, proto.getFadeDragWrapIndexes = function() {
                    var distances = this.slides.map(function(slide2, i) {
                            return this.getSlideDistance(-this.x, i)
                        }, this),
                        absDistances = distances.map(function(distance2) {
                            return Math.abs(distance2)
                        }),
                        minDistance = Math.min.apply(Math, absDistances),
                        closestIndex = absDistances.indexOf(minDistance),
                        distance = distances[closestIndex],
                        len = this.slides.length,
                        delta = distance >= 0 ? 1 : -1;
                    return {
                        a: closestIndex,
                        b: utils2.modulo(closestIndex + delta, len)
                    }
                }, proto.getFadeDragLimitIndexes = function() {
                    for (var dragIndex = 0, i = 0; i < this.slides.length - 1; i++) {
                        var slide2 = this.slides[i];
                        if (-this.x < slide2.target) break;
                        dragIndex = i
                    }
                    return {
                        a: dragIndex,
                        b: dragIndex + 1
                    }
                }, proto.wrapDifference = function(a, b) {
                    var diff = b - a;
                    if (!this.options.wrapAround) return diff;
                    var diffPlus = diff + this.slideableWidth,
                        diffMinus = diff - this.slideableWidth;
                    return Math.abs(diffPlus) < Math.abs(diff) && (diff = diffPlus), Math.abs(diffMinus) < Math.abs(diff) && (diff = diffMinus), diff
                };
                var _getWrapShiftCells = proto._getWrapShiftCells;
                proto._getWrapShiftCells = function() {
                    this.options.fade || _getWrapShiftCells.apply(this, arguments)
                };
                var shiftWrapCells = proto.shiftWrapCells;
                return proto.shiftWrapCells = function() {
                    this.options.fade || shiftWrapCells.apply(this, arguments)
                }, Flickity
            })
        }),
        photoswipe = createCommonjsModule(function(module, exports) {
            /*! PhotoSwipe - v4.1.3 - 2019-01-08
             * http://photoswipe.com
             * Copyright (c) 2019 Dmitry Semenov; */
            (function(root, factory) {
                module.exports = factory()
            })(commonjsGlobal, function() {
                var PhotoSwipe = function(template, UiClass, items, options) {
                    var framework = {
                        features: null,
                        bind: function(target, type, listener, unbind) {
                            var methodName = (unbind ? "remove" : "add") + "EventListener";
                            type = type.split(" ");
                            for (var i = 0; i < type.length; i++) type[i] && target[methodName](type[i], listener, !1)
                        },
                        isArray: function(obj) {
                            return obj instanceof Array
                        },
                        createEl: function(classes, tag) {
                            var el = document.createElement(tag || "div");
                            return classes && (el.className = classes), el
                        },
                        getScrollY: function() {
                            var yOffset = window.pageYOffset;
                            return yOffset !== void 0 ? yOffset : document.documentElement.scrollTop
                        },
                        unbind: function(target, type, listener) {
                            framework.bind(target, type, listener, !0)
                        },
                        removeClass: function(el, className) {
                            var reg = new RegExp("(\\s|^)" + className + "(\\s|$)");
                            el.className = el.className.replace(reg, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "")
                        },
                        addClass: function(el, className) {
                            framework.hasClass(el, className) || (el.className += (el.className ? " " : "") + className)
                        },
                        hasClass: function(el, className) {
                            return el.className && new RegExp("(^|\\s)" + className + "(\\s|$)").test(el.className)
                        },
                        getChildByClass: function(parentEl, childClassName) {
                            for (var node = parentEl.firstChild; node;) {
                                if (framework.hasClass(node, childClassName)) return node;
                                node = node.nextSibling
                            }
                        },
                        arraySearch: function(array, value, key) {
                            for (var i = array.length; i--;)
                                if (array[i][key] === value) return i;
                            return -1
                        },
                        extend: function(o1, o2, preventOverwrite) {
                            for (var prop in o2)
                                if (o2.hasOwnProperty(prop)) {
                                    if (preventOverwrite && o1.hasOwnProperty(prop)) continue;
                                    o1[prop] = o2[prop]
                                }
                        },
                        easing: {
                            sine: {
                                out: function(k) {
                                    return Math.sin(k * (Math.PI / 2))
                                },
                                inOut: function(k) {
                                    return -(Math.cos(Math.PI * k) - 1) / 2
                                }
                            },
                            cubic: {
                                out: function(k) {
                                    return --k * k * k + 1
                                }
                            }
                        },
                        detectFeatures: function() {
                            if (framework.features) return framework.features;
                            var helperEl = framework.createEl(),
                                helperStyle = helperEl.style,
                                vendor = "",
                                features = {};
                            if (features.oldIE = document.all && !document.addEventListener, features.touch = "ontouchstart" in window, window.requestAnimationFrame && (features.raf = window.requestAnimationFrame, features.caf = window.cancelAnimationFrame), features.pointerEvent = !!window.PointerEvent || navigator.msPointerEnabled, !features.pointerEvent) {
                                var ua = navigator.userAgent;
                                if (/iP(hone|od)/.test(navigator.platform)) {
                                    var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                                    v && v.length > 0 && (v = parseInt(v[1], 10), v >= 1 && v < 8 && (features.isOldIOSPhone = !0))
                                }
                                var match = ua.match(/Android\s([0-9\.]*)/),
                                    androidversion = match ? match[1] : 0;
                                androidversion = parseFloat(androidversion), androidversion >= 1 && (androidversion < 4.4 && (features.isOldAndroid = !0), features.androidVersion = androidversion), features.isMobileOpera = /opera mini|opera mobi/i.test(ua)
                            }
                            for (var styleChecks = ["transform", "perspective", "animationName"], vendors = ["", "webkit", "Moz", "ms", "O"], styleCheckItem, styleName, i = 0; i < 4; i++) {
                                vendor = vendors[i];
                                for (var a = 0; a < 3; a++) styleCheckItem = styleChecks[a], styleName = vendor + (vendor ? styleCheckItem.charAt(0).toUpperCase() + styleCheckItem.slice(1) : styleCheckItem), !features[styleCheckItem] && styleName in helperStyle && (features[styleCheckItem] = styleName);
                                vendor && !features.raf && (vendor = vendor.toLowerCase(), features.raf = window[vendor + "RequestAnimationFrame"], features.raf && (features.caf = window[vendor + "CancelAnimationFrame"] || window[vendor + "CancelRequestAnimationFrame"]))
                            }
                            if (!features.raf) {
                                var lastTime = 0;
                                features.raf = function(fn) {
                                    var currTime = new Date().getTime(),
                                        timeToCall = Math.max(0, 16 - (currTime - lastTime)),
                                        id = window.setTimeout(function() {
                                            fn(currTime + timeToCall)
                                        }, timeToCall);
                                    return lastTime = currTime + timeToCall, id
                                }, features.caf = function(id) {
                                    clearTimeout(id)
                                }
                            }
                            return features.svg = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect, framework.features = features, features
                        }
                    };
                    framework.detectFeatures(), framework.features.oldIE && (framework.bind = function(target, type, listener, unbind) {
                        type = type.split(" ");
                        for (var methodName = (unbind ? "detach" : "attach") + "Event", evName, _handleEv = function() {
                                listener.handleEvent.call(listener)
                            }, i = 0; i < type.length; i++)
                            if (evName = type[i], evName)
                                if (_typeof(listener) === "object" && listener.handleEvent) {
                                    if (!unbind) listener["oldIE" + evName] = _handleEv;
                                    else if (!listener["oldIE" + evName]) return !1;
                                    target[methodName]("on" + evName, listener["oldIE" + evName])
                                } else target[methodName]("on" + evName, listener)
                    });
                    var self2 = this,
                        DOUBLE_TAP_RADIUS = 25,
                        NUM_HOLDERS = 3,
                        _options = {
                            allowPanToNext: !0,
                            spacing: .12,
                            bgOpacity: 1,
                            mouseUsed: !1,
                            loop: !0,
                            pinchToClose: !0,
                            closeOnScroll: !0,
                            closeOnVerticalDrag: !0,
                            verticalDragRange: .75,
                            hideAnimationDuration: 333,
                            showAnimationDuration: 333,
                            showHideOpacity: !1,
                            focus: !0,
                            escKey: !0,
                            arrowKeys: !0,
                            mainScrollEndFriction: .35,
                            panEndFriction: .35,
                            isClickableElement: function(el) {
                                return el.tagName === "A"
                            },
                            getDoubleTapZoom: function(isMouseClick, item) {
                                return isMouseClick || item.initialZoomLevel < .7 ? 1 : 1.33
                            },
                            maxSpreadZoom: 1.33,
                            modal: !0,
                            scaleMode: "fit"
                        };
                    framework.extend(_options, options);
                    var _getEmptyPoint = function() {
                            return {
                                x: 0,
                                y: 0
                            }
                        },
                        _isOpen, _isDestroying, _closedByScroll, _currentItemIndex, _containerStyle, _containerShiftIndex, _currPanDist = _getEmptyPoint(),
                        _startPanOffset = _getEmptyPoint(),
                        _panOffset = _getEmptyPoint(),
                        _upMoveEvents, _downEvents, _globalEventHandlers, _viewportSize = {},
                        _currZoomLevel, _startZoomLevel, _translatePrefix, _translateSufix, _updateSizeInterval, _itemsNeedUpdate, _currPositionIndex = 0,
                        _offset = {},
                        _slideSize = _getEmptyPoint(),
                        _itemHolders, _prevItemIndex, _indexDiff = 0,
                        _dragStartEvent, _dragMoveEvent, _dragEndEvent, _dragCancelEvent, _transformKey, _pointerEventEnabled, _isFixedPosition = !0,
                        _likelyTouchDevice, _modules = [],
                        _requestAF, _cancelAF, _initalClassName, _initalWindowScrollY, _oldIE, _currentWindowScrollY, _features, _windowVisibleSize = {},
                        _renderMaxResolution = !1,
                        _orientationChangeTimeout, _registerModule = function(name, module2) {
                            framework.extend(self2, module2.publicMethods), _modules.push(name)
                        },
                        _getLoopedId = function(index) {
                            var numSlides = _getNumItems();
                            return index > numSlides - 1 ? index - numSlides : index < 0 ? numSlides + index : index
                        },
                        _listeners = {},
                        _listen = function(name, fn) {
                            return _listeners[name] || (_listeners[name] = []), _listeners[name].push(fn)
                        },
                        _shout = function(name) {
                            var listeners = _listeners[name];
                            if (listeners) {
                                var args = Array.prototype.slice.call(arguments);
                                args.shift();
                                for (var i = 0; i < listeners.length; i++) listeners[i].apply(self2, args)
                            }
                        },
                        _getCurrentTime = function() {
                            return new Date().getTime()
                        },
                        _applyBgOpacity = function(opacity) {
                            _bgOpacity = opacity, self2.bg.style.opacity = opacity * _options.bgOpacity
                        },
                        _applyZoomTransform = function(styleObj, x, y, zoom, item) {
                            (!_renderMaxResolution || item && item !== self2.currItem) && (zoom = zoom / (item ? item.fitRatio : self2.currItem.fitRatio)), styleObj[_transformKey] = _translatePrefix + x + "px, " + y + "px" + _translateSufix + " scale(" + zoom + ")"
                        },
                        _applyCurrentZoomPan = function(allowRenderResolution) {
                            _currZoomElementStyle && (allowRenderResolution && (_currZoomLevel > self2.currItem.fitRatio ? _renderMaxResolution || (_setImageSize(self2.currItem, !1, !0), _renderMaxResolution = !0) : _renderMaxResolution && (_setImageSize(self2.currItem), _renderMaxResolution = !1)), _applyZoomTransform(_currZoomElementStyle, _panOffset.x, _panOffset.y, _currZoomLevel))
                        },
                        _applyZoomPanToItem = function(item) {
                            item.container && _applyZoomTransform(item.container.style, item.initialPosition.x, item.initialPosition.y, item.initialZoomLevel, item)
                        },
                        _setTranslateX = function(x, elStyle) {
                            elStyle[_transformKey] = _translatePrefix + x + "px, 0px" + _translateSufix
                        },
                        _moveMainScroll = function(x, dragging) {
                            if (!_options.loop && dragging) {
                                var newSlideIndexOffset = _currentItemIndex + (_slideSize.x * _currPositionIndex - x) / _slideSize.x,
                                    delta2 = Math.round(x - _mainScrollPos.x);
                                (newSlideIndexOffset < 0 && delta2 > 0 || newSlideIndexOffset >= _getNumItems() - 1 && delta2 < 0) && (x = _mainScrollPos.x + delta2 * _options.mainScrollEndFriction)
                            }
                            _mainScrollPos.x = x, _setTranslateX(x, _containerStyle)
                        },
                        _calculatePanOffset = function(axis, zoomLevel) {
                            var m = _midZoomPoint[axis] - _offset[axis];
                            return _startPanOffset[axis] + _currPanDist[axis] + m - m * (zoomLevel / _startZoomLevel)
                        },
                        _equalizePoints = function(p1, p22) {
                            p1.x = p22.x, p1.y = p22.y, p22.id && (p1.id = p22.id)
                        },
                        _roundPoint = function(p3) {
                            p3.x = Math.round(p3.x), p3.y = Math.round(p3.y)
                        },
                        _mouseMoveTimeout = null,
                        _onFirstMouseMove = function _onFirstMouseMove2() {
                            _mouseMoveTimeout && (framework.unbind(document, "mousemove", _onFirstMouseMove2), framework.addClass(template, "pswp--has_mouse"), _options.mouseUsed = !0, _shout("mouseUsed")), _mouseMoveTimeout = setTimeout(function() {
                                _mouseMoveTimeout = null
                            }, 100)
                        },
                        _bindEvents = function() {
                            framework.bind(document, "keydown", self2), _features.transform && framework.bind(self2.scrollWrap, "click", self2), _options.mouseUsed || framework.bind(document, "mousemove", _onFirstMouseMove), framework.bind(window, "resize scroll orientationchange", self2), _shout("bindEvents")
                        },
                        _unbindEvents = function() {
                            framework.unbind(window, "resize scroll orientationchange", self2), framework.unbind(window, "scroll", _globalEventHandlers.scroll), framework.unbind(document, "keydown", self2), framework.unbind(document, "mousemove", _onFirstMouseMove), _features.transform && framework.unbind(self2.scrollWrap, "click", self2), _isDragging && framework.unbind(window, _upMoveEvents, self2), clearTimeout(_orientationChangeTimeout), _shout("unbindEvents")
                        },
                        _calculatePanBounds = function(zoomLevel, update) {
                            var bounds = _calculateItemSize(self2.currItem, _viewportSize, zoomLevel);
                            return update && (_currPanBounds = bounds), bounds
                        },
                        _getMinZoomLevel = function(item) {
                            return item || (item = self2.currItem), item.initialZoomLevel
                        },
                        _getMaxZoomLevel = function(item) {
                            return item || (item = self2.currItem), item.w > 0 ? _options.maxSpreadZoom : 1
                        },
                        _modifyDestPanOffset = function(axis, destPanBounds, destPanOffset, destZoomLevel) {
                            return destZoomLevel === self2.currItem.initialZoomLevel ? (destPanOffset[axis] = self2.currItem.initialPosition[axis], !0) : (destPanOffset[axis] = _calculatePanOffset(axis, destZoomLevel), destPanOffset[axis] > destPanBounds.min[axis] ? (destPanOffset[axis] = destPanBounds.min[axis], !0) : destPanOffset[axis] < destPanBounds.max[axis] ? (destPanOffset[axis] = destPanBounds.max[axis], !0) : !1)
                        },
                        _setupTransforms = function() {
                            if (_transformKey) {
                                var allow3dTransform = _features.perspective && !_likelyTouchDevice;
                                _translatePrefix = "translate" + (allow3dTransform ? "3d(" : "("), _translateSufix = _features.perspective ? ", 0px)" : ")";
                                return
                            }
                            _transformKey = "left", framework.addClass(template, "pswp--ie"), _setTranslateX = function(x, elStyle) {
                                elStyle.left = x + "px"
                            }, _applyZoomPanToItem = function(item) {
                                var zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio,
                                    s = item.container.style,
                                    w = zoomRatio * item.w,
                                    h = zoomRatio * item.h;
                                s.width = w + "px", s.height = h + "px", s.left = item.initialPosition.x + "px", s.top = item.initialPosition.y + "px"
                            }, _applyCurrentZoomPan = function() {
                                if (_currZoomElementStyle) {
                                    var s = _currZoomElementStyle,
                                        item = self2.currItem,
                                        zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio,
                                        w = zoomRatio * item.w,
                                        h = zoomRatio * item.h;
                                    s.width = w + "px", s.height = h + "px", s.left = _panOffset.x + "px", s.top = _panOffset.y + "px"
                                }
                            }
                        },
                        _onKeyDown = function(e) {
                            var keydownAction = "";
                            _options.escKey && e.keyCode === 27 ? keydownAction = "close" : _options.arrowKeys && (e.keyCode === 37 ? keydownAction = "prev" : e.keyCode === 39 && (keydownAction = "next")), keydownAction && !e.ctrlKey && !e.altKey && !e.shiftKey && !e.metaKey && (e.preventDefault ? e.preventDefault() : e.returnValue = !1, self2[keydownAction]())
                        },
                        _onGlobalClick = function(e) {
                            e && (_moved || _zoomStarted || _mainScrollAnimating || _verticalDragInitiated) && (e.preventDefault(), e.stopPropagation())
                        },
                        _updatePageScrollOffset = function() {
                            self2.setScrollOffset(0, framework.getScrollY())
                        },
                        _animations = {},
                        _numAnimations = 0,
                        _stopAnimation = function(name) {
                            _animations[name] && (_animations[name].raf && _cancelAF(_animations[name].raf), _numAnimations--, delete _animations[name])
                        },
                        _registerStartAnimation = function(name) {
                            _animations[name] && _stopAnimation(name), _animations[name] || (_numAnimations++, _animations[name] = {})
                        },
                        _stopAllAnimations = function() {
                            for (var prop in _animations) _animations.hasOwnProperty(prop) && _stopAnimation(prop)
                        },
                        _animateProp = function(name, b, endProp, d, easingFn, onUpdate, onComplete) {
                            var startAnimTime = _getCurrentTime(),
                                t;
                            _registerStartAnimation(name);
                            var animloop = function animloop2() {
                                if (_animations[name]) {
                                    if (t = _getCurrentTime() - startAnimTime, t >= d) {
                                        _stopAnimation(name), onUpdate(endProp), onComplete && onComplete();
                                        return
                                    }
                                    onUpdate((endProp - b) * easingFn(t / d) + b), _animations[name].raf = _requestAF(animloop2)
                                }
                            };
                            animloop()
                        },
                        publicMethods = {
                            shout: _shout,
                            listen: _listen,
                            viewportSize: _viewportSize,
                            options: _options,
                            isMainScrollAnimating: function() {
                                return _mainScrollAnimating
                            },
                            getZoomLevel: function() {
                                return _currZoomLevel
                            },
                            getCurrentIndex: function() {
                                return _currentItemIndex
                            },
                            isDragging: function() {
                                return _isDragging
                            },
                            isZooming: function() {
                                return _isZooming
                            },
                            setScrollOffset: function(x, y) {
                                _offset.x = x, _currentWindowScrollY = _offset.y = y, _shout("updateScrollOffset", _offset)
                            },
                            applyZoomPan: function(zoomLevel, panX, panY, allowRenderResolution) {
                                _panOffset.x = panX, _panOffset.y = panY, _currZoomLevel = zoomLevel, _applyCurrentZoomPan(allowRenderResolution)
                            },
                            init: function() {
                                if (!(_isOpen || _isDestroying)) {
                                    var i;
                                    self2.framework = framework, self2.template = template, self2.bg = framework.getChildByClass(template, "pswp__bg"), _initalClassName = template.className, _isOpen = !0, _features = framework.detectFeatures(), _requestAF = _features.raf, _cancelAF = _features.caf, _transformKey = _features.transform, _oldIE = _features.oldIE, self2.scrollWrap = framework.getChildByClass(template, "pswp__scroll-wrap"), self2.container = framework.getChildByClass(self2.scrollWrap, "pswp__container"), _containerStyle = self2.container.style, self2.itemHolders = _itemHolders = [{
                                        el: self2.container.children[0],
                                        wrap: 0,
                                        index: -1
                                    }, {
                                        el: self2.container.children[1],
                                        wrap: 0,
                                        index: -1
                                    }, {
                                        el: self2.container.children[2],
                                        wrap: 0,
                                        index: -1
                                    }], _itemHolders[0].el.style.display = _itemHolders[2].el.style.display = "none", _setupTransforms(), _globalEventHandlers = {
                                        resize: self2.updateSize,
                                        orientationchange: function() {
                                            clearTimeout(_orientationChangeTimeout), _orientationChangeTimeout = setTimeout(function() {
                                                _viewportSize.x !== self2.scrollWrap.clientWidth && self2.updateSize()
                                            }, 500)
                                        },
                                        scroll: _updatePageScrollOffset,
                                        keydown: _onKeyDown,
                                        click: _onGlobalClick
                                    };
                                    var oldPhone = _features.isOldIOSPhone || _features.isOldAndroid || _features.isMobileOpera;
                                    for ((!_features.animationName || !_features.transform || oldPhone) && (_options.showAnimationDuration = _options.hideAnimationDuration = 0), i = 0; i < _modules.length; i++) self2["init" + _modules[i]]();
                                    if (UiClass) {
                                        var ui = self2.ui = new UiClass(self2, framework);
                                        ui.init()
                                    }
                                    _shout("firstUpdate"), _currentItemIndex = _currentItemIndex || _options.index || 0, (isNaN(_currentItemIndex) || _currentItemIndex < 0 || _currentItemIndex >= _getNumItems()) && (_currentItemIndex = 0), self2.currItem = _getItemAt(_currentItemIndex), (_features.isOldIOSPhone || _features.isOldAndroid) && (_isFixedPosition = !1), template.setAttribute("aria-hidden", "false"), _options.modal && (_isFixedPosition ? template.style.position = "fixed" : (template.style.position = "absolute", template.style.top = framework.getScrollY() + "px")), _currentWindowScrollY === void 0 && (_shout("initialLayout"), _currentWindowScrollY = _initalWindowScrollY = framework.getScrollY());
                                    var rootClasses = "pswp--open ";
                                    for (_options.mainClass && (rootClasses += _options.mainClass + " "), _options.showHideOpacity && (rootClasses += "pswp--animate_opacity "), rootClasses += _likelyTouchDevice ? "pswp--touch" : "pswp--notouch", rootClasses += _features.animationName ? " pswp--css_animation" : "", rootClasses += _features.svg ? " pswp--svg" : "", framework.addClass(template, rootClasses), self2.updateSize(), _containerShiftIndex = -1, _indexDiff = null, i = 0; i < NUM_HOLDERS; i++) _setTranslateX((i + _containerShiftIndex) * _slideSize.x, _itemHolders[i].el.style);
                                    _oldIE || framework.bind(self2.scrollWrap, _downEvents, self2), _listen("initialZoomInEnd", function() {
                                        self2.setContent(_itemHolders[0], _currentItemIndex - 1), self2.setContent(_itemHolders[2], _currentItemIndex + 1), _itemHolders[0].el.style.display = _itemHolders[2].el.style.display = "block", _options.focus && template.focus(), _bindEvents()
                                    }), self2.setContent(_itemHolders[1], _currentItemIndex), self2.updateCurrItem(), _shout("afterInit"), _isFixedPosition || (_updateSizeInterval = setInterval(function() {
                                        !_numAnimations && !_isDragging && !_isZooming && _currZoomLevel === self2.currItem.initialZoomLevel && self2.updateSize()
                                    }, 1e3)), framework.addClass(template, "pswp--visible")
                                }
                            },
                            close: function() {
                                _isOpen && (_isOpen = !1, _isDestroying = !0, _shout("close"), _unbindEvents(), _showOrHide(self2.currItem, null, !0, self2.destroy))
                            },
                            destroy: function() {
                                _shout("destroy"), _showOrHideTimeout && clearTimeout(_showOrHideTimeout), template.setAttribute("aria-hidden", "true"), template.className = _initalClassName, _updateSizeInterval && clearInterval(_updateSizeInterval), framework.unbind(self2.scrollWrap, _downEvents, self2), framework.unbind(window, "scroll", self2), _stopDragUpdateLoop(), _stopAllAnimations(), _listeners = null
                            },
                            panTo: function(x, y, force) {
                                force || (x > _currPanBounds.min.x ? x = _currPanBounds.min.x : x < _currPanBounds.max.x && (x = _currPanBounds.max.x), y > _currPanBounds.min.y ? y = _currPanBounds.min.y : y < _currPanBounds.max.y && (y = _currPanBounds.max.y)), _panOffset.x = x, _panOffset.y = y, _applyCurrentZoomPan()
                            },
                            handleEvent: function(e) {
                                e = e || window.event, _globalEventHandlers[e.type] && _globalEventHandlers[e.type](e)
                            },
                            goTo: function(index) {
                                index = _getLoopedId(index);
                                var diff = index - _currentItemIndex;
                                _indexDiff = diff, _currentItemIndex = index, self2.currItem = _getItemAt(_currentItemIndex), _currPositionIndex -= diff, _moveMainScroll(_slideSize.x * _currPositionIndex), _stopAllAnimations(), _mainScrollAnimating = !1, self2.updateCurrItem()
                            },
                            next: function() {
                                self2.goTo(_currentItemIndex + 1)
                            },
                            prev: function() {
                                self2.goTo(_currentItemIndex - 1)
                            },
                            updateCurrZoomItem: function(emulateSetContent) {
                                if (emulateSetContent && _shout("beforeChange", 0), _itemHolders[1].el.children.length) {
                                    var zoomElement = _itemHolders[1].el.children[0];
                                    framework.hasClass(zoomElement, "pswp__zoom-wrap") ? _currZoomElementStyle = zoomElement.style : _currZoomElementStyle = null
                                } else _currZoomElementStyle = null;
                                _currPanBounds = self2.currItem.bounds, _startZoomLevel = _currZoomLevel = self2.currItem.initialZoomLevel, _panOffset.x = _currPanBounds.center.x, _panOffset.y = _currPanBounds.center.y, emulateSetContent && _shout("afterChange")
                            },
                            invalidateCurrItems: function() {
                                _itemsNeedUpdate = !0;
                                for (var i = 0; i < NUM_HOLDERS; i++) _itemHolders[i].item && (_itemHolders[i].item.needsUpdate = !0)
                            },
                            updateCurrItem: function(beforeAnimation) {
                                if (_indexDiff !== 0) {
                                    var diffAbs = Math.abs(_indexDiff),
                                        tempHolder;
                                    if (!(beforeAnimation && diffAbs < 2)) {
                                        self2.currItem = _getItemAt(_currentItemIndex), _renderMaxResolution = !1, _shout("beforeChange", _indexDiff), diffAbs >= NUM_HOLDERS && (_containerShiftIndex += _indexDiff + (_indexDiff > 0 ? -NUM_HOLDERS : NUM_HOLDERS), diffAbs = NUM_HOLDERS);
                                        for (var i = 0; i < diffAbs; i++) _indexDiff > 0 ? (tempHolder = _itemHolders.shift(), _itemHolders[NUM_HOLDERS - 1] = tempHolder, _containerShiftIndex++, _setTranslateX((_containerShiftIndex + 2) * _slideSize.x, tempHolder.el.style), self2.setContent(tempHolder, _currentItemIndex - diffAbs + i + 1 + 1)) : (tempHolder = _itemHolders.pop(), _itemHolders.unshift(tempHolder), _containerShiftIndex--, _setTranslateX(_containerShiftIndex * _slideSize.x, tempHolder.el.style), self2.setContent(tempHolder, _currentItemIndex + diffAbs - i - 1 - 1));
                                        if (_currZoomElementStyle && Math.abs(_indexDiff) === 1) {
                                            var prevItem = _getItemAt(_prevItemIndex);
                                            prevItem.initialZoomLevel !== _currZoomLevel && (_calculateItemSize(prevItem, _viewportSize), _setImageSize(prevItem), _applyZoomPanToItem(prevItem))
                                        }
                                        _indexDiff = 0, self2.updateCurrZoomItem(), _prevItemIndex = _currentItemIndex, _shout("afterChange")
                                    }
                                }
                            },
                            updateSize: function(force) {
                                if (!_isFixedPosition && _options.modal) {
                                    var windowScrollY = framework.getScrollY();
                                    if (_currentWindowScrollY !== windowScrollY && (template.style.top = windowScrollY + "px", _currentWindowScrollY = windowScrollY), !force && _windowVisibleSize.x === window.innerWidth && _windowVisibleSize.y === window.innerHeight) return;
                                    _windowVisibleSize.x = window.innerWidth, _windowVisibleSize.y = window.innerHeight, template.style.height = _windowVisibleSize.y + "px"
                                }
                                if (_viewportSize.x = self2.scrollWrap.clientWidth, _viewportSize.y = self2.scrollWrap.clientHeight, _updatePageScrollOffset(), _slideSize.x = _viewportSize.x + Math.round(_viewportSize.x * _options.spacing), _slideSize.y = _viewportSize.y, _moveMainScroll(_slideSize.x * _currPositionIndex), _shout("beforeResize"), _containerShiftIndex !== void 0) {
                                    for (var holder, item, hIndex, i = 0; i < NUM_HOLDERS; i++) holder = _itemHolders[i], _setTranslateX((i + _containerShiftIndex) * _slideSize.x, holder.el.style), hIndex = _currentItemIndex + i - 1, _options.loop && _getNumItems() > 2 && (hIndex = _getLoopedId(hIndex)), item = _getItemAt(hIndex), item && (_itemsNeedUpdate || item.needsUpdate || !item.bounds) ? (self2.cleanSlide(item), self2.setContent(holder, hIndex), i === 1 && (self2.currItem = item, self2.updateCurrZoomItem(!0)), item.needsUpdate = !1) : holder.index === -1 && hIndex >= 0 && self2.setContent(holder, hIndex), item && item.container && (_calculateItemSize(item, _viewportSize), _setImageSize(item), _applyZoomPanToItem(item));
                                    _itemsNeedUpdate = !1
                                }
                                _startZoomLevel = _currZoomLevel = self2.currItem.initialZoomLevel, _currPanBounds = self2.currItem.bounds, _currPanBounds && (_panOffset.x = _currPanBounds.center.x, _panOffset.y = _currPanBounds.center.y, _applyCurrentZoomPan(!0)), _shout("resize")
                            },
                            zoomTo: function(destZoomLevel, centerPoint, speed, easingFn, updateFn) {
                                centerPoint && (_startZoomLevel = _currZoomLevel, _midZoomPoint.x = Math.abs(centerPoint.x) - _panOffset.x, _midZoomPoint.y = Math.abs(centerPoint.y) - _panOffset.y, _equalizePoints(_startPanOffset, _panOffset));
                                var destPanBounds = _calculatePanBounds(destZoomLevel, !1),
                                    destPanOffset = {};
                                _modifyDestPanOffset("x", destPanBounds, destPanOffset, destZoomLevel), _modifyDestPanOffset("y", destPanBounds, destPanOffset, destZoomLevel);
                                var initialZoomLevel = _currZoomLevel,
                                    initialPanOffset = {
                                        x: _panOffset.x,
                                        y: _panOffset.y
                                    };
                                _roundPoint(destPanOffset);
                                var onUpdate = function(now) {
                                    now === 1 ? (_currZoomLevel = destZoomLevel, _panOffset.x = destPanOffset.x, _panOffset.y = destPanOffset.y) : (_currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel, _panOffset.x = (destPanOffset.x - initialPanOffset.x) * now + initialPanOffset.x, _panOffset.y = (destPanOffset.y - initialPanOffset.y) * now + initialPanOffset.y), updateFn && updateFn(now), _applyCurrentZoomPan(now === 1)
                                };
                                speed ? _animateProp("customZoomTo", 0, 1, speed, easingFn || framework.easing.sine.inOut, onUpdate) : onUpdate(1)
                            }
                        },
                        MIN_SWIPE_DISTANCE = 30,
                        DIRECTION_CHECK_OFFSET = 10,
                        _gestureStartTime, _gestureCheckSpeedTime, p = {},
                        p2 = {},
                        delta = {},
                        _currPoint = {},
                        _startPoint = {},
                        _currPointers = [],
                        _startMainScrollPos = {},
                        _releaseAnimData, _posPoints = [],
                        _tempPoint = {},
                        _isZoomingIn, _verticalDragInitiated, _oldAndroidTouchEndTimeout, _currZoomedItemIndex = 0,
                        _centerPoint = _getEmptyPoint(),
                        _lastReleaseTime = 0,
                        _isDragging, _isMultitouch, _zoomStarted, _moved, _dragAnimFrame, _mainScrollShifted, _currentPoints, _isZooming, _currPointsDistance, _startPointsDistance, _currPanBounds, _mainScrollPos = _getEmptyPoint(),
                        _currZoomElementStyle, _mainScrollAnimating, _midZoomPoint = _getEmptyPoint(),
                        _currCenterPoint = _getEmptyPoint(),
                        _direction, _isFirstMove, _opacityChanged, _bgOpacity, _wasOverInitialZoom, _isEqualPoints = function(p1, p22) {
                            return p1.x === p22.x && p1.y === p22.y
                        },
                        _isNearbyPoints = function(touch0, touch1) {
                            return Math.abs(touch0.x - touch1.x) < DOUBLE_TAP_RADIUS && Math.abs(touch0.y - touch1.y) < DOUBLE_TAP_RADIUS
                        },
                        _calculatePointsDistance = function(p1, p22) {
                            return _tempPoint.x = Math.abs(p1.x - p22.x), _tempPoint.y = Math.abs(p1.y - p22.y), Math.sqrt(_tempPoint.x * _tempPoint.x + _tempPoint.y * _tempPoint.y)
                        },
                        _stopDragUpdateLoop = function() {
                            _dragAnimFrame && (_cancelAF(_dragAnimFrame), _dragAnimFrame = null)
                        },
                        _dragUpdateLoop = function _dragUpdateLoop2() {
                            _isDragging && (_dragAnimFrame = _requestAF(_dragUpdateLoop2), _renderMovement())
                        },
                        _canPan = function() {
                            return !(_options.scaleMode === "fit" && _currZoomLevel === self2.currItem.initialZoomLevel)
                        },
                        _closestElement = function _closestElement2(el, fn) {
                            return !el || el === document || el.getAttribute("class") && el.getAttribute("class").indexOf("pswp__scroll-wrap") > -1 ? !1 : fn(el) ? el : _closestElement2(el.parentNode, fn)
                        },
                        _preventObj = {},
                        _preventDefaultEventBehaviour = function(e, isDown) {
                            return _preventObj.prevent = !_closestElement(e.target, _options.isClickableElement), _shout("preventDragEvent", e, isDown, _preventObj), _preventObj.prevent
                        },
                        _convertTouchToPoint = function(touch, p3) {
                            return p3.x = touch.pageX, p3.y = touch.pageY, p3.id = touch.identifier, p3
                        },
                        _findCenterOfPoints = function(p1, p22, pCenter) {
                            pCenter.x = (p1.x + p22.x) * .5, pCenter.y = (p1.y + p22.y) * .5
                        },
                        _pushPosPoint = function(time, x, y) {
                            if (time - _gestureCheckSpeedTime > 50) {
                                var o = _posPoints.length > 2 ? _posPoints.shift() : {};
                                o.x = x, o.y = y, _posPoints.push(o), _gestureCheckSpeedTime = time
                            }
                        },
                        _calculateVerticalDragOpacityRatio = function() {
                            var yOffset = _panOffset.y - self2.currItem.initialPosition.y;
                            return 1 - Math.abs(yOffset / (_viewportSize.y / 2))
                        },
                        _ePoint1 = {},
                        _ePoint2 = {},
                        _tempPointsArr = [],
                        _tempCounter, _getTouchPoints = function(e) {
                            for (; _tempPointsArr.length > 0;) _tempPointsArr.pop();
                            return _pointerEventEnabled ? (_tempCounter = 0, _currPointers.forEach(function(p3) {
                                _tempCounter === 0 ? _tempPointsArr[0] = p3 : _tempCounter === 1 && (_tempPointsArr[1] = p3), _tempCounter++
                            })) : e.type.indexOf("touch") > -1 ? e.touches && e.touches.length > 0 && (_tempPointsArr[0] = _convertTouchToPoint(e.touches[0], _ePoint1), e.touches.length > 1 && (_tempPointsArr[1] = _convertTouchToPoint(e.touches[1], _ePoint2))) : (_ePoint1.x = e.pageX, _ePoint1.y = e.pageY, _ePoint1.id = "", _tempPointsArr[0] = _ePoint1), _tempPointsArr
                        },
                        _panOrMoveMainScroll = function(axis, delta2) {
                            var panFriction, overDiff = 0,
                                newOffset = _panOffset[axis] + delta2[axis],
                                startOverDiff, dir = delta2[axis] > 0,
                                newMainScrollPosition = _mainScrollPos.x + delta2.x,
                                mainScrollDiff = _mainScrollPos.x - _startMainScrollPos.x,
                                newPanPos, newMainScrollPos;
                            if (newOffset > _currPanBounds.min[axis] || newOffset < _currPanBounds.max[axis] ? panFriction = _options.panEndFriction : panFriction = 1, newOffset = _panOffset[axis] + delta2[axis] * panFriction, (_options.allowPanToNext || _currZoomLevel === self2.currItem.initialZoomLevel) && (_currZoomElementStyle ? _direction === "h" && axis === "x" && !_zoomStarted && (dir ? (newOffset > _currPanBounds.min[axis] && (panFriction = _options.panEndFriction, overDiff = _currPanBounds.min[axis] - newOffset, startOverDiff = _currPanBounds.min[axis] - _startPanOffset[axis]), (startOverDiff <= 0 || mainScrollDiff < 0) && _getNumItems() > 1 ? (newMainScrollPos = newMainScrollPosition, mainScrollDiff < 0 && newMainScrollPosition > _startMainScrollPos.x && (newMainScrollPos = _startMainScrollPos.x)) : _currPanBounds.min.x !== _currPanBounds.max.x && (newPanPos = newOffset)) : (newOffset < _currPanBounds.max[axis] && (panFriction = _options.panEndFriction, overDiff = newOffset - _currPanBounds.max[axis], startOverDiff = _startPanOffset[axis] - _currPanBounds.max[axis]), (startOverDiff <= 0 || mainScrollDiff > 0) && _getNumItems() > 1 ? (newMainScrollPos = newMainScrollPosition, mainScrollDiff > 0 && newMainScrollPosition < _startMainScrollPos.x && (newMainScrollPos = _startMainScrollPos.x)) : _currPanBounds.min.x !== _currPanBounds.max.x && (newPanPos = newOffset))) : newMainScrollPos = newMainScrollPosition, axis === "x")) return newMainScrollPos !== void 0 && (_moveMainScroll(newMainScrollPos, !0), newMainScrollPos === _startMainScrollPos.x ? _mainScrollShifted = !1 : _mainScrollShifted = !0), _currPanBounds.min.x !== _currPanBounds.max.x && (newPanPos !== void 0 ? _panOffset.x = newPanPos : _mainScrollShifted || (_panOffset.x += delta2.x * panFriction)), newMainScrollPos !== void 0;
                            _mainScrollAnimating || _mainScrollShifted || _currZoomLevel > self2.currItem.fitRatio && (_panOffset[axis] += delta2[axis] * panFriction)
                        },
                        _onDragStart = function(e) {
                            if (!(e.type === "mousedown" && e.button > 0)) {
                                if (_initialZoomRunning) {
                                    e.preventDefault();
                                    return
                                }
                                if (!(_oldAndroidTouchEndTimeout && e.type === "mousedown")) {
                                    if (_preventDefaultEventBehaviour(e, !0) && e.preventDefault(), _shout("pointerDown"), _pointerEventEnabled) {
                                        var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, "id");
                                        pointerIndex < 0 && (pointerIndex = _currPointers.length), _currPointers[pointerIndex] = {
                                            x: e.pageX,
                                            y: e.pageY,
                                            id: e.pointerId
                                        }
                                    }
                                    var startPointsList = _getTouchPoints(e),
                                        numPoints = startPointsList.length;
                                    _currentPoints = null, _stopAllAnimations(), (!_isDragging || numPoints === 1) && (_isDragging = _isFirstMove = !0, framework.bind(window, _upMoveEvents, self2), _isZoomingIn = _wasOverInitialZoom = _opacityChanged = _verticalDragInitiated = _mainScrollShifted = _moved = _isMultitouch = _zoomStarted = !1, _direction = null, _shout("firstTouchStart", startPointsList), _equalizePoints(_startPanOffset, _panOffset), _currPanDist.x = _currPanDist.y = 0, _equalizePoints(_currPoint, startPointsList[0]), _equalizePoints(_startPoint, _currPoint), _startMainScrollPos.x = _slideSize.x * _currPositionIndex, _posPoints = [{
                                        x: _currPoint.x,
                                        y: _currPoint.y
                                    }], _gestureCheckSpeedTime = _gestureStartTime = _getCurrentTime(), _calculatePanBounds(_currZoomLevel, !0), _stopDragUpdateLoop(), _dragUpdateLoop()), !_isZooming && numPoints > 1 && !_mainScrollAnimating && !_mainScrollShifted && (_startZoomLevel = _currZoomLevel, _zoomStarted = !1, _isZooming = _isMultitouch = !0, _currPanDist.y = _currPanDist.x = 0, _equalizePoints(_startPanOffset, _panOffset), _equalizePoints(p, startPointsList[0]), _equalizePoints(p2, startPointsList[1]), _findCenterOfPoints(p, p2, _currCenterPoint), _midZoomPoint.x = Math.abs(_currCenterPoint.x) - _panOffset.x, _midZoomPoint.y = Math.abs(_currCenterPoint.y) - _panOffset.y, _currPointsDistance = _startPointsDistance = _calculatePointsDistance(p, p2))
                                }
                            }
                        },
                        _onDragMove = function(e) {
                            if (e.preventDefault(), _pointerEventEnabled) {
                                var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, "id");
                                if (pointerIndex > -1) {
                                    var p3 = _currPointers[pointerIndex];
                                    p3.x = e.pageX, p3.y = e.pageY
                                }
                            }
                            if (_isDragging) {
                                var touchesList = _getTouchPoints(e);
                                if (!_direction && !_moved && !_isZooming)
                                    if (_mainScrollPos.x !== _slideSize.x * _currPositionIndex) _direction = "h";
                                    else {
                                        var diff = Math.abs(touchesList[0].x - _currPoint.x) - Math.abs(touchesList[0].y - _currPoint.y);
                                        Math.abs(diff) >= DIRECTION_CHECK_OFFSET && (_direction = diff > 0 ? "h" : "v", _currentPoints = touchesList)
                                    }
                                else _currentPoints = touchesList
                            }
                        },
                        _renderMovement = function() {
                            if (_currentPoints) {
                                var numPoints = _currentPoints.length;
                                if (numPoints !== 0)
                                    if (_equalizePoints(p, _currentPoints[0]), delta.x = p.x - _currPoint.x, delta.y = p.y - _currPoint.y, _isZooming && numPoints > 1) {
                                        if (_currPoint.x = p.x, _currPoint.y = p.y, !delta.x && !delta.y && _isEqualPoints(_currentPoints[1], p2)) return;
                                        _equalizePoints(p2, _currentPoints[1]), _zoomStarted || (_zoomStarted = !0, _shout("zoomGestureStarted"));
                                        var pointsDistance = _calculatePointsDistance(p, p2),
                                            zoomLevel = _calculateZoomLevel(pointsDistance);
                                        zoomLevel > self2.currItem.initialZoomLevel + self2.currItem.initialZoomLevel / 15 && (_wasOverInitialZoom = !0);
                                        var zoomFriction = 1,
                                            minZoomLevel = _getMinZoomLevel(),
                                            maxZoomLevel = _getMaxZoomLevel();
                                        if (zoomLevel < minZoomLevel)
                                            if (_options.pinchToClose && !_wasOverInitialZoom && _startZoomLevel <= self2.currItem.initialZoomLevel) {
                                                var minusDiff = minZoomLevel - zoomLevel,
                                                    percent = 1 - minusDiff / (minZoomLevel / 1.2);
                                                _applyBgOpacity(percent), _shout("onPinchClose", percent), _opacityChanged = !0
                                            } else zoomFriction = (minZoomLevel - zoomLevel) / minZoomLevel, zoomFriction > 1 && (zoomFriction = 1), zoomLevel = minZoomLevel - zoomFriction * (minZoomLevel / 3);
                                        else zoomLevel > maxZoomLevel && (zoomFriction = (zoomLevel - maxZoomLevel) / (minZoomLevel * 6), zoomFriction > 1 && (zoomFriction = 1), zoomLevel = maxZoomLevel + zoomFriction * minZoomLevel);
                                        zoomFriction < 0 && (zoomFriction = 0), _currPointsDistance = pointsDistance, _findCenterOfPoints(p, p2, _centerPoint), _currPanDist.x += _centerPoint.x - _currCenterPoint.x, _currPanDist.y += _centerPoint.y - _currCenterPoint.y, _equalizePoints(_currCenterPoint, _centerPoint), _panOffset.x = _calculatePanOffset("x", zoomLevel), _panOffset.y = _calculatePanOffset("y", zoomLevel), _isZoomingIn = zoomLevel > _currZoomLevel, _currZoomLevel = zoomLevel, _applyCurrentZoomPan()
                                    } else {
                                        if (!_direction || (_isFirstMove && (_isFirstMove = !1, Math.abs(delta.x) >= DIRECTION_CHECK_OFFSET && (delta.x -= _currentPoints[0].x - _startPoint.x), Math.abs(delta.y) >= DIRECTION_CHECK_OFFSET && (delta.y -= _currentPoints[0].y - _startPoint.y)), _currPoint.x = p.x, _currPoint.y = p.y, delta.x === 0 && delta.y === 0)) return;
                                        if (_direction === "v" && _options.closeOnVerticalDrag && !_canPan()) {
                                            _currPanDist.y += delta.y, _panOffset.y += delta.y;
                                            var opacityRatio = _calculateVerticalDragOpacityRatio();
                                            _verticalDragInitiated = !0, _shout("onVerticalDrag", opacityRatio), _applyBgOpacity(opacityRatio), _applyCurrentZoomPan();
                                            return
                                        }
                                        _pushPosPoint(_getCurrentTime(), p.x, p.y), _moved = !0, _currPanBounds = self2.currItem.bounds;
                                        var mainScrollChanged = _panOrMoveMainScroll("x", delta);
                                        mainScrollChanged || (_panOrMoveMainScroll("y", delta), _roundPoint(_panOffset), _applyCurrentZoomPan())
                                    }
                            }
                        },
                        _onDragRelease = function(e) {
                            if (_features.isOldAndroid) {
                                if (_oldAndroidTouchEndTimeout && e.type === "mouseup") return;
                                e.type.indexOf("touch") > -1 && (clearTimeout(_oldAndroidTouchEndTimeout), _oldAndroidTouchEndTimeout = setTimeout(function() {
                                    _oldAndroidTouchEndTimeout = 0
                                }, 600))
                            }
                            _shout("pointerUp"), _preventDefaultEventBehaviour(e, !1) && e.preventDefault();
                            var releasePoint;
                            if (_pointerEventEnabled) {
                                var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, "id");
                                if (pointerIndex > -1)
                                    if (releasePoint = _currPointers.splice(pointerIndex, 1)[0], navigator.msPointerEnabled) {
                                        var MSPOINTER_TYPES = {
                                            4: "mouse",
                                            2: "touch",
                                            3: "pen"
                                        };
                                        releasePoint.type = MSPOINTER_TYPES[e.pointerType], releasePoint.type || (releasePoint.type = e.pointerType || "mouse")
                                    } else releasePoint.type = e.pointerType || "mouse"
                            }
                            var touchList = _getTouchPoints(e),
                                gestureType, numPoints = touchList.length;
                            if (e.type === "mouseup" && (numPoints = 0), numPoints === 2) return _currentPoints = null, !0;
                            numPoints === 1 && _equalizePoints(_startPoint, touchList[0]), numPoints === 0 && !_direction && !_mainScrollAnimating && (releasePoint || (e.type === "mouseup" ? releasePoint = {
                                x: e.pageX,
                                y: e.pageY,
                                type: "mouse"
                            } : e.changedTouches && e.changedTouches[0] && (releasePoint = {
                                x: e.changedTouches[0].pageX,
                                y: e.changedTouches[0].pageY,
                                type: "touch"
                            })), _shout("touchRelease", e, releasePoint));
                            var releaseTimeDiff = -1;
                            if (numPoints === 0 && (_isDragging = !1, framework.unbind(window, _upMoveEvents, self2), _stopDragUpdateLoop(), _isZooming ? releaseTimeDiff = 0 : _lastReleaseTime !== -1 && (releaseTimeDiff = _getCurrentTime() - _lastReleaseTime)), _lastReleaseTime = numPoints === 1 ? _getCurrentTime() : -1, releaseTimeDiff !== -1 && releaseTimeDiff < 150 ? gestureType = "zoom" : gestureType = "swipe", _isZooming && numPoints < 2 && (_isZooming = !1, numPoints === 1 && (gestureType = "zoomPointerUp"), _shout("zoomGestureEnded")), _currentPoints = null, !(!_moved && !_zoomStarted && !_mainScrollAnimating && !_verticalDragInitiated)) {
                                if (_stopAllAnimations(), _releaseAnimData || (_releaseAnimData = _initDragReleaseAnimationData()), _releaseAnimData.calculateSwipeSpeed("x"), _verticalDragInitiated) {
                                    var opacityRatio = _calculateVerticalDragOpacityRatio();
                                    if (opacityRatio < _options.verticalDragRange) self2.close();
                                    else {
                                        var initalPanY = _panOffset.y,
                                            initialBgOpacity = _bgOpacity;
                                        _animateProp("verticalDrag", 0, 1, 300, framework.easing.cubic.out, function(now) {
                                            _panOffset.y = (self2.currItem.initialPosition.y - initalPanY) * now + initalPanY, _applyBgOpacity((1 - initialBgOpacity) * now + initialBgOpacity), _applyCurrentZoomPan()
                                        }), _shout("onVerticalDrag", 1)
                                    }
                                    return
                                }
                                if ((_mainScrollShifted || _mainScrollAnimating) && numPoints === 0) {
                                    var itemChanged = _finishSwipeMainScrollGesture(gestureType, _releaseAnimData);
                                    if (itemChanged) return;
                                    gestureType = "zoomPointerUp"
                                }
                                if (!_mainScrollAnimating) {
                                    if (gestureType !== "swipe") {
                                        _completeZoomGesture();
                                        return
                                    }!_mainScrollShifted && _currZoomLevel > self2.currItem.fitRatio && _completePanGesture(_releaseAnimData)
                                }
                            }
                        },
                        _initDragReleaseAnimationData = function() {
                            var lastFlickDuration, tempReleasePos, s = {
                                lastFlickOffset: {},
                                lastFlickDist: {},
                                lastFlickSpeed: {},
                                slowDownRatio: {},
                                slowDownRatioReverse: {},
                                speedDecelerationRatio: {},
                                speedDecelerationRatioAbs: {},
                                distanceOffset: {},
                                backAnimDestination: {},
                                backAnimStarted: {},
                                calculateSwipeSpeed: function(axis) {
                                    _posPoints.length > 1 ? (lastFlickDuration = _getCurrentTime() - _gestureCheckSpeedTime + 50, tempReleasePos = _posPoints[_posPoints.length - 2][axis]) : (lastFlickDuration = _getCurrentTime() - _gestureStartTime, tempReleasePos = _startPoint[axis]), s.lastFlickOffset[axis] = _currPoint[axis] - tempReleasePos, s.lastFlickDist[axis] = Math.abs(s.lastFlickOffset[axis]), s.lastFlickDist[axis] > 20 ? s.lastFlickSpeed[axis] = s.lastFlickOffset[axis] / lastFlickDuration : s.lastFlickSpeed[axis] = 0, Math.abs(s.lastFlickSpeed[axis]) < .1 && (s.lastFlickSpeed[axis] = 0), s.slowDownRatio[axis] = .95, s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis], s.speedDecelerationRatio[axis] = 1
                                },
                                calculateOverBoundsAnimOffset: function(axis, speed) {
                                    s.backAnimStarted[axis] || (_panOffset[axis] > _currPanBounds.min[axis] ? s.backAnimDestination[axis] = _currPanBounds.min[axis] : _panOffset[axis] < _currPanBounds.max[axis] && (s.backAnimDestination[axis] = _currPanBounds.max[axis]), s.backAnimDestination[axis] !== void 0 && (s.slowDownRatio[axis] = .7, s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis], s.speedDecelerationRatioAbs[axis] < .05 && (s.lastFlickSpeed[axis] = 0, s.backAnimStarted[axis] = !0, _animateProp("bounceZoomPan" + axis, _panOffset[axis], s.backAnimDestination[axis], speed || 300, framework.easing.sine.out, function(pos) {
                                        _panOffset[axis] = pos, _applyCurrentZoomPan()
                                    }))))
                                },
                                calculateAnimOffset: function(axis) {
                                    s.backAnimStarted[axis] || (s.speedDecelerationRatio[axis] = s.speedDecelerationRatio[axis] * (s.slowDownRatio[axis] + s.slowDownRatioReverse[axis] - s.slowDownRatioReverse[axis] * s.timeDiff / 10), s.speedDecelerationRatioAbs[axis] = Math.abs(s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis]), s.distanceOffset[axis] = s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis] * s.timeDiff, _panOffset[axis] += s.distanceOffset[axis])
                                },
                                panAnimLoop: function() {
                                    if (_animations.zoomPan && (_animations.zoomPan.raf = _requestAF(s.panAnimLoop), s.now = _getCurrentTime(), s.timeDiff = s.now - s.lastNow, s.lastNow = s.now, s.calculateAnimOffset("x"), s.calculateAnimOffset("y"), _applyCurrentZoomPan(), s.calculateOverBoundsAnimOffset("x"), s.calculateOverBoundsAnimOffset("y"), s.speedDecelerationRatioAbs.x < .05 && s.speedDecelerationRatioAbs.y < .05)) {
                                        _panOffset.x = Math.round(_panOffset.x), _panOffset.y = Math.round(_panOffset.y), _applyCurrentZoomPan(), _stopAnimation("zoomPan");
                                        return
                                    }
                                }
                            };
                            return s
                        },
                        _completePanGesture = function(animData) {
                            if (animData.calculateSwipeSpeed("y"), _currPanBounds = self2.currItem.bounds, animData.backAnimDestination = {}, animData.backAnimStarted = {}, Math.abs(animData.lastFlickSpeed.x) <= .05 && Math.abs(animData.lastFlickSpeed.y) <= .05) return animData.speedDecelerationRatioAbs.x = animData.speedDecelerationRatioAbs.y = 0, animData.calculateOverBoundsAnimOffset("x"), animData.calculateOverBoundsAnimOffset("y"), !0;
                            _registerStartAnimation("zoomPan"), animData.lastNow = _getCurrentTime(), animData.panAnimLoop()
                        },
                        _finishSwipeMainScrollGesture = function(gestureType, _releaseAnimData2) {
                            var itemChanged;
                            _mainScrollAnimating || (_currZoomedItemIndex = _currentItemIndex);
                            var itemsDiff;
                            if (gestureType === "swipe") {
                                var totalShiftDist = _currPoint.x - _startPoint.x,
                                    isFastLastFlick = _releaseAnimData2.lastFlickDist.x < 10;
                                totalShiftDist > MIN_SWIPE_DISTANCE && (isFastLastFlick || _releaseAnimData2.lastFlickOffset.x > 20) ? itemsDiff = -1 : totalShiftDist < -MIN_SWIPE_DISTANCE && (isFastLastFlick || _releaseAnimData2.lastFlickOffset.x < -20) && (itemsDiff = 1)
                            }
                            var nextCircle;
                            itemsDiff && (_currentItemIndex += itemsDiff, _currentItemIndex < 0 ? (_currentItemIndex = _options.loop ? _getNumItems() - 1 : 0, nextCircle = !0) : _currentItemIndex >= _getNumItems() && (_currentItemIndex = _options.loop ? 0 : _getNumItems() - 1, nextCircle = !0), (!nextCircle || _options.loop) && (_indexDiff += itemsDiff, _currPositionIndex -= itemsDiff, itemChanged = !0));
                            var animateToX = _slideSize.x * _currPositionIndex,
                                animateToDist = Math.abs(animateToX - _mainScrollPos.x),
                                finishAnimDuration;
                            return !itemChanged && animateToX > _mainScrollPos.x != _releaseAnimData2.lastFlickSpeed.x > 0 ? finishAnimDuration = 333 : (finishAnimDuration = Math.abs(_releaseAnimData2.lastFlickSpeed.x) > 0 ? animateToDist / Math.abs(_releaseAnimData2.lastFlickSpeed.x) : 333, finishAnimDuration = Math.min(finishAnimDuration, 400), finishAnimDuration = Math.max(finishAnimDuration, 250)), _currZoomedItemIndex === _currentItemIndex && (itemChanged = !1), _mainScrollAnimating = !0, _shout("mainScrollAnimStart"), _animateProp("mainScroll", _mainScrollPos.x, animateToX, finishAnimDuration, framework.easing.cubic.out, _moveMainScroll, function() {
                                _stopAllAnimations(), _mainScrollAnimating = !1, _currZoomedItemIndex = -1, (itemChanged || _currZoomedItemIndex !== _currentItemIndex) && self2.updateCurrItem(), _shout("mainScrollAnimComplete")
                            }), itemChanged && self2.updateCurrItem(!0), itemChanged
                        },
                        _calculateZoomLevel = function(touchesDistance) {
                            return 1 / _startPointsDistance * touchesDistance * _startZoomLevel
                        },
                        _completeZoomGesture = function() {
                            var destZoomLevel = _currZoomLevel,
                                minZoomLevel = _getMinZoomLevel(),
                                maxZoomLevel = _getMaxZoomLevel();
                            _currZoomLevel < minZoomLevel ? destZoomLevel = minZoomLevel : _currZoomLevel > maxZoomLevel && (destZoomLevel = maxZoomLevel);
                            var destOpacity = 1,
                                onUpdate, initialOpacity = _bgOpacity;
                            return _opacityChanged && !_isZoomingIn && !_wasOverInitialZoom && _currZoomLevel < minZoomLevel ? (self2.close(), !0) : (_opacityChanged && (onUpdate = function(now) {
                                _applyBgOpacity((destOpacity - initialOpacity) * now + initialOpacity)
                            }), self2.zoomTo(destZoomLevel, 0, 200, framework.easing.cubic.out, onUpdate), !0)
                        };
                    _registerModule("Gestures", {
                        publicMethods: {
                            initGestures: function() {
                                var addEventNames = function(pref, down, move, up, cancel) {
                                    _dragStartEvent = pref + down, _dragMoveEvent = pref + move, _dragEndEvent = pref + up, cancel ? _dragCancelEvent = pref + cancel : _dragCancelEvent = ""
                                };
                                _pointerEventEnabled = _features.pointerEvent, _pointerEventEnabled && _features.touch && (_features.touch = !1), _pointerEventEnabled ? navigator.msPointerEnabled ? addEventNames("MSPointer", "Down", "Move", "Up", "Cancel") : addEventNames("pointer", "down", "move", "up", "cancel") : _features.touch ? (addEventNames("touch", "start", "move", "end", "cancel"), _likelyTouchDevice = !0) : addEventNames("mouse", "down", "move", "up"), _upMoveEvents = _dragMoveEvent + " " + _dragEndEvent + " " + _dragCancelEvent, _downEvents = _dragStartEvent, _pointerEventEnabled && !_likelyTouchDevice && (_likelyTouchDevice = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1), self2.likelyTouchDevice = _likelyTouchDevice, _globalEventHandlers[_dragStartEvent] = _onDragStart, _globalEventHandlers[_dragMoveEvent] = _onDragMove, _globalEventHandlers[_dragEndEvent] = _onDragRelease, _dragCancelEvent && (_globalEventHandlers[_dragCancelEvent] = _globalEventHandlers[_dragEndEvent]), _features.touch && (_downEvents += " mousedown", _upMoveEvents += " mousemove mouseup", _globalEventHandlers.mousedown = _globalEventHandlers[_dragStartEvent], _globalEventHandlers.mousemove = _globalEventHandlers[_dragMoveEvent], _globalEventHandlers.mouseup = _globalEventHandlers[_dragEndEvent]), _likelyTouchDevice || (_options.allowPanToNext = !1)
                            }
                        }
                    });
                    var _showOrHideTimeout, _showOrHide = function(item, img, out, completeFn) {
                            _showOrHideTimeout && clearTimeout(_showOrHideTimeout), _initialZoomRunning = !0, _initialContentSet = !0;
                            var thumbBounds;
                            item.initialLayout ? (thumbBounds = item.initialLayout, item.initialLayout = null) : thumbBounds = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
                            var duration = out ? _options.hideAnimationDuration : _options.showAnimationDuration,
                                onComplete = function() {
                                    _stopAnimation("initialZoom"), out ? (self2.template.removeAttribute("style"), self2.bg.removeAttribute("style")) : (_applyBgOpacity(1), img && (img.style.display = "block"), framework.addClass(template, "pswp--animated-in"), _shout("initialZoom" + (out ? "OutEnd" : "InEnd"))), completeFn && completeFn(), _initialZoomRunning = !1
                                };
                            if (!duration || !thumbBounds || thumbBounds.x === void 0) {
                                _shout("initialZoom" + (out ? "Out" : "In")), _currZoomLevel = item.initialZoomLevel, _equalizePoints(_panOffset, item.initialPosition), _applyCurrentZoomPan(), template.style.opacity = out ? 0 : 1, _applyBgOpacity(1), duration ? setTimeout(function() {
                                    onComplete()
                                }, duration) : onComplete();
                                return
                            }
                            var startAnimation = function() {
                                var closeWithRaf = _closedByScroll,
                                    fadeEverything = !self2.currItem.src || self2.currItem.loadError || _options.showHideOpacity;
                                item.miniImg && (item.miniImg.style.webkitBackfaceVisibility = "hidden"), out || (_currZoomLevel = thumbBounds.w / item.w, _panOffset.x = thumbBounds.x, _panOffset.y = thumbBounds.y - _initalWindowScrollY, self2[fadeEverything ? "template" : "bg"].style.opacity = .001, _applyCurrentZoomPan()), _registerStartAnimation("initialZoom"), out && !closeWithRaf && framework.removeClass(template, "pswp--animated-in"), fadeEverything && (out ? framework[(closeWithRaf ? "remove" : "add") + "Class"](template, "pswp--animate_opacity") : setTimeout(function() {
                                    framework.addClass(template, "pswp--animate_opacity")
                                }, 30)), _showOrHideTimeout = setTimeout(function() {
                                    if (_shout("initialZoom" + (out ? "Out" : "In")), !out) _currZoomLevel = item.initialZoomLevel, _equalizePoints(_panOffset, item.initialPosition), _applyCurrentZoomPan(), _applyBgOpacity(1), fadeEverything ? template.style.opacity = 1 : _applyBgOpacity(1), _showOrHideTimeout = setTimeout(onComplete, duration + 20);
                                    else {
                                        var destZoomLevel = thumbBounds.w / item.w,
                                            initialPanOffset = {
                                                x: _panOffset.x,
                                                y: _panOffset.y
                                            },
                                            initialZoomLevel = _currZoomLevel,
                                            initalBgOpacity = _bgOpacity,
                                            onUpdate = function(now) {
                                                now === 1 ? (_currZoomLevel = destZoomLevel, _panOffset.x = thumbBounds.x, _panOffset.y = thumbBounds.y - _currentWindowScrollY) : (_currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel, _panOffset.x = (thumbBounds.x - initialPanOffset.x) * now + initialPanOffset.x, _panOffset.y = (thumbBounds.y - _currentWindowScrollY - initialPanOffset.y) * now + initialPanOffset.y), _applyCurrentZoomPan(), fadeEverything ? template.style.opacity = 1 - now : _applyBgOpacity(initalBgOpacity - now * initalBgOpacity)
                                            };
                                        closeWithRaf ? _animateProp("initialZoom", 0, 1, duration, framework.easing.cubic.out, onUpdate, onComplete) : (onUpdate(1), _showOrHideTimeout = setTimeout(onComplete, duration + 20))
                                    }
                                }, out ? 25 : 90)
                            };
                            startAnimation()
                        },
                        _items, _tempPanAreaSize = {},
                        _imagesToAppendPool = [],
                        _initialContentSet, _initialZoomRunning, _controllerDefaultOptions = {
                            index: 0,
                            errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
                            forceProgressiveLoading: !1,
                            preload: [1, 1],
                            getNumItemsFn: function() {
                                return _items.length
                            }
                        },
                        _getItemAt, _getNumItems, _getZeroBounds = function() {
                            return {
                                center: {
                                    x: 0,
                                    y: 0
                                },
                                max: {
                                    x: 0,
                                    y: 0
                                },
                                min: {
                                    x: 0,
                                    y: 0
                                }
                            }
                        },
                        _calculateSingleItemPanBounds = function(item, realPanElementW, realPanElementH) {
                            var bounds = item.bounds;
                            bounds.center.x = Math.round((_tempPanAreaSize.x - realPanElementW) / 2), bounds.center.y = Math.round((_tempPanAreaSize.y - realPanElementH) / 2) + item.vGap.top, bounds.max.x = realPanElementW > _tempPanAreaSize.x ? Math.round(_tempPanAreaSize.x - realPanElementW) : bounds.center.x, bounds.max.y = realPanElementH > _tempPanAreaSize.y ? Math.round(_tempPanAreaSize.y - realPanElementH) + item.vGap.top : bounds.center.y, bounds.min.x = realPanElementW > _tempPanAreaSize.x ? 0 : bounds.center.x, bounds.min.y = realPanElementH > _tempPanAreaSize.y ? item.vGap.top : bounds.center.y
                        },
                        _calculateItemSize = function(item, viewportSize, zoomLevel) {
                            if (item.src && !item.loadError) {
                                var isInitial = !zoomLevel;
                                if (isInitial && (item.vGap || (item.vGap = {
                                        top: 0,
                                        bottom: 0
                                    }), _shout("parseVerticalMargin", item)), _tempPanAreaSize.x = viewportSize.x, _tempPanAreaSize.y = viewportSize.y - item.vGap.top - item.vGap.bottom, isInitial) {
                                    var hRatio = _tempPanAreaSize.x / item.w,
                                        vRatio = _tempPanAreaSize.y / item.h;
                                    item.fitRatio = hRatio < vRatio ? hRatio : vRatio;
                                    var scaleMode = _options.scaleMode;
                                    scaleMode === "orig" ? zoomLevel = 1 : scaleMode === "fit" && (zoomLevel = item.fitRatio), zoomLevel > 1 && (zoomLevel = 1), item.initialZoomLevel = zoomLevel, item.bounds || (item.bounds = _getZeroBounds())
                                }
                                return zoomLevel ? (_calculateSingleItemPanBounds(item, item.w * zoomLevel, item.h * zoomLevel), isInitial && zoomLevel === item.initialZoomLevel && (item.initialPosition = item.bounds.center), item.bounds) : void 0
                            } else return item.w = item.h = 0, item.initialZoomLevel = item.fitRatio = 1, item.bounds = _getZeroBounds(), item.initialPosition = item.bounds.center, item.bounds
                        },
                        _appendImage = function(index, item, baseDiv, img, preventAnimation, keepPlaceholder) {
                            item.loadError || img && (item.imageAppended = !0, _setImageSize(item, img, item === self2.currItem && _renderMaxResolution), baseDiv.appendChild(img), keepPlaceholder && setTimeout(function() {
                                item && item.loaded && item.placeholder && (item.placeholder.style.display = "none", item.placeholder = null)
                            }, 500))
                        },
                        _preloadImage = function(item) {
                            item.loading = !0, item.loaded = !1;
                            var img = item.img = framework.createEl("pswp__img", "img"),
                                onComplete = function() {
                                    item.loading = !1, item.loaded = !0, item.loadComplete ? item.loadComplete(item) : item.img = null, img.onload = img.onerror = null, img = null
                                };
                            return img.onload = onComplete, img.onerror = function() {
                                item.loadError = !0, onComplete()
                            }, img.src = item.src, img
                        },
                        _checkForError = function(item, cleanUp) {
                            if (item.src && item.loadError && item.container) return cleanUp && (item.container.innerHTML = ""), item.container.innerHTML = _options.errorMsg.replace("%url%", item.src), !0
                        },
                        _setImageSize = function(item, img, maxRes) {
                            if (item.src) {
                                img || (img = item.container.lastChild);
                                var w = maxRes ? item.w : Math.round(item.w * item.fitRatio),
                                    h = maxRes ? item.h : Math.round(item.h * item.fitRatio);
                                item.placeholder && !item.loaded && (item.placeholder.style.width = w + "px", item.placeholder.style.height = h + "px"), img.style.width = w + "px", img.style.height = h + "px"
                            }
                        },
                        _appendImagesPool = function() {
                            if (_imagesToAppendPool.length) {
                                for (var poolItem, i = 0; i < _imagesToAppendPool.length; i++) poolItem = _imagesToAppendPool[i], poolItem.holder.index === poolItem.index && _appendImage(poolItem.index, poolItem.item, poolItem.baseDiv, poolItem.img, !1, poolItem.clearPlaceholder);
                                _imagesToAppendPool = []
                            }
                        };
                    _registerModule("Controller", {
                        publicMethods: {
                            lazyLoadItem: function(index) {
                                index = _getLoopedId(index);
                                var item = _getItemAt(index);
                                !item || (item.loaded || item.loading) && !_itemsNeedUpdate || (_shout("gettingData", index, item), item.src && _preloadImage(item))
                            },
                            initController: function() {
                                framework.extend(_options, _controllerDefaultOptions, !0), self2.items = _items = items, _getItemAt = self2.getItemAt, _getNumItems = _options.getNumItemsFn, _getNumItems() < 3 && (_options.loop = !1), _listen("beforeChange", function(diff) {
                                    var p3 = _options.preload,
                                        isNext = diff === null ? !0 : diff >= 0,
                                        preloadBefore = Math.min(p3[0], _getNumItems()),
                                        preloadAfter = Math.min(p3[1], _getNumItems()),
                                        i;
                                    for (i = 1; i <= (isNext ? preloadAfter : preloadBefore); i++) self2.lazyLoadItem(_currentItemIndex + i);
                                    for (i = 1; i <= (isNext ? preloadBefore : preloadAfter); i++) self2.lazyLoadItem(_currentItemIndex - i)
                                }), _listen("initialLayout", function() {
                                    self2.currItem.initialLayout = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex)
                                }), _listen("mainScrollAnimComplete", _appendImagesPool), _listen("initialZoomInEnd", _appendImagesPool), _listen("destroy", function() {
                                    for (var item, i = 0; i < _items.length; i++) item = _items[i], item.container && (item.container = null), item.placeholder && (item.placeholder = null), item.img && (item.img = null), item.preloader && (item.preloader = null), item.loadError && (item.loaded = item.loadError = !1);
                                    _imagesToAppendPool = null
                                })
                            },
                            getItemAt: function(index) {
                                return index >= 0 && _items[index] !== void 0 ? _items[index] : !1
                            },
                            allowProgressiveImg: function() {
                                return _options.forceProgressiveLoading || !_likelyTouchDevice || _options.mouseUsed || screen.width > 1200
                            },
                            setContent: function(holder, index) {
                                _options.loop && (index = _getLoopedId(index));
                                var prevItem = self2.getItemAt(holder.index);
                                prevItem && (prevItem.container = null);
                                var item = self2.getItemAt(index),
                                    img;
                                if (!item) {
                                    holder.el.innerHTML = "";
                                    return
                                }
                                _shout("gettingData", index, item), holder.index = index, holder.item = item;
                                var baseDiv = item.container = framework.createEl("pswp__zoom-wrap");
                                if (!item.src && item.html && (item.html.tagName ? baseDiv.appendChild(item.html) : baseDiv.innerHTML = item.html), _checkForError(item), _calculateItemSize(item, _viewportSize), item.src && !item.loadError && !item.loaded) {
                                    if (item.loadComplete = function(item2) {
                                            if (_isOpen) {
                                                if (holder && holder.index === index) {
                                                    if (_checkForError(item2, !0)) {
                                                        item2.loadComplete = item2.img = null, _calculateItemSize(item2, _viewportSize), _applyZoomPanToItem(item2), holder.index === _currentItemIndex && self2.updateCurrZoomItem();
                                                        return
                                                    }
                                                    item2.imageAppended ? !_initialZoomRunning && item2.placeholder && (item2.placeholder.style.display = "none", item2.placeholder = null) : _features.transform && (_mainScrollAnimating || _initialZoomRunning) ? _imagesToAppendPool.push({
                                                        item: item2,
                                                        baseDiv: baseDiv,
                                                        img: item2.img,
                                                        index: index,
                                                        holder: holder,
                                                        clearPlaceholder: !0
                                                    }) : _appendImage(index, item2, baseDiv, item2.img, _mainScrollAnimating || _initialZoomRunning, !0)
                                                }
                                                item2.loadComplete = null, item2.img = null, _shout("imageLoadComplete", index, item2)
                                            }
                                        }, framework.features.transform) {
                                        var placeholderClassName = "pswp__img pswp__img--placeholder";
                                        placeholderClassName += item.msrc ? "" : " pswp__img--placeholder--blank";
                                        var placeholder = framework.createEl(placeholderClassName, item.msrc ? "img" : "");
                                        item.msrc && (placeholder.src = item.msrc), _setImageSize(item, placeholder), baseDiv.appendChild(placeholder), item.placeholder = placeholder
                                    }
                                    item.loading || _preloadImage(item), self2.allowProgressiveImg() && (!_initialContentSet && _features.transform ? _imagesToAppendPool.push({
                                        item: item,
                                        baseDiv: baseDiv,
                                        img: item.img,
                                        index: index,
                                        holder: holder
                                    }) : _appendImage(index, item, baseDiv, item.img, !0, !0))
                                } else item.src && !item.loadError && (img = framework.createEl("pswp__img", "img"), img.style.opacity = 1, img.src = item.src, _setImageSize(item, img), _appendImage(index, item, baseDiv, img));
                                !_initialContentSet && index === _currentItemIndex ? (_currZoomElementStyle = baseDiv.style, _showOrHide(item, img || item.img)) : _applyZoomPanToItem(item), holder.el.innerHTML = "", holder.el.appendChild(baseDiv)
                            },
                            cleanSlide: function(item) {
                                item.img && (item.img.onload = item.img.onerror = null), item.loaded = item.loading = item.img = item.imageAppended = !1
                            }
                        }
                    });
                    var tapTimer, tapReleasePoint = {},
                        _dispatchTapEvent = function(origEvent, releasePoint, pointerType) {
                            var e = document.createEvent("CustomEvent"),
                                eDetail = {
                                    origEvent: origEvent,
                                    target: origEvent.target,
                                    releasePoint: releasePoint,
                                    pointerType: pointerType || "touch"
                                };
                            e.initCustomEvent("pswpTap", !0, !0, eDetail), origEvent.target.dispatchEvent(e)
                        };
                    _registerModule("Tap", {
                        publicMethods: {
                            initTap: function() {
                                _listen("firstTouchStart", self2.onTapStart), _listen("touchRelease", self2.onTapRelease), _listen("destroy", function() {
                                    tapReleasePoint = {}, tapTimer = null
                                })
                            },
                            onTapStart: function(touchList) {
                                touchList.length > 1 && (clearTimeout(tapTimer), tapTimer = null)
                            },
                            onTapRelease: function(e, releasePoint) {
                                if (releasePoint && !_moved && !_isMultitouch && !_numAnimations) {
                                    var p0 = releasePoint;
                                    if (tapTimer && (clearTimeout(tapTimer), tapTimer = null, _isNearbyPoints(p0, tapReleasePoint))) {
                                        _shout("doubleTap", p0);
                                        return
                                    }
                                    if (releasePoint.type === "mouse") {
                                        _dispatchTapEvent(e, releasePoint, "mouse");
                                        return
                                    }
                                    var clickedTagName = e.target.tagName.toUpperCase();
                                    if (clickedTagName === "BUTTON" || framework.hasClass(e.target, "pswp__single-tap")) {
                                        _dispatchTapEvent(e, releasePoint);
                                        return
                                    }
                                    _equalizePoints(tapReleasePoint, p0), tapTimer = setTimeout(function() {
                                        _dispatchTapEvent(e, releasePoint), tapTimer = null
                                    }, 300)
                                }
                            }
                        }
                    });
                    var _wheelDelta;
                    _registerModule("DesktopZoom", {
                        publicMethods: {
                            initDesktopZoom: function() {
                                _oldIE || (_likelyTouchDevice ? _listen("mouseUsed", function() {
                                    self2.setupDesktopZoom()
                                }) : self2.setupDesktopZoom(!0))
                            },
                            setupDesktopZoom: function(onInit) {
                                _wheelDelta = {};
                                var events = "wheel mousewheel DOMMouseScroll";
                                _listen("bindEvents", function() {
                                    framework.bind(template, events, self2.handleMouseWheel)
                                }), _listen("unbindEvents", function() {
                                    _wheelDelta && framework.unbind(template, events, self2.handleMouseWheel)
                                }), self2.mouseZoomedIn = !1;
                                var hasDraggingClass, updateZoomable = function() {
                                        self2.mouseZoomedIn && (framework.removeClass(template, "pswp--zoomed-in"), self2.mouseZoomedIn = !1), _currZoomLevel < 1 ? framework.addClass(template, "pswp--zoom-allowed") : framework.removeClass(template, "pswp--zoom-allowed"), removeDraggingClass()
                                    },
                                    removeDraggingClass = function() {
                                        hasDraggingClass && (framework.removeClass(template, "pswp--dragging"), hasDraggingClass = !1)
                                    };
                                _listen("resize", updateZoomable), _listen("afterChange", updateZoomable), _listen("pointerDown", function() {
                                    self2.mouseZoomedIn && (hasDraggingClass = !0, framework.addClass(template, "pswp--dragging"))
                                }), _listen("pointerUp", removeDraggingClass), onInit || updateZoomable()
                            },
                            handleMouseWheel: function(e) {
                                if (_currZoomLevel <= self2.currItem.fitRatio) return _options.modal && (!_options.closeOnScroll || _numAnimations || _isDragging ? e.preventDefault() : _transformKey && Math.abs(e.deltaY) > 2 && (_closedByScroll = !0, self2.close())), !0;
                                if (e.stopPropagation(), _wheelDelta.x = 0, "deltaX" in e) e.deltaMode === 1 ? (_wheelDelta.x = e.deltaX * 18, _wheelDelta.y = e.deltaY * 18) : (_wheelDelta.x = e.deltaX, _wheelDelta.y = e.deltaY);
                                else if ("wheelDelta" in e) e.wheelDeltaX && (_wheelDelta.x = -.16 * e.wheelDeltaX), e.wheelDeltaY ? _wheelDelta.y = -.16 * e.wheelDeltaY : _wheelDelta.y = -.16 * e.wheelDelta;
                                else if ("detail" in e) _wheelDelta.y = e.detail;
                                else return;
                                _calculatePanBounds(_currZoomLevel, !0);
                                var newPanX = _panOffset.x - _wheelDelta.x,
                                    newPanY = _panOffset.y - _wheelDelta.y;
                                (_options.modal || newPanX <= _currPanBounds.min.x && newPanX >= _currPanBounds.max.x && newPanY <= _currPanBounds.min.y && newPanY >= _currPanBounds.max.y) && e.preventDefault(), self2.panTo(newPanX, newPanY)
                            },
                            toggleDesktopZoom: function(centerPoint) {
                                centerPoint = centerPoint || {
                                    x: _viewportSize.x / 2 + _offset.x,
                                    y: _viewportSize.y / 2 + _offset.y
                                };
                                var doubleTapZoomLevel = _options.getDoubleTapZoom(!0, self2.currItem),
                                    zoomOut = _currZoomLevel === doubleTapZoomLevel;
                                self2.mouseZoomedIn = !zoomOut, self2.zoomTo(zoomOut ? self2.currItem.initialZoomLevel : doubleTapZoomLevel, centerPoint, 333), framework[(zoomOut ? "remove" : "add") + "Class"](template, "pswp--zoomed-in")
                            }
                        }
                    });
                    var _historyDefaultOptions = {
                            history: !0,
                            galleryUID: 1
                        },
                        _historyUpdateTimeout, _hashChangeTimeout, _hashAnimCheckTimeout, _hashChangedByScript, _hashChangedByHistory, _hashReseted, _initialHash, _historyChanged, _closedFromURL, _urlChangedOnce, _windowLoc, _supportsPushState, _getHash = function() {
                            return _windowLoc.hash.substring(1)
                        },
                        _cleanHistoryTimeouts = function() {
                            _historyUpdateTimeout && clearTimeout(_historyUpdateTimeout), _hashAnimCheckTimeout && clearTimeout(_hashAnimCheckTimeout)
                        },
                        _parseItemIndexFromURL = function() {
                            var hash = _getHash(),
                                params = {};
                            if (hash.length < 5) return params;
                            var i, vars = hash.split("&");
                            for (i = 0; i < vars.length; i++)
                                if (vars[i]) {
                                    var pair = vars[i].split("=");
                                    pair.length < 2 || (params[pair[0]] = pair[1])
                                } if (_options.galleryPIDs) {
                                var searchfor = params.pid;
                                for (params.pid = 0, i = 0; i < _items.length; i++)
                                    if (_items[i].pid === searchfor) {
                                        params.pid = i;
                                        break
                                    }
                            } else params.pid = parseInt(params.pid, 10) - 1;
                            return params.pid < 0 && (params.pid = 0), params
                        },
                        _updateHash = function _updateHash2() {
                            if (_hashAnimCheckTimeout && clearTimeout(_hashAnimCheckTimeout), _numAnimations || _isDragging) {
                                _hashAnimCheckTimeout = setTimeout(_updateHash2, 500);
                                return
                            }
                            _hashChangedByScript ? clearTimeout(_hashChangeTimeout) : _hashChangedByScript = !0;
                            var pid = _currentItemIndex + 1,
                                item = _getItemAt(_currentItemIndex);
                            item.hasOwnProperty("pid") && (pid = item.pid);
                            var newHash = _initialHash + "&gid=" + _options.galleryUID + "&pid=" + pid;
                            _historyChanged || _windowLoc.hash.indexOf(newHash) === -1 && (_urlChangedOnce = !0);
                            var newURL = _windowLoc.href.split("#")[0] + "#" + newHash;
                            _supportsPushState ? "#" + newHash !== window.location.hash && history[_historyChanged ? "replaceState" : "pushState"]("", document.title, newURL) : _historyChanged ? _windowLoc.replace(newURL) : _windowLoc.hash = newHash, _historyChanged = !0, _hashChangeTimeout = setTimeout(function() {
                                _hashChangedByScript = !1
                            }, 60)
                        };
                    _registerModule("History", {
                        publicMethods: {
                            initHistory: function() {
                                if (framework.extend(_options, _historyDefaultOptions, !0), !!_options.history) {
                                    _windowLoc = window.location, _urlChangedOnce = !1, _closedFromURL = !1, _historyChanged = !1, _initialHash = _getHash(), _supportsPushState = "pushState" in history, _initialHash.indexOf("gid=") > -1 && (_initialHash = _initialHash.split("&gid=")[0], _initialHash = _initialHash.split("?gid=")[0]), _listen("afterChange", self2.updateURL), _listen("unbindEvents", function() {
                                        framework.unbind(window, "hashchange", self2.onHashChange)
                                    });
                                    var returnToOriginal = function() {
                                        _hashReseted = !0, _closedFromURL || (_urlChangedOnce ? history.back() : _initialHash ? _windowLoc.hash = _initialHash : _supportsPushState ? history.pushState("", document.title, _windowLoc.pathname + _windowLoc.search) : _windowLoc.hash = ""), _cleanHistoryTimeouts()
                                    };
                                    _listen("unbindEvents", function() {
                                        _closedByScroll && returnToOriginal()
                                    }), _listen("destroy", function() {
                                        _hashReseted || returnToOriginal()
                                    }), _listen("firstUpdate", function() {
                                        _currentItemIndex = _parseItemIndexFromURL().pid
                                    });
                                    var index = _initialHash.indexOf("pid=");
                                    index > -1 && (_initialHash = _initialHash.substring(0, index), _initialHash.slice(-1) === "&" && (_initialHash = _initialHash.slice(0, -1))), setTimeout(function() {
                                        _isOpen && framework.bind(window, "hashchange", self2.onHashChange)
                                    }, 40)
                                }
                            },
                            onHashChange: function() {
                                if (_getHash() === _initialHash) {
                                    _closedFromURL = !0, self2.close();
                                    return
                                }
                                _hashChangedByScript || (_hashChangedByHistory = !0, self2.goTo(_parseItemIndexFromURL().pid), _hashChangedByHistory = !1)
                            },
                            updateURL: function() {
                                _cleanHistoryTimeouts(), !_hashChangedByHistory && (_historyChanged ? _historyUpdateTimeout = setTimeout(_updateHash, 800) : _updateHash())
                            }
                        }
                    }), framework.extend(self2, publicMethods)
                };
                return PhotoSwipe
            })
        });

    function _typeof$1(obj) {
        return typeof Symbol == "function" && _typeof(Symbol.iterator) === "symbol" ? _typeof$1 = function(obj2) {
            return _typeof(obj2)
        } : _typeof$1 = function(obj2) {
            return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : _typeof(obj2)
        }, _typeof$1(obj)
    }
    var HAS_DOM_2 = (typeof HTMLElement == "undefined" ? "undefined" : _typeof$1(HTMLElement)) === "object";

    function isDOMElement(obj) {
        return HAS_DOM_2 ? obj instanceof HTMLElement : obj && _typeof$1(obj) === "object" && obj !== null && obj.nodeType === 1 && typeof obj.nodeName == "string"
    }

    function addClasses(el, classNames) {
        classNames.forEach(function(className) {
            el.classList.add(className)
        })
    }

    function removeClasses(el, classNames) {
        classNames.forEach(function(className) {
            el.classList.remove(className)
        })
    }
    var RULES = ".drift-bounding-box,.drift-zoom-pane{position:absolute;pointer-events:none}@keyframes noop{0%{zoom:1}}@-webkit-keyframes noop{0%{zoom:1}}.drift-zoom-pane.drift-open{display:block}.drift-zoom-pane.drift-closing,.drift-zoom-pane.drift-opening{animation:noop 1ms;-webkit-animation:noop 1ms}.drift-zoom-pane{overflow:hidden;width:100%;height:100%;top:0;left:0}.drift-zoom-pane-loader{display:none}.drift-zoom-pane img{position:absolute;display:block;max-width:none;max-height:none}";

    function injectBaseStylesheet() {
        if (!document.querySelector(".drift-base-styles")) {
            var styleEl = document.createElement("style");
            styleEl.type = "text/css", styleEl.classList.add("drift-base-styles"), styleEl.appendChild(document.createTextNode(RULES));
            var head = document.head;
            head.insertBefore(styleEl, head.firstChild)
        }
    }

    function throwIfMissing() {
        throw new Error("Missing parameter")
    }

    function _classCallCheck$1(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function")
    }

    function _defineProperties$1(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor)
        }
    }

    function _createClass$1(Constructor, protoProps, staticProps) {
        return protoProps && _defineProperties$1(Constructor.prototype, protoProps), staticProps && _defineProperties$1(Constructor, staticProps), Constructor
    }
    var BoundingBox = (function() {
        function BoundingBox2(options) {
            _classCallCheck$1(this, BoundingBox2), this.isShowing = !1;
            var _options$namespace = options.namespace,
                namespace = _options$namespace === void 0 ? null : _options$namespace,
                _options$zoomFactor = options.zoomFactor,
                zoomFactor = _options$zoomFactor === void 0 ? throwIfMissing() : _options$zoomFactor,
                _options$containerEl = options.containerEl,
                containerEl = _options$containerEl === void 0 ? throwIfMissing() : _options$containerEl;
            this.settings = {
                namespace: namespace,
                zoomFactor: zoomFactor,
                containerEl: containerEl
            }, this.openClasses = this._buildClasses("open"), this._buildElement()
        }
        return _createClass$1(BoundingBox2, [{
            key: "_buildClasses",
            value: function(suffix) {
                var classes = ["drift-".concat(suffix)],
                    ns = this.settings.namespace;
                return ns && classes.push("".concat(ns, "-").concat(suffix)), classes
            }
        }, {
            key: "_buildElement",
            value: function() {
                this.el = document.createElement("div"), addClasses(this.el, this._buildClasses("bounding-box"))
            }
        }, {
            key: "show",
            value: function(zoomPaneWidth, zoomPaneHeight) {
                this.isShowing = !0, this.settings.containerEl.appendChild(this.el);
                var style = this.el.style;
                style.width = "".concat(Math.round(zoomPaneWidth / this.settings.zoomFactor), "px"), style.height = "".concat(Math.round(zoomPaneHeight / this.settings.zoomFactor), "px"), addClasses(this.el, this.openClasses)
            }
        }, {
            key: "hide",
            value: function() {
                this.isShowing && this.settings.containerEl.removeChild(this.el), this.isShowing = !1, removeClasses(this.el, this.openClasses)
            }
        }, {
            key: "setPosition",
            value: function(percentageOffsetX, percentageOffsetY, triggerRect) {
                var pageXOffset = window.pageXOffset,
                    pageYOffset = window.pageYOffset,
                    inlineLeft = triggerRect.left + percentageOffsetX * triggerRect.width - this.el.clientWidth / 2 + pageXOffset,
                    inlineTop = triggerRect.top + percentageOffsetY * triggerRect.height - this.el.clientHeight / 2 + pageYOffset;
                inlineLeft < triggerRect.left + pageXOffset ? inlineLeft = triggerRect.left + pageXOffset : inlineLeft + this.el.clientWidth > triggerRect.left + triggerRect.width + pageXOffset && (inlineLeft = triggerRect.left + triggerRect.width - this.el.clientWidth + pageXOffset), inlineTop < triggerRect.top + pageYOffset ? inlineTop = triggerRect.top + pageYOffset : inlineTop + this.el.clientHeight > triggerRect.top + triggerRect.height + pageYOffset && (inlineTop = triggerRect.top + triggerRect.height - this.el.clientHeight + pageYOffset), this.el.style.left = "".concat(inlineLeft, "px"), this.el.style.top = "".concat(inlineTop, "px")
            }
        }]), BoundingBox2
    })();

    function _classCallCheck$2(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function")
    }

    function _defineProperties$2(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor)
        }
    }

    function _createClass$2(Constructor, protoProps, staticProps) {
        return protoProps && _defineProperties$2(Constructor.prototype, protoProps), staticProps && _defineProperties$2(Constructor, staticProps), Constructor
    }
    var Trigger = (function() {
        function Trigger2() {
            var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            _classCallCheck$2(this, Trigger2), this._show = this._show.bind(this), this._hide = this._hide.bind(this), this._handleEntry = this._handleEntry.bind(this), this._handleMovement = this._handleMovement.bind(this);
            var _options$el = options.el,
                el = _options$el === void 0 ? throwIfMissing() : _options$el,
                _options$zoomPane = options.zoomPane,
                zoomPane = _options$zoomPane === void 0 ? throwIfMissing() : _options$zoomPane,
                _options$sourceAttrib = options.sourceAttribute,
                sourceAttribute = _options$sourceAttrib === void 0 ? throwIfMissing() : _options$sourceAttrib,
                _options$handleTouch = options.handleTouch,
                handleTouch = _options$handleTouch === void 0 ? throwIfMissing() : _options$handleTouch,
                _options$onShow = options.onShow,
                onShow = _options$onShow === void 0 ? null : _options$onShow,
                _options$onHide = options.onHide,
                onHide = _options$onHide === void 0 ? null : _options$onHide,
                _options$hoverDelay = options.hoverDelay,
                hoverDelay = _options$hoverDelay === void 0 ? 0 : _options$hoverDelay,
                _options$touchDelay = options.touchDelay,
                touchDelay = _options$touchDelay === void 0 ? 0 : _options$touchDelay,
                _options$hoverBoundin = options.hoverBoundingBox,
                hoverBoundingBox = _options$hoverBoundin === void 0 ? throwIfMissing() : _options$hoverBoundin,
                _options$touchBoundin = options.touchBoundingBox,
                touchBoundingBox = _options$touchBoundin === void 0 ? throwIfMissing() : _options$touchBoundin,
                _options$namespace = options.namespace,
                namespace = _options$namespace === void 0 ? null : _options$namespace,
                _options$zoomFactor = options.zoomFactor,
                zoomFactor = _options$zoomFactor === void 0 ? throwIfMissing() : _options$zoomFactor,
                _options$boundingBoxC = options.boundingBoxContainer,
                boundingBoxContainer = _options$boundingBoxC === void 0 ? throwIfMissing() : _options$boundingBoxC;
            this.settings = {
                el: el,
                zoomPane: zoomPane,
                sourceAttribute: sourceAttribute,
                handleTouch: handleTouch,
                onShow: onShow,
                onHide: onHide,
                hoverDelay: hoverDelay,
                touchDelay: touchDelay,
                hoverBoundingBox: hoverBoundingBox,
                touchBoundingBox: touchBoundingBox,
                namespace: namespace,
                zoomFactor: zoomFactor,
                boundingBoxContainer: boundingBoxContainer
            }, (this.settings.hoverBoundingBox || this.settings.touchBoundingBox) && (this.boundingBox = new BoundingBox({
                namespace: this.settings.namespace,
                zoomFactor: this.settings.zoomFactor,
                containerEl: this.settings.boundingBoxContainer
            })), this.enabled = !0, this._bindEvents()
        }
        return _createClass$2(Trigger2, [{
            key: "_preventDefault",
            value: function(event2) {
                event2.preventDefault()
            }
        }, {
            key: "_preventDefaultAllowTouchScroll",
            value: function(event2) {
                (!this.settings.touchDelay || !this._isTouchEvent(event2) || this.isShowing) && event2.preventDefault()
            }
        }, {
            key: "_isTouchEvent",
            value: function(event2) {
                return !!event2.touches
            }
        }, {
            key: "_bindEvents",
            value: function() {
                this.settings.el.addEventListener("mouseenter", this._handleEntry, !1), this.settings.el.addEventListener("mouseleave", this._hide, !1), this.settings.el.addEventListener("mousemove", this._handleMovement, !1), this.settings.handleTouch ? (this.settings.el.addEventListener("touchstart", this._handleEntry, !1), this.settings.el.addEventListener("touchend", this._hide, !1), this.settings.el.addEventListener("touchmove", this._handleMovement, !1)) : (this.settings.el.addEventListener("touchstart", this._preventDefault, !1), this.settings.el.addEventListener("touchend", this._preventDefault, !1), this.settings.el.addEventListener("touchmove", this._preventDefault, !1))
            }
        }, {
            key: "_unbindEvents",
            value: function() {
                this.settings.el.removeEventListener("mouseenter", this._handleEntry, !1), this.settings.el.removeEventListener("mouseleave", this._hide, !1), this.settings.el.removeEventListener("mousemove", this._handleMovement, !1), this.settings.handleTouch ? (this.settings.el.removeEventListener("touchstart", this._handleEntry, !1), this.settings.el.removeEventListener("touchend", this._hide, !1), this.settings.el.removeEventListener("touchmove", this._handleMovement, !1)) : (this.settings.el.removeEventListener("touchstart", this._preventDefault, !1), this.settings.el.removeEventListener("touchend", this._preventDefault, !1), this.settings.el.removeEventListener("touchmove", this._preventDefault, !1))
            }
        }, {
            key: "_handleEntry",
            value: function(e) {
                this._preventDefaultAllowTouchScroll(e), this._lastMovement = e, e.type == "mouseenter" && this.settings.hoverDelay ? this.entryTimeout = setTimeout(this._show, this.settings.hoverDelay) : this.settings.touchDelay ? this.entryTimeout = setTimeout(this._show, this.settings.touchDelay) : this._show()
            }
        }, {
            key: "_show",
            value: function() {
                if (this.enabled) {
                    var onShow = this.settings.onShow;
                    if (onShow && typeof onShow == "function" && onShow(), this.settings.zoomPane.show(this.settings.el.getAttribute(this.settings.sourceAttribute), this.settings.el.clientWidth, this.settings.el.clientHeight), this._lastMovement) {
                        var touchActivated = this._lastMovement.touches;
                        (touchActivated && this.settings.touchBoundingBox || !touchActivated && this.settings.hoverBoundingBox) && this.boundingBox.show(this.settings.zoomPane.el.clientWidth, this.settings.zoomPane.el.clientHeight)
                    }
                    this._handleMovement()
                }
            }
        }, {
            key: "_hide",
            value: function(e) {
                e && this._preventDefaultAllowTouchScroll(e), this._lastMovement = null, this.entryTimeout && clearTimeout(this.entryTimeout), this.boundingBox && this.boundingBox.hide();
                var onHide = this.settings.onHide;
                onHide && typeof onHide == "function" && onHide(), this.settings.zoomPane.hide()
            }
        }, {
            key: "_handleMovement",
            value: function(e) {
                if (e) this._preventDefaultAllowTouchScroll(e), this._lastMovement = e;
                else if (this._lastMovement) e = this._lastMovement;
                else return;
                var movementX, movementY;
                if (e.touches) {
                    var firstTouch = e.touches[0];
                    movementX = firstTouch.clientX, movementY = firstTouch.clientY
                } else movementX = e.clientX, movementY = e.clientY;
                var el = this.settings.el,
                    rect = el.getBoundingClientRect(),
                    offsetX = movementX - rect.left,
                    offsetY = movementY - rect.top,
                    percentageOffsetX = offsetX / this.settings.el.clientWidth,
                    percentageOffsetY = offsetY / this.settings.el.clientHeight;
                this.boundingBox && this.boundingBox.setPosition(percentageOffsetX, percentageOffsetY, rect), this.settings.zoomPane.setPosition(percentageOffsetX, percentageOffsetY, rect)
            }
        }, {
            key: "isShowing",
            get: function() {
                return this.settings.zoomPane.isShowing
            }
        }]), Trigger2
    })();

    function _classCallCheck$3(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function")
    }

    function _defineProperties$3(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor)
        }
    }

    function _createClass$3(Constructor, protoProps, staticProps) {
        return protoProps && _defineProperties$3(Constructor.prototype, protoProps), staticProps && _defineProperties$3(Constructor, staticProps), Constructor
    }
    var divStyle = document.createElement("div").style,
        HAS_ANIMATION = typeof document == "undefined" ? !1 : "animation" in divStyle || "webkitAnimation" in divStyle,
        ZoomPane = (function() {
            function ZoomPane2() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                _classCallCheck$3(this, ZoomPane2), this._completeShow = this._completeShow.bind(this), this._completeHide = this._completeHide.bind(this), this._handleLoad = this._handleLoad.bind(this), this.isShowing = !1;
                var _options$container = options.container,
                    container = _options$container === void 0 ? null : _options$container,
                    _options$zoomFactor = options.zoomFactor,
                    zoomFactor = _options$zoomFactor === void 0 ? throwIfMissing() : _options$zoomFactor,
                    _options$inline = options.inline,
                    inline = _options$inline === void 0 ? throwIfMissing() : _options$inline,
                    _options$namespace = options.namespace,
                    namespace = _options$namespace === void 0 ? null : _options$namespace,
                    _options$showWhitespa = options.showWhitespaceAtEdges,
                    showWhitespaceAtEdges = _options$showWhitespa === void 0 ? throwIfMissing() : _options$showWhitespa,
                    _options$containInlin = options.containInline,
                    containInline = _options$containInlin === void 0 ? throwIfMissing() : _options$containInlin,
                    _options$inlineOffset = options.inlineOffsetX,
                    inlineOffsetX = _options$inlineOffset === void 0 ? 0 : _options$inlineOffset,
                    _options$inlineOffset2 = options.inlineOffsetY,
                    inlineOffsetY = _options$inlineOffset2 === void 0 ? 0 : _options$inlineOffset2,
                    _options$inlineContai = options.inlineContainer,
                    inlineContainer = _options$inlineContai === void 0 ? document.body : _options$inlineContai;
                this.settings = {
                    container: container,
                    zoomFactor: zoomFactor,
                    inline: inline,
                    namespace: namespace,
                    showWhitespaceAtEdges: showWhitespaceAtEdges,
                    containInline: containInline,
                    inlineOffsetX: inlineOffsetX,
                    inlineOffsetY: inlineOffsetY,
                    inlineContainer: inlineContainer
                }, this.openClasses = this._buildClasses("open"), this.openingClasses = this._buildClasses("opening"), this.closingClasses = this._buildClasses("closing"), this.inlineClasses = this._buildClasses("inline"), this.loadingClasses = this._buildClasses("loading"), this._buildElement()
            }
            return _createClass$3(ZoomPane2, [{
                key: "_buildClasses",
                value: function(suffix) {
                    var classes = ["drift-".concat(suffix)],
                        ns = this.settings.namespace;
                    return ns && classes.push("".concat(ns, "-").concat(suffix)), classes
                }
            }, {
                key: "_buildElement",
                value: function() {
                    this.el = document.createElement("div"), addClasses(this.el, this._buildClasses("zoom-pane"));
                    var loaderEl = document.createElement("div");
                    addClasses(loaderEl, this._buildClasses("zoom-pane-loader")), this.el.appendChild(loaderEl), this.imgEl = document.createElement("img"), this.el.appendChild(this.imgEl)
                }
            }, {
                key: "_setImageURL",
                value: function(imageURL) {
                    this.imgEl.setAttribute("src", imageURL)
                }
            }, {
                key: "_setImageSize",
                value: function(triggerWidth, triggerHeight) {
                    this.imgEl.style.width = "".concat(triggerWidth * this.settings.zoomFactor, "px"), this.imgEl.style.height = "".concat(triggerHeight * this.settings.zoomFactor, "px")
                }
            }, {
                key: "setPosition",
                value: function(percentageOffsetX, percentageOffsetY, triggerRect) {
                    var imgElWidth = this.imgEl.offsetWidth,
                        imgElHeight = this.imgEl.offsetHeight,
                        elWidth = this.el.offsetWidth,
                        elHeight = this.el.offsetHeight,
                        centreOfContainerX = elWidth / 2,
                        centreOfContainerY = elHeight / 2,
                        targetImgXToBeCentre = imgElWidth * percentageOffsetX,
                        targetImgYToBeCentre = imgElHeight * percentageOffsetY,
                        left = centreOfContainerX - targetImgXToBeCentre,
                        top = centreOfContainerY - targetImgYToBeCentre,
                        differenceBetweenContainerWidthAndImgWidth = elWidth - imgElWidth,
                        differenceBetweenContainerHeightAndImgHeight = elHeight - imgElHeight,
                        isContainerLargerThanImgX = differenceBetweenContainerWidthAndImgWidth > 0,
                        isContainerLargerThanImgY = differenceBetweenContainerHeightAndImgHeight > 0,
                        minLeft = isContainerLargerThanImgX ? differenceBetweenContainerWidthAndImgWidth / 2 : 0,
                        minTop = isContainerLargerThanImgY ? differenceBetweenContainerHeightAndImgHeight / 2 : 0,
                        maxLeft = isContainerLargerThanImgX ? differenceBetweenContainerWidthAndImgWidth / 2 : differenceBetweenContainerWidthAndImgWidth,
                        maxTop = isContainerLargerThanImgY ? differenceBetweenContainerHeightAndImgHeight / 2 : differenceBetweenContainerHeightAndImgHeight;
                    if (this.el.parentElement === this.settings.inlineContainer) {
                        var scrollX = window.pageXOffset,
                            scrollY = window.pageYOffset,
                            inlineLeft = triggerRect.left + percentageOffsetX * triggerRect.width - elWidth / 2 + this.settings.inlineOffsetX + scrollX,
                            inlineTop = triggerRect.top + percentageOffsetY * triggerRect.height - elHeight / 2 + this.settings.inlineOffsetY + scrollY;
                        this.settings.containInline && (inlineLeft < triggerRect.left + scrollX ? inlineLeft = triggerRect.left + scrollX : inlineLeft + elWidth > triggerRect.left + triggerRect.width + scrollX && (inlineLeft = triggerRect.left + triggerRect.width - elWidth + scrollX), inlineTop < triggerRect.top + scrollY ? inlineTop = triggerRect.top + scrollY : inlineTop + elHeight > triggerRect.top + triggerRect.height + scrollY && (inlineTop = triggerRect.top + triggerRect.height - elHeight + scrollY)), this.el.style.left = "".concat(inlineLeft, "px"), this.el.style.top = "".concat(inlineTop, "px")
                    }
                    this.settings.showWhitespaceAtEdges || (left > minLeft ? left = minLeft : left < maxLeft && (left = maxLeft), top > minTop ? top = minTop : top < maxTop && (top = maxTop)), this.imgEl.style.transform = "translate(".concat(left, "px, ").concat(top, "px)"), this.imgEl.style.webkitTransform = "translate(".concat(left, "px, ").concat(top, "px)")
                }
            }, {
                key: "_removeListenersAndResetClasses",
                value: function() {
                    this.el.removeEventListener("animationend", this._completeShow, !1), this.el.removeEventListener("animationend", this._completeHide, !1), this.el.removeEventListener("webkitAnimationEnd", this._completeShow, !1), this.el.removeEventListener("webkitAnimationEnd", this._completeHide, !1), removeClasses(this.el, this.openClasses), removeClasses(this.el, this.closingClasses)
                }
            }, {
                key: "show",
                value: function(imageURL, triggerWidth, triggerHeight) {
                    this._removeListenersAndResetClasses(), this.isShowing = !0, addClasses(this.el, this.openClasses), this.imgEl.getAttribute("src") != imageURL && (addClasses(this.el, this.loadingClasses), this.imgEl.addEventListener("load", this._handleLoad, !1), this._setImageURL(imageURL)), this._setImageSize(triggerWidth, triggerHeight), this._isInline ? this._showInline() : this._showInContainer(), HAS_ANIMATION && (this.el.addEventListener("animationend", this._completeShow, !1), this.el.addEventListener("webkitAnimationEnd", this._completeShow, !1), addClasses(this.el, this.openingClasses))
                }
            }, {
                key: "_showInline",
                value: function() {
                    this.settings.inlineContainer.appendChild(this.el), addClasses(this.el, this.inlineClasses)
                }
            }, {
                key: "_showInContainer",
                value: function() {
                    this.settings.container.appendChild(this.el)
                }
            }, {
                key: "hide",
                value: function() {
                    this._removeListenersAndResetClasses(), this.isShowing = !1, HAS_ANIMATION ? (this.el.addEventListener("animationend", this._completeHide, !1), this.el.addEventListener("webkitAnimationEnd", this._completeHide, !1), addClasses(this.el, this.closingClasses)) : (removeClasses(this.el, this.openClasses), removeClasses(this.el, this.inlineClasses))
                }
            }, {
                key: "_completeShow",
                value: function() {
                    this.el.removeEventListener("animationend", this._completeShow, !1), this.el.removeEventListener("webkitAnimationEnd", this._completeShow, !1), removeClasses(this.el, this.openingClasses)
                }
            }, {
                key: "_completeHide",
                value: function() {
                    this.el.removeEventListener("animationend", this._completeHide, !1), this.el.removeEventListener("webkitAnimationEnd", this._completeHide, !1), removeClasses(this.el, this.openClasses), removeClasses(this.el, this.closingClasses), removeClasses(this.el, this.inlineClasses), this.el.setAttribute("style", ""), this.el.parentElement === this.settings.container ? this.settings.container.removeChild(this.el) : this.el.parentElement === this.settings.inlineContainer && this.settings.inlineContainer.removeChild(this.el)
                }
            }, {
                key: "_handleLoad",
                value: function() {
                    this.imgEl.removeEventListener("load", this._handleLoad, !1), removeClasses(this.el, this.loadingClasses)
                }
            }, {
                key: "_isInline",
                get: function() {
                    var inline = this.settings.inline;
                    return inline === !0 || typeof inline == "number" && window.innerWidth <= inline
                }
            }]), ZoomPane2
        })();

    function _classCallCheck$4(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function")
    }

    function _defineProperties$4(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor)
        }
    }

    function _createClass$4(Constructor, protoProps, staticProps) {
        return protoProps && _defineProperties$4(Constructor.prototype, protoProps), staticProps && _defineProperties$4(Constructor, staticProps), Constructor
    }
    var Drift = (function() {
        function Drift2(triggerEl) {
            var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (_classCallCheck$4(this, Drift2), this.VERSION = "1.4.0", this.triggerEl = triggerEl, this.destroy = this.destroy.bind(this), !isDOMElement(this.triggerEl)) throw new TypeError("`new Drift` requires a DOM element as its first argument.");
            var namespace = options.namespace || null,
                showWhitespaceAtEdges = options.showWhitespaceAtEdges || !1,
                containInline = options.containInline || !1,
                inlineOffsetX = options.inlineOffsetX || 0,
                inlineOffsetY = options.inlineOffsetY || 0,
                inlineContainer = options.inlineContainer || document.body,
                sourceAttribute = options.sourceAttribute || "data-zoom",
                zoomFactor = options.zoomFactor || 3,
                paneContainer = options.paneContainer === void 0 ? document.body : options.paneContainer,
                inlinePane = options.inlinePane || 375,
                handleTouch = "handleTouch" in options ? !!options.handleTouch : !0,
                onShow = options.onShow || null,
                onHide = options.onHide || null,
                injectBaseStyles = "injectBaseStyles" in options ? !!options.injectBaseStyles : !0,
                hoverDelay = options.hoverDelay || 0,
                touchDelay = options.touchDelay || 0,
                hoverBoundingBox = options.hoverBoundingBox || !1,
                touchBoundingBox = options.touchBoundingBox || !1,
                boundingBoxContainer = options.boundingBoxContainer || document.body;
            if (inlinePane !== !0 && !isDOMElement(paneContainer)) throw new TypeError("`paneContainer` must be a DOM element when `inlinePane !== true`");
            if (!isDOMElement(inlineContainer)) throw new TypeError("`inlineContainer` must be a DOM element");
            this.settings = {
                namespace: namespace,
                showWhitespaceAtEdges: showWhitespaceAtEdges,
                containInline: containInline,
                inlineOffsetX: inlineOffsetX,
                inlineOffsetY: inlineOffsetY,
                inlineContainer: inlineContainer,
                sourceAttribute: sourceAttribute,
                zoomFactor: zoomFactor,
                paneContainer: paneContainer,
                inlinePane: inlinePane,
                handleTouch: handleTouch,
                onShow: onShow,
                onHide: onHide,
                injectBaseStyles: injectBaseStyles,
                hoverDelay: hoverDelay,
                touchDelay: touchDelay,
                hoverBoundingBox: hoverBoundingBox,
                touchBoundingBox: touchBoundingBox,
                boundingBoxContainer: boundingBoxContainer
            }, this.settings.injectBaseStyles && injectBaseStylesheet(), this._buildZoomPane(), this._buildTrigger()
        }
        return _createClass$4(Drift2, [{
            key: "_buildZoomPane",
            value: function() {
                this.zoomPane = new ZoomPane({
                    container: this.settings.paneContainer,
                    zoomFactor: this.settings.zoomFactor,
                    showWhitespaceAtEdges: this.settings.showWhitespaceAtEdges,
                    containInline: this.settings.containInline,
                    inline: this.settings.inlinePane,
                    namespace: this.settings.namespace,
                    inlineOffsetX: this.settings.inlineOffsetX,
                    inlineOffsetY: this.settings.inlineOffsetY,
                    inlineContainer: this.settings.inlineContainer
                })
            }
        }, {
            key: "_buildTrigger",
            value: function() {
                this.trigger = new Trigger({
                    el: this.triggerEl,
                    zoomPane: this.zoomPane,
                    handleTouch: this.settings.handleTouch,
                    onShow: this.settings.onShow,
                    onHide: this.settings.onHide,
                    sourceAttribute: this.settings.sourceAttribute,
                    hoverDelay: this.settings.hoverDelay,
                    touchDelay: this.settings.touchDelay,
                    hoverBoundingBox: this.settings.hoverBoundingBox,
                    touchBoundingBox: this.settings.touchBoundingBox,
                    namespace: this.settings.namespace,
                    zoomFactor: this.settings.zoomFactor,
                    boundingBoxContainer: this.settings.boundingBoxContainer
                })
            }
        }, {
            key: "setZoomImageURL",
            value: function(imageURL) {
                this.zoomPane._setImageURL(imageURL)
            }
        }, {
            key: "disable",
            value: function() {
                this.trigger.enabled = !1
            }
        }, {
            key: "enable",
            value: function() {
                this.trigger.enabled = !0
            }
        }, {
            key: "destroy",
            value: function() {
                this.trigger._hide(), this.trigger._unbindEvents()
            }
        }, {
            key: "isShowing",
            get: function() {
                return this.zoomPane.isShowing
            }
        }, {
            key: "zoomFactor",
            get: function() {
                return this.settings.zoomFactor
            },
            set: function(zf) {
                this.settings.zoomFactor = zf, this.zoomPane.settings.zoomFactor = zf, this.trigger.settings.zoomFactor = zf, this.boundingBox.settings.zoomFactor = zf
            }
        }]), Drift2
    })();
    Object.defineProperty(Drift.prototype, "isShowing", {
        get: function() {
            return this.isShowing
        }
    }), Object.defineProperty(Drift.prototype, "zoomFactor", {
        get: function() {
            return this.zoomFactor
        },
        set: function(value) {
            this.zoomFactor = value
        }
    }), Drift.prototype.setZoomImageURL = Drift.prototype.setZoomImageURL, Drift.prototype.disable = Drift.prototype.disable, Drift.prototype.enable = Drift.prototype.enable, Drift.prototype.destroy = Drift.prototype.destroy;
    var ProductGallery = (function() {
            function ProductGallery2(element, options) {
                _classCallCheck(this, ProductGallery2), this.element = element, this.delegateElement = new Delegate(this.element), this.viewInSpaceElement = this.element.querySelector("[data-shopify-xr]"), this.options = options, this.media = {}, this.previouslySelectedMedia = null, this._createCarousel(), this._createZoom(), this._attachListeners()
            }
            return _createClass(ProductGallery2, [{
                key: "destroy",
                value: function() {
                    this.flickityInstance && this.flickityInstance.destroy();
                    for (var mediaId in this.media) this.media.hasOwnProperty(mediaId) && this.media[mediaId].destroy()
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this.delegateElement.on("model:played", this._disableDrag.bind(this)), this.delegateElement.on("video:played", this._disableDrag.bind(this)), this.delegateElement.on("model:paused", this._enableDrag.bind(this)), this.delegateElement.on("video:paused", this._enableDrag.bind(this)), this.options.enableImageZoom && (window.addEventListener("resize", this._handleZoomForMediaQuery.bind(this)), this.delegateElement.on("click", ".product-gallery__image", this._openMobileZoom.bind(this)), this.delegateElement.on("click", ".pswp__button", this._doPswpAction.bind(this)))
                }
            }, {
                key: "variantHasChanged",
                value: function(newVariant) {
                    var _this = this,
                        shouldReload = !1;
                    fastdom.mutate(function() {
                        if (_this.productGalleryCellsElements.forEach(function(cell2, imageIndex) {
                                if (cell2.hasAttribute("data-group-name")) {
                                    var groupName = cell2.getAttribute("data-group-name");
                                    _this.options.productOptions.forEach(function(option, optionIndex) {
                                        option.toLowerCase() === groupName && (newVariant["option".concat(optionIndex + 1)].toLowerCase() === cell2.getAttribute("data-group-value") || newVariant.featured_media && newVariant.featured_media.id === parseInt(cell2.getAttribute("data-media-id")) ? (cell2.classList.remove("is-filtered"), _this.productThumbnailsCellsElements[imageIndex].classList.remove("is-filtered")) : (cell2.classList.add("is-filtered"), _this.productThumbnailsCellsElements[imageIndex].classList.add("is-filtered")))
                                    }), shouldReload = !0
                                }
                            }), shouldReload && (_this.flickityInstance.deactivate(), _this.flickityInstance.activate()), Responsive.matchesBreakpoint("lap-and-up")) {
                            var slides = _this.element.querySelectorAll(".product-gallery__carousel-item");
                            slides.forEach(function(slide2) {
                                slide2.classList.remove("product-gallery__carousel-item--hidden")
                            })
                        }
                        _this.flickityInstance && newVariant && newVariant.featured_media && _this.flickityInstance.selectCell('[data-media-id="'.concat(newVariant.featured_media.id, '"]'))
                    })
                }
            }, {
                key: "_createCarousel",
                value: function() {
                    var _this2 = this;
                    if (this.productGalleryElement = this.element.querySelector(".product-gallery__carousel"), this.productGalleryCellsElements = this.productGalleryElement ? this.productGalleryElement.querySelectorAll(".product-gallery__carousel-item") : [], this.productGalleryElement && (this.productGalleryCellsElements.forEach(function(item) {
                            switch (item.getAttribute("data-media-type")) {
                                case "external_video":
                                case "video":
                                    _this2.media[item.getAttribute("data-media-id")] = new ProductVideo(item, _this2.options.enableVideoLooping);
                                    break;
                                case "model":
                                    _this2.media[item.getAttribute("data-media-id")] = new ProductModel(item);
                                    break
                            }
                        }), parseInt(this.productGalleryElement.getAttribute("data-media-count")) > 1)) {
                        var filteredCells = [].slice.call(this.productGalleryCellsElements).filter(function(item) {
                                return !item.classList.contains("is-filtered")
                            }),
                            initialIndex = 0;
                        filteredCells.forEach(function(item, index) {
                            item.getAttribute("data-media-id") === _this2.productGalleryElement.getAttribute("data-initial-media-id") && (initialIndex = index)
                        });
                        var firstSlide = filteredCells[initialIndex];
                        firstSlide.classList.add("is-selected"), this.productGalleryElement.style.height = "".concat(firstSlide.clientHeight, "px"), this.flickityInstance = new flickityFade(this.productGalleryElement, {
                            accessibility: !1,
                            prevNextButtons: !1,
                            pageDots: !1,
                            adaptiveHeight: !0,
                            draggable: !Responsive.matchesBreakpoint("supports-hover"),
                            fade: this.options.galleryTransitionEffect === "fade",
                            cellSelector: ".product-gallery__carousel-item:not(.is-filtered)",
                            initialIndex: initialIndex,
                            on: {
                                ready: function() {
                                    setTimeout(function() {
                                        _this2.productGalleryElement.style.height = null
                                    }, 1e3)
                                }
                            }
                        })
                    }
                    this.productThumbnailsListElement = this.element.querySelector(".product-gallery__thumbnail-list"), this.delegateElement.on("click", ".product-gallery__thumbnail", this._onThumbnailClicked.bind(this)), this.productThumbnailsListElement && this.flickityInstance && (this.productThumbnailsCellsElements = this.productThumbnailsListElement.querySelectorAll(".product-gallery__thumbnail"), this.flickityInstance.on("select", this._onGallerySlideChanged.bind(this)), this.options.galleryTransitionEffect === "fade" ? this.flickityInstance.on("select", this._onGallerySlideSettled.bind(this)) : this.flickityInstance.on("settle", this._onGallerySlideSettled.bind(this)), this._onGallerySlideChanged(!1), this._onGallerySlideSettled())
                }
            }, {
                key: "_createZoom",
                value: function() {
                    var _this3 = this;
                    if (this.options.enableImageZoom && Responsive.matchesBreakpoint("lap-and-up")) {
                        this.driftObjects = [];
                        var zoomWrapper = this.element.querySelector(".product__zoom-wrapper");
                        this.element.querySelectorAll(".product-gallery__image").forEach(function(image) {
                            _this3.driftObjects.push(new Drift(image, {
                                containInline: _this3.options.zoomEffect === "outside",
                                inlinePane: window.innerWidth < 1024 ? !0 : _this3.options.zoomEffect !== "outside",
                                hoverBoundingBox: _this3.options.zoomEffect === "outside",
                                handleTouch: !1,
                                inlineOffsetY: window.innerWidth < 1024 ? -85 : 0,
                                paneContainer: zoomWrapper
                            }))
                        })
                    }
                }
            }, {
                key: "_openMobileZoom",
                value: function() {
                    var _this4 = this,
                        pswpElement = this.element.querySelector(".pswp");
                    if (!(!pswpElement || !Responsive.matchesBreakpoint("pocket"))) {
                        var filteredItems = this.element.querySelectorAll('.product-gallery__carousel-item:not(.is-filtered)[data-media-type="image"]'),
                            defaultIndex = 0,
                            items = [];
                        filteredItems.forEach(function(filteredItem, index) {
                            var image = filteredItem.querySelector(".product-gallery__image");
                            items.push({
                                src: image.getAttribute("data-zoom"),
                                w: parseInt(image.getAttribute("data-zoom-width")),
                                h: parseInt(image.getAttribute("data-zoom-width")) * (image.height / image.width),
                                msrc: image.currentSrc
                            }), filteredItem.classList.contains("is-selected") && (defaultIndex = index)
                        });
                        var prevNextElement = pswpElement.querySelector(".pswp__prev-next");
                        prevNextElement.style.display = items.length > 1 ? "flex" : "none", this.photoSwipeInstance = new photoswipe(pswpElement, !1, items, {
                            index: defaultIndex,
                            closeOnVerticalDrag: !1,
                            closeOnScroll: !1,
                            history: !1,
                            showHideOpacity: !0,
                            pinchToClose: !1,
                            maxSpreadZoom: 1,
                            showAnimationDuration: !1,
                            allowPanToNext: !1
                        }), this.photoSwipeInstance.listen("destroy", function() {
                            _this4.photoSwipeInstance = null
                        }), this.photoSwipeInstance.listen("beforeChange", function() {
                            var currentItem = _this4.element.querySelector(".pswp__pagination-current"),
                                paginationCount = _this4.element.querySelector(".pswp__pagination-count");
                            currentItem.textContent = _this4.photoSwipeInstance.getCurrentIndex() + 1, paginationCount.textContent = _this4.photoSwipeInstance.options.getNumItemsFn()
                        }), this.photoSwipeInstance.init()
                    }
                }
            }, {
                key: "_doPswpAction",
                value: function(event2, element) {
                    this.photoSwipeInstance && (element.classList.contains("pswp__button--close") ? this.photoSwipeInstance.close() : element.classList.contains("pswp__button--arrow--left") ? this.photoSwipeInstance.prev() : element.classList.contains("pswp__button--arrow--right") && this.photoSwipeInstance.next())
                }
            }, {
                key: "_handleZoomForMediaQuery",
                value: function() {
                    Responsive.matchesBreakpoint("lap-and-up") && this.photoSwipeInstance && (this.photoSwipeInstance.close(), this.photoSwipeInstance = null)
                }
            }, {
                key: "_onGallerySlideChanged",
                value: function() {
                    var _this5 = this,
                        animate2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0,
                        previousNavElement = null,
                        newNavElement = null;
                    if (this.productThumbnailsCellsElements.forEach(function(item) {
                            item.classList.contains("is-nav-selected") && (previousNavElement = item), item.getAttribute("data-media-id") === _this5.flickityInstance.selectedElement.getAttribute("data-media-id") && (newNavElement = item)
                        }), previousNavElement.classList.remove("is-nav-selected"), newNavElement.classList.add("is-nav-selected"), Responsive.matchesBreakpoint("pocket")) {
                        var scrollX = newNavElement.offsetLeft - (this.productThumbnailsListElement.parentNode.clientWidth - newNavElement.clientWidth) / 2;
                        this.productThumbnailsListElement.parentNode.scrollTo({
                            left: scrollX,
                            behavior: animate2 ? "smooth" : "auto"
                        })
                    } else {
                        var scrollY = newNavElement.offsetTop - (this.productThumbnailsListElement.clientHeight - newNavElement.clientHeight) / 2;
                        this.productThumbnailsListElement.scrollTo({
                            top: scrollY,
                            behavior: animate2 ? "smooth" : "auto"
                        })
                    }
                }
            }, {
                key: "_onGallerySlideSettled",
                value: function() {
                    if (this._handleMedia(this.flickityInstance.selectedElement), Responsive.matchesBreakpoint("lap-and-up")) {
                        var slides = this.element.querySelectorAll(".product-gallery__carousel-item:not(.is-selected)");
                        slides.forEach(function(slide2) {
                            slide2.classList.add("product-gallery__carousel-item--hidden")
                        })
                    }
                }
            }, {
                key: "_onThumbnailClicked",
                value: function(event2, target) {
                    if (event2.preventDefault(), this.flickityInstance && (this.flickityInstance.selectCell('[data-media-id="'.concat(target.getAttribute("data-media-id"), '"]')), Responsive.matchesBreakpoint("lap-and-up"))) {
                        var slides = this.element.querySelectorAll(".product-gallery__carousel-item");
                        slides.forEach(function(slide2) {
                            slide2.classList.remove("product-gallery__carousel-item--hidden")
                        })
                    }
                }
            }, {
                key: "_disableDrag",
                value: function() {
                    this.flickityInstance.options.draggable = !1, this.flickityInstance.updateDraggable()
                }
            }, {
                key: "_enableDrag",
                value: function() {
                    this.flickityInstance.options.draggable = !Responsive.matchesBreakpoint("supports-hover"), this.flickityInstance.updateDraggable()
                }
            }, {
                key: "_handleMedia",
                value: function(item) {
                    var isInitialLoading = this.previouslySelectedMedia === null;
                    if (this.previouslySelectedMedia && this.previouslySelectedMedia !== item) {
                        switch (this.previouslySelectedMedia.getAttribute("data-media-type")) {
                            case "video":
                            case "external_video":
                            case "model":
                                this.media[this.previouslySelectedMedia.getAttribute("data-media-id")].hasBeenDeselected()
                        }
                        this.previouslySelectedMedia.getAttribute("data-media-type") === "model" && this.viewInSpaceElement && this.viewInSpaceElement.setAttribute("data-shopify-model3d-id", this.viewInSpaceElement.getAttribute("data-shopify-model3d-default-id"))
                    }
                    switch (item.getAttribute("data-media-type")) {
                        case "video":
                        case "external_video":
                        case "model":
                            this.media[item.getAttribute("data-media-id")].hasBeenSelected(isInitialLoading), this.element.querySelector(".product-gallery__carousel").classList.remove("product-gallery__carousel--zoomable");
                            break;
                        case "image":
                            this.element.querySelector(".product-gallery__carousel").classList.add("product-gallery__carousel--zoomable");
                            break
                    }
                    item.getAttribute("data-media-type") === "model" && this.viewInSpaceElement && this.viewInSpaceElement.setAttribute("data-shopify-model3d-id", item.getAttribute("data-media-id")), this.previouslySelectedMedia = item
                }
            }]), ProductGallery2
        })(),
        QuantityPicker = (function() {
            function QuantityPicker2(element) {
                _classCallCheck(this, QuantityPicker2), element && (this.element = element, this.inputElement = this.element.querySelector('[name="quantity"]'), this.delegateElement = new Delegate(this.element), this._attachListeners())
            }
            return _createClass(QuantityPicker2, [{
                key: "_attachListeners",
                value: function() {
                    this.delegateElement.on("click", '[data-action="decrease-picker-quantity"]', this._onDecrease.bind(this)), this.delegateElement.on("click", '[data-action="increase-picker-quantity"]', this._onIncrease.bind(this)), this.delegateElement.on("keyup", this._onInputValueChanged.bind(this)), this.delegateElement.on("focusout", this._onInputFocusOut.bind(this))
                }
            }, {
                key: "_onDecrease",
                value: function() {
                    this.inputElement.value = Math.max(1, parseInt(this.inputElement.value) - 1)
                }
            }, {
                key: "_onIncrease",
                value: function() {
                    this.inputElement.value = parseInt(this.inputElement.value) + 1
                }
            }, {
                key: "_onInputValueChanged",
                value: function(event2) {
                    var value = event2.target.value;
                    value !== "" && isNaN(value) && (event2.target.value = Math.max(1, parseInt(value) || 1))
                }
            }, {
                key: "_onInputFocusOut",
                value: function(event2) {
                    event2.target.value = Math.max(1, parseInt(event2.target.value) || 1)
                }
            }]), QuantityPicker2
        })(),
        ShippingEstimator = (function() {
            function ShippingEstimator2(element, options) {
                _classCallCheck(this, ShippingEstimator2), this.element = element, this.delegateElement = new Delegate(this.element), this.options = options, this.countrySelector = new CountrySelector(this.element.querySelector('[name="country"]'), this.element.querySelector('[name="province"]')), this._attachListeners()
            }
            return _createClass(ShippingEstimator2, [{
                key: "destroy",
                value: function() {
                    this.delegateElement.off("click"), this.countrySelector.destroy()
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this.delegateElement.on("click", '[data-action="estimate-shipping"]', this._fetchRates.bind(this))
                }
            }, {
                key: "_fetchRates",
                value: function() {
                    document.dispatchEvent(new CustomEvent("theme:loading:start")), this.options.singleProduct ? this._fetchRatesForProduct() : this._fetchRatesForCart()
                }
            }, {
                key: "_fetchRatesForCart",
                value: function() {
                    var _this = this,
                        country = this.element.querySelector('[name="country"]').value,
                        province = this.element.querySelector('[name="province"]').value,
                        zip = this.element.querySelector('[name="zip"]').value;
                    fetch("".concat(window.routes.cartUrl, "/shipping_rates.json?shipping_address[zip]=").concat(zip, "&shipping_address[country]=").concat(country, "&shipping_address[province]=").concat(province), {
                        credentials: "same-origin",
                        method: "GET"
                    }).then(function(response) {
                        document.dispatchEvent(new CustomEvent("theme:loading:end")), response.json().then(function(result) {
                            _this._formatResults(response.ok, result)
                        })
                    })
                }
            }, {
                key: "_fetchRatesForProduct",
                value: function() {
                    var _this2 = this,
                        cartCookie = this._getCookie("cart"),
                        tempCookieValue = "temp-cart-cookie___" + Date.now() + parseInt(Math.random() * 1e3),
                        fakeCookieValue = "fake-cart-cookie___" + Date.now() + parseInt(Math.random() * 1e3);
                    if (cartCookie || (this._updateCartCookie(tempCookieValue), cartCookie = this._getCookie("cart")), !(cartCookie.length < 32)) {
                        this._updateCartCookie(fakeCookieValue);
                        var formElement = document.querySelector('form[action*="/cart/add"]');
                        fetch("".concat(window.routes.cartAddUrl, ".js"), {
                            body: JSON.stringify(Form.serialize(formElement)),
                            credentials: "same-origin",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Requested-With": "XMLHttpRequest"
                            },
                            method: "POST"
                        }).then(function(response) {
                            response.json().then(function() {
                                var country = _this2.element.querySelector('[name="country"]').value,
                                    province = _this2.element.querySelector('[name="province"]').value,
                                    zip = _this2.element.querySelector('[name="zip"]').value;
                                fetch("".concat(window.routes.cartUrl, "/shipping_rates.json?shipping_address[zip]=").concat(zip, "&shipping_address[country]=").concat(country, "&shipping_address[province]=").concat(province), {
                                    credentials: "same-origin",
                                    method: "GET"
                                }).then(function(response2) {
                                    document.dispatchEvent(new CustomEvent("theme:loading:end")), response2.json().then(function(result) {
                                        _this2._formatResults(response2.ok, result)
                                    }), _this2._updateCartCookie(cartCookie)
                                }).catch(function() {
                                    _this2._updateCartCookie(cartCookie)
                                })
                            }).catch(function() {
                                _this2._updateCartCookie(cartCookie), document.dispatchEvent(new CustomEvent("theme:loading:end"))
                            })
                        })
                    }
                }
            }, {
                key: "_formatResults",
                value: function(isOk, results) {
                    var resultsElement = this.element.querySelector(".shipping-estimator__results");
                    if (resultsElement.innerHTML = "", isOk) {
                        var shippingRates = results.shipping_rates;
                        if (shippingRates.length === 0) resultsElement.innerHTML = "<p>".concat(window.languages.shippingEstimatorNoResults, "</p>");
                        else {
                            shippingRates.length === 1 ? resultsElement.innerHTML = "<p>".concat(window.languages.shippingEstimatorOneResult, "</p>") : resultsElement.innerHTML = "<p>".concat(window.languages.shippingEstimatorMultipleResults.replace("{{count}}", shippingRates.length), "</p>");
                            var listRatesHtml = "";
                            shippingRates.forEach(function(item) {
                                listRatesHtml += "<li>".concat(item.name, ": ").concat(Currency.formatMoney(parseInt(item.price * 100), window.theme.moneyFormat), "</li>")
                            }), resultsElement.innerHTML += "<ul>".concat(listRatesHtml, "</ul>")
                        }
                    } else {
                        resultsElement.innerHTML = "<p>".concat(window.languages.shippingEstimatorErrors, "</p>");
                        var errorHtml = "";
                        Object.keys(results).forEach(function(key) {
                            errorHtml += '<li class="alert__list-item">'.concat(key, " ").concat(results[key], "</li>")
                        }), resultsElement.innerHTML += "<ul>".concat(errorHtml, "</ul>")
                    }
                    resultsElement.style.display = "block"
                }
            }, {
                key: "_getCookie",
                value: function(name) {
                    var value = "; ".concat(document.cookie),
                        parts = value.split("; " + name + "=");
                    if (parts.length === 2) return parts.pop().split(";").shift()
                }
            }, {
                key: "_updateCartCookie",
                value: function(value) {
                    var date = new Date;
                    date.setTime(date.getTime() + 14 * 864e5), document.cookie = "cart=".concat(value, "; expires=").concat(date.toUTCString(), "; path=/")
                }
            }]), ShippingEstimator2
        })(),
        ValuePicker = (function() {
            function ValuePicker2(id) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                _classCallCheck(this, ValuePicker2), this.id = id, this.delegateRoot = new Delegate(document.documentElement), this.isOpen = !1, this.togglerElement = document.querySelector('[data-action="open-value-picker"][aria-controls="'.concat(this.id, '"]')), this.onSelect = options.onValueSelect || function() {}, this._attachListeners()
            }
            return _createClass(ValuePicker2, [{
                key: "destroy",
                value: function() {
                    this.delegateRoot.off()
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this.delegateRoot.on("click", '[data-action="open-value-picker"][aria-controls="'.concat(this.id, '"]'), this._toggle.bind(this)), this.delegateRoot.on("click", '[data-action="close-value-picker"][aria-controls="'.concat(this.id, '"]'), this._toggle.bind(this)), this.delegateRoot.on("click", "#".concat(this.id, ' [data-action="select-value"]'), this._selectValue.bind(this)), this.delegateRoot.on("click", this._detectOutsideClick.bind(this), !0), this.delegateRoot.on("focusout", "#".concat(this.id), this._onFocusOut.bind(this))
                }
            }, {
                key: "_toggle",
                value: function(event2) {
                    this.isOpen ? this._close(event2) : this._open(event2)
                }
            }, {
                key: "_open",
                value: function() {
                    if (document.querySelector('[data-action="open-value-picker"][aria-controls="'.concat(this.id, '"]')).setAttribute("aria-expanded", "true"), document.getElementById(this.id).setAttribute("aria-hidden", "false"), Responsive.matchesBreakpoint("phone")) {
                        var headerElement = document.querySelector(".shopify-section__header");
                        headerElement.style.zIndex = "3"
                    }
                    this.isOpen = !0, document.body.classList.add("no-mobile-scroll")
                }
            }, {
                key: "_close",
                value: function() {
                    document.querySelector('[data-action="open-value-picker"][aria-controls="'.concat(this.id, '"]')).setAttribute("aria-expanded", "false"), document.getElementById(this.id).setAttribute("aria-hidden", "true");
                    var headerElement = document.querySelector(".shopify-section__header");
                    headerElement.style.zIndex = "", this.isOpen = !1, document.body.classList.remove("no-mobile-scroll")
                }
            }, {
                key: "_selectValue",
                value: function(event2, target) {
                    this.onSelect(target.getAttribute("data-value")), this._close()
                }
            }, {
                key: "_onFocusOut",
                value: function(event2) {
                    var container = document.getElementById(this.id);
                    container.contains(event2.relatedTarget) || this._close()
                }
            }, {
                key: "_detectOutsideClick",
                value: function(event2) {
                    !this.isOpen || this.togglerElement === event2.target || this.togglerElement.contains(event2.target) || !event2.target.closest(".value-picker__inner") && this.isOpen && this._close(event2)
                }
            }]), ValuePicker2
        })(),
        AccountSection = (function() {
            function AccountSection2(element) {
                _classCallCheck(this, AccountSection2), this.element = element, this.domDelegate = new Delegate(this.element), this.element.querySelectorAll('[action*="/account/addresses"]').forEach(function(addressForm) {
                    new CountrySelector(addressForm.querySelector('[name="address[country]"]'), addressForm.querySelector('[name="address[province]"]'))
                }), this.pageSelector = new ValuePicker("account-selector")
            }
            return _createClass(AccountSection2, [{
                key: "_onUnload",
                value: function() {
                    this.pageSelector.destroy()
                }
            }]), AccountSection2
        })(),
        AnnouncementBarSection = (function() {
            function AnnouncementBarSection2(element) {
                _classCallCheck(this, AnnouncementBarSection2), this.element = element, this.domDelegate = new Delegate(this.element), this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.isOpen = !1, this.options.showNewsletter ? document.documentElement.style.setProperty("--announcement-bar-button-width", this.element.querySelector(".announcement-bar__button").clientWidth + "px") : document.documentElement.style.removeProperty("--announcement-bar-button-width"), this._attachListeners()
            }
            return _createClass(AnnouncementBarSection2, [{
                key: "onSelect",
                value: function() {
                    this.options.showNewsletter && !this.isOpen && this._toggleNewsletter()
                }
            }, {
                key: "onDeselect",
                value: function() {
                    this.options.showNewsletter && this.isOpen && this._toggleNewsletter()
                }
            }, {
                key: "onUnload",
                value: function() {
                    this.domDelegate.off()
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this.domDelegate.on("click", '[data-action="toggle-newsletter"]', this._toggleNewsletter.bind(this)), this.domDelegate.on("keyup", this._handleKey.bind(this))
                }
            }, {
                key: "_toggleNewsletter",
                value: function() {
                    var togglerElement = this.element.querySelector(".announcement-bar__button"),
                        newsletterElement = this.element.querySelector(".announcement-bar__newsletter");
                    togglerElement.getAttribute("aria-expanded") === "false" ? (togglerElement.setAttribute("aria-expanded", "true"), newsletterElement.setAttribute("aria-hidden", "false"), Animation.slideDown(newsletterElement, function() {
                        Accessibility.trapFocus(newsletterElement, "announcement-bar")
                    })) : (togglerElement.setAttribute("aria-expanded", "false"), newsletterElement.setAttribute("aria-hidden", "true"), Animation.slideUp(newsletterElement), Accessibility.removeTrapFocus(newsletterElement, "announcement-bar")), this.isOpen = !this.isOpen
                }
            }, {
                key: "_handleKey",
                value: function(event2) {
                    event2.key === "Escape" && this.isOpen && this._toggleNewsletter()
                }
            }]), AnnouncementBarSection2
        })(),
        BlogSection = (function() {
            function BlogSection2(element) {
                if (_classCallCheck(this, BlogSection2), this.element = element, this.blogTagSelector = new ValuePicker("blog-tag-selector"), Shopify.designMode) {
                    var elementToAdd = this.element.querySelector(".page__header");
                    elementToAdd && (document.querySelector(".blog-container").previousElementSibling.remove(), document.querySelector(".blog-container").insertAdjacentElement("beforebegin", elementToAdd))
                }
            }
            return _createClass(BlogSection2, [{
                key: "onUnload",
                value: function() {
                    this.blogTagSelector.destroy()
                }
            }]), BlogSection2
        })(),
        BlogPostSection = function BlogPostSection2(element) {
            if (_classCallCheck(this, BlogPostSection2), this.element = element, Shopify.designMode) {
                var elementToAdd = this.element.querySelector(".page__header");
                elementToAdd && (document.querySelector(".blog-container").previousElementSibling.remove(), document.querySelector(".blog-container").insertAdjacentElement("beforebegin", elementToAdd))
            }
        },
        BlogSidebarSection = (function() {
            function BlogSidebarSection2(element) {
                _classCallCheck(this, BlogSidebarSection2), this.element = element, window.theme.pageType === "blog" && this._fixItemsPerRow()
            }
            return _createClass(BlogSidebarSection2, [{
                key: "_fixItemsPerRow",
                value: function() {
                    var blocks = this.element.querySelectorAll(".blog-sidebar__item");
                    blocks.length === 0 ? (document.querySelector(".blog-container").classList.add("blog-container--without-sidebar"), document.querySelectorAll(".shopify-section__blog-posts .block-list__item").forEach(function(item) {
                        item.classList.contains("1/2--lap-and-up") && (item.classList.remove("1/2--lap-and-up"), item.classList.add("1/3--lap-and-up"))
                    })) : (document.querySelector(".blog-container").classList.remove("blog-container--without-sidebar"), document.querySelectorAll(".shopify-section__blog-posts .block-list__item").forEach(function(item) {
                        item.classList.contains("1/3--lap-and-up") && (item.classList.remove("1/3--lap-and-up"), item.classList.add("1/2--lap-and-up"))
                    }))
                }
            }]), BlogSidebarSection2
        })(),
        ProductSection = (function() {
            function ProductSection2(element) {
                var _this = this;
                if (_classCallCheck(this, ProductSection2), this.element = element, this.delegateElement = new Delegate(this.element), this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.productGallery = new ProductGallery(this.element, this.options), this._initShopifyReviews(), this.options.isQuickView && this.options.showPaymentButton && window.Shopify.PaymentButton && Shopify.PaymentButton.init(), this.productVariants = new ProductVariants(this.element, this.options), this.options.showShippingEstimator && (this.shippingEstimator = new ShippingEstimator(this.element.querySelector(".shipping-estimator"), {
                        singleProduct: !0
                    })), this.options.showQuantitySelector) {
                    var quantityPickerElement = this.element.querySelector(".quantity-selector--product");
                    quantityPickerElement && (this.quantityPicker = new QuantityPicker(quantityPickerElement))
                }
                var productInfoElement = this.element.querySelector(".product-block-list__item--info .card");
                productInfoElement && (this.element.querySelector(".product-block-list__wrapper").style.minHeight = "".concat(productInfoElement.clientHeight, "px"), window.ResizeObserver && (this.productInfoResizeObserver = new ResizeObserver(function(event2) {
                    event2[0].contentBoxSize ? _this.element.querySelector(".product-block-list__wrapper").style.minHeight = "".concat(event2[0].contentBoxSize[0].blockSize, "px") : _this.element.querySelector(".product-block-list__wrapper").style.minHeight = "".concat(event2[0].contentRect.height, "px")
                }), this.productInfoResizeObserver.observe(productInfoElement)), this.options.infoOverflowScroll && (this.infoOverflowScroller = new OverflowScroller(productInfoElement, {
                    offsetTop: document.documentElement.style.getPropertyValue("--header-is-sticky") * parseInt(document.documentElement.style.getPropertyValue("--header-height") + 30),
                    offsetBottom: 30
                }))), this._attachListeners()
            }
            return _createClass(ProductSection2, [{
                key: "onUnload",
                value: function() {
                    this.productVariants.destroy(), this.productGallery.destroy(), this.options.showShippingEstimator && this.shippingEstimator.destroy(), this.options.infoOverflowScroll && this.infoOverflowScroller.destroy(), window.ResizeObserver && this.productInfoResizeObserver && this.productInfoResizeObserver.disconnect(), this.delegateElement.off(), this.element.removeEventListener("variant:changed", this._onVariantChangedListener)
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this._onVariantChangedListener = this._onVariantChanged.bind(this), this.element.addEventListener("variant:changed", this._onVariantChangedListener)
                }
            }, {
                key: "_initShopifyReviews",
                value: function() {
                    var _this2 = this;
                    Shopify.designMode && window.SPR && (window.SPR.initDomEls(), window.SPR.loadProducts()), window.SPRCallbacks = {}, window.SPRCallbacks.onFormSuccess = function() {
                        _this2.element.querySelector("#shopify-product-reviews .spr-form").classList.add("spr-form-submitted")
                    }, this.options.isQuickView && this.options.showPaymentButton && window.Shopify.PaymentButton && Shopify.PaymentButton.init()
                }
            }, {
                key: "_onVariantChanged",
                value: function(event2) {
                    this.productGallery.variantHasChanged(event2.detail.variant)
                }
            }]), ProductSection2
        })(),
        CartSection = (function() {
            function CartSection2(element) {
                _classCallCheck(this, CartSection2), this.element = element, this.domDelegate = new Delegate(this.element), this.delegateRoot = new Delegate(document.documentElement), this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.options.showShippingEstimator && (this.shippingEstimator = new ShippingEstimator(this.element.querySelector(".shipping-estimator"), {
                    singleProduct: !1
                })), this._attachListeners(), this._enforceMinimumHeight()
            }
            return _createClass(CartSection2, [{
                key: "onUnload",
                value: function() {
                    this.options.showShippingEstimator && this.shippingEstimator.destroy()
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this.domDelegate.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this)), this.domDelegate.on("click", '[data-action="save-note"]', this._saveNote.bind(this)), this.domDelegate.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this)), this.delegateRoot.on("cart:rerendered", this._onCartRerendered.bind(this))
                }
            }, {
                key: "_saveNote",
                value: function() {
                    var noteValue = this.element.querySelector('[name="note"]').value;
                    fetch("".concat(window.routes.cartUrl, "/update.js"), {
                        body: JSON.stringify({
                            note: noteValue
                        }),
                        credentials: "same-origin",
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest"
                        }
                    }), this.element.querySelector(".cart-recap__note-edit").classList.toggle("is-visible", noteValue !== ""), document.dispatchEvent(new CustomEvent("collapsible:toggle", {
                        detail: {
                            id: "order-note"
                        }
                    }))
                }
            }, {
                key: "_addToCart",
                value: function(event2, target) {
                    var _this = this;
                    if (window.theme.cartType !== "page") {
                        event2.preventDefault(), event2.stopPropagation(), target.setAttribute("disabled", "disabled"), document.dispatchEvent(new CustomEvent("theme:loading:start"));
                        var formElement = target.closest('form[action*="/cart/add"]');
                        fetch("".concat(window.routes.cartAddUrl, ".js"), {
                            body: JSON.stringify(Form.serialize(formElement)),
                            credentials: "same-origin",
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Requested-With": "XMLHttpRequest"
                            }
                        }).then(function(response) {
                            response.ok ? (target.removeAttribute("disabled"), _this.element.dispatchEvent(new CustomEvent("product:added", {
                                bubbles: !0,
                                detail: {
                                    variant: null,
                                    quantity: parseInt(formElement.querySelector('[name="quantity"]').value)
                                }
                            }))) : target.removeAttribute("disabled")
                        }), event2.preventDefault()
                    }
                }
            }, {
                key: "_openQuickView",
                value: function(event2, target) {
                    var modal = document.getElementById(target.getAttribute("aria-controls"));
                    modal.classList.add("is-loading"), fetch("".concat(target.getAttribute("data-product-url"), "?view=quick-view"), {
                        credentials: "same-origin",
                        method: "GET"
                    }).then(function(response) {
                        response.text().then(function(content) {
                            modal.querySelector(".modal__inner").innerHTML = content, modal.classList.remove("is-loading");
                            var modalProductSection = new ProductSection(modal.querySelector('[data-section-type="product"]')),
                                doCleanUp = function doCleanUp2() {
                                    modalProductSection.onUnload(), modal.removeEventListener("modal:closed", doCleanUp2)
                                };
                            modal.addEventListener("modal:closed", doCleanUp)
                        })
                    })
                }
            }, {
                key: "_enforceMinimumHeight",
                value: function() {
                    var cartWrapperElement = this.element.querySelector(".cart-wrapper"),
                        cartRecapScrollerElement = this.element.querySelector(".cart-recap__scroller");
                    if (cartWrapperElement && cartRecapScrollerElement && (cartWrapperElement.style.minHeight = "".concat(cartRecapScrollerElement.clientHeight, "px"), window.ResizeObserver)) {
                        var resizeObserver = new ResizeObserver(function(entries) {
                            var _iterator = _createForOfIteratorHelper(entries),
                                _step;
                            try {
                                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                                    var entry = _step.value;
                                    cartWrapperElement.style.minHeight = "".concat(parseInt(entry.contentRect.height), "px")
                                }
                            } catch (err) {
                                _iterator.e(err)
                            } finally {
                                _iterator.f()
                            }
                        });
                        resizeObserver.observe(cartRecapScrollerElement)
                    }
                }
            }, {
                key: "_onCartRerendered",
                value: function() {
                    this.options.showShippingEstimator && (this.shippingEstimator.destroy(), this.shippingEstimator = new ShippingEstimator(this.element.querySelector(".shipping-estimator"), {
                        singleProduct: !1
                    })), this._enforceMinimumHeight()
                }
            }]), CartSection2
        })(),
        CollectionListSection = (function() {
            function CollectionListSection2(element) {
                _classCallCheck(this, CollectionListSection2), this.element = element;
                var collectionListElement = this.element.querySelector(".collection-list");
                this.flickityInstance = new js(collectionListElement, {
                    watchCSS: !0,
                    prevNextButtons: !0,
                    draggable: !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches,
                    pageDots: !1,
                    cellAlign: collectionListElement.childElementCount < 6 ? "center" : "left",
                    contain: !0,
                    groupCells: !0
                })
            }
            return _createClass(CollectionListSection2, [{
                key: "onUnload",
                value: function() {
                    this.flickityInstance.destroy()
                }
            }, {
                key: "onBlockSelect",
                value: function(event2) {
                    this.flickityInstance.isActive && this.flickityInstance.selectCell(parseInt(event2.target.getAttribute("data-collection-index")), null, event2.detail.load)
                }
            }]), CollectionListSection2
        })(),
        CollectionSection = (function() {
            function CollectionSection2(element) {
                _classCallCheck(this, CollectionSection2), this.element = element, this.delegateElement = new Delegate(this.element), this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.currentUrl = new URL(window.location.href), this.mobileFilterDrawer = new CollectionFilterDrawer(this.options), this.displayByValuePicker = new ValuePicker("display-by-selector", {
                    onValueSelect: this._showingCountChanged.bind(this)
                }), this.sortByValuePicker = new ValuePicker("sort-by-selector", {
                    onValueSelect: this._sortByChanged.bind(this)
                }), this.productItemColorSwatch = new ProductItemColorSwatch(this.element), window.theme.pageType === "search" && window.theme.searchMode !== "product" && this._loadContentResults(), this._attachListeners()
            }
            return _createClass(CollectionSection2, [{
                key: "onUnload",
                value: function() {
                    this.delegateElement.off(), this.mobileFilterDrawer.destroy(), this.displayByValuePicker.destroy(), this.sortByValuePicker.destroy(), this.productItemColorSwatch.destroy()
                }
            }, {
                key: "onSelect",
                value: function(event2) {
                    Shopify.designMode && event2.detail.load && (this.element.querySelector('.collection__layout-button[data-layout-mode="'.concat(this.options.defaultLayout, '"]')).click(), this._showingCountChanged(this.options.defaultProductsPerPage))
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this.delegateElement.on("click", '[data-action="change-layout"]', this._changeLayout.bind(this)), this.delegateElement.on("change", "#mobile-sort-by, #desktop-sort-by", this._sortByChanged.bind(this)), this.delegateElement.on("change", "#showing-count", this._showingCountChanged.bind(this)), this.delegateElement.on("click", ".pagination [data-page]", this._paginationPageChanged.bind(this)), this.delegateElement.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this)), this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this)), this.delegateElement.on("change", '[name^="filter."]', this._onFilterChanged.bind(this)), this.delegateElement.on("click", '[data-action="clear-filters"]', this._onFiltersCleared.bind(this))
                }
            }, {
                key: "_openQuickView",
                value: function(event2, target) {
                    var productUrl = new URL("".concat(window.location.origin).concat(target.getAttribute("data-product-url")));
                    if (Responsive.matchesBreakpoint("phone") || Responsive.matchesBreakpoint("tablet")) return window.location.href = productUrl.href, !1;
                    var modal = document.getElementById(target.getAttribute("aria-controls"));
                    modal.classList.add("is-loading"), productUrl.searchParams.set("view", "quick-view"), fetch(productUrl.href, {
                        credentials: "same-origin",
                        method: "GET"
                    }).then(function(response) {
                        response.text().then(function(content) {
                            modal.querySelector(".modal__inner").innerHTML = content, modal.classList.remove("is-loading"), console.log(modal.querySelector('[data-section-type="product"]'));
                            var modalProductSection = new ProductSection(modal.querySelector('[data-section-type="product"]')),
                                doCleanUp = function doCleanUp2() {
                                    modalProductSection.onUnload(), modal.removeEventListener("modal:closed", doCleanUp2)
                                };
                            modal.addEventListener("modal:closed", doCleanUp)
                        })
                    })
                }
            }, {
                key: "_changeLayout",
                value: function(event2, target) {
                    var _this = this;
                    if (!target.classList.contains("is-selected")) {
                        var newLayoutMode = target.getAttribute("data-layout-mode");
                        fetch("".concat(window.routes.cartUrl, "/update.js"), {
                            body: JSON.stringify({
                                attributes: {
                                    collection_layout: newLayoutMode
                                }
                            }),
                            credentials: "same-origin",
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Requested-With": "XMLHttpRequest"
                            }
                        }), fastdom.mutate(function() {
                            Dom.getSiblings(target, ".is-selected").forEach(function(button) {
                                return button.classList.remove("is-selected")
                            }), target.classList.add("is-selected"), _this.element.querySelectorAll(".product-item").forEach(function(item) {
                                newLayoutMode === "grid" ? item.className = "product-item product-item--vertical ".concat(_this.options.gridClasses) : item.className = "product-item product-item--list"
                            }), _this.productItemColorSwatch.recalculateSwatches()
                        })
                    }
                }
            }, {
                key: "_sortByChanged",
                value: function(value) {
                    this.currentUrl.searchParams.set("sort_by", value), this.currentUrl.searchParams.delete("page"), this._reload(!0)
                }
            }, {
                key: "_showingCountChanged",
                value: function(value) {
                    var _this2 = this;
                    this.currentUrl.searchParams.delete("page"), fetch("".concat(window.routes.cartUrl, "/update.js"), {
                        body: JSON.stringify({
                            attributes: {
                                collection_products_per_page: value
                            }
                        }),
                        credentials: "same-origin",
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest"
                        }
                    }).then(function() {
                        _this2._reload(!0)
                    })
                }
            }, {
                key: "_paginationPageChanged",
                value: function(event2, target) {
                    event2.preventDefault(), this.currentUrl.searchParams.set("page", parseInt(target.getAttribute("data-page"))), this._reload(!0)
                }
            }, {
                key: "_onFilterChanged",
                value: function(event2, target) {
                    var formData = new FormData(target.closest("form")),
                        searchParamsAsString = new URLSearchParams(formData).toString();
                    this.currentUrl = new URL("".concat(window.location.pathname, "?").concat(searchParamsAsString), window.location.origin), this._reload(!0)
                }
            }, {
                key: "_onFiltersCleared",
                value: function(event2, target) {
                    this.currentUrl = new URL(target.getAttribute("data-url"), window.location.origin), this._reload(!0)
                }
            }, {
                key: "_reload",
                value: function(pushState) {
                    var _this3 = this;
                    this.abortController && this.abortController.abort(), pushState && window.history.pushState({
                        path: this.currentUrl.toString()
                    }, "", this.currentUrl.toString()), document.dispatchEvent(new CustomEvent("theme:loading:start"));
                    var computedStyles = window.getComputedStyle(document.documentElement),
                        sectionUrl = "";
                    this.currentUrl.search ? sectionUrl = "".concat(this.currentUrl.pathname, "/").concat(this.currentUrl.search, "&section_id=").concat(this.element.getAttribute("data-section-id")) : sectionUrl = "".concat(this.currentUrl.pathname, "?section_id=").concat(this.element.getAttribute("data-section-id"));
                    try {
                        return this.abortController = new AbortController, fetch(sectionUrl, {
                            credentials: "same-origin",
                            method: "GET",
                            signal: this.abortController.signal
                        }).then(function(response) {
                            response.text().then(function(content) {
                                var tempElement = document.createElement("div");
                                tempElement.innerHTML = content, _this3.element.querySelector(".collection__dynamic-part").innerHTML = tempElement.querySelector(".collection__dynamic-part").innerHTML;
                                var desktopFilters = _this3.element.querySelector("#desktop-filters-form"),
                                    mobileFilters = _this3.element.querySelector("#mobile-collection-filters"),
                                    previousMobileScrollTop = 0;
                                mobileFilters && (previousMobileScrollTop = mobileFilters.querySelector(".collection-drawer__inner").scrollTop), desktopFilters && (Array.from(_this3.element.querySelectorAll(".collection__filter-group-name")).forEach(function(groupName) {
                                    var newGroup = tempElement.querySelector('[aria-controls="'.concat(groupName.getAttribute("aria-controls"), '"]'));
                                    groupName.getAttribute("aria-expanded") === "true" ? (newGroup.setAttribute("aria-expanded", "true"), newGroup.nextElementSibling.setAttribute("aria-hidden", "false"), newGroup.nextElementSibling.style.height = "auto", newGroup.nextElementSibling.style.overflow = "visible") : (newGroup.setAttribute("aria-expanded", "false"), newGroup.nextElementSibling.setAttribute("aria-hidden", "true"), newGroup.nextElementSibling.style = "")
                                }), desktopFilters.innerHTML = tempElement.querySelector("#desktop-filters-form").innerHTML, mobileFilters.innerHTML = tempElement.querySelector("#mobile-collection-filters").innerHTML, mobileFilters.querySelector(".collection-drawer__inner").scrollTop = previousMobileScrollTop, _this3.mobileFilterDrawer._computeDrawerHeight()), _this3.productItemColorSwatch.recalculateSwatches();
                                var elementOffset = _this3.element.querySelector(".collection").getBoundingClientRect().top - 25 - parseInt(computedStyles.getPropertyValue("--header-is-sticky")) * parseInt(computedStyles.getPropertyValue("--header-height"));
                                elementOffset < 0 && window.scrollBy({
                                    top: elementOffset,
                                    behavior: "smooth"
                                }), document.dispatchEvent(new CustomEvent("theme:loading:end"))
                            })
                        })
                    } catch (e) {}
                }
            }, {
                key: "_loadContentResults",
                value: function() {
                    var _this4 = this,
                        currentUrl = new URL(window.location.href);
                    fetch("".concat(window.routes.searchUrl, "?section_id=search-content&q=").concat(currentUrl.searchParams.get("q"), "&type=").concat(window.theme.searchMode.replace("product,", "")), {
                        credentials: "same-origin"
                    }).then(function(response) {
                        response.text().then(function(content) {
                            var linkSearchResults = _this4.element.querySelector(".link-search-results"),
                                fakeDiv = document.createElement("div");
                            fakeDiv.innerHTML = content, linkSearchResults && content.trim() !== "" && (linkSearchResults.innerHTML = fakeDiv.firstElementChild.innerHTML, linkSearchResults.style.display = "block")
                        })
                    })
                }
            }, {
                key: "_addToCart",
                value: function(event2, target) {
                    var _this5 = this;
                    if (window.theme.cartType !== "page") {
                        event2.preventDefault(), event2.stopPropagation(), target.setAttribute("disabled", "disabled"), document.dispatchEvent(new CustomEvent("theme:loading:start"));
                        var formElement = target.closest('form[action*="/cart/add"]');
                        fetch("".concat(window.routes.cartAddUrl, ".js"), {
                            body: JSON.stringify(Form.serialize(formElement)),
                            credentials: "same-origin",
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Requested-With": "XMLHttpRequest"
                            }
                        }).then(function(response) {
                            target.removeAttribute("disabled"), response.ok ? _this5.element.dispatchEvent(new CustomEvent("product:added", {
                                bubbles: !0,
                                detail: {
                                    button: target,
                                    variant: null,
                                    quantity: parseInt(formElement.querySelector('[name="quantity"]').value)
                                }
                            })) : document.dispatchEvent(new CustomEvent("theme:loading:end"))
                        }), event2.preventDefault()
                    }
                }
            }]), CollectionSection2
        })(),
        FeaturedCollectionSection = (function() {
            function FeaturedCollectionSection2(element) {
                _classCallCheck(this, FeaturedCollectionSection2), this.element = element, this.delegateElement = new Delegate(this.element), this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.options.stackable || (this.flickityInstance = new js(this.element.querySelector(".product-list"), {
                    watchCSS: !0,
                    pageDots: !1,
                    prevNextButtons: !0,
                    contain: !0,
                    groupCells: !0,
                    cellAlign: "left",
                    draggable: !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches
                })), this.productItemColorSwatch = new ProductItemColorSwatch(this.element), this._fixSafari(), this._attachListeners()
            }
            return _createClass(FeaturedCollectionSection2, [{
                key: "onUnload",
                value: function() {
                    this.options.stackable || this.flickityInstance.destroy(), window.removeEventListener("resize", this._fixSafariListener), this.delegateElement.off("change"), this.productItemColorSwatch.destroy(), this.resizeObserver && this.resizeObserver.disconnect()
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    var _this = this;
                    this._fixSafariListener = this._fixSafari.bind(this), window.addEventListener("resize", this._fixSafariListener), this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this)), this.delegateElement.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this)), window.ResizeObserver && this.flickityInstance && (this.resizeObserver = new ResizeObserver(function() {
                        _this.flickityInstance.resize()
                    }), this.element.querySelectorAll(".product-item").forEach(function(item) {
                        _this.resizeObserver.observe(item)
                    }))
                }
            }, {
                key: "_fixSafari",
                value: function() {
                    var userAgent = window.navigator.userAgent.toLowerCase();
                    if (userAgent.includes("safari") && (userAgent.includes("version/10.1") || userAgent.includes("version/10.3") || userAgent.includes("version/11.0"))) {
                        var isPhone = Responsive.matchesBreakpoint("phone");
                        this.element.querySelectorAll(".product-item__image-wrapper .aspect-ratio, .product-item__image-wrapper .placeholder-svg").forEach(function(image) {
                            isPhone ? image.parentNode.style.height = null : image.parentNode.style.height = "".concat(image.clientHeight, "px")
                        })
                    }
                }
            }, {
                key: "_openQuickView",
                value: function(event2, target) {
                    var productUrl = new URL("".concat(window.location.origin).concat(target.getAttribute("data-product-url")));
                    if (Responsive.matchesBreakpoint("phone") || Responsive.matchesBreakpoint("tablet")) return window.location.href = productUrl.href, !1;
                    var modal = document.getElementById(target.getAttribute("aria-controls"));
                    modal.classList.add("is-loading"), productUrl.searchParams.set("view", "quick-view"), fetch(productUrl.href, {
                        credentials: "same-origin",
                        method: "GET"
                    }).then(function(response) {
                        response.text().then(function(content) {
                            modal.querySelector(".modal__inner").innerHTML = content, modal.classList.remove("is-loading");
                            var modalProductSection = new ProductSection(modal.querySelector('[data-section-type="product"]')),
                                doCleanUp = function doCleanUp2() {
                                    modalProductSection.onUnload(), modal.removeEventListener("modal:closed", doCleanUp2)
                                };
                            modal.addEventListener("modal:closed", doCleanUp)
                        })
                    })
                }
            }, {
                key: "_addToCart",
                value: function(event2, target) {
                    var _this2 = this;
                    if (window.theme.cartType !== "page") {
                        event2.preventDefault(), event2.stopPropagation(), target.setAttribute("disabled", "disabled"), document.dispatchEvent(new CustomEvent("theme:loading:start"));
                        var formElement = target.closest('form[action*="/cart/add"]');
                        fetch("".concat(window.routes.cartAddUrl, ".js"), {
                            body: JSON.stringify(Form.serialize(formElement)),
                            credentials: "same-origin",
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Requested-With": "XMLHttpRequest"
                            }
                        }).then(function(response) {
                            target.removeAttribute("disabled"), response.ok ? _this2.element.dispatchEvent(new CustomEvent("product:added", {
                                bubbles: !0,
                                detail: {
                                    button: target,
                                    variant: null,
                                    quantity: parseInt(formElement.querySelector('[name="quantity"]').value)
                                }
                            })) : document.dispatchEvent(new CustomEvent("theme:loading:end"))
                        }), event2.preventDefault()
                    }
                }
            }]), FeaturedCollectionSection2
        })(),
        GiftCardSection = (function() {
            function GiftCardSection2(container) {
                _classCallCheck(this, GiftCardSection2), this.element = container, this.delegateElement = new Delegate(this.element), this._createQrCode(), this._attachListeners()
            }
            return _createClass(GiftCardSection2, [{
                key: "onUnload",
                value: function() {
                    this.delegateElement.off()
                }
            }, {
                key: "_createQrCode",
                value: function() {
                    var qrCodeElements = document.querySelectorAll(".gift-card__qr");
                    qrCodeElements.forEach(function(qrCodeElement) {
                        new QRCode(qrCodeElement, {
                            text: qrCodeElement.getAttribute("data-identifier"),
                            width: 200,
                            height: 200
                        })
                    })
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this.delegateElement.on("click", '[data-action="print"]', this._print.bind(this)), this.delegateElement.on("click", '[data-action="select-code"]', this._selectCode.bind(this))
                }
            }, {
                key: "_print",
                value: function() {
                    window.print()
                }
            }, {
                key: "_selectCode",
                value: function(event2, element) {
                    element.select()
                }
            }]), GiftCardSection2
        })(),
        FooterSection = (function() {
            function FooterSection2(element) {
                _classCallCheck(this, FooterSection2), this.element = element, this.domDelegate = new Delegate(this.element), this.localeValuePicker = new ValuePicker("footer-locale-picker"), this.currencyValuePicker = new ValuePicker("footer-currency-picker"), this.cookieBarElement = this.element.querySelector(".cookie-bar"), this.cookieBarElement && this._setupCookieBar(), this._setupCollapsibles(), this._attachListeners()
            }
            return _createClass(FooterSection2, [{
                key: "onUnload",
                value: function() {
                    window.removeEventListener("resize", this._setupCollapsiblesListener), this.domDelegate.off(), this.localeValuePicker.destroy(), this.currencyValuePicker.destroy()
                }
            }, {
                key: "onSelect",
                value: function() {
                    this.cookieBarElement && this.cookieBarElement.setAttribute("aria-hidden", "false")
                }
            }, {
                key: "onDeselect",
                value: function() {
                    this.cookieBarElement && this.cookieBarElement.setAttribute("aria-hidden", "true")
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this._setupCollapsiblesListener = this._setupCollapsibles.bind(this), window.addEventListener("resize", this._setupCollapsiblesListener), this.domDelegate.on("click", '[data-action="accept-terms"]', this._acceptCookieBarTerms.bind(this))
                }
            }, {
                key: "_setupCollapsibles",
                value: function() {
                    var collapsibleToggles = this.element.querySelectorAll('[data-action="toggle-collapsible"]'),
                        isPhone = Responsive.matchesBreakpoint("phone");
                    collapsibleToggles.forEach(function(collapsibleToggle) {
                        isPhone ? collapsibleToggle.removeAttribute("disabled") : (collapsibleToggle.setAttribute("disabled", "disabled"), document.getElementById(collapsibleToggle.getAttribute("aria-controls")).style.height = "")
                    })
                }
            }, {
                key: "_setupCookieBar",
                value: function() {
                    try {
                        localStorage.getItem("cookieWasAccepted") === null && this.cookieBarElement.setAttribute("aria-hidden", "false")
                    } catch (exception) {}
                }
            }, {
                key: "_acceptCookieBarTerms",
                value: function() {
                    this.cookieBarElement.setAttribute("aria-hidden", "true");
                    try {
                        localStorage.setItem("cookieWasAccepted", "true")
                    } catch (exception) {}
                }
            }]), FooterSection2
        })(),
        SearchBar = (function() {
            function SearchBar2(element) {
                _classCallCheck(this, SearchBar2), this.element = element, this.delegateElement = new Delegate(this.element), this.headerElement = this.element.closest(".header"), this.searchBarElement = this.element.querySelector(".search-bar"), this.inputElement = this.element.querySelector('[name="q"]'), this.searchMenuElement = this.element.querySelector(".search-bar__menu-wrapper"), this.searchResultsElement = this.element.querySelector(".search-bar__results"), this.closeButtonElement = this.element.querySelector(".search-bar__close-button"), this.productTypeFilter = "", this.isSearchOpen = !1, this._attachListeners()
            }
            return _createClass(SearchBar2, [{
                key: "destroy",
                value: function() {
                    this.delegateElement.off()
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this.delegateElement.on("click", '[data-action="clear-input"]', this._clearInput.bind(this)), this.delegateElement.on("click", '[data-action="unfix-search"]', this._unfixMobileSearch.bind(this)), this.delegateElement.on("focusin", '[name="q"]', this._onInputFocus.bind(this)), this.delegateElement.on("focusout", this._onFocusOut.bind(this)), this.delegateElement.on("keydown", '[name="q"]', this._handleTab.bind(this)), this.delegateElement.on("input", '[name="q"]', this._debounce(this._doSearch.bind(this), 250)), this.delegateElement.on("change", "#search-product-type", this._productTypeChanged.bind(this)), this.delegateElement.on("submit", this._onFormSubmit.bind(this))
                }
            }, {
                key: "toggleMobileSearch",
                value: function() {
                    this.isSearchOpen ? (this.headerElement.classList.remove("header--search-expanded"), this.element.classList.remove("is-visible")) : (this.headerElement.classList.add("header--search-expanded"), this.element.classList.add("is-visible")), this.isSearchOpen = !this.isSearchOpen
                }
            }, {
                key: "_unfixMobileSearch",
                value: function() {
                    this.element.classList.remove("is-fixed"), this.closeButtonElement.style.width = "", this.searchBarElement.classList.remove("is-expanded"), this.searchResultsElement.setAttribute("aria-hidden", "true"), this.inputElement.classList.remove("is-filled"), document.body.classList.remove("no-mobile-scroll"), this.searchMenuElement && this.searchMenuElement.setAttribute("aria-hidden", "true")
                }
            }, {
                key: "_clearInput",
                value: function() {
                    this.inputElement.value = "", this.inputElement.classList.remove("is-filled"), this.searchResultsElement.setAttribute("aria-hidden", "true"), this.searchMenuElement && this.searchMenuElement.setAttribute("aria-hidden", "false")
                }
            }, {
                key: "_onInputFocus",
                value: function() {
                    this.element.classList.add("is-fixed"), this.closeButtonElement.style.width = "".concat(this.closeButtonElement.firstElementChild.offsetWidth, "px"), document.body.classList.add("no-mobile-scroll"), this.inputElement.value === "" ? (this.searchMenuElement && this.searchMenuElement.setAttribute("aria-hidden", "false"), this.searchResultsElement.setAttribute("aria-hidden", "true")) : (this.searchMenuElement && this.searchMenuElement.setAttribute("aria-hidden", "true"), this.searchResultsElement.setAttribute("aria-hidden", "false"), this.inputElement.classList.add("is-filled"), this.searchBarElement.classList.add("is-expanded")), this.searchMenuElement && this.searchBarElement.classList.add("is-expanded")
                }
            }, {
                key: "_onFocusOut",
                value: function(event2) {
                    Responsive.matchesBreakpoint("phone") || (this.element.classList.remove("is-fixed"), document.body.classList.remove("no-mobile-scroll"), this.element.contains(event2.relatedTarget) || (this.searchMenuElement && this.searchMenuElement.setAttribute("aria-hidden", "true"), this.searchResultsElement.setAttribute("aria-hidden", "true"), this.searchBarElement.classList.remove("is-expanded")))
                }
            }, {
                key: "_handleTab",
                value: function(event2) {
                    if (event2.key === "Tab") {
                        var firstFocusableElement = this.searchResultsElement.querySelector("a");
                        firstFocusableElement && (firstFocusableElement.focus(), event2.preventDefault())
                    }
                }
            }, {
                key: "_doSearch",
                value: function() {
                    var _this = this,
                        currentInput = this.inputElement.value;
                    if (this.lastInputValue = currentInput, currentInput === "") this.searchMenuElement ? this.searchMenuElement.setAttribute("aria-hidden", "false") : this.searchBarElement.classList.remove("is-expanded"), this.searchResultsElement.setAttribute("aria-hidden", "true");
                    else {
                        this.searchMenuElement && this.searchMenuElement.setAttribute("aria-hidden", "true"), this.searchResultsElement.setAttribute("aria-hidden", "false"), this.searchBarElement.classList.add("is-expanded", "is-loading");
                        var queryOptions = {
                                method: "GET",
                                credentials: "same-origin"
                            },
                            productQuery = "".concat(this.productTypeFilter !== "" ? "product_type:".concat(this.productTypeFilter, " AND ") : "").concat(encodeURIComponent(this.lastInputValue)),
                            queries = [fetch("".concat(window.routes.searchUrl, "?section_id=search-ajax&q=").concat(productQuery, "&options[prefix]=last&options[unavailable_products]=").concat(window.theme.searchUnavailableProducts, "&type=product"), queryOptions)];
                        window.theme.searchMode !== "product" && queries.push(fetch("".concat(window.routes.searchUrl, "?section_id=search-ajax&q=").concat(encodeURIComponent(this.lastInputValue), "&options[prefix]=last&type=").concat(window.theme.searchMode.replace("product,", "")), queryOptions)), Promise.all(queries).then(function(responses) {
                            _this.lastInputValue === currentInput && Promise.all(responses.map(function(response) {
                                return response.text().then(function(responseAsText) {
                                    var div = document.createElement("div");
                                    return div.innerHTML = responseAsText, div.querySelector(".search-ajax").innerHTML
                                })
                            })).then(function(contents) {
                                _this.searchBarElement.classList.remove("is-loading");
                                var searchContent = document.createElement("div");
                                searchContent.innerHTML = contents.join("").trim();
                                var viewAll = searchContent.querySelector(".search-bar__view-all");
                                viewAll && searchContent.insertAdjacentElement("beforeend", viewAll), _this.searchBarElement.querySelector(".search-bar__results-inner").innerHTML = searchContent.innerHTML
                            })
                        })
                    }
                }
            }, {
                key: "_productTypeChanged",
                value: function(event2, target) {
                    target.closest(".search-bar__filter").querySelector(".search-bar__filter-active").innerText = target.options[target.selectedIndex].innerText, this.productTypeFilter = target.value, this.inputElement.value !== "" && this._doSearch()
                }
            }, {
                key: "_onFormSubmit",
                value: function(event2) {
                    var cloneNode = this.inputElement.cloneNode();
                    cloneNode.setAttribute("type", "hidden"), cloneNode.value = "", this.productTypeFilter !== "" && (cloneNode.value += "product_type:".concat(this.productTypeFilter), this.inputElement.value !== "" && (cloneNode.value += " AND ")), cloneNode.value += this.inputElement.value, this.inputElement.removeAttribute("name"), this.inputElement.insertAdjacentElement("afterend", cloneNode)
                }
            }, {
                key: "_debounce",
                value: function(fn, delay) {
                    var _this2 = this,
                        timer = null;
                    return function() {
                        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
                        clearTimeout(timer), timer = setTimeout(function() {
                            fn.apply(_this2, args)
                        }, delay)
                    }
                }
            }]), SearchBar2
        })(),
        HeaderSection = (function() {
            function HeaderSection2(element) {
                _classCallCheck(this, HeaderSection2), this.element = element, this.delegateElement = new Delegate(this.element), this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.searchBar = new SearchBar(this.element.querySelector(".header__search-bar-wrapper")), this.cart = new Cart(this.element.querySelector(".header__action-item--cart"), {
                    useStickyHeader: this.options.useStickyHeader
                });
                var desktopNavigationElement = this.element.querySelector(this.options.navigationLayout === "inline" ? ".nav-bar" : ".header__desktop-nav");
                desktopNavigationElement && (this.desktopNavigation = new DesktopNavigation(desktopNavigationElement, this.options.navigationLayout, this.options.desktopOpenTrigger));
                var mobileNavigationElement = this.element.querySelector(".header__mobile-nav");
                mobileNavigationElement && (this.mobileNavigation = new MobileNavigation(mobileNavigationElement)), this._setupCssVariables(), this._attachListeners()
            }
            return _createClass(HeaderSection2, [{
                key: "onUnload",
                value: function() {
                    this.searchBar.destroy(), this.cart.destroy(), this.desktopNavigation && this.desktopNavigation.destroy(), this.mobileNavigation && this.mobileNavigation.destroy(), window.removeEventListener("resize", this._setupCssVariablesListener)
                }
            }, {
                key: "onBlockSelect",
                value: function(event2) {
                    this.desktopNavigation && this.desktopNavigation.onBlockSelect(event2)
                }
            }, {
                key: "onBlockDeselect",
                value: function(event2) {
                    this.desktopNavigation && this.desktopNavigation.onBlockDeselect(event2)
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this._setupCssVariablesListener = this._setupCssVariables.bind(this), window.addEventListener("resize", this._setupCssVariablesListener), this.delegateElement.on("click", '[data-action="toggle-search"]', this._toggleMobileSearch.bind(this))
                }
            }, {
                key: "_setupCssVariables",
                value: function() {
                    document.documentElement.style.setProperty("--header-height", this.element.parentNode.clientHeight + "px")
                }
            }, {
                key: "_toggleMobileSearch",
                value: function(event2) {
                    this.searchBar.toggleMobileSearch(), event2.preventDefault()
                }
            }]), HeaderSection2
        })(),
        LoginSection = (function() {
            function LoginSection2(element) {
                _classCallCheck(this, LoginSection2), this.element = element, this.domDelegate = new Delegate(this.element), this.customerLoginForm = this.element.querySelector("#customer_login"), this.recoverPasswordForm = this.element.querySelector("#recover_customer_password"), this.domDelegate.on("click", '[data-action="toggle-login-form"]', this._showRecoverPassword.bind(this))
            }
            return _createClass(LoginSection2, [{
                key: "_showRecoverPassword",
                value: function() {
                    var isLoginActive = this.customerLoginForm.style.display === "block";
                    isLoginActive ? (this.customerLoginForm.style.display = "none", this.recoverPasswordForm.style.display = "block") : (this.customerLoginForm.style.display = "block", this.recoverPasswordForm.style.display = "none")
                }
            }]), LoginSection2
        })(),
        MapSection = (function() {
            function MapSection2(element) {
                _classCallCheck(this, MapSection2), this.element = element, this.delegateElement = new Delegate(this.element), this.options = JSON.parse(element.getAttribute("data-section-settings")), this.mapPositions = [], this.desktopMarkers = [], this.desktopMapElement = null, this.mobileMarkers = [], this.mobileMapElements = [], this.options.apiKey && this.options.mapAddresses.length > 0 && this._loadScript().then(this._initMaps.bind(this)), this._attachListeners()
            }
            return _createClass(MapSection2, [{
                key: "onUnload",
                value: function() {
                    this.delegateElement.off("click"), this.options.apiKey && this.options.mapAddresses.length > 0 && google.maps.event.clearInstanceListeners(window)
                }
            }, {
                key: "onBlockSelect",
                value: function(event2) {
                    this._showStore(event2.target)
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    var _this = this;
                    this.delegateElement.on("click", '[data-action="toggle-store"]', function(event2, target) {
                        _this._showStore(target.closest(".map__store-item"))
                    })
                }
            }, {
                key: "_showStore",
                value: function(storeItem) {
                    var _this2 = this,
                        toggleButton = storeItem.querySelector('[data-action="toggle-store"]');
                    if (!(Responsive.getCurrentBreakpoint() !== "phone" && toggleButton.getAttribute("aria-expanded") === "true")) {
                        toggleButton.getAttribute("aria-expanded") === "true" ? (toggleButton.setAttribute("aria-expanded", "false"), Animation.slideUp(storeItem.querySelector(".map__store-collapsible"))) : (toggleButton.setAttribute("aria-expanded", "true"), Animation.slideDown(storeItem.querySelector(".map__store-collapsible"))), Dom.getSiblings(storeItem).forEach(function(storeItemToClose) {
                            storeItemToClose.querySelector('[data-action="toggle-store"]').setAttribute("aria-expanded", "false"), Animation.slideUp(storeItemToClose.querySelector(".map__store-collapsible"))
                        });
                        var storeIndex = parseInt(storeItem.getAttribute("data-store-index"));
                        this.desktopMapElement.panTo(this.mapPositions[storeIndex]), this.desktopMarkers.forEach(function(marker, index) {
                            marker.setMap(_this2.desktopMapElement), index === storeIndex ? marker.icon.fillColor = _this2.options.markerActiveColor : marker.icon.fillColor = _this2.options.markerColor
                        })
                    }
                }
            }, {
                key: "_loadScript",
                value: function() {
                    var _this3 = this;
                    return new Promise(function(resolve, reject) {
                        var script = document.createElement("script");
                        document.body.appendChild(script), script.onload = resolve, script.onerror = reject, script.async = !0, script.src = "https://maps.googleapis.com/maps/api/js?key=".concat(_this3.options.apiKey)
                    })
                }
            }, {
                key: "_initMaps",
                value: function() {
                    var _this4 = this,
                        mapOptions = {
                            zoom: this.options.zoom,
                            draggable: this.options.draggableMap,
                            clickableIcons: !1,
                            scrollwheel: this.options.draggableMap,
                            disableDoubleClickZoom: !0,
                            disableDefaultUI: !this.options.showMapControls,
                            styles: JSON.parse(this.element.querySelector("[data-gmap-style]").innerHTML)
                        };
                    this.desktopMapElement = new google.maps.Map(this.element.querySelector(".map__map-container--desktop .map__gmap"), mapOptions), this.mobileMapElements = [], this.element.querySelectorAll(".map__map-container--mobile .map__gmap").forEach(function(item, index) {
                        _this4.mobileMapElements[index] = new google.maps.Map(item, mapOptions)
                    }), this._geocodeAddresses(), google.maps.event.addDomListener(window, "resize", function() {
                        var desktopCenter = _this4.desktopMapElement.getCenter();
                        google.maps.event.trigger(_this4.desktopMapElement, "resize"), _this4.desktopMapElement.setCenter(desktopCenter), _this4.mobileMapElements.forEach(function(mobileMap) {
                            var mobileCenter = mobileMap.getCenter();
                            google.maps.event.trigger(mobileMap, "resize"), mobileMap.setCenter(mobileCenter)
                        })
                    })
                }
            }, {
                key: "_onMarkerClicked",
                value: function(address) {
                    window.open("https://www.google.com/maps/search/?api=1&query=".concat(address), "_blank")
                }
            }, {
                key: "_geocodeAddresses",
                value: function() {
                    var _this5 = this,
                        geocoder = new google.maps.Geocoder;
                    this.options.mapAddresses.forEach(function(address, index) {
                        geocoder.geocode({
                            address: address
                        }, function(results, status) {
                            if (status !== google.maps.GeocoderStatus.OK) Shopify.designMode;
                            else {
                                var position = results[0].geometry.location;
                                _this5.mapPositions[index] = position, _this5.desktopMarkers[index] = new google.maps.Marker({
                                    map: index === 0 ? _this5.desktopMapElement : null,
                                    position: position,
                                    icon: {
                                        path: "M12.5,0 C6.388889,0 0,4.7304348 0,12.5217391 C0,19.8956522 11.111111,31.1652174 11.527778,31.5826087 C11.805556,31.8608696 12.083333,32 12.5,32 C12.916667,32 13.194444,31.8608696 13.472222,31.5826087 C13.888889,31.1652174 25,19.8956522 25,12.5217391 C25,4.7304348 18.611111,0 12.5,0 Z M12,16 C9.733333,16 8,14.2666667 8,12 C8,9.7333333 9.733333,8 12,8 C14.266667,8 16,9.7333333 16,12 C16,14.2666667 14.266667,16 12,16 Z",
                                        fillColor: index === 0 ? _this5.options.markerActiveColor : _this5.options.markerColor,
                                        fillOpacity: 1,
                                        anchor: new google.maps.Point(12, 30),
                                        strokeWeight: 0
                                    }
                                }), _this5.mobileMarkers[index] = new google.maps.Marker({
                                    map: _this5.mobileMapElements[index],
                                    position: position,
                                    icon: {
                                        path: "M12.5,0 C6.388889,0 0,4.7304348 0,12.5217391 C0,19.8956522 11.111111,31.1652174 11.527778,31.5826087 C11.805556,31.8608696 12.083333,32 12.5,32 C12.916667,32 13.194444,31.8608696 13.472222,31.5826087 C13.888889,31.1652174 25,19.8956522 25,12.5217391 C25,4.7304348 18.611111,0 12.5,0 Z M12,16 C9.733333,16 8,14.2666667 8,12 C8,9.7333333 9.733333,8 12,8 C14.266667,8 16,9.7333333 16,12 C16,14.2666667 14.266667,16 12,16 Z",
                                        fillColor: _this5.options.markerActiveColor,
                                        fillOpacity: 1,
                                        anchor: new google.maps.Point(12, 30),
                                        strokeWeight: 0
                                    }
                                }), _this5.desktopMarkers[index].addListener("click", _this5._onMarkerClicked.bind(_this5, address)), _this5.mobileMarkers[index].addListener("click", _this5._onMarkerClicked.bind(_this5, address)), index === 0 && _this5.desktopMapElement.setCenter(position), _this5.mobileMapElements[index].setCenter(position)
                            }
                        })
                    })
                }
            }]), MapSection2
        })(),
        MinimalHeaderSection = (function() {
            function MinimalHeaderSection2(element) {
                _classCallCheck(this, MinimalHeaderSection2), this.element = element, this._setupCssVariables(), this._attachListeners()
            }
            return _createClass(MinimalHeaderSection2, [{
                key: "onUnload",
                value: function() {
                    window.removeEventListener("resize", this._setupCssVariablesListener)
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this._setupCssVariablesListener = this._setupCssVariables.bind(this), window.addEventListener("resize", this._setupCssVariablesListener)
                }
            }, {
                key: "_setupCssVariables",
                value: function() {
                    document.documentElement.style.setProperty("--header-height", this.element.parentNode.clientHeight + "px")
                }
            }]), MinimalHeaderSection2
        })(),
        QuickLinksSection = function QuickLinksSection2(element) {
            _classCallCheck(this, QuickLinksSection2), this.element = element, Shopify.designMode && this.element.classList.remove("hidden-lap-and-up")
        },
        PopupsSection = (function() {
            function PopupsSection2(element) {
                var _this = this;
                _classCallCheck(this, PopupsSection2), element.querySelectorAll("[data-popup-type]").forEach(function(popup) {
                    popup.getAttribute("data-popup-type") === "exit" ? _this.exitPopup = new ExitPopup(popup) : popup.getAttribute("data-popup-type") === "newsletter" && (_this.newsletterPopup = new NewsletterPopup(popup))
                })
            }
            return _createClass(PopupsSection2, [{
                key: "onUnload",
                value: function() {
                    this.exitPopup && this.exitPopup.destroy(), this.newsletterPopup && this.newsletterPopup.destroy()
                }
            }, {
                key: "onBlockSelect",
                value: function(event2) {
                    event2.target.getAttribute("data-popup-type") === "exit" && this.exitPopup ? this.exitPopup._openPopup() : event2.target.getAttribute("data-popup-type") === "newsletter" && this.newsletterPopup && this.newsletterPopup._openPopup()
                }
            }, {
                key: "onBlockDeselect",
                value: function() {
                    this.exitPopup && this.exitPopup._closePopup(), this.newsletterPopup && this.newsletterPopup._closePopup()
                }
            }]), PopupsSection2
        })(),
        ProductRecommendationsSection = (function() {
            function ProductRecommendationsSection2(element) {
                _classCallCheck(this, ProductRecommendationsSection2), this.element = element, this.delegateElement = new Delegate(this.element), this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.options.useRecommendations ? this._loadRecommendations().then(this._createSlideshow.bind(this)) : this._createSlideshow(), this.productItemColorSwatch = new ProductItemColorSwatch(this.element), this._fixSafari(), this._attachListeners()
            }
            return _createClass(ProductRecommendationsSection2, [{
                key: "onUnload",
                value: function() {
                    this.options.stackable || this.flickityInstance.destroy(), window.removeEventListener("resize", this._fixSafariListener), this.delegateElement.off("change"), this.productItemColorSwatch.destroy(), this.resizeObserver && this.resizeObserver.disconnect()
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this._fixSafariListener = this._fixSafari.bind(this), window.addEventListener("resize", this._fixSafariListener), this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this)), this.delegateElement.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this))
                }
            }, {
                key: "_fixSafari",
                value: function() {
                    var userAgent = window.navigator.userAgent.toLowerCase();
                    if (userAgent.includes("safari") && (userAgent.includes("version/10.1") || userAgent.includes("version/10.3") || userAgent.includes("version/11.0"))) {
                        var isPhone = Responsive.matchesBreakpoint("phone");
                        this.element.querySelectorAll(".product-item__image-wrapper .aspect-ratio, .product-item__image-wrapper .placeholder-svg").forEach(function(image) {
                            isPhone ? image.parentNode.style.height = null : image.parentNode.style.height = "".concat(image.clientHeight, "px")
                        })
                    }
                }
            }, {
                key: "_loadRecommendations",
                value: function() {
                    var _this = this,
                        url = "".concat(window.routes.productRecommendationsUrl, "?section_id=").concat(this.element.getAttribute("data-section-id"), "&product_id=").concat(this.options.productId, "&limit=").concat(this.options.recommendationsCount);
                    return fetch(url).then(function(response) {
                        return response.text().then(function(content) {
                            var container = document.createElement("div");
                            container.innerHTML = content, _this.element.querySelector(".product-recommendations").innerHTML = container.querySelector(".product-recommendations").innerHTML, _this.productItemColorSwatch.recalculateSwatches()
                        })
                    })
                }
            }, {
                key: "_createSlideshow",
                value: function() {
                    var _this2 = this;
                    this.options.stackable || (this.flickityInstance = new js(this.element.querySelector(".product-list"), {
                        watchCSS: !0,
                        pageDots: !1,
                        prevNextButtons: !0,
                        contain: !0,
                        groupCells: !0,
                        cellAlign: "left",
                        draggable: !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches
                    })), window.ResizeObserver && this.flickityInstance && (this.resizeObserver = new ResizeObserver(function() {
                        _this2.flickityInstance.resize()
                    }), this.element.querySelectorAll(".product-item").forEach(function(item) {
                        _this2.resizeObserver.observe(item)
                    }))
                }
            }, {
                key: "_openQuickView",
                value: function(event2, target) {
                    var productUrl = new URL("".concat(window.location.origin).concat(target.getAttribute("data-product-url")));
                    if (Responsive.matchesBreakpoint("phone") || Responsive.matchesBreakpoint("tablet")) return window.location.href = productUrl.href, !1;
                    var modal = document.getElementById(target.getAttribute("aria-controls"));
                    modal.classList.add("is-loading"), productUrl.searchParams.set("view", "quick-view"), fetch(productUrl.href, {
                        credentials: "same-origin",
                        method: "GET"
                    }).then(function(response) {
                        response.text().then(function(content) {
                            modal.querySelector(".modal__inner").innerHTML = content, modal.classList.remove("is-loading");
                            var modalProductSection = new ProductSection(modal.querySelector('[data-section-type="product"]')),
                                doCleanUp = function doCleanUp2() {
                                    modalProductSection.onUnload(), modal.removeEventListener("modal:closed", doCleanUp2)
                                };
                            modal.addEventListener("modal:closed", doCleanUp)
                        })
                    })
                }
            }, {
                key: "_addToCart",
                value: function(event2, target) {
                    var _this3 = this;
                    if (window.theme.cartType !== "page") {
                        event2.preventDefault(), event2.stopPropagation(), target.setAttribute("disabled", "disabled"), document.dispatchEvent(new CustomEvent("theme:loading:start"));
                        var formElement = target.closest('form[action*="/cart/add"]');
                        fetch("".concat(window.routes.cartAddUrl, ".js"), {
                            body: JSON.stringify(Form.serialize(formElement)),
                            credentials: "same-origin",
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Requested-With": "XMLHttpRequest"
                            }
                        }).then(function(response) {
                            target.removeAttribute("disabled"), response.ok ? _this3.element.dispatchEvent(new CustomEvent("product:added", {
                                bubbles: !0,
                                detail: {
                                    button: target,
                                    variant: null,
                                    quantity: parseInt(formElement.querySelector('[name="quantity"]').value)
                                }
                            })) : document.dispatchEvent(new CustomEvent("theme:loading:end"))
                        }), event2.preventDefault()
                    }
                }
            }]), ProductRecommendationsSection2
        })(),
        RecentlyViewedProductsSection = (function() {
            function RecentlyViewedProductsSection2(element) {
                _classCallCheck(this, RecentlyViewedProductsSection2), this.element = element, this.delegateElement = new Delegate(this.element), this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.productItemColorSwatch = new ProductItemColorSwatch(this.element), this._fetchProducts(), this._attachListeners()
            }
            return _createClass(RecentlyViewedProductsSection2, [{
                key: "onUnload",
                value: function() {
                    this.flickityInstance && this.flickityInstance.destroy(), this.productItemColorSwatch.destroy(), this.resizeObserver && this.resizeObserver.disconnect()
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this)), this.delegateElement.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this))
                }
            }, {
                key: "_fetchProducts",
                value: function() {
                    var _this = this,
                        queryString = this._getSearchQueryString();
                    queryString !== "" && fetch("".concat(window.routes.searchUrl, "?section_id=").concat(this.element.getAttribute("data-section-id"), "&type=product&q=").concat(queryString), {
                        credentials: "same-origin",
                        method: "GET"
                    }).then(function(response) {
                        response.text().then(function(content) {
                            var tempElement = document.createElement("div");
                            tempElement.innerHTML = content, _this.element.querySelector(".recently-viewed-products-placeholder").innerHTML = tempElement.querySelector('[data-section-type="recently-viewed-products"] .recently-viewed-products-placeholder').innerHTML, _this.element.parentNode.style.display = "block", _this.productItemColorSwatch.recalculateSwatches(), _this.flickityInstance = new js(_this.element.querySelector(".product-list"), {
                                watchCSS: !0,
                                pageDots: !1,
                                prevNextButtons: !0,
                                contain: !0,
                                groupCells: !0,
                                cellAlign: "left",
                                draggable: !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches
                            }), window.ResizeObserver && _this.flickityInstance && (_this.resizeObserver = new ResizeObserver(function() {
                                _this.flickityInstance.resize()
                            }), _this.element.querySelectorAll(".product-item").forEach(function(item) {
                                _this.resizeObserver.observe(item)
                            }))
                        })
                    })
                }
            }, {
                key: "_getSearchQueryString",
                value: function() {
                    var items = JSON.parse(localStorage.getItem("recentlyViewedProducts") || "[]");
                    return items.includes(this.options.currentProductId) && items.splice(items.indexOf(this.options.currentProductId), 1), items.map(function(item) {
                        return "id:" + item
                    }).join(" OR ")
                }
            }, {
                key: "_openQuickView",
                value: function(event2, target) {
                    var productUrl = new URL("".concat(window.location.origin).concat(target.getAttribute("data-product-url")));
                    if (Responsive.matchesBreakpoint("phone") || Responsive.matchesBreakpoint("tablet")) return window.location.href = productUrl.href, !1;
                    var modal = document.getElementById(target.getAttribute("aria-controls"));
                    modal.classList.add("is-loading"), productUrl.searchParams.set("view", "quick-view"), fetch(productUrl.href, {
                        credentials: "same-origin",
                        method: "GET"
                    }).then(function(response) {
                        response.text().then(function(content) {
                            modal.querySelector(".modal__inner").innerHTML = content, modal.classList.remove("is-loading");
                            var modalProductSection = new ProductSection(modal.querySelector('[data-section-type="product"]')),
                                doCleanUp = function doCleanUp2() {
                                    modalProductSection.onUnload(), modal.removeEventListener("modal:closed", doCleanUp2)
                                };
                            modal.addEventListener("modal:closed", doCleanUp)
                        })
                    })
                }
            }, {
                key: "_addToCart",
                value: function(event2, target) {
                    var _this2 = this;
                    if (window.theme.cartType !== "page") {
                        event2.preventDefault(), event2.stopPropagation(), target.setAttribute("disabled", "disabled"), document.dispatchEvent(new CustomEvent("theme:loading:start"));
                        var formElement = target.closest('form[action*="/cart/add"]');
                        fetch("".concat(window.routes.cartAddUrl, ".js"), {
                            body: JSON.stringify(Form.serialize(formElement)),
                            credentials: "same-origin",
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Requested-With": "XMLHttpRequest"
                            }
                        }).then(function(response) {
                            target.removeAttribute("disabled"), response.ok ? _this2.element.dispatchEvent(new CustomEvent("product:added", {
                                bubbles: !0,
                                detail: {
                                    button: target,
                                    variant: null,
                                    quantity: parseInt(formElement.querySelector('[name="quantity"]').value)
                                }
                            })) : document.dispatchEvent(new CustomEvent("theme:loading:end"))
                        }), event2.preventDefault()
                    }
                }
            }]), RecentlyViewedProductsSection2
        })(),
        SectionContainer = (function() {
            function SectionContainer2() {
                _classCallCheck(this, SectionContainer2), this.constructors = [], this.instances = [], this._attachListeners()
            }
            return _createClass(SectionContainer2, [{
                key: "_attachListeners",
                value: function() {
                    document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this)), document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this)), document.addEventListener("shopify:section:select", this._onSelect.bind(this)), document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this)), document.addEventListener("shopify:section:reorder", this._onReorder.bind(this)), document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this)), document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this))
                }
            }, {
                key: "register",
                value: function(type, constructor) {
                    var _this = this;
                    this.constructors[type] = constructor, document.querySelectorAll("[data-section-type=".concat(type, "]")).forEach(function(container) {
                        _this._createInstance(container, constructor)
                    })
                }
            }, {
                key: "_findInstance",
                value: function(array, key, value) {
                    for (var i = 0; i < array.length; i++)
                        if (array[i][key] === value) return array[i]
                }
            }, {
                key: "_removeInstance",
                value: function(array, key, value) {
                    for (var i = array.length; i--;)
                        if (array[i][key] === value) {
                            array.splice(i, 1);
                            break
                        } return array
                }
            }, {
                key: "_onSectionLoad",
                value: function(event2) {
                    var container = event2.target.querySelector("[data-section-id]");
                    container && this._createInstance(container)
                }
            }, {
                key: "_onSectionUnload",
                value: function(event2) {
                    var instance = this._findInstance(this.instances, "id", event2.detail.sectionId);
                    instance && (typeof instance.onUnload == "function" && instance.onUnload(event2), this.instances = this._removeInstance(this.instances, "id", event2.detail.sectionId))
                }
            }, {
                key: "_onSelect",
                value: function(event2) {
                    var instance = this._findInstance(this.instances, "id", event2.detail.sectionId);
                    instance && typeof instance.onSelect == "function" && instance.onSelect(event2)
                }
            }, {
                key: "_onDeselect",
                value: function(event2) {
                    var instance = this._findInstance(this.instances, "id", event2.detail.sectionId);
                    instance && typeof instance.onDeselect == "function" && instance.onDeselect(event2)
                }
            }, {
                key: "_onReorder",
                value: function(event2) {
                    var instance = this._findInstance(this.instances, "id", event2.detail.sectionId);
                    instance && typeof instance.onReorder == "function" && instance.onReorder(event2)
                }
            }, {
                key: "_onBlockSelect",
                value: function(event2) {
                    var instance = this._findInstance(this.instances, "id", event2.detail.sectionId);
                    instance && typeof instance.onBlockSelect == "function" && instance.onBlockSelect(event2)
                }
            }, {
                key: "_onBlockDeselect",
                value: function(event2) {
                    var instance = this._findInstance(this.instances, "id", event2.detail.sectionId);
                    instance && typeof instance.onBlockDeselect == "function" && instance.onBlockDeselect(event2)
                }
            }, {
                key: "_createInstance",
                value: function(container, constructor) {
                    var id = container.getAttribute("data-section-id"),
                        type = container.getAttribute("data-section-type");
                    if (constructor = constructor || this.constructors[type], typeof constructor != "undefined") try {
                        var instance = Object.assign(new constructor(container), {
                            id: id,
                            type: type,
                            container: container
                        });
                        this.instances.push(instance)
                    } catch (exception) {
                        console.error("Logged exception (this may happen if you have tried to edit the code without properly adjusting the JavaScript): " + exception.message)
                    }
                }
            }]), SectionContainer2
        })(),
        SlideshowSection = (function() {
            function SlideshowSection2(element) {
                _classCallCheck(this, SlideshowSection2), this.element = element, this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.flickityInstance = new flickityFade(element.querySelector(".slideshow"), {
                    pageDots: this.options.pageDots,
                    prevNextButtons: this.options.prevNextButtons,
                    wrapAround: !0,
                    dragThreshold: 12,
                    draggable: ">1",
                    fade: this.options.transitionEffect === "fade",
                    setGallerySize: this.options.setGallerySize,
                    adaptiveHeight: this.options.adaptiveHeight,
                    autoPlay: this.options.autoPlay ? this.options.cycleSpeed : !1
                })
            }
            return _createClass(SlideshowSection2, [{
                key: "onUnload",
                value: function() {
                    this.flickityInstance.destroy()
                }
            }, {
                key: "onBlockSelect",
                value: function(event2) {
                    this.flickityInstance.isActive && (this.flickityInstance.selectCell(parseInt(event2.target.getAttribute("data-block-index")), !1, event2.detail.load), this.flickityInstance.pausePlayer())
                }
            }, {
                key: "onBlockDeselect",
                value: function() {
                    this.flickityInstance.isActive && this.flickityInstance.unpausePlayer()
                }
            }]), SlideshowSection2
        })(),
        TextWithIconsSection = (function() {
            function TextWithIconsSection2(element) {
                _classCallCheck(this, TextWithIconsSection2), this.flickityInstance = new js(element.querySelector(".text-with-icons"), {
                    pageDots: !0,
                    prevNextButtons: !1,
                    wrapAround: !0,
                    autoPlay: 5e3,
                    watchCSS: !0
                })
            }
            return _createClass(TextWithIconsSection2, [{
                key: "onUnload",
                value: function() {
                    this.flickityInstance.destroy()
                }
            }, {
                key: "onBlockSelect",
                value: function(event2) {
                    this.flickityInstance.isActive && (this.flickityInstance.selectCell(parseInt(event2.target.getAttribute("data-block-index")), !1, event2.detail.load), this.flickityInstance.pausePlayer())
                }
            }, {
                key: "onBlockDeselect",
                value: function() {
                    this.flickityInstance.isActive && this.flickityInstance.unpausePlayer()
                }
            }]), TextWithIconsSection2
        })(),
        VideoSection = (function() {
            function VideoSection2(element) {
                _classCallCheck(this, VideoSection2), this.element = element, this.domDelegate = new Delegate(this.element), this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this._attachListeners()
            }
            return _createClass(VideoSection2, [{
                key: "onUnload",
                value: function() {
                    this.domDelegate.off("click")
                }
            }, {
                key: "_attachListeners",
                value: function() {
                    this.domDelegate.on("click", '[data-action="play-video"]', this._playVideo.bind(this))
                }
            }, {
                key: "_playVideo",
                value: function(event2, target) {
                    var iframe = target.querySelector("iframe");
                    iframe.src = iframe.getAttribute("data-src"), target.classList.add("is-playing")
                }
            }]), VideoSection2
        })(),
        smoothscroll = createCommonjsModule(function(module, exports) {
            (function() {
                function polyfill() {
                    var w = window,
                        d = document;
                    if ("scrollBehavior" in d.documentElement.style && w.__forceSmoothScrollPolyfill__ !== !0) return;
                    var Element2 = w.HTMLElement || w.Element,
                        SCROLL_TIME = 468,
                        original = {
                            scroll: w.scroll || w.scrollTo,
                            scrollBy: w.scrollBy,
                            elementScroll: Element2.prototype.scroll || scrollElement,
                            scrollIntoView: Element2.prototype.scrollIntoView
                        },
                        now = w.performance && w.performance.now ? w.performance.now.bind(w.performance) : Date.now;

                    function isMicrosoftBrowser(userAgent) {
                        var userAgentPatterns = ["MSIE ", "Trident/", "Edge/"];
                        return new RegExp(userAgentPatterns.join("|")).test(userAgent)
                    }
                    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

                    function scrollElement(x, y) {
                        this.scrollLeft = x, this.scrollTop = y
                    }

                    function ease(k) {
                        return .5 * (1 - Math.cos(Math.PI * k))
                    }

                    function shouldBailOut(firstArg) {
                        if (firstArg === null || _typeof(firstArg) !== "object" || firstArg.behavior === void 0 || firstArg.behavior === "auto" || firstArg.behavior === "instant") return !0;
                        if (_typeof(firstArg) === "object" && firstArg.behavior === "smooth") return !1;
                        throw new TypeError("behavior member of ScrollOptions " + firstArg.behavior + " is not a valid value for enumeration ScrollBehavior.")
                    }

                    function hasScrollableSpace(el, axis) {
                        if (axis === "Y") return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
                        if (axis === "X") return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth
                    }

                    function canOverflow(el, axis) {
                        var overflowValue = w.getComputedStyle(el, null)["overflow" + axis];
                        return overflowValue === "auto" || overflowValue === "scroll"
                    }

                    function isScrollable(el) {
                        var isScrollableY = hasScrollableSpace(el, "Y") && canOverflow(el, "Y"),
                            isScrollableX = hasScrollableSpace(el, "X") && canOverflow(el, "X");
                        return isScrollableY || isScrollableX
                    }

                    function findScrollableParent(el) {
                        for (; el !== d.body && isScrollable(el) === !1;) el = el.parentNode || el.host;
                        return el
                    }

                    function step(context) {
                        var time = now(),
                            value, currentX, currentY, elapsed = (time - context.startTime) / SCROLL_TIME;
                        elapsed = elapsed > 1 ? 1 : elapsed, value = ease(elapsed), currentX = context.startX + (context.x - context.startX) * value, currentY = context.startY + (context.y - context.startY) * value, context.method.call(context.scrollable, currentX, currentY), (currentX !== context.x || currentY !== context.y) && w.requestAnimationFrame(step.bind(w, context))
                    }

                    function smoothScroll(el, x, y) {
                        var scrollable, startX, startY, method, startTime = now();
                        el === d.body ? (scrollable = w, startX = w.scrollX || w.pageXOffset, startY = w.scrollY || w.pageYOffset, method = original.scroll) : (scrollable = el, startX = el.scrollLeft, startY = el.scrollTop, method = scrollElement), step({
                            scrollable: scrollable,
                            method: method,
                            startTime: startTime,
                            startX: startX,
                            startY: startY,
                            x: x,
                            y: y
                        })
                    }
                    w.scroll = w.scrollTo = function() {
                        if (arguments[0] !== void 0) {
                            if (shouldBailOut(arguments[0]) === !0) {
                                original.scroll.call(w, arguments[0].left !== void 0 ? arguments[0].left : _typeof(arguments[0]) !== "object" ? arguments[0] : w.scrollX || w.pageXOffset, arguments[0].top !== void 0 ? arguments[0].top : arguments[1] !== void 0 ? arguments[1] : w.scrollY || w.pageYOffset);
                                return
                            }
                            smoothScroll.call(w, d.body, arguments[0].left !== void 0 ? ~~arguments[0].left : w.scrollX || w.pageXOffset, arguments[0].top !== void 0 ? ~~arguments[0].top : w.scrollY || w.pageYOffset)
                        }
                    }, w.scrollBy = function() {
                        if (arguments[0] !== void 0) {
                            if (shouldBailOut(arguments[0])) {
                                original.scrollBy.call(w, arguments[0].left !== void 0 ? arguments[0].left : _typeof(arguments[0]) !== "object" ? arguments[0] : 0, arguments[0].top !== void 0 ? arguments[0].top : arguments[1] !== void 0 ? arguments[1] : 0);
                                return
                            }
                            smoothScroll.call(w, d.body, ~~arguments[0].left + (w.scrollX || w.pageXOffset), ~~arguments[0].top + (w.scrollY || w.pageYOffset))
                        }
                    }, Element2.prototype.scroll = Element2.prototype.scrollTo = function() {
                        if (arguments[0] !== void 0) {
                            if (shouldBailOut(arguments[0]) === !0) {
                                if (typeof arguments[0] == "number" && arguments[1] === void 0) throw new SyntaxError("Value could not be converted");
                                original.elementScroll.call(this, arguments[0].left !== void 0 ? ~~arguments[0].left : _typeof(arguments[0]) !== "object" ? ~~arguments[0] : this.scrollLeft, arguments[0].top !== void 0 ? ~~arguments[0].top : arguments[1] !== void 0 ? ~~arguments[1] : this.scrollTop);
                                return
                            }
                            var left = arguments[0].left,
                                top = arguments[0].top;
                            smoothScroll.call(this, this, typeof left == "undefined" ? this.scrollLeft : ~~left, typeof top == "undefined" ? this.scrollTop : ~~top)
                        }
                    }, Element2.prototype.scrollBy = function() {
                        if (arguments[0] !== void 0) {
                            if (shouldBailOut(arguments[0]) === !0) {
                                original.elementScroll.call(this, arguments[0].left !== void 0 ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, arguments[0].top !== void 0 ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop);
                                return
                            }
                            this.scroll({
                                left: ~~arguments[0].left + this.scrollLeft,
                                top: ~~arguments[0].top + this.scrollTop,
                                behavior: arguments[0].behavior
                            })
                        }
                    }, Element2.prototype.scrollIntoView = function() {
                        if (shouldBailOut(arguments[0]) === !0) {
                            original.scrollIntoView.call(this, arguments[0] === void 0 ? !0 : arguments[0]);
                            return
                        }
                        var scrollableParent = findScrollableParent(this),
                            parentRects = scrollableParent.getBoundingClientRect(),
                            clientRects = this.getBoundingClientRect();
                        scrollableParent !== d.body ? (smoothScroll.call(this, scrollableParent, scrollableParent.scrollLeft + clientRects.left - parentRects.left, scrollableParent.scrollTop + clientRects.top - parentRects.top), w.getComputedStyle(scrollableParent).position !== "fixed" && w.scrollBy({
                            left: parentRects.left,
                            top: parentRects.top,
                            behavior: "smooth"
                        })) : w.scrollBy({
                            left: clientRects.left,
                            top: clientRects.top,
                            behavior: "smooth"
                        })
                    }
                }
                module.exports = {
                    polyfill: polyfill
                }
            })()
        }); /*! instant.page v5.1.0 - (C) 2019-2020 Alexandre Dieulot - https://instant.page/license */
    var mouseoverTimer, lastTouchTimestamp, prefetches = new Set,
        prefetchElement = document.createElement("link"),
        isSupported = prefetchElement.relList && prefetchElement.relList.supports && prefetchElement.relList.supports("prefetch") && window.IntersectionObserver && "isIntersecting" in IntersectionObserverEntry.prototype,
        allowQueryString = "instantAllowQueryString" in document.body.dataset,
        allowExternalLinks = "instantAllowExternalLinks" in document.body.dataset,
        useWhitelist = "instantWhitelist" in document.body.dataset,
        mousedownShortcut = "instantMousedownShortcut" in document.body.dataset,
        DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION = 1111,
        delayOnHover = 65,
        useMousedown = !1,
        useMousedownOnly = !1,
        useViewport = !1;
    if ("instantIntensity" in document.body.dataset) {
        var intensity = document.body.dataset.instantIntensity;
        if (intensity.substr(0, 9) == "mousedown") useMousedown = !0, intensity == "mousedown-only" && (useMousedownOnly = !0);
        else if (intensity.substr(0, 8) == "viewport") navigator.connection && (navigator.connection.saveData || navigator.connection.effectiveType && navigator.connection.effectiveType.includes("2g")) || (intensity == "viewport" ? document.documentElement.clientWidth * document.documentElement.clientHeight < 45e4 && (useViewport = !0) : intensity == "viewport-all" && (useViewport = !0));
        else {
            var milliseconds = parseInt(intensity);
            isNaN(milliseconds) || (delayOnHover = milliseconds)
        }
    }
    if (isSupported) {
        var eventListenersOptions = {
            capture: !0,
            passive: !0
        };
        if (useMousedownOnly || document.addEventListener("touchstart", touchstartListener, eventListenersOptions), useMousedown ? mousedownShortcut || document.addEventListener("mousedown", mousedownListener, eventListenersOptions) : document.addEventListener("mouseover", mouseoverListener, eventListenersOptions), mousedownShortcut && document.addEventListener("mousedown", mousedownShortcutListener, eventListenersOptions), useViewport) {
            var triggeringFunction;
            window.requestIdleCallback ? triggeringFunction = function(callback) {
                requestIdleCallback(callback, {
                    timeout: 1500
                })
            } : triggeringFunction = function(callback) {
                callback()
            }, triggeringFunction(function() {
                var intersectionObserver = new IntersectionObserver(function(entries) {
                    entries.forEach(function(entry) {
                        if (entry.isIntersecting) {
                            var linkElement = entry.target;
                            intersectionObserver.unobserve(linkElement), preload(linkElement.href)
                        }
                    })
                });
                document.querySelectorAll("a").forEach(function(linkElement) {
                    isPreloadable(linkElement) && intersectionObserver.observe(linkElement)
                })
            })
        }
    }

    function touchstartListener(event2) {
        lastTouchTimestamp = performance.now();
        var linkElement = event2.target.closest("a");
        isPreloadable(linkElement) && preload(linkElement.href)
    }

    function mouseoverListener(event2) {
        if (!(performance.now() - lastTouchTimestamp < DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION)) {
            var linkElement = event2.target.closest("a");
            isPreloadable(linkElement) && (linkElement.addEventListener("mouseout", mouseoutListener, {
                passive: !0
            }), mouseoverTimer = setTimeout(function() {
                preload(linkElement.href), mouseoverTimer = void 0
            }, delayOnHover))
        }
    }

    function mousedownListener(event2) {
        var linkElement = event2.target.closest("a");
        isPreloadable(linkElement) && preload(linkElement.href)
    }

    function mouseoutListener(event2) {
        event2.relatedTarget && event2.target.closest("a") == event2.relatedTarget.closest("a") || mouseoverTimer && (clearTimeout(mouseoverTimer), mouseoverTimer = void 0)
    }

    function mousedownShortcutListener(event2) {
        if (!(performance.now() - lastTouchTimestamp < DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION)) {
            var linkElement = event2.target.closest("a");
            if (!(event2.which > 1 || event2.metaKey || event2.ctrlKey) && linkElement) {
                linkElement.addEventListener("click", function(event3) {
                    event3.detail != 1337 && event3.preventDefault()
                }, {
                    capture: !0,
                    passive: !1,
                    once: !0
                });
                var customEvent = new MouseEvent("click", {
                    view: window,
                    bubbles: !0,
                    cancelable: !1,
                    detail: 1337
                });
                linkElement.dispatchEvent(customEvent)
            }
        }
    }

    function isPreloadable(linkElement) {
        if (!(!linkElement || !linkElement.href) && !(useWhitelist && !("instant" in linkElement.dataset)) && !(!allowExternalLinks && linkElement.origin != location.origin && !("instant" in linkElement.dataset)) && ["http:", "https:"].includes(linkElement.protocol) && !(linkElement.protocol == "http:" && location.protocol == "https:") && !(!allowQueryString && linkElement.search && !("instant" in linkElement.dataset)) && !(linkElement.hash && linkElement.pathname + linkElement.search == location.pathname + location.search) && !("noInstant" in linkElement.dataset)) return !0
    }

    function preload(url) {
        if (!prefetches.has(url)) {
            var prefetcher = document.createElement("link");
            prefetcher.rel = "prefetch", prefetcher.href = url, document.head.appendChild(prefetcher), prefetches.add(url)
        }
    }
    var lazysizes = createCommonjsModule(function(module) {
            (function(window2, factory) {
                var lazySizes = factory(window2, window2.document, Date);
                window2.lazySizes = lazySizes, module.exports && (module.exports = lazySizes)
            })(typeof window != "undefined" ? window : {}, function(window2, document2, Date2) {
                var lazysizes2, lazySizesCfg;
                if ((function() {
                        var prop, lazySizesDefaults = {
                            lazyClass: "lazyload",
                            loadedClass: "lazyloaded",
                            loadingClass: "lazyloading",
                            preloadClass: "lazypreload",
                            errorClass: "lazyerror",
                            autosizesClass: "lazyautosizes",
                            srcAttr: "data-src",
                            srcsetAttr: "data-srcset",
                            sizesAttr: "data-sizes",
                            minSize: 40,
                            customMedia: {},
                            init: !0,
                            expFactor: 1.5,
                            hFac: .8,
                            loadMode: 2,
                            loadHidden: !0,
                            ricTimeout: 0,
                            throttleDelay: 125
                        };
                        lazySizesCfg = window2.lazySizesConfig || window2.lazysizesConfig || {};
                        for (prop in lazySizesDefaults) prop in lazySizesCfg || (lazySizesCfg[prop] = lazySizesDefaults[prop])
                    })(), !document2 || !document2.getElementsByClassName) return {
                    init: function() {},
                    cfg: lazySizesCfg,
                    noSupport: !0
                };
                var docElem = document2.documentElement,
                    supportPicture = window2.HTMLPictureElement,
                    _addEventListener = "addEventListener",
                    _getAttribute = "getAttribute",
                    addEventListener2 = window2[_addEventListener].bind(window2),
                    setTimeout2 = window2.setTimeout,
                    requestAnimationFrame2 = window2.requestAnimationFrame || setTimeout2,
                    requestIdleCallback2 = window2.requestIdleCallback,
                    regPicture = /^picture$/i,
                    loadEvents = ["load", "error", "lazyincluded", "_lazyloaded"],
                    regClassCache = {},
                    forEach = Array.prototype.forEach,
                    hasClass = function(ele, cls) {
                        return regClassCache[cls] || (regClassCache[cls] = new RegExp("(\\s|^)" + cls + "(\\s|$)")), regClassCache[cls].test(ele[_getAttribute]("class") || "") && regClassCache[cls]
                    },
                    addClass = function(ele, cls) {
                        hasClass(ele, cls) || ele.setAttribute("class", (ele[_getAttribute]("class") || "").trim() + " " + cls)
                    },
                    removeClass = function(ele, cls) {
                        var reg;
                        (reg = hasClass(ele, cls)) && ele.setAttribute("class", (ele[_getAttribute]("class") || "").replace(reg, " "))
                    },
                    addRemoveLoadEvents = function addRemoveLoadEvents2(dom, fn, add) {
                        var action = add ? _addEventListener : "removeEventListener";
                        add && addRemoveLoadEvents2(dom, fn), loadEvents.forEach(function(evt) {
                            dom[action](evt, fn)
                        })
                    },
                    triggerEvent = function(elem, name, detail, noBubbles, noCancelable) {
                        var event2 = document2.createEvent("Event");
                        return detail || (detail = {}), detail.instance = lazysizes2, event2.initEvent(name, !noBubbles, !noCancelable), event2.detail = detail, elem.dispatchEvent(event2), event2
                    },
                    updatePolyfill = function(el, full) {
                        var polyfill;
                        !supportPicture && (polyfill = window2.picturefill || lazySizesCfg.pf) ? (full && full.src && !el[_getAttribute]("srcset") && el.setAttribute("srcset", full.src), polyfill({
                            reevaluate: !0,
                            elements: [el]
                        })) : full && full.src && (el.src = full.src)
                    },
                    getCSS = function(elem, style) {
                        return (getComputedStyle(elem, null) || {})[style]
                    },
                    getWidth = function(elem, parent, width) {
                        for (width = width || elem.offsetWidth; width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth;) width = parent.offsetWidth, parent = parent.parentNode;
                        return width
                    },
                    rAF = (function() {
                        var running, waiting, firstFns = [],
                            secondFns = [],
                            fns = firstFns,
                            run = function() {
                                var runFns = fns;
                                for (fns = firstFns.length ? secondFns : firstFns, running = !0, waiting = !1; runFns.length;) runFns.shift()();
                                running = !1
                            },
                            rafBatch = function(fn, queue) {
                                running && !queue ? fn.apply(this, arguments) : (fns.push(fn), waiting || (waiting = !0, (document2.hidden ? setTimeout2 : requestAnimationFrame2)(run)))
                            };
                        return rafBatch._lsFlush = run, rafBatch
                    })(),
                    rAFIt = function(fn, simple) {
                        return simple ? function() {
                            rAF(fn)
                        } : function() {
                            var that = this,
                                args = arguments;
                            rAF(function() {
                                fn.apply(that, args)
                            })
                        }
                    },
                    throttle = function(fn) {
                        var running, lastTime = 0,
                            gDelay = lazySizesCfg.throttleDelay,
                            rICTimeout = lazySizesCfg.ricTimeout,
                            run = function() {
                                running = !1, lastTime = Date2.now(), fn()
                            },
                            idleCallback = requestIdleCallback2 && rICTimeout > 49 ? function() {
                                requestIdleCallback2(run, {
                                    timeout: rICTimeout
                                }), rICTimeout !== lazySizesCfg.ricTimeout && (rICTimeout = lazySizesCfg.ricTimeout)
                            } : rAFIt(function() {
                                setTimeout2(run)
                            }, !0);
                        return function(isPriority) {
                            var delay;
                            (isPriority = isPriority === !0) && (rICTimeout = 33), !running && (running = !0, delay = gDelay - (Date2.now() - lastTime), delay < 0 && (delay = 0), isPriority || delay < 9 ? idleCallback() : setTimeout2(idleCallback, delay))
                        }
                    },
                    debounce = function(func) {
                        var timeout, timestamp, wait = 99,
                            run = function() {
                                timeout = null, func()
                            },
                            later = function later2() {
                                var last = Date2.now() - timestamp;
                                last < wait ? setTimeout2(later2, wait - last) : (requestIdleCallback2 || run)(run)
                            };
                        return function() {
                            timestamp = Date2.now(), timeout || (timeout = setTimeout2(later, wait))
                        }
                    },
                    loader = (function() {
                        var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started, eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden, regImg = /^img$/i,
                            regIframe = /^iframe$/i,
                            supportScroll = "onscroll" in window2 && !/(gle|ing)bot/.test(navigator.userAgent),
                            shrinkExpand = 0,
                            currentExpand = 0,
                            isLoading = 0,
                            lowRuns = -1,
                            resetPreloading = function(e) {
                                isLoading--, (!e || isLoading < 0 || !e.target) && (isLoading = 0)
                            },
                            isVisible = function(elem) {
                                return isBodyHidden == null && (isBodyHidden = getCSS(document2.body, "visibility") == "hidden"), isBodyHidden || !(getCSS(elem.parentNode, "visibility") == "hidden" && getCSS(elem, "visibility") == "hidden")
                            },
                            isNestedVisible = function(elem, elemExpand) {
                                var outerRect, parent = elem,
                                    visible = isVisible(elem);
                                for (eLtop -= elemExpand, eLbottom += elemExpand, eLleft -= elemExpand, eLright += elemExpand; visible && (parent = parent.offsetParent) && parent != document2.body && parent != docElem;) visible = (getCSS(parent, "opacity") || 1) > 0, visible && getCSS(parent, "overflow") != "visible" && (outerRect = parent.getBoundingClientRect(), visible = eLright > outerRect.left && eLleft < outerRect.right && eLbottom > outerRect.top - 1 && eLtop < outerRect.bottom + 1);
                                return visible
                            },
                            checkElements = function() {
                                var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal, defaultExpand, preloadExpand, hFac, lazyloadElems = lazysizes2.elements;
                                if ((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)) {
                                    for (i = 0, lowRuns++; i < eLlen; i++)
                                        if (!(!lazyloadElems[i] || lazyloadElems[i]._lazyRace)) {
                                            if (!supportScroll || lazysizes2.prematureUnveil && lazysizes2.prematureUnveil(lazyloadElems[i])) {
                                                unveilElement(lazyloadElems[i]);
                                                continue
                                            }
                                            if ((!(elemExpandVal = lazyloadElems[i][_getAttribute]("data-expand")) || !(elemExpand = elemExpandVal * 1)) && (elemExpand = currentExpand), defaultExpand || (defaultExpand = !lazySizesCfg.expand || lazySizesCfg.expand < 1 ? docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 : lazySizesCfg.expand, lazysizes2._defEx = defaultExpand, preloadExpand = defaultExpand * lazySizesCfg.expFactor, hFac = lazySizesCfg.hFac, isBodyHidden = null, currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document2.hidden ? (currentExpand = preloadExpand, lowRuns = 0) : loadMode > 1 && lowRuns > 1 && isLoading < 6 ? currentExpand = defaultExpand : currentExpand = shrinkExpand), beforeExpandVal !== elemExpand && (eLvW = innerWidth + elemExpand * hFac, elvH = innerHeight + elemExpand, elemNegativeExpand = elemExpand * -1, beforeExpandVal = elemExpand), rect = lazyloadElems[i].getBoundingClientRect(), (eLbottom = rect.bottom) >= elemNegativeExpand && (eLtop = rect.top) <= elvH && (eLright = rect.right) >= elemNegativeExpand * hFac && (eLleft = rect.left) <= eLvW && (eLbottom || eLright || eLleft || eLtop) && (lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) && (isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4) || isNestedVisible(lazyloadElems[i], elemExpand))) {
                                                if (unveilElement(lazyloadElems[i]), loadedSomething = !0, isLoading > 9) break
                                            } else !loadedSomething && isCompleted && !autoLoadElem && isLoading < 4 && lowRuns < 4 && loadMode > 2 && (preloadElems[0] || lazySizesCfg.preloadAfterLoad) && (preloadElems[0] || !elemExpandVal && (eLbottom || eLright || eLleft || eLtop || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != "auto")) && (autoLoadElem = preloadElems[0] || lazyloadElems[i])
                                        } autoLoadElem && !loadedSomething && unveilElement(autoLoadElem)
                                }
                            },
                            throttledCheckElements = throttle(checkElements),
                            switchLoadingClass = function(e) {
                                var elem = e.target;
                                if (elem._lazyCache) {
                                    delete elem._lazyCache;
                                    return
                                }
                                resetPreloading(e), addClass(elem, lazySizesCfg.loadedClass), removeClass(elem, lazySizesCfg.loadingClass), addRemoveLoadEvents(elem, rafSwitchLoadingClass), triggerEvent(elem, "lazyloaded")
                            },
                            rafedSwitchLoadingClass = rAFIt(switchLoadingClass),
                            rafSwitchLoadingClass = function(e) {
                                rafedSwitchLoadingClass({
                                    target: e.target
                                })
                            },
                            changeIframeSrc = function(elem, src) {
                                try {
                                    elem.contentWindow.location.replace(src)
                                } catch (e) {
                                    elem.src = src
                                }
                            },
                            handleSources = function(source) {
                                var customMedia, sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);
                                (customMedia = lazySizesCfg.customMedia[source[_getAttribute]("data-media") || source[_getAttribute]("media")]) && source.setAttribute("media", customMedia), sourceSrcset && source.setAttribute("srcset", sourceSrcset)
                            },
                            lazyUnveil = rAFIt(function(elem, detail, isAuto, sizes, isImg) {
                                var src, srcset, parent, isPicture, event2, firesLoad;
                                (event2 = triggerEvent(elem, "lazybeforeunveil", detail)).defaultPrevented || (sizes && (isAuto ? addClass(elem, lazySizesCfg.autosizesClass) : elem.setAttribute("sizes", sizes)), srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr), src = elem[_getAttribute](lazySizesCfg.srcAttr), isImg && (parent = elem.parentNode, isPicture = parent && regPicture.test(parent.nodeName || "")), firesLoad = detail.firesLoad || "src" in elem && (srcset || src || isPicture), event2 = {
                                    target: elem
                                }, addClass(elem, lazySizesCfg.loadingClass), firesLoad && (clearTimeout(resetPreloadingTimer), resetPreloadingTimer = setTimeout2(resetPreloading, 2500), addRemoveLoadEvents(elem, rafSwitchLoadingClass, !0)), isPicture && forEach.call(parent.getElementsByTagName("source"), handleSources), srcset ? elem.setAttribute("srcset", srcset) : src && !isPicture && (regIframe.test(elem.nodeName) ? changeIframeSrc(elem, src) : elem.src = src), isImg && (srcset || isPicture) && updatePolyfill(elem, {
                                    src: src
                                })), elem._lazyRace && delete elem._lazyRace, removeClass(elem, lazySizesCfg.lazyClass), rAF(function() {
                                    var isLoaded = elem.complete && elem.naturalWidth > 1;
                                    (!firesLoad || isLoaded) && (isLoaded && addClass(elem, "ls-is-cached"), switchLoadingClass(event2), elem._lazyCache = !0, setTimeout2(function() {
                                        "_lazyCache" in elem && delete elem._lazyCache
                                    }, 9)), elem.loading == "lazy" && isLoading--
                                }, !0)
                            }),
                            unveilElement = function(elem) {
                                if (!elem._lazyRace) {
                                    var detail, isImg = regImg.test(elem.nodeName),
                                        sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]("sizes")),
                                        isAuto = sizes == "auto";
                                    (isAuto || !isCompleted) && isImg && (elem[_getAttribute]("src") || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass) || (detail = triggerEvent(elem, "lazyunveilread").detail, isAuto && autoSizer.updateElem(elem, !0, elem.offsetWidth), elem._lazyRace = !0, isLoading++, lazyUnveil(elem, detail, isAuto, sizes, isImg))
                                }
                            },
                            afterScroll = debounce(function() {
                                lazySizesCfg.loadMode = 3, throttledCheckElements()
                            }),
                            altLoadmodeScrollListner = function() {
                                lazySizesCfg.loadMode == 3 && (lazySizesCfg.loadMode = 2), afterScroll()
                            },
                            onload = function onload2() {
                                if (!isCompleted) {
                                    if (Date2.now() - started < 999) {
                                        setTimeout2(onload2, 999);
                                        return
                                    }
                                    isCompleted = !0, lazySizesCfg.loadMode = 3, throttledCheckElements(), addEventListener2("scroll", altLoadmodeScrollListner, !0)
                                }
                            };
                        return {
                            _: function() {
                                started = Date2.now(), lazysizes2.elements = document2.getElementsByClassName(lazySizesCfg.lazyClass), preloadElems = document2.getElementsByClassName(lazySizesCfg.lazyClass + " " + lazySizesCfg.preloadClass), addEventListener2("scroll", throttledCheckElements, !0), addEventListener2("resize", throttledCheckElements, !0), addEventListener2("pageshow", function(e) {
                                    if (e.persisted) {
                                        var loadingElements = document2.querySelectorAll("." + lazySizesCfg.loadingClass);
                                        loadingElements.length && loadingElements.forEach && requestAnimationFrame2(function() {
                                            loadingElements.forEach(function(img) {
                                                img.complete && unveilElement(img)
                                            })
                                        })
                                    }
                                }), window2.MutationObserver ? new MutationObserver(throttledCheckElements).observe(docElem, {
                                    childList: !0,
                                    subtree: !0,
                                    attributes: !0
                                }) : (docElem[_addEventListener]("DOMNodeInserted", throttledCheckElements, !0), docElem[_addEventListener]("DOMAttrModified", throttledCheckElements, !0), setInterval(throttledCheckElements, 999)), addEventListener2("hashchange", throttledCheckElements, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend"].forEach(function(name) {
                                    document2[_addEventListener](name, throttledCheckElements, !0)
                                }), /d$|^c/.test(document2.readyState) ? onload() : (addEventListener2("load", onload), document2[_addEventListener]("DOMContentLoaded", throttledCheckElements), setTimeout2(onload, 2e4)), lazysizes2.elements.length ? (checkElements(), rAF._lsFlush()) : throttledCheckElements()
                            },
                            checkElems: throttledCheckElements,
                            unveil: unveilElement,
                            _aLSL: altLoadmodeScrollListner
                        }
                    })(),
                    autoSizer = (function() {
                        var autosizesElems, sizeElement = rAFIt(function(elem, parent, event2, width) {
                                var sources, i, len;
                                if (elem._lazysizesWidth = width, width += "px", elem.setAttribute("sizes", width), regPicture.test(parent.nodeName || ""))
                                    for (sources = parent.getElementsByTagName("source"), i = 0, len = sources.length; i < len; i++) sources[i].setAttribute("sizes", width);
                                event2.detail.dataAttr || updatePolyfill(elem, event2.detail)
                            }),
                            getSizeElement = function(elem, dataAttr, width) {
                                var event2, parent = elem.parentNode;
                                parent && (width = getWidth(elem, parent, width), event2 = triggerEvent(elem, "lazybeforesizes", {
                                    width: width,
                                    dataAttr: !!dataAttr
                                }), event2.defaultPrevented || (width = event2.detail.width, width && width !== elem._lazysizesWidth && sizeElement(elem, parent, event2, width)))
                            },
                            updateElementsSizes = function() {
                                var i, len = autosizesElems.length;
                                if (len)
                                    for (i = 0; i < len; i++) getSizeElement(autosizesElems[i])
                            },
                            debouncedUpdateElementsSizes = debounce(updateElementsSizes);
                        return {
                            _: function() {
                                autosizesElems = document2.getElementsByClassName(lazySizesCfg.autosizesClass), addEventListener2("resize", debouncedUpdateElementsSizes)
                            },
                            checkElems: debouncedUpdateElementsSizes,
                            updateElem: getSizeElement
                        }
                    })(),
                    init = function init2() {
                        !init2.i && document2.getElementsByClassName && (init2.i = !0, autoSizer._(), loader._())
                    };
                return setTimeout2(function() {
                    lazySizesCfg.init && init()
                }), lazysizes2 = {
                    cfg: lazySizesCfg,
                    autoSizer: autoSizer,
                    loader: loader,
                    init: init,
                    uP: updatePolyfill,
                    aC: addClass,
                    rC: removeClass,
                    hC: hasClass,
                    fire: triggerEvent,
                    gW: getWidth,
                    rAF: rAF
                }, lazysizes2
            })
        }),
        ls_rias = createCommonjsModule(function(module) {
            (function(window2, factory) {
                var globalInstall = function globalInstall2() {
                    factory(window2.lazySizes), window2.removeEventListener("lazyunveilread", globalInstall2, !0)
                };
                factory = factory.bind(null, window2, window2.document), module.exports ? factory(lazysizes) : window2.lazySizes ? globalInstall() : window2.addEventListener("lazyunveilread", globalInstall, !0)
            })(window, function(window2, document2, lazySizes) {
                var config, riasCfg, lazySizesCfg = lazySizes.cfg,
                    replaceTypes = {
                        string: 1,
                        number: 1
                    },
                    regNumber = /^\-*\+*\d+\.*\d*$/,
                    regPicture = /^picture$/i,
                    regWidth = /\s*\{\s*width\s*\}\s*/i,
                    regHeight = /\s*\{\s*height\s*\}\s*/i,
                    regPlaceholder = /\s*\{\s*([a-z0-9]+)\s*\}\s*/ig,
                    regObj = /^\[.*\]|\{.*\}$/,
                    regAllowedSizes = /^(?:auto|\d+(px)?)$/,
                    anchor = document2.createElement("a"),
                    img = document2.createElement("img"),
                    buggySizes = "srcset" in img && !("sizes" in img),
                    supportPicture = !!window2.HTMLPictureElement && !buggySizes;
                (function() {
                    var prop, noop = function() {},
                        riasDefaults = {
                            prefix: "",
                            postfix: "",
                            srcAttr: "data-src",
                            absUrl: !1,
                            modifyOptions: noop,
                            widthmap: {},
                            ratio: !1,
                            traditionalRatio: !1,
                            aspectratio: !1
                        };
                    config = lazySizes && lazySizes.cfg, config.supportsType || (config.supportsType = function(type) {
                        return !type
                    }), config.rias || (config.rias = {}), riasCfg = config.rias, "widths" in riasCfg || (riasCfg.widths = [], (function(widths) {
                        for (var width, i = 0; !width || width < 3e3;) i += 5, i > 30 && (i += 1), width = 36 * i, widths.push(width)
                    })(riasCfg.widths));
                    for (prop in riasDefaults) prop in riasCfg || (riasCfg[prop] = riasDefaults[prop])
                })();

                function getElementOptions(elem, src) {
                    var attr, parent, setOption, options, elemStyles = window2.getComputedStyle(elem);
                    parent = elem.parentNode, options = {
                        isPicture: !!(parent && regPicture.test(parent.nodeName || ""))
                    }, setOption = function(attr2, run) {
                        var attrVal = elem.getAttribute("data-" + attr2);
                        if (!attrVal) {
                            var styles = elemStyles.getPropertyValue("--ls-" + attr2);
                            styles && (attrVal = styles.trim())
                        }
                        if (attrVal) {
                            if (attrVal == "true") attrVal = !0;
                            else if (attrVal == "false") attrVal = !1;
                            else if (regNumber.test(attrVal)) attrVal = parseFloat(attrVal);
                            else if (typeof riasCfg[attr2] == "function") attrVal = riasCfg[attr2](elem, attrVal);
                            else if (regObj.test(attrVal)) try {
                                attrVal = JSON.parse(attrVal)
                            } catch (e) {}
                            options[attr2] = attrVal
                        } else attr2 in riasCfg && typeof riasCfg[attr2] != "function" ? options[attr2] = riasCfg[attr2] : run && typeof riasCfg[attr2] == "function" && (options[attr2] = riasCfg[attr2](elem, attrVal))
                    };
                    for (attr in riasCfg) setOption(attr);
                    return src.replace(regPlaceholder, function(full, match) {
                        match in options || setOption(match, !0)
                    }), options
                }

                function replaceUrlProps(url, options) {
                    var candidates = [],
                        replaceFn = function(full, match) {
                            return replaceTypes[_typeof(options[match])] ? options[match] : full
                        };
                    return candidates.srcset = [], options.absUrl && (anchor.setAttribute("href", url), url = anchor.href), url = ((options.prefix || "") + url + (options.postfix || "")).replace(regPlaceholder, replaceFn), options.widths.forEach(function(width) {
                        var widthAlias = options.widthmap[width] || width,
                            ratio = options.aspectratio || options.ratio,
                            traditionalRatio = !options.aspectratio && riasCfg.traditionalRatio,
                            candidate = {
                                u: url.replace(regWidth, widthAlias).replace(regHeight, ratio ? Math.round(traditionalRatio ? width * ratio : width / ratio) : ""),
                                w: width
                            };
                        candidates.push(candidate), candidates.srcset.push(candidate.c = candidate.u + " " + width + "w")
                    }), candidates
                }

                function setSrc(src, opts, elem) {
                    var elemW = 0,
                        elemH = 0,
                        sizeElement = elem;
                    if (src) {
                        if (opts.ratio === "container") {
                            for (elemW = sizeElement.scrollWidth, elemH = sizeElement.scrollHeight;
                                (!elemW || !elemH) && sizeElement !== document2;) sizeElement = sizeElement.parentNode, elemW = sizeElement.scrollWidth, elemH = sizeElement.scrollHeight;
                            elemW && elemH && (opts.ratio = opts.traditionalRatio ? elemH / elemW : elemW / elemH)
                        }
                        src = replaceUrlProps(src, opts), src.isPicture = opts.isPicture, buggySizes && elem.nodeName.toUpperCase() == "IMG" ? elem.removeAttribute(config.srcsetAttr) : elem.setAttribute(config.srcsetAttr, src.srcset.join(", ")), Object.defineProperty(elem, "_lazyrias", {
                            value: src,
                            writable: !0
                        })
                    }
                }

                function createAttrObject(elem, src) {
                    var opts = getElementOptions(elem, src);
                    return riasCfg.modifyOptions.call(elem, {
                        target: elem,
                        details: opts,
                        detail: opts
                    }), lazySizes.fire(elem, "lazyriasmodifyoptions", opts), opts
                }

                function getSrc(elem) {
                    return elem.getAttribute(elem.getAttribute("data-srcattr") || riasCfg.srcAttr) || elem.getAttribute(config.srcsetAttr) || elem.getAttribute(config.srcAttr) || elem.getAttribute("data-pfsrcset") || ""
                }
                addEventListener("lazybeforesizes", function(e) {
                    if (e.detail.instance == lazySizes) {
                        var elem, src, elemOpts, parent, sources, i, len, sourceSrc, sizes, detail, hasPlaceholder, modified, emptyList;
                        if (elem = e.target, !(!e.detail.dataAttr || e.defaultPrevented || riasCfg.disabled || !((sizes = elem.getAttribute(config.sizesAttr) || elem.getAttribute("sizes")) && regAllowedSizes.test(sizes)))) {
                            if (src = getSrc(elem), elemOpts = createAttrObject(elem, src), hasPlaceholder = regWidth.test(elemOpts.prefix) || regWidth.test(elemOpts.postfix), elemOpts.isPicture && (parent = elem.parentNode))
                                for (sources = parent.getElementsByTagName("source"), i = 0, len = sources.length; i < len; i++)(hasPlaceholder || regWidth.test(sourceSrc = getSrc(sources[i]))) && (setSrc(sourceSrc, elemOpts, sources[i]), modified = !0);
                            hasPlaceholder || regWidth.test(src) ? (setSrc(src, elemOpts, elem), modified = !0) : modified && (emptyList = [], emptyList.srcset = [], emptyList.isPicture = !0, Object.defineProperty(elem, "_lazyrias", {
                                value: emptyList,
                                writable: !0
                            })), modified && (supportPicture ? elem.removeAttribute(config.srcAttr) : sizes != "auto" && (detail = {
                                width: parseInt(sizes, 10)
                            }, polyfill({
                                target: elem,
                                detail: detail
                            })))
                        }
                    }
                }, !0);
                var polyfill = (function() {
                    var ascendingSort = function(a, b) {
                            return a.w - b.w
                        },
                        reduceCandidate = function(srces) {
                            var lowerCandidate, bonusFactor, len = srces.length,
                                candidate = srces[len - 1],
                                i = 0;
                            for (i; i < len; i++)
                                if (candidate = srces[i], candidate.d = candidate.w / srces.w, candidate.d >= srces.d) {
                                    !candidate.cached && (lowerCandidate = srces[i - 1]) && lowerCandidate.d > srces.d - .13 * Math.pow(srces.d, 2.2) && (bonusFactor = Math.pow(lowerCandidate.d - .6, 1.6), lowerCandidate.cached && (lowerCandidate.d += .15 * bonusFactor), lowerCandidate.d + (candidate.d - srces.d) * bonusFactor > srces.d && (candidate = lowerCandidate));
                                    break
                                } return candidate
                        },
                        getWSet = function(elem, testPicture) {
                            var src;
                            return !elem._lazyrias && lazySizes.pWS && (src = lazySizes.pWS(elem.getAttribute(config.srcsetAttr || ""))).length && (Object.defineProperty(elem, "_lazyrias", {
                                value: src,
                                writable: !0
                            }), testPicture && elem.parentNode && (src.isPicture = elem.parentNode.nodeName.toUpperCase() == "PICTURE")), elem._lazyrias
                        },
                        getX = function(elem) {
                            var dpr = window2.devicePixelRatio || 1,
                                optimum = lazySizes.getX && lazySizes.getX(elem);
                            return Math.min(optimum || dpr, 2.4, dpr)
                        },
                        getCandidate = function(elem, width) {
                            var sources, i, len, media, srces, src;
                            if (srces = elem._lazyrias, srces.isPicture && window2.matchMedia) {
                                for (i = 0, sources = elem.parentNode.getElementsByTagName("source"), len = sources.length; i < len; i++)
                                    if (getWSet(sources[i]) && !sources[i].getAttribute("type") && (!(media = sources[i].getAttribute("media")) || (matchMedia(media) || {}).matches)) {
                                        srces = sources[i]._lazyrias;
                                        break
                                    }
                            }
                            return (!srces.w || srces.w < width) && (srces.w = width, srces.d = getX(elem), src = reduceCandidate(srces.sort(ascendingSort))), src
                        },
                        _polyfill = function(e) {
                            if (e.detail.instance == lazySizes) {
                                var candidate, elem = e.target;
                                if (!buggySizes && (window2.respimage || window2.picturefill || lazySizesCfg.pf)) {
                                    document2.removeEventListener("lazybeforesizes", _polyfill);
                                    return
                                }!("_lazyrias" in elem) && (!e.detail.dataAttr || !getWSet(elem, !0)) || (candidate = getCandidate(elem, e.detail.width), candidate && candidate.u && elem._lazyrias.cur != candidate.u && (elem._lazyrias.cur = candidate.u, candidate.cached = !0, lazySizes.rAF(function() {
                                    elem.setAttribute(config.srcAttr, candidate.u), elem.setAttribute("src", candidate.u)
                                })))
                            }
                        };
                    return supportPicture ? _polyfill = function() {} : addEventListener("lazybeforesizes", _polyfill), _polyfill
                })()
            })
        }),
        ls_unveilhooks = createCommonjsModule(function(module) {
            (function(window2, factory) {
                var globalInstall = function globalInstall2() {
                    factory(window2.lazySizes), window2.removeEventListener("lazyunveilread", globalInstall2, !0)
                };
                factory = factory.bind(null, window2, window2.document), module.exports ? factory(lazysizes) : window2.lazySizes ? globalInstall() : window2.addEventListener("lazyunveilread", globalInstall, !0)
            })(window, function(window2, document2, lazySizes) {
                var bgLoad, regBgUrlEscape, uniqueUrls = {};
                document2.addEventListener && (regBgUrlEscape = /\(|\)|\s|'/, bgLoad = function(url, cb) {
                    var img = document2.createElement("img");
                    img.onload = function() {
                        img.onload = null, img.onerror = null, img = null, cb()
                    }, img.onerror = img.onload, img.src = url, img && img.complete && img.onload && img.onload()
                }, addEventListener("lazybeforeunveil", function(e) {
                    if (e.detail.instance == lazySizes) {
                        var tmp, load, bg, poster;
                        if (!e.defaultPrevented) {
                            var target = e.target;
                            if (target.preload == "none" && (target.preload = target.getAttribute("data-preload") || "auto"), target.getAttribute("data-autoplay") != null)
                                if (target.getAttribute("data-expand") && !target.autoplay) try {
                                    target.play()
                                } catch (er) {} else requestAnimationFrame(function() {
                                    target.setAttribute("data-expand", "-10"), lazySizes.aC(target, lazySizes.cfg.lazyClass)
                                });
                            tmp = target.getAttribute("data-link"), tmp && addStyleScript(tmp, !0), tmp = target.getAttribute("data-script"), tmp && addStyleScript(tmp), tmp = target.getAttribute("data-require"), tmp && (lazySizes.cfg.requireJs ? lazySizes.cfg.requireJs([tmp]) : addStyleScript(tmp)), bg = target.getAttribute("data-bg"), bg && (e.detail.firesLoad = !0, load = function() {
                                target.style.backgroundImage = "url(" + (regBgUrlEscape.test(bg) ? JSON.stringify(bg) : bg) + ")", e.detail.firesLoad = !1, lazySizes.fire(target, "_lazyloaded", {}, !0, !0)
                            }, bgLoad(bg, load)), poster = target.getAttribute("data-poster"), poster && (e.detail.firesLoad = !0, load = function() {
                                target.poster = poster, e.detail.firesLoad = !1, lazySizes.fire(target, "_lazyloaded", {}, !0, !0)
                            }, bgLoad(poster, load))
                        }
                    }
                }, !1));

                function addStyleScript(src, style) {
                    if (!uniqueUrls[src]) {
                        var elem = document2.createElement(style ? "link" : "script"),
                            insertElem = document2.getElementsByTagName("script")[0];
                        style ? (elem.rel = "stylesheet", elem.href = src) : elem.src = src, uniqueUrls[src] = !0, uniqueUrls[elem.src || elem.href] = !0, insertElem.parentNode.insertBefore(elem, insertElem)
                    }
                }
            })
        }),
        ls_bgset = createCommonjsModule(function(module) {
            (function(window2, factory) {
                var globalInstall = function globalInstall2() {
                    factory(window2.lazySizes), window2.removeEventListener("lazyunveilread", globalInstall2, !0)
                };
                factory = factory.bind(null, window2, window2.document), module.exports ? factory(lazysizes) : window2.lazySizes ? globalInstall() : window2.addEventListener("lazyunveilread", globalInstall, !0)
            })(window, function(window2, document2, lazySizes) {
                if (window2.addEventListener) {
                    var lazySizesCfg = lazySizes.cfg,
                        regWhite = /\s+/g,
                        regSplitSet = /\s*\|\s+|\s+\|\s*/g,
                        regSource = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/,
                        regType = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/,
                        regBgUrlEscape = /\(|\)|'/,
                        allowedBackgroundSize = {
                            contain: 1,
                            cover: 1
                        },
                        proxyWidth = function(elem) {
                            var width = lazySizes.gW(elem, elem.parentNode);
                            return (!elem._lazysizesWidth || width > elem._lazysizesWidth) && (elem._lazysizesWidth = width), elem._lazysizesWidth
                        },
                        getBgSize = function(elem) {
                            var bgSize;
                            return bgSize = (getComputedStyle(elem) || {
                                getPropertyValue: function() {}
                            }).getPropertyValue("background-size"), !allowedBackgroundSize[bgSize] && allowedBackgroundSize[elem.style.backgroundSize] && (bgSize = elem.style.backgroundSize), bgSize
                        },
                        setTypeOrMedia = function(source, match) {
                            if (match) {
                                var typeMatch = match.match(regType);
                                typeMatch && typeMatch[1] ? source.setAttribute("type", typeMatch[1]) : source.setAttribute("media", lazySizesCfg.customMedia[match] || match)
                            }
                        },
                        createPicture = function(sets, elem, img) {
                            var picture = document2.createElement("picture"),
                                sizes = elem.getAttribute(lazySizesCfg.sizesAttr),
                                ratio = elem.getAttribute("data-ratio"),
                                optimumx = elem.getAttribute("data-optimumx");
                            elem._lazybgset && elem._lazybgset.parentNode == elem && elem.removeChild(elem._lazybgset), Object.defineProperty(img, "_lazybgset", {
                                value: elem,
                                writable: !0
                            }), Object.defineProperty(elem, "_lazybgset", {
                                value: picture,
                                writable: !0
                            }), sets = sets.replace(regWhite, " ").split(regSplitSet), picture.style.display = "none", img.className = lazySizesCfg.lazyClass, sets.length == 1 && !sizes && (sizes = "auto"), sets.forEach(function(set) {
                                var match, source = document2.createElement("source");
                                sizes && sizes != "auto" && source.setAttribute("sizes", sizes), (match = set.match(regSource)) ? (source.setAttribute(lazySizesCfg.srcsetAttr, match[1]), setTypeOrMedia(source, match[2]), setTypeOrMedia(source, match[3])) : source.setAttribute(lazySizesCfg.srcsetAttr, set), picture.appendChild(source)
                            }), sizes && (img.setAttribute(lazySizesCfg.sizesAttr, sizes), elem.removeAttribute(lazySizesCfg.sizesAttr), elem.removeAttribute("sizes")), optimumx && img.setAttribute("data-optimumx", optimumx), ratio && img.setAttribute("data-ratio", ratio), picture.appendChild(img), elem.appendChild(picture)
                        },
                        proxyLoad = function(e) {
                            if (e.target._lazybgset) {
                                var image = e.target,
                                    elem = image._lazybgset,
                                    bg = image.currentSrc || image.src;
                                if (bg) {
                                    var event2 = lazySizes.fire(elem, "bgsetproxy", {
                                        src: bg,
                                        useSrc: regBgUrlEscape.test(bg) ? JSON.stringify(bg) : bg
                                    });
                                    event2.defaultPrevented || (elem.style.backgroundImage = "url(" + event2.detail.useSrc + ")")
                                }
                                image._lazybgsetLoading && (lazySizes.fire(elem, "_lazyloaded", {}, !1, !0), delete image._lazybgsetLoading)
                            }
                        };
                    addEventListener("lazybeforeunveil", function(e) {
                        var set, image, elem;
                        e.defaultPrevented || !(set = e.target.getAttribute("data-bgset")) || (elem = e.target, image = document2.createElement("img"), image.alt = "", image._lazybgsetLoading = !0, e.detail.firesLoad = !0, createPicture(set, elem, image), setTimeout(function() {
                            lazySizes.loader.unveil(image), lazySizes.rAF(function() {
                                lazySizes.fire(image, "_lazyloaded", {}, !0, !0), image.complete && proxyLoad({
                                    target: image
                                })
                            })
                        }))
                    }), document2.addEventListener("load", proxyLoad, !0), window2.addEventListener("lazybeforesizes", function(e) {
                        if (e.detail.instance == lazySizes && e.target._lazybgset && e.detail.dataAttr) {
                            var elem = e.target._lazybgset,
                                bgSize = getBgSize(elem);
                            allowedBackgroundSize[bgSize] && (e.target._lazysizesParentFit = bgSize, lazySizes.rAF(function() {
                                e.target.setAttribute("data-parent-fit", bgSize), e.target._lazysizesParentFit && delete e.target._lazysizesParentFit
                            }))
                        }
                    }, !0), document2.documentElement.addEventListener("lazybeforesizes", function(e) {
                        e.defaultPrevented || !e.target._lazybgset || e.detail.instance != lazySizes || (e.detail.width = proxyWidth(e.target._lazybgset))
                    })
                }
            })
        }),
        ls_respimg = createCommonjsModule(function(module) {
            (function(window2, factory) {
                if (window2) {
                    var globalInstall = function globalInstall2() {
                        factory(window2.lazySizes), window2.removeEventListener("lazyunveilread", globalInstall2, !0)
                    };
                    factory = factory.bind(null, window2, window2.document), module.exports ? factory(lazysizes) : window2.lazySizes ? globalInstall() : window2.addEventListener("lazyunveilread", globalInstall, !0)
                }
            })(typeof window != "undefined" ? window : 0, function(window2, document2, lazySizes) {
                var polyfill, lazySizesCfg = lazySizes.cfg,
                    img = document2.createElement("img"),
                    supportSrcset = "sizes" in img && "srcset" in img,
                    regHDesc = /\s+\d+h/g,
                    fixEdgeHDescriptor = (function() {
                        var regDescriptors = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
                            forEach = Array.prototype.forEach;
                        return function() {
                            var img2 = document2.createElement("img"),
                                removeHDescriptors = function(source) {
                                    var ratio, match, srcset = source.getAttribute(lazySizesCfg.srcsetAttr);
                                    srcset && (match = srcset.match(regDescriptors)) && (match[2] == "w" ? ratio = match[1] / match[3] : ratio = match[3] / match[1], ratio && source.setAttribute("data-aspectratio", ratio), source.setAttribute(lazySizesCfg.srcsetAttr, srcset.replace(regHDesc, "")))
                                },
                                handler = function(e) {
                                    if (e.detail.instance == lazySizes) {
                                        var picture = e.target.parentNode;
                                        picture && picture.nodeName == "PICTURE" && forEach.call(picture.getElementsByTagName("source"), removeHDescriptors), removeHDescriptors(e.target)
                                    }
                                },
                                test = function() {
                                    img2.currentSrc && document2.removeEventListener("lazybeforeunveil", handler)
                                };
                            document2.addEventListener("lazybeforeunveil", handler), img2.onload = test, img2.onerror = test, img2.srcset = "data:,a 1w 1h", img2.complete && test()
                        }
                    })();
                if (lazySizesCfg.supportsType || (lazySizesCfg.supportsType = function(type) {
                        return !type
                    }), window2.HTMLPictureElement && supportSrcset) {
                    !lazySizes.hasHDescriptorFix && document2.msElementsFromPoint && (lazySizes.hasHDescriptorFix = !0, fixEdgeHDescriptor());
                    return
                }
                window2.picturefill || lazySizesCfg.pf || (lazySizesCfg.pf = function(options) {
                    var i, len;
                    if (!window2.picturefill)
                        for (i = 0, len = options.elements.length; i < len; i++) polyfill(options.elements[i])
                }, polyfill = (function() {
                    var ascendingSort = function(a, b) {
                            return a.w - b.w
                        },
                        regPxLength = /^\s*\d+\.*\d*px\s*$/,
                        reduceCandidate = function(srces) {
                            var lowerCandidate, bonusFactor, len = srces.length,
                                candidate = srces[len - 1],
                                i = 0;
                            for (i; i < len; i++)
                                if (candidate = srces[i], candidate.d = candidate.w / srces.w, candidate.d >= srces.d) {
                                    !candidate.cached && (lowerCandidate = srces[i - 1]) && lowerCandidate.d > srces.d - .13 * Math.pow(srces.d, 2.2) && (bonusFactor = Math.pow(lowerCandidate.d - .6, 1.6), lowerCandidate.cached && (lowerCandidate.d += .15 * bonusFactor), lowerCandidate.d + (candidate.d - srces.d) * bonusFactor > srces.d && (candidate = lowerCandidate));
                                    break
                                } return candidate
                        },
                        parseWsrcset = (function() {
                            var candidates, regWCandidates = /(([^,\s].[^\s]+)\s+(\d+)w)/g,
                                regMultiple = /\s/,
                                addCandidate = function(match, candidate, url, wDescriptor) {
                                    candidates.push({
                                        c: candidate,
                                        u: url,
                                        w: wDescriptor * 1
                                    })
                                };
                            return function(input) {
                                return candidates = [], input = input.trim(), input.replace(regHDesc, "").replace(regWCandidates, addCandidate), !candidates.length && input && !regMultiple.test(input) && candidates.push({
                                    c: input,
                                    u: input,
                                    w: 99
                                }), candidates
                            }
                        })(),
                        runMatchMedia = function runMatchMedia2() {
                            runMatchMedia2.init || (runMatchMedia2.init = !0, addEventListener("resize", (function() {
                                var timer, matchMediaElems = document2.getElementsByClassName("lazymatchmedia"),
                                    run = function() {
                                        var i, len;
                                        for (i = 0, len = matchMediaElems.length; i < len; i++) polyfill(matchMediaElems[i])
                                    };
                                return function() {
                                    clearTimeout(timer), timer = setTimeout(run, 66)
                                }
                            })()))
                        },
                        createSrcset = function(elem, isImage) {
                            var parsedSet, srcSet = elem.getAttribute("srcset") || elem.getAttribute(lazySizesCfg.srcsetAttr);
                            !srcSet && isImage && (srcSet = elem._lazypolyfill ? elem._lazypolyfill._set : elem.getAttribute(lazySizesCfg.srcAttr) || elem.getAttribute("src")), (!elem._lazypolyfill || elem._lazypolyfill._set != srcSet) && (parsedSet = parseWsrcset(srcSet || ""), isImage && elem.parentNode && (parsedSet.isPicture = elem.parentNode.nodeName.toUpperCase() == "PICTURE", parsedSet.isPicture && window2.matchMedia && (lazySizes.aC(elem, "lazymatchmedia"), runMatchMedia())), parsedSet._set = srcSet, Object.defineProperty(elem, "_lazypolyfill", {
                                value: parsedSet,
                                writable: !0
                            }))
                        },
                        getX = function(elem) {
                            var dpr = window2.devicePixelRatio || 1,
                                optimum = lazySizes.getX && lazySizes.getX(elem);
                            return Math.min(optimum || dpr, 2.5, dpr)
                        },
                        _matchesMedia = function(media) {
                            if (window2.matchMedia) _matchesMedia = function(media2) {
                                return !media2 || (matchMedia(media2) || {}).matches
                            };
                            else return !media;
                            return _matchesMedia(media)
                        },
                        getCandidate = function(elem) {
                            var sources, i, len, source, srces, src, width;
                            if (source = elem, createSrcset(source, !0), srces = source._lazypolyfill, srces.isPicture) {
                                for (i = 0, sources = elem.parentNode.getElementsByTagName("source"), len = sources.length; i < len; i++)
                                    if (lazySizesCfg.supportsType(sources[i].getAttribute("type"), elem) && _matchesMedia(sources[i].getAttribute("media"))) {
                                        source = sources[i], createSrcset(source), srces = source._lazypolyfill;
                                        break
                                    }
                            }
                            return srces.length > 1 ? (width = source.getAttribute("sizes") || "", width = regPxLength.test(width) && parseInt(width, 10) || lazySizes.gW(elem, elem.parentNode), srces.d = getX(elem), !srces.src || !srces.w || srces.w < width ? (srces.w = width, src = reduceCandidate(srces.sort(ascendingSort)), srces.src = src) : src = srces.src) : src = srces[0], src
                        },
                        p = function(elem) {
                            if (!(supportSrcset && elem.parentNode && elem.parentNode.nodeName.toUpperCase() != "PICTURE")) {
                                var candidate = getCandidate(elem);
                                candidate && candidate.u && elem._lazypolyfill.cur != candidate.u && (elem._lazypolyfill.cur = candidate.u, candidate.cached = !0, elem.setAttribute(lazySizesCfg.srcAttr, candidate.u), elem.setAttribute("src", candidate.u))
                            }
                        };
                    return p.parse = parseWsrcset, p
                })(), lazySizesCfg.loadedClass && lazySizesCfg.loadingClass && (function() {
                    var sels = [];
                    ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function(sel) {
                        sels.push(sel + lazySizesCfg.loadedClass), sels.push(sel + lazySizesCfg.loadingClass)
                    }), lazySizesCfg.pf({
                        elements: document2.querySelectorAll(sels.join(", "))
                    })
                })())
            })
        }),
        PriceRange = (function(_HTMLElement) {
            _inherits(PriceRange2, _HTMLElement);
            var _super = _createSuper(PriceRange2);

            function PriceRange2() {
                return _classCallCheck(this, PriceRange2), _super.apply(this, arguments)
            }
            return _createClass(PriceRange2, [{
                key: "connectedCallback",
                value: function() {
                    var _this = this;
                    this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child"), this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child"), this.textInputLowerBound = this.querySelector(".price-range__input:first-child input"), this.textInputHigherBound = this.querySelector(".price-range__input:last-child input"), this.textInputLowerBound.addEventListener("focus", function() {
                        return _this.textInputLowerBound.select()
                    }), this.textInputHigherBound.addEventListener("focus", function() {
                        return _this.textInputHigherBound.select()
                    }), this.textInputLowerBound.addEventListener("change", function(event2) {
                        event2.target.value = Math.max(Math.min(parseInt(event2.target.value), parseInt(_this.textInputHigherBound.value || event2.target.max) - 1), event2.target.min), _this.rangeLowerBound.value = event2.target.value, _this.rangeLowerBound.parentElement.style.setProperty("--range-min", "".concat(parseInt(_this.rangeLowerBound.value) / parseInt(_this.rangeLowerBound.max) * 100, "%"))
                    }), this.textInputHigherBound.addEventListener("change", function(event2) {
                        event2.target.value = Math.min(Math.max(parseInt(event2.target.value), parseInt(_this.textInputLowerBound.value || event2.target.min) + 1), event2.target.max), _this.rangeHigherBound.value = event2.target.value, _this.rangeHigherBound.parentElement.style.setProperty("--range-max", "".concat(parseInt(_this.rangeHigherBound.value) / parseInt(_this.rangeHigherBound.max) * 100, "%"))
                    }), this.rangeLowerBound.addEventListener("change", function(event2) {
                        _this.textInputLowerBound.value = event2.target.value, _this.textInputLowerBound.dispatchEvent(new Event("change", {
                            bubbles: !0
                        }))
                    }), this.rangeHigherBound.addEventListener("change", function(event2) {
                        _this.textInputHigherBound.value = event2.target.value, _this.textInputHigherBound.dispatchEvent(new Event("change", {
                            bubbles: !0
                        }))
                    }), this.rangeLowerBound.addEventListener("input", function(event2) {
                        _this.dispatchEvent(new CustomEvent("collection:abort-loading", {
                            bubbles: !0
                        })), event2.target.value = Math.min(parseInt(event2.target.value), parseInt(_this.textInputHigherBound.value || event2.target.max) - 1), event2.target.parentElement.style.setProperty("--range-min", "".concat(parseInt(event2.target.value) / parseInt(event2.target.max) * 100, "%")), _this.textInputLowerBound.value = event2.target.value
                    }), this.rangeHigherBound.addEventListener("input", function(event2) {
                        _this.dispatchEvent(new CustomEvent("collection:abort-loading", {
                            bubbles: !0
                        })), event2.target.value = Math.max(parseInt(event2.target.value), parseInt(_this.textInputLowerBound.value || event2.target.min) + 1), event2.target.parentElement.style.setProperty("--range-max", "".concat(parseInt(event2.target.value) / parseInt(event2.target.max) * 100, "%")), _this.textInputHigherBound.value = event2.target.value
                    })
                }
            }]), PriceRange2
        })(_wrapNativeSuper(HTMLElement));
    window.customElements.define("price-range", PriceRange), (function() {
        var bootTheme = function() {
            window.NodeList && !NodeList.prototype.forEach && (NodeList.prototype.forEach = function(callback, thisArg) {
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) callback.call(thisArg, this[i], i, this)
            }), smoothscroll.polyfill(), new CollapsibleManager, new LoadingBar, new ModalManager, new PopoverManager;
            var sections = new SectionContainer;
            sections.register("account", AccountSection), sections.register("announcement-bar", AnnouncementBarSection), sections.register("blog", BlogSection), sections.register("blog-sidebar", BlogSidebarSection), sections.register("blog-post", BlogPostSection), sections.register("cart", CartSection), sections.register("collection-list", CollectionListSection), sections.register("collection", CollectionSection), sections.register("featured-collection", FeaturedCollectionSection), sections.register("footer", FooterSection), sections.register("gift-card", GiftCardSection), sections.register("header", HeaderSection), sections.register("login", LoginSection), sections.register("map", MapSection), sections.register("minimal-header", MinimalHeaderSection), sections.register("popups", PopupsSection), sections.register("product-recommendations", ProductRecommendationsSection), sections.register("product", ProductSection), sections.register("quick-links", QuickLinksSection), sections.register("recently-viewed-products", RecentlyViewedProductsSection), sections.register("slideshow", SlideshowSection), sections.register("text-with-icons", TextWithIconsSection), sections.register("video", VideoSection), (function() {
                document.querySelectorAll(".rte table").forEach(function(table) {
                    table.outerHTML = '<div class="table-wrapper">' + table.outerHTML + "</div>"
                }), document.querySelectorAll(".rte iframe").forEach(function(iframe) {
                    (iframe.src.indexOf("youtube") !== -1 || iframe.src.indexOf("youtu.be") !== -1 || iframe.src.indexOf("vimeo") !== -1) && (iframe.outerHTML = '<div class="video-wrapper">' + iframe.outerHTML + "</div>", iframe.src = iframe.src)
                })
            })(), (function() {
                var touchingCarousel = !1,
                    touchStartCoords;
                document.body.addEventListener("touchstart", function(e) {
                    var flickitySliderElement = e.target.closest(".flickity-slider");
                    if (flickitySliderElement) {
                        var flickity2 = js.data(flickitySliderElement.closest(".flickity-enabled"));
                        if (flickity2.isDraggable) touchingCarousel = !0;
                        else {
                            touchingCarousel = !1;
                            return
                        }
                    } else {
                        touchingCarousel = !1;
                        return
                    }
                    touchStartCoords = {
                        x: e.touches[0].pageX,
                        y: e.touches[0].pageY
                    }
                }), document.body.addEventListener("touchmove", function(e) {
                    if (touchingCarousel && e.cancelable) {
                        var moveVector = {
                            x: e.touches[0].pageX - touchStartCoords.x,
                            y: e.touches[0].pageY - touchStartCoords.y
                        };
                        Math.abs(moveVector.x) > 8 && e.preventDefault()
                    }
                }, {
                    passive: !1
                })
            })(), (function() {
                var documentDelegate = new Delegate(document.body);
                documentDelegate.on("click", ".expandable-content__toggle", function(item, expandableButton) {
                    var parentSection = expandableButton.closest(".expandable-content");
                    if (parentSection.getAttribute("aria-expanded") === "true") {
                        parentSection.setAttribute("aria-expanded", "false"), parentSection.style["max-height"] = "".concat(parentSection.offsetHeight, "px"), parentSection.offsetHeight, parentSection.style["max-height"] = null;
                        var expandableText = expandableButton.querySelector(".expandable-content__toggle-text");
                        expandableText.innerHTML = expandableText.getAttribute("data-view-more");
                        var parentCard = parentSection.closest(".card");
                        if (parentCard) {
                            var amountToScroll = parentCard.getBoundingClientRect().top - 15 - parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height"));
                            window.scrollBy({
                                top: amountToScroll,
                                behavior: "smooth"
                            })
                        }
                    } else {
                        parentSection.setAttribute("aria-expanded", "true"), expandableButton.previousElementSibling && (expandableButton.previousElementSibling.style["margin-bottom"] = "".concat(parseInt(expandableButton.clientHeight), "px")), Animation.slideDown(parentSection, null, "max-height");
                        var _expandableText = expandableButton.querySelector(".expandable-content__toggle-text");
                        _expandableText.innerHTML = _expandableText.getAttribute("data-view-less")
                    }
                });
                var processCollapsibles = function() {
                    document.querySelectorAll(".expandable-content[aria-expanded]").forEach(function(item) {
                        item.scrollHeight > item.clientHeight ? item.classList.add("expandable-content--expandable") : item.setAttribute("aria-expanded", "true")
                    })
                };
                document.addEventListener("shopify:section:load", function(event2) {
                    processCollapsibles()
                }), processCollapsibles()
            })(), (function() {
                if (Responsive.getCurrentBreakpoint() === "phone")
                    for (var autoFocusedElements = document.querySelectorAll("input[autofocus]"), i = 0; i < autoFocusedElements.length; i++) autoFocusedElements[i].blur(), autoFocusedElements[i].removeAttribute("autofocus")
            })(), (function() {
                var documentDelegate = new Delegate(document.body);
                documentDelegate.on("click", '[href^="#"], [data-href]', function(event2, target) {
                    var selector = target.hasAttribute("href") ? target.getAttribute("href") : target.getAttribute("data-href");
                    if (!(selector === "#" || selector === "#main")) {
                        var element = null;
                        try {
                            element = document.querySelector(selector)
                        } catch (exception) {
                            return
                        }
                        for (var offset = parseInt(target.getAttribute("data-offset") || 0), toTop = 0; element.offsetParent.tagName !== "BODY";) toTop += element.offsetTop, element = element.offsetParent;
                        toTop += element.offsetTop, window.scrollTo({
                            behavior: "smooth",
                            top: toTop - offset
                        }), event2.preventDefault()
                    }
                })
            })(), (function() {
                function handleFirstTab(event2) {
                    event2.key === "Tab" && (document.body.classList.add("is-tabbing"), window.removeEventListener("keydown", handleFirstTab))
                }
                window.addEventListener("keydown", handleFirstTab)
            })(), (function() {
                var documentDelegate = new Delegate(document.body);
                documentDelegate.on("keyup", "input, textarea", function(event2, target) {
                    target.classList.toggle("is-filled", target.value !== "")
                }), documentDelegate.on("change", "select", function(event2, target) {
                    target.parentNode.classList.toggle("is-filled", target.value !== "")
                })
            })(), (function() {
                var links = document.links;
                fastdom.mutate(function() {
                    for (var i = 0, linksLength = links.length; i < linksLength; i++) links[i].hostname !== window.location.hostname && (links[i].target = "_blank", links[i].relList.add("noopener"), links[i].setAttribute("aria-describedby", "a11y-new-window-message"))
                })
            })()
        };
        if ("fetch" in window && "assign" in Object) bootTheme();
        else {
            var scriptEl = document.createElement("script");
            scriptEl.src = "//cdn.polyfill.io/v3/polyfill.min.js?unknown=polyfill&features=fetch,Element.prototype.closest,Element.prototype.matches,Element.prototype.remove,Element.prototype.classList,Array.prototype.includes,String.prototype.includes,Object.assign,CustomEvent,URL,DOMTokenList", scriptEl.async = !1, scriptEl.onload = function() {
                bootTheme()
            }, document.head.appendChild(scriptEl)
        }
    })()
}));
//# sourceMappingURL=/cdn/shop/t/8/assets/theme.js.map?v=89738589015987816271742222655